import * as v from "react";
import ee, { createContext as Ts, useContext as Kt, useEffect as At, isValidElement as ky, useRef as st, useLayoutEffect as My, useState as Ht, forwardRef as lo, useMemo as Kn, Children as Ly, useCallback as wn, useImperativeHandle as Iu, useDebugValue as Sd, createElement as Dy } from "react";
import { useConfig as $s, loadPackageTranslations as Fy, request as jy, i18nInstance as Ed, CWElementsI18NProvider as By, useTranslation as mg, CWElementsSharedService as Vy } from "@cw-elements/config";
import * as yg from "react-dom";
import _d, { createPortal as bg, unstable_batchedUpdates as zy, flushSync as Hy } from "react-dom";
const ir = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
function Cg() {
  throw new Error("setTimeout has not been defined");
}
function wg() {
  throw new Error("clearTimeout has not been defined");
}
var Rr = Cg, Nr = wg;
typeof ir.setTimeout == "function" && (Rr = setTimeout);
typeof ir.clearTimeout == "function" && (Nr = clearTimeout);
function Sg(e) {
  if (Rr === setTimeout)
    return setTimeout(e, 0);
  if ((Rr === Cg || !Rr) && setTimeout)
    return Rr = setTimeout, setTimeout(e, 0);
  try {
    return Rr(e, 0);
  } catch {
    try {
      return Rr.call(null, e, 0);
    } catch {
      return Rr.call(this, e, 0);
    }
  }
}
function Uy(e) {
  if (Nr === clearTimeout)
    return clearTimeout(e);
  if ((Nr === wg || !Nr) && clearTimeout)
    return Nr = clearTimeout, clearTimeout(e);
  try {
    return Nr(e);
  } catch {
    try {
      return Nr.call(null, e);
    } catch {
      return Nr.call(this, e);
    }
  }
}
var pr = [], Lo = !1, Zr, Da = -1;
function Wy() {
  !Lo || !Zr || (Lo = !1, Zr.length ? pr = Zr.concat(pr) : Da = -1, pr.length && Eg());
}
function Eg() {
  if (!Lo) {
    var e = Sg(Wy);
    Lo = !0;
    for (var t = pr.length; t; ) {
      for (Zr = pr, pr = []; ++Da < t; )
        Zr && Zr[Da].run();
      Da = -1, t = pr.length;
    }
    Zr = null, Lo = !1, Uy(e);
  }
}
function qy(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  pr.push(new _g(e, t)), pr.length === 1 && !Lo && Sg(Eg);
}
function _g(e, t) {
  this.fun = e, this.array = t;
}
_g.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var Gy = "browser", Ky = "browser", Xy = !0, Yy = {}, Zy = [], Qy = "", Jy = {}, eb = {}, tb = {};
function co() {
}
var nb = co, rb = co, ob = co, ib = co, ab = co, sb = co, lb = co;
function cb(e) {
  throw new Error("process.binding is not supported");
}
function ub() {
  return "/";
}
function db(e) {
  throw new Error("process.chdir is not supported");
}
function fb() {
  return 0;
}
var $o = ir.performance || {}, vb = $o.now || $o.mozNow || $o.msNow || $o.oNow || $o.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function gb(e) {
  var t = vb.call($o) * 1e-3, n = Math.floor(t), r = Math.floor(t % 1 * 1e9);
  return e && (n = n - e[0], r = r - e[1], r < 0 && (n--, r += 1e9)), [n, r];
}
var pb = /* @__PURE__ */ new Date();
function hb() {
  var e = /* @__PURE__ */ new Date(), t = e - pb;
  return t / 1e3;
}
var z = {
  nextTick: qy,
  title: Gy,
  browser: Xy,
  env: Yy,
  argv: Zy,
  version: Qy,
  versions: Jy,
  on: nb,
  addListener: rb,
  once: ob,
  off: ib,
  removeListener: ab,
  removeAllListeners: sb,
  emit: lb,
  binding: cb,
  cwd: ub,
  chdir: db,
  umask: fb,
  hrtime: gb,
  platform: Ky,
  release: eb,
  config: tb,
  uptime: hb
};
function xg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var oc = { exports: {} }, fi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xd;
function mb() {
  if (xd)
    return fi;
  xd = 1;
  var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, f = null, g = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (g = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: f, ref: g, props: d, _owner: o.current };
  }
  return fi.Fragment = n, fi.jsx = a, fi.jsxs = a, fi;
}
var vi = {}, Od;
function yb() {
  return Od || (Od = 1, z.env.NODE_ENV !== "production" && function() {
    var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h = Symbol.iterator, y = "@@iterator";
    function p(I) {
      if (I === null || typeof I != "object")
        return null;
      var Z = h && I[h] || I[y];
      return typeof Z == "function" ? Z : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(I) {
      {
        for (var Z = arguments.length, ae = new Array(Z > 1 ? Z - 1 : 0), be = 1; be < Z; be++)
          ae[be - 1] = arguments[be];
        b("error", I, ae);
      }
    }
    function b(I, Z, ae) {
      {
        var be = C.ReactDebugCurrentFrame, Oe = be.getStackAddendum();
        Oe !== "" && (Z += "%s", ae = ae.concat([Oe]));
        var We = ae.map(function($e) {
          return String($e);
        });
        We.unshift("Warning: " + Z), Function.prototype.apply.call(console[I], console, We);
      }
    }
    var w = !1, E = !1, S = !1, _ = !1, O = !1, P;
    P = Symbol.for("react.module.reference");
    function $(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === r || I === i || O || I === o || I === c || I === u || _ || I === g || w || E || S || typeof I == "object" && I !== null && (I.$$typeof === f || I.$$typeof === d || I.$$typeof === a || I.$$typeof === s || I.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === P || I.getModuleId !== void 0));
    }
    function L(I, Z, ae) {
      var be = I.displayName;
      if (be)
        return be;
      var Oe = Z.displayName || Z.name || "";
      return Oe !== "" ? ae + "(" + Oe + ")" : ae;
    }
    function N(I) {
      return I.displayName || "Context";
    }
    function k(I) {
      if (I == null)
        return null;
      if (typeof I.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
        return I.displayName || I.name || null;
      if (typeof I == "string")
        return I;
      switch (I) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case s:
            var Z = I;
            return N(Z) + ".Consumer";
          case a:
            var ae = I;
            return N(ae._context) + ".Provider";
          case l:
            return L(I, I.render, "ForwardRef");
          case d:
            var be = I.displayName || null;
            return be !== null ? be : k(I.type) || "Memo";
          case f: {
            var Oe = I, We = Oe._payload, $e = Oe._init;
            try {
              return k($e(We));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, U = 0, A, R, D, B, M, G, H;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function K() {
      {
        if (U === 0) {
          A = console.log, R = console.info, D = console.warn, B = console.error, M = console.group, G = console.groupCollapsed, H = console.groupEnd;
          var I = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: I,
            log: I,
            warn: I,
            error: I,
            group: I,
            groupCollapsed: I,
            groupEnd: I
          });
        }
        U++;
      }
    }
    function J() {
      {
        if (U--, U === 0) {
          var I = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, I, {
              value: A
            }),
            info: F({}, I, {
              value: R
            }),
            warn: F({}, I, {
              value: D
            }),
            error: F({}, I, {
              value: B
            }),
            group: F({}, I, {
              value: M
            }),
            groupCollapsed: F({}, I, {
              value: G
            }),
            groupEnd: F({}, I, {
              value: H
            })
          });
        }
        U < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = C.ReactCurrentDispatcher, le;
    function ne(I, Z, ae) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (Oe) {
            var be = Oe.stack.trim().match(/\n( *(at )?)/);
            le = be && be[1] || "";
          }
        return `
` + le + I;
      }
    }
    var te = !1, re;
    {
      var _e = typeof WeakMap == "function" ? WeakMap : Map;
      re = new _e();
    }
    function me(I, Z) {
      if (!I || te)
        return "";
      {
        var ae = re.get(I);
        if (ae !== void 0)
          return ae;
      }
      var be;
      te = !0;
      var Oe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var We;
      We = ie.current, ie.current = null, K();
      try {
        if (Z) {
          var $e = function() {
            throw Error();
          };
          if (Object.defineProperty($e.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct($e, []);
            } catch (Mt) {
              be = Mt;
            }
            Reflect.construct(I, [], $e);
          } else {
            try {
              $e.call();
            } catch (Mt) {
              be = Mt;
            }
            I.call($e.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Mt) {
            be = Mt;
          }
          I();
        }
      } catch (Mt) {
        if (Mt && be && typeof Mt.stack == "string") {
          for (var Le = Mt.stack.split(`
`), Ct = be.stack.split(`
`), Qe = Le.length - 1, qe = Ct.length - 1; Qe >= 1 && qe >= 0 && Le[Qe] !== Ct[qe]; )
            qe--;
          for (; Qe >= 1 && qe >= 0; Qe--, qe--)
            if (Le[Qe] !== Ct[qe]) {
              if (Qe !== 1 || qe !== 1)
                do
                  if (Qe--, qe--, qe < 0 || Le[Qe] !== Ct[qe]) {
                    var qt = `
` + Le[Qe].replace(" at new ", " at ");
                    return I.displayName && qt.includes("<anonymous>") && (qt = qt.replace("<anonymous>", I.displayName)), typeof I == "function" && re.set(I, qt), qt;
                  }
                while (Qe >= 1 && qe >= 0);
              break;
            }
        }
      } finally {
        te = !1, ie.current = We, J(), Error.prepareStackTrace = Oe;
      }
      var In = I ? I.displayName || I.name : "", on = In ? ne(In) : "";
      return typeof I == "function" && re.set(I, on), on;
    }
    function De(I, Z, ae) {
      return me(I, !1);
    }
    function oe(I) {
      var Z = I.prototype;
      return !!(Z && Z.isReactComponent);
    }
    function Te(I, Z, ae) {
      if (I == null)
        return "";
      if (typeof I == "function")
        return me(I, oe(I));
      if (typeof I == "string")
        return ne(I);
      switch (I) {
        case c:
          return ne("Suspense");
        case u:
          return ne("SuspenseList");
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case l:
            return De(I.render);
          case d:
            return Te(I.type, Z, ae);
          case f: {
            var be = I, Oe = be._payload, We = be._init;
            try {
              return Te(We(Oe), Z, ae);
            } catch {
            }
          }
        }
      return "";
    }
    var Re = Object.prototype.hasOwnProperty, Ye = {}, Fe = C.ReactDebugCurrentFrame;
    function Ze(I) {
      if (I) {
        var Z = I._owner, ae = Te(I.type, I._source, Z ? Z.type : null);
        Fe.setExtraStackFrame(ae);
      } else
        Fe.setExtraStackFrame(null);
    }
    function nt(I, Z, ae, be, Oe) {
      {
        var We = Function.call.bind(Re);
        for (var $e in I)
          if (We(I, $e)) {
            var Le = void 0;
            try {
              if (typeof I[$e] != "function") {
                var Ct = Error((be || "React class") + ": " + ae + " type `" + $e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[$e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ct.name = "Invariant Violation", Ct;
              }
              Le = I[$e](Z, $e, be, ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Qe) {
              Le = Qe;
            }
            Le && !(Le instanceof Error) && (Ze(Oe), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", ae, $e, typeof Le), Ze(null)), Le instanceof Error && !(Le.message in Ye) && (Ye[Le.message] = !0, Ze(Oe), m("Failed %s type: %s", ae, Le.message), Ze(null));
          }
      }
    }
    var xe = Array.isArray;
    function He(I) {
      return xe(I);
    }
    function ye(I) {
      {
        var Z = typeof Symbol == "function" && Symbol.toStringTag, ae = Z && I[Symbol.toStringTag] || I.constructor.name || "Object";
        return ae;
      }
    }
    function it(I) {
      try {
        return Me(I), !1;
      } catch {
        return !0;
      }
    }
    function Me(I) {
      return "" + I;
    }
    function Ve(I) {
      if (it(I))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ye(I)), Me(I);
    }
    var lt = C.ReactCurrentOwner, yt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mt, Ne, Ue;
    Ue = {};
    function x(I) {
      if (Re.call(I, "ref")) {
        var Z = Object.getOwnPropertyDescriptor(I, "ref").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return I.ref !== void 0;
    }
    function T(I) {
      if (Re.call(I, "key")) {
        var Z = Object.getOwnPropertyDescriptor(I, "key").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return I.key !== void 0;
    }
    function q(I, Z) {
      if (typeof I.ref == "string" && lt.current && Z && lt.current.stateNode !== Z) {
        var ae = k(lt.current.type);
        Ue[ae] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(lt.current.type), I.ref), Ue[ae] = !0);
      }
    }
    function W(I, Z) {
      {
        var ae = function() {
          mt || (mt = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ae.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: ae,
          configurable: !0
        });
      }
    }
    function Y(I, Z) {
      {
        var ae = function() {
          Ne || (Ne = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        ae.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: ae,
          configurable: !0
        });
      }
    }
    var ce = function(I, Z, ae, be, Oe, We, $e) {
      var Le = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: I,
        key: Z,
        ref: ae,
        props: $e,
        // Record the component responsible for creating this element.
        _owner: We
      };
      return Le._store = {}, Object.defineProperty(Le._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Le, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: be
      }), Object.defineProperty(Le, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Oe
      }), Object.freeze && (Object.freeze(Le.props), Object.freeze(Le)), Le;
    };
    function fe(I, Z, ae, be, Oe) {
      {
        var We, $e = {}, Le = null, Ct = null;
        ae !== void 0 && (Ve(ae), Le = "" + ae), T(Z) && (Ve(Z.key), Le = "" + Z.key), x(Z) && (Ct = Z.ref, q(Z, Oe));
        for (We in Z)
          Re.call(Z, We) && !yt.hasOwnProperty(We) && ($e[We] = Z[We]);
        if (I && I.defaultProps) {
          var Qe = I.defaultProps;
          for (We in Qe)
            $e[We] === void 0 && ($e[We] = Qe[We]);
        }
        if (Le || Ct) {
          var qe = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          Le && W($e, qe), Ct && Y($e, qe);
        }
        return ce(I, Le, Ct, Oe, be, lt.current, $e);
      }
    }
    var je = C.ReactCurrentOwner, Be = C.ReactDebugCurrentFrame;
    function ze(I) {
      if (I) {
        var Z = I._owner, ae = Te(I.type, I._source, Z ? Z.type : null);
        Be.setExtraStackFrame(ae);
      } else
        Be.setExtraStackFrame(null);
    }
    var et;
    et = !1;
    function Ke(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function Je() {
      {
        if (je.current) {
          var I = k(je.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
    }
    function Pt(I) {
      return "";
    }
    var rt = {};
    function we(I) {
      {
        var Z = Je();
        if (!Z) {
          var ae = typeof I == "string" ? I : I.displayName || I.name;
          ae && (Z = `

Check the top-level render call using <` + ae + ">.");
        }
        return Z;
      }
    }
    function ge(I, Z) {
      {
        if (!I._store || I._store.validated || I.key != null)
          return;
        I._store.validated = !0;
        var ae = we(Z);
        if (rt[ae])
          return;
        rt[ae] = !0;
        var be = "";
        I && I._owner && I._owner !== je.current && (be = " It was passed a child from " + k(I._owner.type) + "."), ze(I), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ae, be), ze(null);
      }
    }
    function Ee(I, Z) {
      {
        if (typeof I != "object")
          return;
        if (He(I))
          for (var ae = 0; ae < I.length; ae++) {
            var be = I[ae];
            Ke(be) && ge(be, Z);
          }
        else if (Ke(I))
          I._store && (I._store.validated = !0);
        else if (I) {
          var Oe = p(I);
          if (typeof Oe == "function" && Oe !== I.entries)
            for (var We = Oe.call(I), $e; !($e = We.next()).done; )
              Ke($e.value) && ge($e.value, Z);
        }
      }
    }
    function ot(I) {
      {
        var Z = I.type;
        if (Z == null || typeof Z == "string")
          return;
        var ae;
        if (typeof Z == "function")
          ae = Z.propTypes;
        else if (typeof Z == "object" && (Z.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Z.$$typeof === d))
          ae = Z.propTypes;
        else
          return;
        if (ae) {
          var be = k(Z);
          nt(ae, I.props, "prop", be, I);
        } else if (Z.PropTypes !== void 0 && !et) {
          et = !0;
          var Oe = k(Z);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Oe || "Unknown");
        }
        typeof Z.getDefaultProps == "function" && !Z.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xt(I) {
      {
        for (var Z = Object.keys(I.props), ae = 0; ae < Z.length; ae++) {
          var be = Z[ae];
          if (be !== "children" && be !== "key") {
            ze(I), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), ze(null);
            break;
          }
        }
        I.ref !== null && (ze(I), m("Invalid attribute `ref` supplied to `React.Fragment`."), ze(null));
      }
    }
    var bt = {};
    function Dt(I, Z, ae, be, Oe, We) {
      {
        var $e = $(I);
        if (!$e) {
          var Le = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (Le += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ct = Pt();
          Ct ? Le += Ct : Le += Je();
          var Qe;
          I === null ? Qe = "null" : He(I) ? Qe = "array" : I !== void 0 && I.$$typeof === t ? (Qe = "<" + (k(I.type) || "Unknown") + " />", Le = " Did you accidentally export a JSX literal instead of a component?") : Qe = typeof I, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Qe, Le);
        }
        var qe = fe(I, Z, ae, Oe, We);
        if (qe == null)
          return qe;
        if ($e) {
          var qt = Z.children;
          if (qt !== void 0)
            if (be)
              if (He(qt)) {
                for (var In = 0; In < qt.length; In++)
                  Ee(qt[In], I);
                Object.freeze && Object.freeze(qt);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ee(qt, I);
        }
        if (Re.call(Z, "key")) {
          var on = k(I), Mt = Object.keys(Z).filter(function(er) {
            return er !== "key";
          }), Jn = Mt.length > 0 ? "{key: someKey, " + Mt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!bt[on + Jn]) {
            var Tn = Mt.length > 0 ? "{" + Mt.join(": ..., ") + ": ...}" : "{}";
            m(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Jn, on, Tn, on), bt[on + Jn] = !0;
          }
        }
        return I === r ? xt(qe) : ot(qe), qe;
      }
    }
    function jn(I, Z, ae) {
      return Dt(I, Z, ae, !0);
    }
    function ct(I, Z, ae) {
      return Dt(I, Z, ae, !1);
    }
    var ut = ct, Wt = jn;
    vi.Fragment = r, vi.jsx = ut, vi.jsxs = Wt;
  }()), vi;
}
z.env.NODE_ENV === "production" ? oc.exports = mb() : oc.exports = yb();
var ue = oc.exports, Tu = /* @__PURE__ */ Ts({});
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pe.apply(null, arguments);
}
function Og(e) {
  if (Array.isArray(e))
    return e;
}
function bb(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, a, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, o = u;
    } finally {
      try {
        if (!l && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (c)
          throw o;
      }
    }
    return s;
  }
}
function ic(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function $u(e, t) {
  if (e) {
    if (typeof e == "string")
      return ic(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ic(e, t) : void 0;
  }
}
function Pg() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q(e, t) {
  return Og(e) || bb(e, t) || $u(e, t) || Pg();
}
function Ie(e) {
  "@babel/helpers - typeof";
  return Ie = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ie(e);
}
function Cb(e, t) {
  if (Ie(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ie(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ig(e) {
  var t = Cb(e, "string");
  return Ie(t) == "symbol" ? t : t + "";
}
function j(e, t, n) {
  return (t = Ig(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function wb(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
function ht(e, t) {
  if (e == null)
    return {};
  var n, r, o = wb(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var Tg = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Tg);
var Sb = Tg.exports;
const se = /* @__PURE__ */ xg(Sb), Jt = Math.round;
function ml(e, t) {
  const n = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = n.map((o) => parseFloat(o));
  for (let o = 0; o < 3; o += 1)
    r[o] = t(r[o] || 0, n[o] || "", o);
  return n[3] ? r[3] = n[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const Pd = (e, t, n) => n === 0 ? e : e / 100;
function gi(e, t) {
  const n = t || 255;
  return e > n ? n : e < 0 ? 0 : e;
}
class Tt {
  constructor(t) {
    j(this, "isValid", !0), j(this, "r", 0), j(this, "g", 0), j(this, "b", 0), j(this, "a", 1), j(this, "_h", void 0), j(this, "_s", void 0), j(this, "_l", void 0), j(this, "_v", void 0), j(this, "_max", void 0), j(this, "_min", void 0), j(this, "_brightness", void 0);
    function n(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t)
      if (typeof t == "string") {
        let o = function(i) {
          return r.startsWith(i);
        };
        const r = t.trim();
        /^#?[A-F\d]{3,8}$/i.test(r) ? this.fromHexString(r) : o("rgb") ? this.fromRgbString(r) : o("hsl") ? this.fromHslString(r) : (o("hsv") || o("hsb")) && this.fromHsvString(r);
      } else if (t instanceof Tt)
        this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
      else if (n("rgb"))
        this.r = gi(t.r), this.g = gi(t.g), this.b = gi(t.b), this.a = typeof t.a == "number" ? gi(t.a, 1) : 1;
      else if (n("hsl"))
        this.fromHsl(t);
      else if (n("hsv"))
        this.fromHsv(t);
      else
        throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const n = this.toHsv();
    return n.h = t, this._c(n);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(i) {
      const a = i / 255;
      return a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
    }
    const n = t(this.r), r = t(this.g), o = t(this.b);
    return 0.2126 * n + 0.7152 * r + 0.0722 * o;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = Jt(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let o = this.getLightness() - t / 100;
    return o < 0 && (o = 0), this._c({
      h: n,
      s: r,
      l: o,
      a: this.a
    });
  }
  lighten(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let o = this.getLightness() + t / 100;
    return o > 1 && (o = 1), this._c({
      h: n,
      s: r,
      l: o,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, n = 50) {
    const r = this._c(t), o = n / 100, i = (s) => (r[s] - this[s]) * o + this[s], a = {
      r: Jt(i("r")),
      g: Jt(i("g")),
      b: Jt(i("b")),
      a: Jt(i("a") * 100) / 100
    };
    return this._c(a);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const n = this._c(t), r = this.a + n.a * (1 - this.a), o = (i) => Jt((this[i] * this.a + n[i] * n.a * (1 - this.a)) / r);
    return this._c({
      r: o("r"),
      g: o("g"),
      b: o("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const n = (this.r || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const o = (this.b || 0).toString(16);
    if (t += o.length === 2 ? o : "0" + o, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const i = Jt(this.a * 255).toString(16);
      t += i.length === 2 ? i : "0" + i;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), n = Jt(this.getSaturation() * 100), r = Jt(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${n}%,${r}%,${this.a})` : `hsl(${t},${n}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, n, r) {
    const o = this.clone();
    return o[t] = gi(n, r), o;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const n = t.replace("#", "");
    function r(o, i) {
      return parseInt(n[o] + n[i || o], 16);
    }
    n.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = n[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = n[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: n,
    l: r,
    a: o
  }) {
    if (this._h = t % 360, this._s = n, this._l = r, this.a = typeof o == "number" ? o : 1, n <= 0) {
      const f = Jt(r * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let i = 0, a = 0, s = 0;
    const l = t / 60, c = (1 - Math.abs(2 * r - 1)) * n, u = c * (1 - Math.abs(l % 2 - 1));
    l >= 0 && l < 1 ? (i = c, a = u) : l >= 1 && l < 2 ? (i = u, a = c) : l >= 2 && l < 3 ? (a = c, s = u) : l >= 3 && l < 4 ? (a = u, s = c) : l >= 4 && l < 5 ? (i = u, s = c) : l >= 5 && l < 6 && (i = c, s = u);
    const d = r - c / 2;
    this.r = Jt((i + d) * 255), this.g = Jt((a + d) * 255), this.b = Jt((s + d) * 255);
  }
  fromHsv({
    h: t,
    s: n,
    v: r,
    a: o
  }) {
    this._h = t % 360, this._s = n, this._v = r, this.a = typeof o == "number" ? o : 1;
    const i = Jt(r * 255);
    if (this.r = i, this.g = i, this.b = i, n <= 0)
      return;
    const a = t / 60, s = Math.floor(a), l = a - s, c = Jt(r * (1 - n) * 255), u = Jt(r * (1 - n * l) * 255), d = Jt(r * (1 - n * (1 - l)) * 255);
    switch (s) {
      case 0:
        this.g = d, this.b = c;
        break;
      case 1:
        this.r = u, this.b = c;
        break;
      case 2:
        this.r = c, this.b = d;
        break;
      case 3:
        this.r = c, this.g = u;
        break;
      case 4:
        this.r = d, this.g = c;
        break;
      case 5:
      default:
        this.g = c, this.b = u;
        break;
    }
  }
  fromHsvString(t) {
    const n = ml(t, Pd);
    this.fromHsv({
      h: n[0],
      s: n[1],
      v: n[2],
      a: n[3]
    });
  }
  fromHslString(t) {
    const n = ml(t, Pd);
    this.fromHsl({
      h: n[0],
      s: n[1],
      l: n[2],
      a: n[3]
    });
  }
  fromRgbString(t) {
    const n = ml(t, (r, o) => (
      // Convert percentage to number. e.g. 50% -> 128
      o.includes("%") ? Jt(r / 100 * 255) : r
    ));
    this.r = n[0], this.g = n[1], this.b = n[2], this.a = n[3];
  }
}
var ga = 2, Id = 0.16, Eb = 0.05, _b = 0.05, xb = 0.15, $g = 5, Rg = 4, Ob = [{
  index: 7,
  amount: 15
}, {
  index: 6,
  amount: 25
}, {
  index: 5,
  amount: 30
}, {
  index: 5,
  amount: 45
}, {
  index: 5,
  amount: 65
}, {
  index: 5,
  amount: 85
}, {
  index: 4,
  amount: 90
}, {
  index: 3,
  amount: 95
}, {
  index: 2,
  amount: 97
}, {
  index: 1,
  amount: 98
}];
function Td(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - ga * t : Math.round(e.h) + ga * t : r = n ? Math.round(e.h) + ga * t : Math.round(e.h) - ga * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function $d(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - Id * t : t === Rg ? r = e.s + Id : r = e.s + Eb * t, r > 1 && (r = 1), n && t === $g && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Math.round(r * 100) / 100;
}
function Rd(e, t, n) {
  var r;
  return n ? r = e.v + _b * t : r = e.v - xb * t, r = Math.max(0, Math.min(1, r)), Math.round(r * 100) / 100;
}
function Ai(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = new Tt(e), o = r.toHsv(), i = $g; i > 0; i -= 1) {
    var a = new Tt({
      h: Td(o, i, !0),
      s: $d(o, i, !0),
      v: Rd(o, i, !0)
    });
    n.push(a);
  }
  n.push(r);
  for (var s = 1; s <= Rg; s += 1) {
    var l = new Tt({
      h: Td(o, s),
      s: $d(o, s),
      v: Rd(o, s)
    });
    n.push(l);
  }
  return t.theme === "dark" ? Ob.map(function(c) {
    var u = c.index, d = c.amount;
    return new Tt(t.backgroundColor || "#141414").mix(n[u], d).toHexString();
  }) : n.map(function(c) {
    return c.toHexString();
  });
}
var yl = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, ac = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
ac.primary = ac[5];
var sc = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
sc.primary = sc[5];
var lc = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
lc.primary = lc[5];
var cc = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
cc.primary = cc[5];
var uc = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
uc.primary = uc[5];
var dc = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
dc.primary = dc[5];
var fc = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
fc.primary = fc[5];
var vc = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
vc.primary = vc[5];
var ss = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
ss.primary = ss[5];
var gc = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
gc.primary = gc[5];
var pc = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
pc.primary = pc[5];
var hc = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
hc.primary = hc[5];
var mc = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
mc.primary = mc[5];
var bl = {
  red: ac,
  volcano: sc,
  orange: lc,
  gold: cc,
  yellow: uc,
  lime: dc,
  green: fc,
  cyan: vc,
  blue: ss,
  geekblue: gc,
  purple: pc,
  magenta: hc,
  grey: mc
};
function Nd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function V(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nd(Object(n), !0).forEach(function(r) {
      j(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function gn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Pb(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var Ad = "data-rc-order", kd = "data-rc-priority", Ib = "rc-util-key", yc = /* @__PURE__ */ new Map();
function Ng() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : Ib;
}
function Rs(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function Tb(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Ru(e) {
  return Array.from((yc.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function Ag(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!gn())
    return null;
  var n = t.csp, r = t.prepend, o = t.priority, i = o === void 0 ? 0 : o, a = Tb(r), s = a === "prependQueue", l = document.createElement("style");
  l.setAttribute(Ad, a), s && i && l.setAttribute(kd, "".concat(i)), n != null && n.nonce && (l.nonce = n == null ? void 0 : n.nonce), l.innerHTML = e;
  var c = Rs(t), u = c.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || Ru(c)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(Ad)))
          return !1;
        var g = Number(f.getAttribute(kd) || 0);
        return i >= g;
      });
      if (d.length)
        return c.insertBefore(l, d[d.length - 1].nextSibling), l;
    }
    c.insertBefore(l, u);
  } else
    c.appendChild(l);
  return l;
}
function kg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Rs(t);
  return (t.styles || Ru(n)).find(function(r) {
    return r.getAttribute(Ng(t)) === e;
  });
}
function ki(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = kg(e, t);
  if (n) {
    var r = Rs(t);
    r.removeChild(n);
  }
}
function $b(e, t) {
  var n = yc.get(e);
  if (!n || !Pb(document, n)) {
    var r = Ag("", t), o = r.parentNode;
    yc.set(e, o), e.removeChild(r);
  }
}
function mr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Rs(n), o = Ru(r), i = V(V({}, n), {}, {
    styles: o
  });
  $b(r, i);
  var a = kg(t, i);
  if (a) {
    var s, l;
    if ((s = i.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((l = i.csp) === null || l === void 0 ? void 0 : l.nonce)) {
      var c;
      a.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = Ag(e, i);
  return u.setAttribute(Ng(i), t), u;
}
function Mg(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function Rb(e) {
  return Mg(e) instanceof ShadowRoot;
}
function ls(e) {
  return Rb(e) ? Mg(e) : null;
}
var bc = {}, Nu = [], Nb = function(t) {
  Nu.push(t);
};
function zo(e, t) {
  if (z.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = Nu.reduce(function(r, o) {
      return o(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function Ab(e, t) {
  if (z.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = Nu.reduce(function(r, o) {
      return o(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function Lg() {
  bc = {};
}
function Dg(e, t, n) {
  !t && !bc[n] && (e(!1, n), bc[n] = !0);
}
function gt(e, t) {
  Dg(zo, e, t);
}
function kb(e, t) {
  Dg(Ab, e, t);
}
gt.preMessage = Nb;
gt.resetWarned = Lg;
gt.noteOnce = kb;
function Mb(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function Lb(e, t) {
  gt(e, "[@ant-design/icons] ".concat(t));
}
function Md(e) {
  return Ie(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Ie(e.icon) === "object" || typeof e.icon == "function");
}
function Ld() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[Mb(n)] = r;
    }
    return t;
  }, {});
}
function Cc(e, t, n) {
  return n ? /* @__PURE__ */ ee.createElement(e.tag, V(V({
    key: t
  }, Ld(e.attrs)), n), (e.children || []).map(function(r, o) {
    return Cc(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ ee.createElement(e.tag, V({
    key: t
  }, Ld(e.attrs)), (e.children || []).map(function(r, o) {
    return Cc(r, "".concat(t, "-").concat(e.tag, "-").concat(o));
  }));
}
function Fg(e) {
  return Ai(e)[0];
}
function jg(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var Db = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, Fb = function(t) {
  var n = Kt(Tu), r = n.csp, o = n.prefixCls, i = n.layer, a = Db;
  o && (a = a.replace(/anticon/g, o)), i && (a = "@layer ".concat(i, ` {
`).concat(a, `
}`)), At(function() {
    var s = t.current, l = ls(s);
    mr(a, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: l
    });
  }, []);
}, jb = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], Pi = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Bb(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  Pi.primaryColor = t, Pi.secondaryColor = n || Fg(t), Pi.calculated = !!n;
}
function Vb() {
  return V({}, Pi);
}
var ti = function(t) {
  var n = t.icon, r = t.className, o = t.onClick, i = t.style, a = t.primaryColor, s = t.secondaryColor, l = ht(t, jb), c = v.useRef(), u = Pi;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || Fg(a)
  }), Fb(c), Lb(Md(n), "icon should be icon definiton, but got ".concat(n)), !Md(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = V(V({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), Cc(d.icon, "svg-".concat(d.name), V(V({
    className: r,
    onClick: o,
    style: i,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, l), {}, {
    ref: c
  }));
};
ti.displayName = "IconReact";
ti.getTwoToneColors = Vb;
ti.setTwoToneColors = Bb;
function Bg(e) {
  var t = jg(e), n = Q(t, 2), r = n[0], o = n[1];
  return ti.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function zb() {
  var e = ti.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Hb = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Bg(ss.primary);
var _n = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, o = e.spin, i = e.rotate, a = e.tabIndex, s = e.onClick, l = e.twoToneColor, c = ht(e, Hb), u = v.useContext(Tu), d = u.prefixCls, f = d === void 0 ? "anticon" : d, g = u.rootClassName, h = se(g, f, j(j({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!o || r.name === "loading"), n), y = a;
  y === void 0 && s && (y = -1);
  var p = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, C = jg(l), m = Q(C, 2), b = m[0], w = m[1];
  return /* @__PURE__ */ v.createElement("span", Pe({
    role: "img",
    "aria-label": r.name
  }, c, {
    ref: t,
    tabIndex: y,
    onClick: s,
    className: h
  }), /* @__PURE__ */ v.createElement(ti, {
    icon: r,
    primaryColor: b,
    secondaryColor: w,
    style: p
  }));
});
_n.displayName = "AntdIcon";
_n.getTwoToneColor = zb;
_n.setTwoToneColor = Bg;
var Ub = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "bars", theme: "outlined" }, Wb = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: Ub
  }));
}, Vg = /* @__PURE__ */ v.forwardRef(Wb);
z.env.NODE_ENV !== "production" && (Vg.displayName = "BarsOutlined");
var qb = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" }, Gb = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: qb
  }));
}, zg = /* @__PURE__ */ v.forwardRef(Gb);
z.env.NODE_ENV !== "production" && (zg.displayName = "CheckCircleFilled");
var Kb = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" }, Xb = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: Kb
  }));
}, Hg = /* @__PURE__ */ v.forwardRef(Xb);
z.env.NODE_ENV !== "production" && (Hg.displayName = "CloseCircleFilled");
var Yb = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" }, Zb = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: Yb
  }));
}, Ug = /* @__PURE__ */ v.forwardRef(Zb);
z.env.NODE_ENV !== "production" && (Ug.displayName = "CloseOutlined");
var Qb = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, name: "ellipsis", theme: "outlined" }, Jb = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: Qb
  }));
}, Wg = /* @__PURE__ */ v.forwardRef(Jb);
z.env.NODE_ENV !== "production" && (Wg.displayName = "EllipsisOutlined");
var eC = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" }, tC = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: eC
  }));
}, qg = /* @__PURE__ */ v.forwardRef(tC);
z.env.NODE_ENV !== "production" && (qg.displayName = "ExclamationCircleFilled");
var nC = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" }, rC = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: nC
  }));
}, Gg = /* @__PURE__ */ v.forwardRef(rC);
z.env.NODE_ENV !== "production" && (Gg.displayName = "InfoCircleFilled");
var oC = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" }, iC = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: oC
  }));
}, wc = /* @__PURE__ */ v.forwardRef(iC);
z.env.NODE_ENV !== "production" && (wc.displayName = "LeftOutlined");
var aC = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" }, sC = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: aC
  }));
}, Ns = /* @__PURE__ */ v.forwardRef(sC);
z.env.NODE_ENV !== "production" && (Ns.displayName = "LoadingOutlined");
var lC = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" }, cC = function(t, n) {
  return /* @__PURE__ */ v.createElement(_n, Pe({}, t, {
    ref: n,
    icon: lC
  }));
}, Sc = /* @__PURE__ */ v.forwardRef(cC);
z.env.NODE_ENV !== "production" && (Sc.displayName = "RightOutlined");
var Ec = { exports: {} }, dt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dd;
function uC() {
  if (Dd)
    return dt;
  Dd = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function y(p) {
    if (typeof p == "object" && p !== null) {
      var C = p.$$typeof;
      switch (C) {
        case e:
          switch (p = p.type, p) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case s:
                case a:
                case l:
                case f:
                case d:
                case i:
                  return p;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  return dt.ContextConsumer = a, dt.ContextProvider = i, dt.Element = e, dt.ForwardRef = l, dt.Fragment = n, dt.Lazy = f, dt.Memo = d, dt.Portal = t, dt.Profiler = o, dt.StrictMode = r, dt.Suspense = c, dt.SuspenseList = u, dt.isAsyncMode = function() {
    return !1;
  }, dt.isConcurrentMode = function() {
    return !1;
  }, dt.isContextConsumer = function(p) {
    return y(p) === a;
  }, dt.isContextProvider = function(p) {
    return y(p) === i;
  }, dt.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === e;
  }, dt.isForwardRef = function(p) {
    return y(p) === l;
  }, dt.isFragment = function(p) {
    return y(p) === n;
  }, dt.isLazy = function(p) {
    return y(p) === f;
  }, dt.isMemo = function(p) {
    return y(p) === d;
  }, dt.isPortal = function(p) {
    return y(p) === t;
  }, dt.isProfiler = function(p) {
    return y(p) === o;
  }, dt.isStrictMode = function(p) {
    return y(p) === r;
  }, dt.isSuspense = function(p) {
    return y(p) === c;
  }, dt.isSuspenseList = function(p) {
    return y(p) === u;
  }, dt.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === n || p === o || p === r || p === c || p === u || p === g || typeof p == "object" && p !== null && (p.$$typeof === f || p.$$typeof === d || p.$$typeof === i || p.$$typeof === a || p.$$typeof === l || p.$$typeof === h || p.getModuleId !== void 0);
  }, dt.typeOf = y, dt;
}
var ft = {}, Fd;
function dC() {
  return Fd || (Fd = 1, z.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h = !1, y = !1, p = !1, C = !1, m = !1, b;
    b = Symbol.for("react.module.reference");
    function w(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === n || oe === o || m || oe === r || oe === c || oe === u || C || oe === g || h || y || p || typeof oe == "object" && oe !== null && (oe.$$typeof === f || oe.$$typeof === d || oe.$$typeof === i || oe.$$typeof === a || oe.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === b || oe.getModuleId !== void 0));
    }
    function E(oe) {
      if (typeof oe == "object" && oe !== null) {
        var Te = oe.$$typeof;
        switch (Te) {
          case e:
            var Re = oe.type;
            switch (Re) {
              case n:
              case o:
              case r:
              case c:
              case u:
                return Re;
              default:
                var Ye = Re && Re.$$typeof;
                switch (Ye) {
                  case s:
                  case a:
                  case l:
                  case f:
                  case d:
                  case i:
                    return Ye;
                  default:
                    return Te;
                }
            }
          case t:
            return Te;
        }
      }
    }
    var S = a, _ = i, O = e, P = l, $ = n, L = f, N = d, k = t, F = o, U = r, A = c, R = u, D = !1, B = !1;
    function M(oe) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(oe) {
      return B || (B = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function H(oe) {
      return E(oe) === a;
    }
    function X(oe) {
      return E(oe) === i;
    }
    function K(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function J(oe) {
      return E(oe) === l;
    }
    function ie(oe) {
      return E(oe) === n;
    }
    function le(oe) {
      return E(oe) === f;
    }
    function ne(oe) {
      return E(oe) === d;
    }
    function te(oe) {
      return E(oe) === t;
    }
    function re(oe) {
      return E(oe) === o;
    }
    function _e(oe) {
      return E(oe) === r;
    }
    function me(oe) {
      return E(oe) === c;
    }
    function De(oe) {
      return E(oe) === u;
    }
    ft.ContextConsumer = S, ft.ContextProvider = _, ft.Element = O, ft.ForwardRef = P, ft.Fragment = $, ft.Lazy = L, ft.Memo = N, ft.Portal = k, ft.Profiler = F, ft.StrictMode = U, ft.Suspense = A, ft.SuspenseList = R, ft.isAsyncMode = M, ft.isConcurrentMode = G, ft.isContextConsumer = H, ft.isContextProvider = X, ft.isElement = K, ft.isForwardRef = J, ft.isFragment = ie, ft.isLazy = le, ft.isMemo = ne, ft.isPortal = te, ft.isProfiler = re, ft.isStrictMode = _e, ft.isSuspense = me, ft.isSuspenseList = De, ft.isValidElementType = w, ft.typeOf = E;
  }()), ft;
}
z.env.NODE_ENV === "production" ? Ec.exports = uC() : Ec.exports = dC();
var Cl = Ec.exports;
function As(e, t, n) {
  var r = v.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var fC = Symbol.for("react.element"), vC = Symbol.for("react.transitional.element"), gC = Symbol.for("react.fragment");
function Kg(e) {
  return (
    // Base object type
    e && Ie(e) === "object" && // React Element type
    (e.$$typeof === fC || e.$$typeof === vC) && // React Fragment type
    e.type === gC
  );
}
var Au = function(t, n) {
  typeof t == "function" ? t(n) : Ie(t) === "object" && t && "current" in t && (t.current = n);
}, Xi = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var o = n.filter(Boolean);
  return o.length <= 1 ? o[0] : function(i) {
    n.forEach(function(a) {
      Au(a, i);
    });
  };
}, Yi = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return As(function() {
    return Xi.apply(void 0, n);
  }, n, function(o, i) {
    return o.length !== i.length || o.every(function(a, s) {
      return a !== i[s];
    });
  });
}, Zi = function(t) {
  var n, r;
  if (!t)
    return !1;
  if (Xg(t) && t.props.propertyIsEnumerable("ref"))
    return !0;
  var o = Cl.isMemo(t) ? t.type.type : t.type;
  return !(typeof o == "function" && !((n = o.prototype) !== null && n !== void 0 && n.render) && o.$$typeof !== Cl.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== Cl.ForwardRef);
};
function Xg(e) {
  return /* @__PURE__ */ ky(e) && !Kg(e);
}
var ks = function(t) {
  if (t && Xg(t)) {
    var n = t;
    return n.props.propertyIsEnumerable("ref") ? n.props.ref : n.ref;
  }
  return null;
}, _c = function(e, t) {
  return _c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r)
      Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, _c(e, t);
};
function xn(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  _c(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Se = function() {
  return Se = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Se.apply(this, arguments);
};
function xc(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function ve(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : o(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function de(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done)
          return i;
        switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = c;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(c);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (u) {
        c = [6, u], o = 0;
      } finally {
        r = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Ut(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function pt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
function rn(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Do(e) {
  return this instanceof Do ? (this.v = e, this) : new Do(e);
}
function pC(e, t, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), o, i = [];
  return o = {}, s("next"), s("throw"), s("return", a), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function a(g) {
    return function(h) {
      return Promise.resolve(h).then(g, d);
    };
  }
  function s(g, h) {
    r[g] && (o[g] = function(y) {
      return new Promise(function(p, C) {
        i.push([g, y, p, C]) > 1 || l(g, y);
      });
    }, h && (o[g] = h(o[g])));
  }
  function l(g, h) {
    try {
      c(r[g](h));
    } catch (y) {
      f(i[0][3], y);
    }
  }
  function c(g) {
    g.value instanceof Do ? Promise.resolve(g.value.v).then(u, d) : f(i[0][2], g);
  }
  function u(g) {
    l("next", g);
  }
  function d(g) {
    l("throw", g);
  }
  function f(g, h) {
    g(h), i.shift(), i.length && l(i[0][0], i[0][1]);
  }
}
function hC(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Ut == "function" ? Ut(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = e[i] && function(a) {
      return new Promise(function(s, l) {
        a = e[i](a), o(s, l, a.done, a.value);
      });
    };
  }
  function o(i, a, s, l) {
    Promise.resolve(l).then(function(c) {
      i({ value: c, done: s });
    }, a);
  }
}
var mC = "Event tracked successfully", yC = "Unexpected error occurred", bC = "Event rejected due to exceeded retry count", CC = "Event skipped due to optOut config", wC = "Event rejected due to missing API key", SC = "Invalid API key", EC = "Client not initialized", en;
(function(e) {
  e.SET = "$set", e.SET_ONCE = "$setOnce", e.ADD = "$add", e.APPEND = "$append", e.PREPEND = "$prepend", e.REMOVE = "$remove", e.PREINSERT = "$preInsert", e.POSTINSERT = "$postInsert", e.UNSET = "$unset", e.CLEAR_ALL = "$clearAll";
})(en || (en = {}));
var Kr;
(function(e) {
  e.REVENUE_PRODUCT_ID = "$productId", e.REVENUE_QUANTITY = "$quantity", e.REVENUE_PRICE = "$price", e.REVENUE_TYPE = "$revenueType", e.REVENUE = "$revenue";
})(Kr || (Kr = {}));
var Ho;
(function(e) {
  e.IDENTIFY = "$identify", e.GROUP_IDENTIFY = "$groupidentify", e.REVENUE = "revenue_amount";
})(Ho || (Ho = {}));
var Cn;
(function(e) {
  e[e.None = 0] = "None", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Verbose = 3] = "Verbose", e[e.Debug = 4] = "Debug";
})(Cn || (Cn = {}));
var cs;
(function(e) {
  e.US = "US", e.EU = "EU";
})(cs || (cs = {}));
var Nt;
(function(e) {
  e.Unknown = "unknown", e.Skipped = "skipped", e.Success = "success", e.RateLimit = "rate_limit", e.PayloadTooLarge = "payload_too_large", e.Invalid = "invalid", e.Failed = "failed", e.Timeout = "Timeout", e.SystemError = "SystemError";
})(Nt || (Nt = {}));
var _C = null, xC = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  "video",
  "audio",
  '[contenteditable="true" i]',
  "[data-amp-default-track]",
  ".amp-default-track"
], OC = "data-amp-track-", PC = ["div", "span", "h1", "h2", "h3", "h4", "h5", "h6"], Fo = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Nt.Unknown), { event: e, code: t, message: n };
}, ni = function(e) {
  return e ? (
    // a random number from 0 to 15
    (e ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    e / 4).toString(16)
  ) : (
    // or otherwise a concatenated string:
    (String(1e7) + // 10000000 +
    String(-1e3) + // -1000 +
    String(-4e3) + // -4000 +
    String(-8e3) + // -80000000 +
    String(-1e11)).replace(
      // replacing
      /[018]/g,
      // zeroes, ones, and eights with
      ni
    )
  );
}, IC = (
  /** @class */
  function() {
    function e(t) {
      this.client = t, this.queue = [], this.applying = !1, this.plugins = [];
    }
    return e.prototype.register = function(t, n) {
      var r, o;
      return ve(this, void 0, void 0, function() {
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return this.plugins.some(function(a) {
                return a.name === t.name;
              }) ? (n.loggerProvider.warn("Plugin with name ".concat(t.name, " already exists, skipping registration")), [
                2
                /*return*/
              ]) : (t.name === void 0 && (t.name = ni(), n.loggerProvider.warn(`Plugin name is undefined. 
      Generating a random UUID for plugin name: `.concat(t.name, `. 
      Set a name for the plugin to prevent it from being added multiple times.`))), t.type = (r = t.type) !== null && r !== void 0 ? r : "enrichment", [4, (o = t.setup) === null || o === void 0 ? void 0 : o.call(t, n, this.client)]);
            case 1:
              return i.sent(), this.plugins.push(t), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.deregister = function(t) {
      var n;
      return ve(this, void 0, void 0, function() {
        var r, o;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.plugins.findIndex(function(a) {
                return a.name === t;
              }), o = this.plugins[r], this.plugins.splice(r, 1), [4, (n = o.teardown) === null || n === void 0 ? void 0 : n.call(o)];
            case 1:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function(t) {
      this.applying = !1;
      var n = this.plugins;
      n.map(function(r) {
        var o;
        return (o = r.teardown) === null || o === void 0 ? void 0 : o.call(r);
      }), this.plugins = [], this.client = t;
    }, e.prototype.push = function(t) {
      var n = this;
      return new Promise(function(r) {
        n.queue.push([t, r]), n.scheduleApply(0);
      });
    }, e.prototype.scheduleApply = function(t) {
      var n = this;
      this.applying || (this.applying = !0, setTimeout(function() {
        n.apply(n.queue.shift()).then(function() {
          n.applying = !1, n.queue.length > 0 && n.scheduleApply(0);
        });
      }, t));
    }, e.prototype.apply = function(t) {
      return ve(this, void 0, void 0, function() {
        var n, r, o, i, a, s, l, g, h, c, u, d, f, g, h, y, p, C, m, b, w, E;
        return de(this, function(S) {
          switch (S.label) {
            case 0:
              if (!t)
                return [
                  2
                  /*return*/
                ];
              n = pt(t, 1), r = n[0], o = pt(t, 2), i = o[1], a = this.plugins.filter(function(_) {
                return _.type === "before";
              }), S.label = 1;
            case 1:
              S.trys.push([1, 6, 7, 8]), s = Ut(a), l = s.next(), S.label = 2;
            case 2:
              return l.done ? [3, 5] : (g = l.value, g.execute ? [4, g.execute(Se({}, r))] : [3, 4]);
            case 3:
              if (h = S.sent(), h === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = h, S.label = 4;
            case 4:
              return l = s.next(), [3, 2];
            case 5:
              return [3, 8];
            case 6:
              return c = S.sent(), m = { error: c }, [3, 8];
            case 7:
              try {
                l && !l.done && (b = s.return) && b.call(s);
              } finally {
                if (m)
                  throw m.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 8:
              u = this.plugins.filter(function(_) {
                return _.type === "enrichment" || _.type === void 0;
              }), S.label = 9;
            case 9:
              S.trys.push([9, 14, 15, 16]), d = Ut(u), f = d.next(), S.label = 10;
            case 10:
              return f.done ? [3, 13] : (g = f.value, g.execute ? [4, g.execute(Se({}, r))] : [3, 12]);
            case 11:
              if (h = S.sent(), h === null)
                return i({ event: r, code: 0, message: "" }), [
                  2
                  /*return*/
                ];
              r = h, S.label = 12;
            case 12:
              return f = d.next(), [3, 10];
            case 13:
              return [3, 16];
            case 14:
              return y = S.sent(), w = { error: y }, [3, 16];
            case 15:
              try {
                f && !f.done && (E = d.return) && E.call(d);
              } finally {
                if (w)
                  throw w.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 16:
              return p = this.plugins.filter(function(_) {
                return _.type === "destination";
              }), C = p.map(function(_) {
                var O = Se({}, r);
                return _.execute(O).catch(function(P) {
                  return Fo(O, 0, String(P));
                });
              }), Promise.all(C).then(function(_) {
                var O = pt(_, 1), P = O[0], $ = P || Fo(r, 100, "Event not tracked, no destination plugins on the instance");
                i($);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.flush = function() {
      return ve(this, void 0, void 0, function() {
        var t, n, r, o = this;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return t = this.queue, this.queue = [], [4, Promise.all(t.map(function(a) {
                return o.apply(a);
              }))];
            case 1:
              return i.sent(), n = this.plugins.filter(function(a) {
                return a.type === "destination";
              }), r = n.map(function(a) {
                return a.flush && a.flush();
              }), [4, Promise.all(r)];
            case 2:
              return i.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), jd = "-", Ms = "AMP", TC = "".concat(Ms, "_unsent"), Yg = "https://api2.amplitude.com/2/httpapi", $C = "https://api.eu.amplitude.com/2/httpapi", RC = "https://api2.amplitude.com/batch", NC = "https://api.eu.amplitude.com/batch", AC = 1e3, Oc = function(e) {
  if (Object.keys(e).length > AC)
    return !1;
  for (var t in e) {
    var n = e[t];
    if (!Zg(t, n))
      return !1;
  }
  return !0;
}, Zg = function(e, t) {
  var n, r;
  if (typeof e != "string")
    return !1;
  if (Array.isArray(t)) {
    var o = !0;
    try {
      for (var i = Ut(t), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        if (Array.isArray(s))
          return !1;
        if (typeof s == "object")
          o = o && Oc(s);
        else if (!["number", "string"].includes(typeof s))
          return !1;
        if (!o)
          return !1;
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
  } else {
    if (t == null)
      return !1;
    if (typeof t == "object")
      return Oc(t);
    if (!["number", "string", "boolean"].includes(typeof t))
      return !1;
  }
  return !0;
}, Mi = (
  /** @class */
  function() {
    function e() {
      this._propertySet = /* @__PURE__ */ new Set(), this._properties = {};
    }
    return e.prototype.getUserProperties = function() {
      return Se({}, this._properties);
    }, e.prototype.set = function(t, n) {
      return this._safeSet(en.SET, t, n), this;
    }, e.prototype.setOnce = function(t, n) {
      return this._safeSet(en.SET_ONCE, t, n), this;
    }, e.prototype.append = function(t, n) {
      return this._safeSet(en.APPEND, t, n), this;
    }, e.prototype.prepend = function(t, n) {
      return this._safeSet(en.PREPEND, t, n), this;
    }, e.prototype.postInsert = function(t, n) {
      return this._safeSet(en.POSTINSERT, t, n), this;
    }, e.prototype.preInsert = function(t, n) {
      return this._safeSet(en.PREINSERT, t, n), this;
    }, e.prototype.remove = function(t, n) {
      return this._safeSet(en.REMOVE, t, n), this;
    }, e.prototype.add = function(t, n) {
      return this._safeSet(en.ADD, t, n), this;
    }, e.prototype.unset = function(t) {
      return this._safeSet(en.UNSET, t, jd), this;
    }, e.prototype.clearAll = function() {
      return this._properties = {}, this._properties[en.CLEAR_ALL] = jd, this;
    }, e.prototype._safeSet = function(t, n, r) {
      if (this._validate(t, n, r)) {
        var o = this._properties[t];
        return o === void 0 && (o = {}, this._properties[t] = o), o[n] = r, this._propertySet.add(n), !0;
      }
      return !1;
    }, e.prototype._validate = function(t, n, r) {
      return this._properties[en.CLEAR_ALL] !== void 0 || this._propertySet.has(n) ? !1 : t === en.ADD ? typeof r == "number" : t !== en.UNSET && t !== en.REMOVE ? Zg(n, r) : !0;
    }, e;
  }()
), kC = function(e, t, n) {
  var r = typeof e == "string" ? { event_type: e } : e;
  return Se(Se(Se({}, r), n), t && { event_properties: t });
}, Qg = function(e, t) {
  var n = Se(Se({}, t), { event_type: Ho.IDENTIFY, user_properties: e.getUserProperties() });
  return n;
}, MC = function(e, t, n, r) {
  var o, i = Se(Se({}, r), { event_type: Ho.GROUP_IDENTIFY, group_properties: n.getUserProperties(), groups: (o = {}, o[e] = t, o) });
  return i;
}, LC = function(e, t, n) {
  var r, o = new Mi();
  o.set(e, t);
  var i = Se(Se({}, n), { event_type: Ho.IDENTIFY, user_properties: o.getUserProperties(), groups: (r = {}, r[e] = t, r) });
  return i;
}, DC = function(e, t) {
  return Se(Se({}, t), { event_type: Ho.REVENUE, event_properties: e.getEventProperties() });
}, vn = function(e) {
  return {
    promise: e || Promise.resolve()
  };
}, FC = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = "$default"), this.initializing = !1, this.isReady = !1, this.q = [], this.dispatchQ = [], this.logEvent = this.track.bind(this), this.timeline = new IC(this), this.name = t;
    }
    return e.prototype._init = function(t) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          switch (n.label) {
            case 0:
              return this.config = t, this.timeline.reset(this), [4, this.runQueuedFunctions("q")];
            case 1:
              return n.sent(), this.isReady = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.runQueuedFunctions = function(t) {
      return ve(this, void 0, void 0, function() {
        var n, r, o, i, a, s, l, c;
        return de(this, function(u) {
          switch (u.label) {
            case 0:
              n = this[t], this[t] = [], u.label = 1;
            case 1:
              u.trys.push([1, 8, 9, 10]), r = Ut(n), o = r.next(), u.label = 2;
            case 2:
              return o.done ? [3, 7] : (i = o.value, a = i(), a && "promise" in a ? [4, a.promise] : [3, 4]);
            case 3:
              return u.sent(), [3, 6];
            case 4:
              return [4, a];
            case 5:
              u.sent(), u.label = 6;
            case 6:
              return o = r.next(), [3, 2];
            case 7:
              return [3, 10];
            case 8:
              return s = u.sent(), l = { error: s }, [3, 10];
            case 9:
              try {
                o && !o.done && (c = r.return) && c.call(r);
              } finally {
                if (l)
                  throw l.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 10:
              return this[t].length ? [4, this.runQueuedFunctions(t)] : [3, 12];
            case 11:
              u.sent(), u.label = 12;
            case 12:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.track = function(t, n, r) {
      var o = kC(t, n, r);
      return vn(this.dispatch(o));
    }, e.prototype.identify = function(t, n) {
      var r = Qg(t, n);
      return vn(this.dispatch(r));
    }, e.prototype.groupIdentify = function(t, n, r, o) {
      var i = MC(t, n, r, o);
      return vn(this.dispatch(i));
    }, e.prototype.setGroup = function(t, n, r) {
      var o = LC(t, n, r);
      return vn(this.dispatch(o));
    }, e.prototype.revenue = function(t, n) {
      var r = DC(t, n);
      return vn(this.dispatch(r));
    }, e.prototype.add = function(t) {
      return this.isReady ? this._addPlugin(t) : (this.q.push(this._addPlugin.bind(this, t)), vn());
    }, e.prototype._addPlugin = function(t) {
      return vn(this.timeline.register(t, this.config));
    }, e.prototype.remove = function(t) {
      return this.isReady ? this._removePlugin(t) : (this.q.push(this._removePlugin.bind(this, t)), vn());
    }, e.prototype._removePlugin = function(t) {
      return vn(this.timeline.deregister(t));
    }, e.prototype.dispatchWithCallback = function(t, n) {
      if (!this.isReady)
        return n(Fo(t, 0, EC));
      this.process(t).then(n);
    }, e.prototype.dispatch = function(t) {
      return ve(this, void 0, void 0, function() {
        var n = this;
        return de(this, function(r) {
          return this.isReady ? [2, this.process(t)] : [2, new Promise(function(o) {
            n.dispatchQ.push(n.dispatchWithCallback.bind(n, t, o));
          })];
        });
      });
    }, e.prototype.process = function(t) {
      return ve(this, void 0, void 0, function() {
        var o, n, r, o;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), this.config.optOut ? [2, Fo(t, 0, CC)] : [4, this.timeline.push(t)];
            case 1:
              return o = i.sent(), o.code === 200 ? this.config.loggerProvider.log(o.message) : o.code === 100 ? this.config.loggerProvider.warn(o.message) : this.config.loggerProvider.error(o.message), [2, o];
            case 2:
              return n = i.sent(), r = String(n), this.config.loggerProvider.error(r), o = Fo(t, 0, r), [2, o];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.setOptOut = function(t) {
      if (!this.isReady) {
        this.q.push(this._setOptOut.bind(this, !!t));
        return;
      }
      this._setOptOut(t);
    }, e.prototype._setOptOut = function(t) {
      this.config.optOut = !!t;
    }, e.prototype.flush = function() {
      return vn(this.timeline.flush());
    }, e;
  }()
), jC = (
  /** @class */
  function() {
    function e() {
      this.productId = "", this.quantity = 1, this.price = 0;
    }
    return e.prototype.setProductId = function(t) {
      return this.productId = t, this;
    }, e.prototype.setQuantity = function(t) {
      return t > 0 && (this.quantity = t), this;
    }, e.prototype.setPrice = function(t) {
      return this.price = t, this;
    }, e.prototype.setRevenueType = function(t) {
      return this.revenueType = t, this;
    }, e.prototype.setRevenue = function(t) {
      return this.revenue = t, this;
    }, e.prototype.setEventProperties = function(t) {
      return Oc(t) && (this.properties = t), this;
    }, e.prototype.getEventProperties = function() {
      var t = this.properties ? Se({}, this.properties) : {};
      return t[Kr.REVENUE_PRODUCT_ID] = this.productId, t[Kr.REVENUE_QUANTITY] = this.quantity, t[Kr.REVENUE_PRICE] = this.price, t[Kr.REVENUE_TYPE] = this.revenueType, t[Kr.REVENUE] = this.revenue, t;
    }, e;
  }()
), BC = function(e, t) {
  var n = Math.max(t, 1);
  return e.reduce(function(r, o, i) {
    var a = Math.floor(i / n);
    return r[a] || (r[a] = []), r[a].push(o), r;
  }, []);
}, pa = "Amplitude Logger ", Jg = (
  /** @class */
  function() {
    function e() {
      this.logLevel = Cn.None;
    }
    return e.prototype.disable = function() {
      this.logLevel = Cn.None;
    }, e.prototype.enable = function(t) {
      t === void 0 && (t = Cn.Warn), this.logLevel = t;
    }, e.prototype.log = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Cn.Verbose || console.log("".concat(pa, "[Log]: ").concat(t.join(" ")));
    }, e.prototype.warn = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Cn.Warn || console.warn("".concat(pa, "[Warn]: ").concat(t.join(" ")));
    }, e.prototype.error = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Cn.Error || console.error("".concat(pa, "[Error]: ").concat(t.join(" ")));
    }, e.prototype.debug = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      this.logLevel < Cn.Debug || console.log("".concat(pa, "[Debug]: ").concat(t.join(" ")));
    }, e;
  }()
), Fa = function() {
  return {
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 1e4,
    instanceName: "$default_instance",
    logLevel: Cn.Warn,
    loggerProvider: new Jg(),
    offline: !1,
    optOut: !1,
    serverUrl: Yg,
    serverZone: "US",
    useBatch: !1
  };
}, VC = (
  /** @class */
  function() {
    function e(t) {
      var n, r, o, i;
      this._optOut = !1;
      var a = Fa();
      this.apiKey = t.apiKey, this.flushIntervalMillis = (n = t.flushIntervalMillis) !== null && n !== void 0 ? n : a.flushIntervalMillis, this.flushMaxRetries = t.flushMaxRetries || a.flushMaxRetries, this.flushQueueSize = t.flushQueueSize || a.flushQueueSize, this.instanceName = t.instanceName || a.instanceName, this.loggerProvider = t.loggerProvider || a.loggerProvider, this.logLevel = (r = t.logLevel) !== null && r !== void 0 ? r : a.logLevel, this.minIdLength = t.minIdLength, this.plan = t.plan, this.ingestionMetadata = t.ingestionMetadata, this.offline = t.offline !== void 0 ? t.offline : a.offline, this.optOut = (o = t.optOut) !== null && o !== void 0 ? o : a.optOut, this.serverUrl = t.serverUrl, this.serverZone = t.serverZone || a.serverZone, this.storageProvider = t.storageProvider, this.transportProvider = t.transportProvider, this.useBatch = (i = t.useBatch) !== null && i !== void 0 ? i : a.useBatch, this.loggerProvider.enable(this.logLevel);
      var s = ep(t.serverUrl, t.serverZone, t.useBatch);
      this.serverZone = s.serverZone, this.serverUrl = s.serverUrl;
    }
    return Object.defineProperty(e.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(t) {
        this._optOut = t;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), zC = function(e, t) {
  return e === "EU" ? t ? NC : $C : t ? RC : Yg;
}, ep = function(e, t, n) {
  if (e === void 0 && (e = ""), t === void 0 && (t = Fa().serverZone), n === void 0 && (n = Fa().useBatch), e)
    return { serverUrl: e, serverZone: void 0 };
  var r = ["US", "EU"].includes(t) ? t : Fa().serverZone;
  return {
    serverZone: r,
    serverUrl: zC(r, n)
  };
}, tp = (
  /** @class */
  function() {
    function e() {
      this.sdk = {
        metrics: {
          histogram: {}
        }
      };
    }
    return e.prototype.recordHistogram = function(t, n) {
      this.sdk.metrics.histogram[t] = n;
    }, e;
  }()
);
function HC(e) {
  return e instanceof Error ? e.message : String(e);
}
function ha(e) {
  var t = "";
  try {
    "body" in e && (t = JSON.stringify(e.body, null, 2));
  } catch {
  }
  return t;
}
var UC = (
  /** @class */
  function() {
    function e() {
      this.name = "amplitude", this.type = "destination", this.retryTimeout = 1e3, this.throttleTimeout = 3e4, this.storageKey = "", this.scheduled = null, this.queue = [];
    }
    return e.prototype.setup = function(t) {
      var n;
      return ve(this, void 0, void 0, function() {
        var r, o = this;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return this.config = t, this.storageKey = "".concat(TC, "_").concat(this.config.apiKey.substring(0, 10)), [4, (n = this.config.storageProvider) === null || n === void 0 ? void 0 : n.get(this.storageKey)];
            case 1:
              return r = i.sent(), r && r.length > 0 && Promise.all(r.map(function(a) {
                return o.execute(a);
              })).catch(), [2, Promise.resolve(void 0)];
          }
        });
      });
    }, e.prototype.execute = function(t) {
      var n = this;
      return t.insert_id || (t.insert_id = ni()), new Promise(function(r) {
        var o = {
          event: t,
          attempts: 0,
          callback: function(i) {
            return r(i);
          },
          timeout: 0
        };
        n.addToQueue(o);
      });
    }, e.prototype.getTryableList = function(t) {
      var n = this;
      return t.filter(function(r) {
        return r.attempts < n.config.flushMaxRetries ? (r.attempts += 1, !0) : (n.fulfillRequest([r], 500, bC), !1);
      });
    }, e.prototype.scheduleTryable = function(t, n) {
      var r = this;
      n === void 0 && (n = !1), t.forEach(function(o) {
        if (n && (r.queue = r.queue.concat(o)), o.timeout === 0) {
          r.schedule(r.config.flushIntervalMillis);
          return;
        }
        setTimeout(function() {
          o.timeout = 0, r.schedule(0);
        }, o.timeout);
      });
    }, e.prototype.addToQueue = function() {
      for (var t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      var r = this.getTryableList(t);
      this.scheduleTryable(r, !0), this.saveEvents();
    }, e.prototype.schedule = function(t) {
      var n = this;
      this.scheduled || this.config.offline || (this.scheduled = setTimeout(function() {
        n.flush(!0).then(function() {
          n.queue.length > 0 && n.schedule(t);
        });
      }, t));
    }, e.prototype.flush = function(t) {
      return t === void 0 && (t = !1), ve(this, void 0, void 0, function() {
        var n, r, o, i = this;
        return de(this, function(a) {
          switch (a.label) {
            case 0:
              return this.config.offline ? (this.config.loggerProvider.debug("Skipping flush while offline."), [
                2
                /*return*/
              ]) : (n = [], r = [], this.queue.forEach(function(s) {
                return s.timeout === 0 ? n.push(s) : r.push(s);
              }), this.scheduled && (clearTimeout(this.scheduled), this.scheduled = null), o = BC(n, this.config.flushQueueSize), [4, Promise.all(o.map(function(s) {
                return i.send(s, t);
              }))]);
            case 1:
              return a.sent(), this.scheduleTryable(r), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.send = function(t, n) {
      return n === void 0 && (n = !0), ve(this, void 0, void 0, function() {
        var r, o, i, a, s;
        return de(this, function(l) {
          switch (l.label) {
            case 0:
              if (!this.config.apiKey)
                return [2, this.fulfillRequest(t, 400, wC)];
              r = {
                api_key: this.config.apiKey,
                events: t.map(function(c) {
                  var u = c.event;
                  u.extra;
                  var d = xc(u, ["extra"]);
                  return d;
                }),
                options: {
                  min_id_length: this.config.minIdLength
                },
                client_upload_time: (/* @__PURE__ */ new Date()).toISOString(),
                request_metadata: this.config.requestMetadata
              }, this.config.requestMetadata = new tp(), l.label = 1;
            case 1:
              return l.trys.push([1, 3, , 4]), o = ep(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl, [4, this.config.transportProvider.send(o, r)];
            case 2:
              return i = l.sent(), i === null ? (this.fulfillRequest(t, 0, yC), [
                2
                /*return*/
              ]) : n ? (this.handleResponse(i, t), [3, 4]) : ("body" in i ? this.fulfillRequest(t, i.statusCode, "".concat(i.status, ": ").concat(ha(i))) : this.fulfillRequest(t, i.statusCode, i.status), [
                2
                /*return*/
              ]);
            case 3:
              return a = l.sent(), s = HC(a), this.config.loggerProvider.error(s), this.handleResponse({ status: Nt.Failed, statusCode: 0 }, t), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleResponse = function(t, n) {
      var r = t.status;
      switch (r) {
        case Nt.Success: {
          this.handleSuccessResponse(t, n);
          break;
        }
        case Nt.Invalid: {
          this.handleInvalidResponse(t, n);
          break;
        }
        case Nt.PayloadTooLarge: {
          this.handlePayloadTooLargeResponse(t, n);
          break;
        }
        case Nt.RateLimit: {
          this.handleRateLimitResponse(t, n);
          break;
        }
        default: {
          this.config.loggerProvider.warn(`{code: 0, error: "Status '`.concat(r, "' provided for ").concat(n.length, ' events"}')), this.handleOtherResponse(n);
          break;
        }
      }
    }, e.prototype.handleSuccessResponse = function(t, n) {
      this.fulfillRequest(n, t.statusCode, mC);
    }, e.prototype.handleInvalidResponse = function(t, n) {
      var r = this;
      if (t.body.missingField || t.body.error.startsWith(SC)) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      var o = rn(rn(rn(rn([], pt(Object.values(t.body.eventsWithInvalidFields)), !1), pt(Object.values(t.body.eventsWithMissingFields)), !1), pt(Object.values(t.body.eventsWithInvalidIdLengths)), !1), pt(t.body.silencedEvents), !1).flat(), i = new Set(o), a = n.filter(function(l, c) {
        if (i.has(c)) {
          r.fulfillRequest([l], t.statusCode, t.body.error);
          return;
        }
        return !0;
      });
      a.length > 0 && this.config.loggerProvider.warn(ha(t));
      var s = this.getTryableList(a);
      this.scheduleTryable(s);
    }, e.prototype.handlePayloadTooLargeResponse = function(t, n) {
      if (n.length === 1) {
        this.fulfillRequest(n, t.statusCode, t.body.error);
        return;
      }
      this.config.loggerProvider.warn(ha(t)), this.config.flushQueueSize /= 2;
      var r = this.getTryableList(n);
      this.scheduleTryable(r);
    }, e.prototype.handleRateLimitResponse = function(t, n) {
      var r = this, o = Object.keys(t.body.exceededDailyQuotaUsers), i = Object.keys(t.body.exceededDailyQuotaDevices), a = t.body.throttledEvents, s = new Set(o), l = new Set(i), c = new Set(a), u = n.filter(function(f, g) {
        if (f.event.user_id && s.has(f.event.user_id) || f.event.device_id && l.has(f.event.device_id)) {
          r.fulfillRequest([f], t.statusCode, t.body.error);
          return;
        }
        return c.has(g) && (f.timeout = r.throttleTimeout), !0;
      });
      u.length > 0 && this.config.loggerProvider.warn(ha(t));
      var d = this.getTryableList(u);
      this.scheduleTryable(d);
    }, e.prototype.handleOtherResponse = function(t) {
      var n = this, r = t.map(function(i) {
        return i.timeout = i.attempts * n.retryTimeout, i;
      }), o = this.getTryableList(r);
      this.scheduleTryable(o);
    }, e.prototype.fulfillRequest = function(t, n, r) {
      this.removeEvents(t), t.forEach(function(o) {
        return o.callback(Fo(o.event, n, r));
      });
    }, e.prototype.saveEvents = function() {
      if (this.config.storageProvider) {
        var t = this.queue.map(function(n) {
          return n.event;
        });
        this.config.storageProvider.set(this.storageKey, t);
      }
    }, e.prototype.removeEvents = function(t) {
      this.queue = this.queue.filter(function(n) {
        return !t.some(function(r) {
          return r.event.insert_id === n.event.insert_id;
        });
      }), this.saveEvents();
    }, e;
  }()
), WC = function(e) {
  var t = new Error().stack || "";
  return t.split(`
`).slice(2 + e).map(function(n) {
    return n.trim();
  });
}, Ft = function(e) {
  return function() {
    var t = Se({}, e.config), n = t.loggerProvider, r = t.logLevel;
    return {
      logger: n,
      logLevel: r
    };
  };
}, qC = function(e, t) {
  var n, r;
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  try {
    for (var o = Ut(t.split(".")), i = o.next(); !i.done; i = o.next()) {
      var a = i.value;
      if (a in e)
        e = e[a];
      else
        return;
    }
  } catch (s) {
    n = { error: s };
  } finally {
    try {
      i && !i.done && (r = o.return) && r.call(o);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return e;
}, jt = function(e, t) {
  return function() {
    var n, r, o = {};
    try {
      for (var i = Ut(t), a = i.next(); !a.done; a = i.next()) {
        var s = a.value;
        o[s] = qC(e, s);
      }
    } catch (l) {
      n = { error: l };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n)
          throw n.error;
      }
    }
    return o;
  };
}, Bt = function(e, t, n, r, o) {
  return o === void 0 && (o = null), function() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    var s = n(), l = s.logger, c = s.logLevel;
    if (c && c < Cn.Debug || !c || !l)
      return e.apply(o, i);
    var u = {
      type: "invoke public method",
      name: t,
      args: i,
      stacktrace: WC(1),
      time: {
        start: (/* @__PURE__ */ new Date()).toISOString()
      },
      states: {}
    };
    r && u.states && (u.states.before = r());
    var d = e.apply(o, i);
    return d && d.promise ? d.promise.then(function() {
      r && u.states && (u.states.after = r()), u.time && (u.time.end = (/* @__PURE__ */ new Date()).toISOString()), l.debug(JSON.stringify(u, null, 2));
    }) : (r && u.states && (u.states.after = r()), u.time && (u.time.end = (/* @__PURE__ */ new Date()).toISOString()), l.debug(JSON.stringify(u, null, 2))), d;
  };
}, ku = (
  /** @class */
  function() {
    function e() {
      this.memoryStorage = /* @__PURE__ */ new Map();
    }
    return e.prototype.isEnabled = function() {
      return ve(this, void 0, void 0, function() {
        return de(this, function(t) {
          return [2, !0];
        });
      });
    }, e.prototype.get = function(t) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          return [2, this.memoryStorage.get(t)];
        });
      });
    }, e.prototype.getRaw = function(t) {
      return ve(this, void 0, void 0, function() {
        var n;
        return de(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.get(t)];
            case 1:
              return n = r.sent(), [2, n ? JSON.stringify(n) : void 0];
          }
        });
      });
    }, e.prototype.set = function(t, n) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(r) {
          return this.memoryStorage.set(t, n), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          return this.memoryStorage.delete(t), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      return ve(this, void 0, void 0, function() {
        return de(this, function(t) {
          return this.memoryStorage.clear(), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), Ls = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.send = function(t, n) {
      return Promise.resolve(null);
    }, e.prototype.buildResponse = function(t) {
      var n, r, o, i, a, s, l, c, u, d, f, g, h, y, p, C, m, b, w, E, S, _;
      if (typeof t != "object")
        return null;
      var O = t.code || 0, P = this.buildStatus(O);
      switch (P) {
        case Nt.Success:
          return {
            status: P,
            statusCode: O,
            body: {
              eventsIngested: (n = t.events_ingested) !== null && n !== void 0 ? n : 0,
              payloadSizeBytes: (r = t.payload_size_bytes) !== null && r !== void 0 ? r : 0,
              serverUploadTime: (o = t.server_upload_time) !== null && o !== void 0 ? o : 0
            }
          };
        case Nt.Invalid:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (i = t.error) !== null && i !== void 0 ? i : "",
              missingField: (a = t.missing_field) !== null && a !== void 0 ? a : "",
              eventsWithInvalidFields: (s = t.events_with_invalid_fields) !== null && s !== void 0 ? s : {},
              eventsWithMissingFields: (l = t.events_with_missing_fields) !== null && l !== void 0 ? l : {},
              eventsWithInvalidIdLengths: (c = t.events_with_invalid_id_lengths) !== null && c !== void 0 ? c : {},
              epsThreshold: (u = t.eps_threshold) !== null && u !== void 0 ? u : 0,
              exceededDailyQuotaDevices: (d = t.exceeded_daily_quota_devices) !== null && d !== void 0 ? d : {},
              silencedDevices: (f = t.silenced_devices) !== null && f !== void 0 ? f : [],
              silencedEvents: (g = t.silenced_events) !== null && g !== void 0 ? g : [],
              throttledDevices: (h = t.throttled_devices) !== null && h !== void 0 ? h : {},
              throttledEvents: (y = t.throttled_events) !== null && y !== void 0 ? y : []
            }
          };
        case Nt.PayloadTooLarge:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (p = t.error) !== null && p !== void 0 ? p : ""
            }
          };
        case Nt.RateLimit:
          return {
            status: P,
            statusCode: O,
            body: {
              error: (C = t.error) !== null && C !== void 0 ? C : "",
              epsThreshold: (m = t.eps_threshold) !== null && m !== void 0 ? m : 0,
              throttledDevices: (b = t.throttled_devices) !== null && b !== void 0 ? b : {},
              throttledUsers: (w = t.throttled_users) !== null && w !== void 0 ? w : {},
              exceededDailyQuotaDevices: (E = t.exceeded_daily_quota_devices) !== null && E !== void 0 ? E : {},
              exceededDailyQuotaUsers: (S = t.exceeded_daily_quota_users) !== null && S !== void 0 ? S : {},
              throttledEvents: (_ = t.throttled_events) !== null && _ !== void 0 ? _ : []
            }
          };
        case Nt.Timeout:
        default:
          return {
            status: P,
            statusCode: O
          };
      }
    }, e.prototype.buildStatus = function(t) {
      return t >= 200 && t < 300 ? Nt.Success : t === 429 ? Nt.RateLimit : t === 413 ? Nt.PayloadTooLarge : t === 408 ? Nt.Timeout : t >= 400 && t < 500 ? Nt.Invalid : t >= 500 ? Nt.Failed : Nt.Unknown;
    }, e;
  }()
), Un = function() {
  var e = "ampIntegrationContext";
  if (typeof globalThis < "u" && typeof globalThis[e] < "u")
    return globalThis[e];
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
  if (typeof ir < "u")
    return ir;
}, us = function() {
  var e, t = Un();
  if (!(!((e = t == null ? void 0 : t.location) === null || e === void 0) && e.search))
    return {};
  var n = t.location.search.substring(1).split("&").filter(Boolean), r = n.reduce(function(o, i) {
    var a = i.split("=", 2), s = Bd(a[0]), l = Bd(a[1]);
    return l && (o[s] = l), o;
  }, {});
  return r;
}, Bd = function(e) {
  e === void 0 && (e = "");
  try {
    return decodeURIComponent(e);
  } catch {
    return "";
  }
}, GC = "utm_campaign", KC = "utm_content", XC = "utm_id", YC = "utm_medium", ZC = "utm_source", QC = "utm_term", Vd = "dclid", zd = "fbclid", Hd = "gbraid", Ud = "gclid", Wd = "ko_click_id", qd = "li_fat_id", Gd = "msclkid", Kd = "rtd_cid", Xd = "ttclid", Yd = "twclid", Zd = "wbraid", Ds = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  referrer: void 0,
  referring_domain: void 0,
  dclid: void 0,
  gbraid: void 0,
  gclid: void 0,
  fbclid: void 0,
  ko_click_id: void 0,
  li_fat_id: void 0,
  msclkid: void 0,
  rtd_cid: void 0,
  ttclid: void 0,
  twclid: void 0,
  wbraid: void 0
}, np = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.parse = function() {
      return ve(this, void 0, void 0, function() {
        return de(this, function(t) {
          return [2, Se(Se(Se(Se({}, Ds), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
        });
      });
    }, e.prototype.getUtmParam = function() {
      var t = us(), n = t[GC], r = t[KC], o = t[XC], i = t[YC], a = t[ZC], s = t[QC];
      return {
        utm_campaign: n,
        utm_content: r,
        utm_id: o,
        utm_medium: i,
        utm_source: a,
        utm_term: s
      };
    }, e.prototype.getReferrer = function() {
      var t, n, r = {
        referrer: void 0,
        referring_domain: void 0
      };
      try {
        r.referrer = document.referrer || void 0, r.referring_domain = (n = (t = r.referrer) === null || t === void 0 ? void 0 : t.split("/")[2]) !== null && n !== void 0 ? n : void 0;
      } catch {
      }
      return r;
    }, e.prototype.getClickIds = function() {
      var t, n = us();
      return t = {}, t[Vd] = n[Vd], t[zd] = n[zd], t[Hd] = n[Hd], t[Ud] = n[Ud], t[Wd] = n[Wd], t[qd] = n[qd], t[Gd] = n[Gd], t[Kd] = n[Kd], t[Xd] = n[Xd], t[Yd] = n[Yd], t[Zd] = n[Zd], t;
    }, e;
  }()
), rp = function(e, t, n) {
  return t === void 0 && (t = ""), n === void 0 && (n = 10), [Ms, t, e.substring(0, n)].filter(Boolean).join("_");
}, JC = function(e) {
  return "".concat(Ms.toLowerCase(), "_").concat(e.substring(0, 6));
}, Qd = function(e) {
  var t = e.split(".");
  return t.length <= 2 ? e : t.slice(t.length - 2, t.length).join(".");
}, ew = function(e) {
  return Object.values(e).every(function(t) {
    return !t;
  });
}, tw = function(e, t, n, r) {
  r === void 0 && (r = !0), e.referrer;
  var o = e.referring_domain, i = xc(e, ["referrer", "referring_domain"]), a = t || {};
  a.referrer;
  var s = a.referring_domain, l = xc(a, ["referrer", "referring_domain"]);
  if (nw(n.excludeReferrers, e.referring_domain) || !r && ew(e) && t)
    return !1;
  var c = JSON.stringify(i) !== JSON.stringify(l), u = Qd(o || "") !== Qd(s || "");
  return !t || c || u;
}, nw = function(e, t) {
  return e === void 0 && (e = []), t === void 0 && (t = ""), e.some(function(n) {
    return n instanceof RegExp ? n.test(t) : n === t;
  });
}, rw = function(e, t) {
  var n = Se(Se({}, Ds), e), r = Object.entries(n).reduce(function(o, i) {
    var a, s = pt(i, 2), l = s[0], c = s[1];
    return o.setOnce("initial_".concat(l), (a = c ?? t.initialEmptyValue) !== null && a !== void 0 ? a : "EMPTY"), c ? o.set(l, c) : o.unset(l);
  }, new Mi());
  return Qg(r);
}, ow = function(e) {
  var t = e;
  return t ? (t.startsWith(".") && (t = t.substring(1)), [new RegExp("".concat(t.replace(".", "\\."), "$"))]) : [];
}, iw = function(e, t, n) {
  return n === void 0 && (n = 10), [Ms, t, e.substring(0, n)].filter(Boolean).join("_");
}, op = function(e, t) {
  t === void 0 && (t = Date.now());
  var n = Date.now(), r = n - t;
  return r > e;
}, aw = (
  /** @class */
  function() {
    function e(t, n) {
      var r;
      this.shouldTrackNewCampaign = !1, this.options = Se({ initialEmptyValue: "EMPTY", resetSessionOnNewCampaign: !1, excludeReferrers: ow((r = n.cookieOptions) === null || r === void 0 ? void 0 : r.domain) }, t), this.storage = n.cookieStorage, this.storageKey = iw(n.apiKey, "MKTG"), this.currentCampaign = Ds, this.sessionTimeout = n.sessionTimeout, this.lastEventTime = n.lastEventTime, n.loggerProvider.log("Installing web attribution tracking.");
    }
    return e.prototype.init = function() {
      return ve(this, void 0, void 0, function() {
        var t, n;
        return de(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.fetchCampaign()];
            case 1:
              return n = pt.apply(void 0, [r.sent(), 2]), this.currentCampaign = n[0], this.previousCampaign = n[1], t = this.lastEventTime ? op(this.sessionTimeout, this.lastEventTime) : !0, tw(this.currentCampaign, this.previousCampaign, this.options, t) ? (this.shouldTrackNewCampaign = !0, [4, this.storage.set(this.storageKey, this.currentCampaign)]) : [3, 3];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.fetchCampaign = function() {
      return ve(this, void 0, void 0, function() {
        return de(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all([new np().parse(), this.storage.get(this.storageKey)])];
            case 1:
              return [2, t.sent()];
          }
        });
      });
    }, e.prototype.generateCampaignEvent = function(t) {
      this.shouldTrackNewCampaign = !1;
      var n = rw(this.currentCampaign, this.options);
      return t && (n.event_id = t), n;
    }, e.prototype.shouldSetSessionIdOnNewCampaign = function() {
      return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    }, e;
  }()
), Pc = (
  /** @class */
  function() {
    function e(t) {
      this.options = Se({}, t);
    }
    return e.prototype.isEnabled = function() {
      return ve(this, void 0, void 0, function() {
        var t, n, r;
        return de(this, function(o) {
          switch (o.label) {
            case 0:
              if (!Un())
                return [2, !1];
              e.testValue = String(Date.now()), t = new e(this.options), n = "AMP_TEST", o.label = 1;
            case 1:
              return o.trys.push([1, 4, 5, 7]), [4, t.set(n, e.testValue)];
            case 2:
              return o.sent(), [4, t.get(n)];
            case 3:
              return r = o.sent(), [2, r === e.testValue];
            case 4:
              return o.sent(), [2, !1];
            case 5:
              return [4, t.remove(n)];
            case 6:
              return o.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      var n;
      return ve(this, void 0, void 0, function() {
        var r, o;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.getRaw(t)];
            case 1:
              if (r = i.sent(), !r)
                return [2, void 0];
              try {
                return o = (n = sw(r)) !== null && n !== void 0 ? n : lw(r), o === void 0 ? (console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(t, ", value: ").concat(r)), [2, void 0]) : [2, JSON.parse(o)];
              } catch {
                return console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(t, ", value: ").concat(r)), [2, void 0];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n, r;
      return ve(this, void 0, void 0, function() {
        var o, i, a;
        return de(this, function(s) {
          return o = Un(), i = (r = (n = o == null ? void 0 : o.document) === null || n === void 0 ? void 0 : n.cookie.split("; ")) !== null && r !== void 0 ? r : [], a = i.find(function(l) {
            return l.indexOf(t + "=") === 0;
          }), a ? [2, a.substring(t.length + 1)] : [2, void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return ve(this, void 0, void 0, function() {
        var o, i, a, s, l, c, u;
        return de(this, function(d) {
          try {
            o = (r = this.options.expirationDays) !== null && r !== void 0 ? r : 0, i = n !== null ? o : -1, a = void 0, i && (s = /* @__PURE__ */ new Date(), s.setTime(s.getTime() + i * 24 * 60 * 60 * 1e3), a = s), l = "".concat(t, "=").concat(btoa(encodeURIComponent(JSON.stringify(n)))), a && (l += "; expires=".concat(a.toUTCString())), l += "; path=/", this.options.domain && (l += "; domain=".concat(this.options.domain)), this.options.secure && (l += "; Secure"), this.options.sameSite && (l += "; SameSite=".concat(this.options.sameSite)), c = Un(), c && (c.document.cookie = l);
          } catch (f) {
            u = f instanceof Error ? f.message : String(f), console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(t, ". Error: ").concat(u));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.set(t, null)];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.reset = function() {
      return ve(this, void 0, void 0, function() {
        return de(this, function(t) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), sw = function(e) {
  try {
    return decodeURIComponent(atob(e));
  } catch {
    return;
  }
}, lw = function(e) {
  try {
    return decodeURIComponent(atob(decodeURIComponent(e)));
  } catch {
    return;
  }
}, cw = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return ve(this, void 0, void 0, function() {
        var o, i, a;
        return de(this, function(s) {
          switch (s.label) {
            case 0:
              if (typeof fetch > "u")
                throw new Error("FetchTransport is not supported");
              return o = {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "*/*"
                },
                body: JSON.stringify(r),
                method: "POST"
              }, [4, fetch(n, o)];
            case 1:
              return i = s.sent(), [4, i.text()];
            case 2:
              a = s.sent();
              try {
                return [2, this.buildResponse(JSON.parse(a))];
              } catch {
                return [2, this.buildResponse({ code: i.status })];
              }
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(Ls)
), uw = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getApplicationContext = function() {
      return {
        versionName: this.versionName,
        language: dw(),
        platform: "Web",
        os: void 0,
        deviceModel: void 0
      };
    }, e;
  }()
), dw = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, fw = (
  /** @class */
  function() {
    function e() {
      this.queue = [];
    }
    return e.prototype.logEvent = function(t) {
      this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
    }, e.prototype.setEventReceiver = function(t) {
      this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function(n) {
        t(n);
      }), this.queue = []);
    }, e;
  }()
), Dr = function() {
  return Dr = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Dr.apply(this, arguments);
}, ja = function(e, t) {
  var n = ["string", "number", "boolean", "undefined"], r = typeof e, o = typeof t;
  if (r !== o)
    return !1;
  for (var i = 0, a = n; i < a.length; i++) {
    var s = a[i];
    if (s === r)
      return e === t;
  }
  if (e == null && t == null)
    return !0;
  if (e == null || t == null || e.length !== t.length)
    return !1;
  var l = Array.isArray(e), c = Array.isArray(t);
  if (l !== c)
    return !1;
  if (l && c) {
    for (var u = 0; u < e.length; u++)
      if (!ja(e[u], t[u]))
        return !1;
  } else {
    var d = Object.keys(e).sort(), f = Object.keys(t).sort();
    if (!ja(d, f))
      return !1;
    var g = !0;
    return Object.keys(e).forEach(function(h) {
      ja(e[h], t[h]) || (g = !1);
    }), g;
  }
  return !0;
}, vw = "$set", gw = "$unset", pw = "$clearAll";
Object.entries || (Object.entries = function(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; )
    r[n] = [t[n], e[t[n]]];
  return r;
});
var hw = (
  /** @class */
  function() {
    function e() {
      this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
    }
    return e.prototype.editIdentity = function() {
      var t = this, n = Dr({}, this.identity.userProperties), r = Dr(Dr({}, this.identity), { userProperties: n });
      return {
        setUserId: function(o) {
          return r.userId = o, this;
        },
        setDeviceId: function(o) {
          return r.deviceId = o, this;
        },
        setUserProperties: function(o) {
          return r.userProperties = o, this;
        },
        setOptOut: function(o) {
          return r.optOut = o, this;
        },
        updateUserProperties: function(o) {
          for (var i = r.userProperties || {}, a = 0, s = Object.entries(o); a < s.length; a++) {
            var l = s[a], c = l[0], u = l[1];
            switch (c) {
              case vw:
                for (var d = 0, f = Object.entries(u); d < f.length; d++) {
                  var g = f[d], h = g[0], y = g[1];
                  i[h] = y;
                }
                break;
              case gw:
                for (var p = 0, C = Object.keys(u); p < C.length; p++) {
                  var h = C[p];
                  delete i[h];
                }
                break;
              case pw:
                i = {};
                break;
            }
          }
          return r.userProperties = i, this;
        },
        commit: function() {
          return t.setIdentity(r), this;
        }
      };
    }, e.prototype.getIdentity = function() {
      return Dr({}, this.identity);
    }, e.prototype.setIdentity = function(t) {
      var n = Dr({}, this.identity);
      this.identity = Dr({}, t), ja(n, this.identity) || this.listeners.forEach(function(r) {
        r(t);
      });
    }, e.prototype.addIdentityListener = function(t) {
      this.listeners.add(t);
    }, e.prototype.removeIdentityListener = function(t) {
      this.listeners.delete(t);
    }, e;
  }()
), pi = typeof globalThis < "u" ? globalThis : typeof ir < "u" ? ir : self, mw = (
  /** @class */
  function() {
    function e() {
      this.identityStore = new hw(), this.eventBridge = new fw(), this.applicationContextProvider = new uw();
    }
    return e.getInstance = function(t) {
      return pi.analyticsConnectorInstances || (pi.analyticsConnectorInstances = {}), pi.analyticsConnectorInstances[t] || (pi.analyticsConnectorInstances[t] = new e()), pi.analyticsConnectorInstances[t];
    }, e;
  }()
), Li = function(e) {
  return e === void 0 && (e = "$default_instance"), mw.getInstance(e);
}, yw = function(e, t) {
  Li(t).identityStore.editIdentity().setUserId(e).commit();
}, bw = function(e, t) {
  Li(t).identityStore.editIdentity().setDeviceId(e).commit();
}, Cw = (
  /** @class */
  function() {
    function e() {
      this.name = "identity", this.type = "before", this.identityStore = Li().identityStore;
    }
    return e.prototype.execute = function(t) {
      return ve(this, void 0, void 0, function() {
        var n;
        return de(this, function(r) {
          return n = t.user_properties, n && this.identityStore.editIdentity().updateUserProperties(n).commit(), [2, t];
        });
      });
    }, e.prototype.setup = function(t) {
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          return t.instanceName && (this.identityStore = Li(t.instanceName).identityStore), [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), ww = function() {
  var e, t, n, r;
  if (typeof navigator > "u")
    return "";
  var o = navigator.userLanguage;
  return (r = (n = (t = (e = navigator.languages) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : navigator.language) !== null && n !== void 0 ? n : o) !== null && r !== void 0 ? r : "";
}, Qi = function(e, t) {
  return typeof e == "boolean" ? e : (e == null ? void 0 : e[t]) !== !1;
}, ip = function(e) {
  return Qi(e, "attribution");
}, Sw = function(e) {
  return Qi(e, "fileDownloads");
}, Ew = function(e) {
  return Qi(e, "formInteractions");
}, ap = function(e) {
  return Qi(e, "pageViews");
}, Jd = function(e) {
  return Qi(e, "sessions");
}, sp = function(e) {
  return typeof e == "boolean" ? e : typeof e == "object" && (e.elementInteractions === !0 || typeof e.elementInteractions == "object");
}, _w = function(e) {
  if (sp(e.autocapture) && typeof e.autocapture == "object" && typeof e.autocapture.elementInteractions == "object")
    return e.autocapture.elementInteractions;
}, xw = function(e) {
  var t = function() {
    return !1;
  }, n = void 0, r, o = e.pageCounter, i = ap(e.defaultTracking);
  return i && (t = void 0, r = void 0, e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.pageViews && typeof e.defaultTracking.pageViews == "object" && ("trackOn" in e.defaultTracking.pageViews && (t = e.defaultTracking.pageViews.trackOn), "trackHistoryChanges" in e.defaultTracking.pageViews && (n = e.defaultTracking.pageViews.trackHistoryChanges), "eventType" in e.defaultTracking.pageViews && e.defaultTracking.pageViews.eventType && (r = e.defaultTracking.pageViews.eventType))), {
    trackOn: t,
    trackHistoryChanges: n,
    eventType: r,
    pageCounter: o
  };
}, Ow = function(e) {
  return ip(e.defaultTracking) && e.defaultTracking && typeof e.defaultTracking == "object" && e.defaultTracking.attribution && typeof e.defaultTracking.attribution == "object" ? Se({}, e.defaultTracking.attribution) : {};
}, wl = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n], o = r.name, i = r.args, a = r.resolve, s = e && e[o];
    if (typeof s == "function") {
      var l = s.apply(e, i);
      typeof a == "function" && a(l == null ? void 0 : l.promise);
    }
  }
  return e;
}, Sl = function(e) {
  var t = e;
  return t && t._q !== void 0;
}, Pw = "2.11.7", Iw = "Web", Tw = "$remote", $w = (
  /** @class */
  function() {
    function e() {
      this.name = "@amplitude/plugin-context-browser", this.type = "before", this.library = "amplitude-ts/".concat(Pw), typeof navigator < "u" && (this.userAgent = navigator.userAgent);
    }
    return e.prototype.setup = function(t) {
      return this.config = t, Promise.resolve(void 0);
    }, e.prototype.execute = function(t) {
      var n, r;
      return ve(this, void 0, void 0, function() {
        var o, i, a, s;
        return de(this, function(l) {
          return o = (/* @__PURE__ */ new Date()).getTime(), i = (n = this.config.lastEventId) !== null && n !== void 0 ? n : -1, a = (r = t.event_id) !== null && r !== void 0 ? r : i + 1, this.config.lastEventId = a, t.time || (this.config.lastEventTime = o), s = Se(Se(Se(Se(Se(Se(Se(Se({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: o }, this.config.appVersion && { app_version: this.config.appVersion }), this.config.trackingOptions.platform && { platform: Iw }), this.config.trackingOptions.language && { language: ww() }), this.config.trackingOptions.ipAddress && { ip: Tw }), { insert_id: ni(), partner_id: this.config.partnerId, plan: this.config.plan }), this.config.ingestionMetadata && {
            ingestion_metadata: {
              source_name: this.config.ingestionMetadata.sourceName,
              source_version: this.config.ingestionMetadata.sourceVersion
            }
          }), t), { event_id: a, library: this.library, user_agent: this.userAgent }), [2, s];
        });
      });
    }, e;
  }()
), lp = (
  /** @class */
  function() {
    function e(t) {
      this.storage = t;
    }
    return e.prototype.isEnabled = function() {
      return ve(this, void 0, void 0, function() {
        var t, n, r, o;
        return de(this, function(i) {
          switch (i.label) {
            case 0:
              if (!this.storage)
                return [2, !1];
              t = String(Date.now()), n = new e(this.storage), r = "AMP_TEST", i.label = 1;
            case 1:
              return i.trys.push([1, 4, 5, 7]), [4, n.set(r, t)];
            case 2:
              return i.sent(), [4, n.get(r)];
            case 3:
              return o = i.sent(), [2, o === t];
            case 4:
              return i.sent(), [2, !1];
            case 5:
              return [4, n.remove(r)];
            case 6:
              return i.sent(), [
                7
                /*endfinally*/
              ];
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.get = function(t) {
      return ve(this, void 0, void 0, function() {
        var n;
        return de(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.getRaw(t)];
            case 1:
              return n = r.sent(), n ? [2, JSON.parse(n)] : [2, void 0];
            case 2:
              return r.sent(), console.error("[Amplitude] Error: Could not get value from storage"), [2, void 0];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRaw = function(t) {
      var n;
      return ve(this, void 0, void 0, function() {
        return de(this, function(r) {
          return [2, ((n = this.storage) === null || n === void 0 ? void 0 : n.getItem(t)) || void 0];
        });
      });
    }, e.prototype.set = function(t, n) {
      var r;
      return ve(this, void 0, void 0, function() {
        return de(this, function(o) {
          try {
            (r = this.storage) === null || r === void 0 || r.setItem(t, JSON.stringify(n));
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.remove = function(t) {
      var n;
      return ve(this, void 0, void 0, function() {
        return de(this, function(r) {
          try {
            (n = this.storage) === null || n === void 0 || n.removeItem(t);
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.reset = function() {
      var t;
      return ve(this, void 0, void 0, function() {
        return de(this, function(n) {
          try {
            (t = this.storage) === null || t === void 0 || t.clear();
          } catch {
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, e;
  }()
), ma = 1e3, cp = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n) {
      var r = this, o;
      return r = e.call(this, (o = Un()) === null || o === void 0 ? void 0 : o.localStorage) || this, r.loggerProvider = n == null ? void 0 : n.loggerProvider, r;
    }
    return t.prototype.set = function(n, r) {
      var o;
      return ve(this, void 0, void 0, function() {
        var i;
        return de(this, function(a) {
          switch (a.label) {
            case 0:
              return Array.isArray(r) && r.length > ma ? (i = r.length - ma, [4, e.prototype.set.call(this, n, r.slice(0, ma))]) : [3, 2];
            case 1:
              return a.sent(), (o = this.loggerProvider) === null || o === void 0 || o.error("Failed to save ".concat(i, " events because the queue length exceeded ").concat(ma, ".")), [3, 4];
            case 2:
              return [4, e.prototype.set.call(this, n, r)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(lp)
), Rw = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n;
      return e.call(this, (n = Un()) === null || n === void 0 ? void 0 : n.sessionStorage) || this;
    }
    return t;
  }(lp)
), Nw = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.state = {
        done: 4
      }, n;
    }
    return t.prototype.send = function(n, r) {
      return ve(this, void 0, void 0, function() {
        var o = this;
        return de(this, function(i) {
          return [2, new Promise(function(a, s) {
            typeof XMLHttpRequest > "u" && s(new Error("XHRTransport is not supported."));
            var l = new XMLHttpRequest();
            l.open("POST", n, !0), l.onreadystatechange = function() {
              if (l.readyState === o.state.done) {
                var c = l.responseText;
                try {
                  a(o.buildResponse(JSON.parse(c)));
                } catch {
                  a(o.buildResponse({ code: l.status }));
                }
              }
            }, l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("Accept", "*/*"), l.send(JSON.stringify(r));
          })];
        });
      });
    }, t;
  }(Ls)
), Aw = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.send = function(n, r) {
      return ve(this, void 0, void 0, function() {
        var o = this;
        return de(this, function(i) {
          return [2, new Promise(function(a, s) {
            var l = Un();
            if (!(l != null && l.navigator.sendBeacon))
              throw new Error("SendBeaconTransport is not supported");
            try {
              var c = JSON.stringify(r), u = l.navigator.sendBeacon(n, JSON.stringify(r));
              return a(u ? o.buildResponse({
                code: 200,
                events_ingested: r.events.length,
                payload_size_bytes: c.length,
                server_upload_time: Date.now()
              }) : o.buildResponse({ code: 500 }));
            } catch (d) {
              s(d);
            }
          })];
        });
      });
    }, t;
  }(Ls)
), kw = function(e, t, n) {
  return n === void 0 && (n = !0), ve(void 0, void 0, void 0, function() {
    var r, o, i, a, s, l, c, u, d;
    return de(this, function(f) {
      switch (f.label) {
        case 0:
          return r = JC(e), [4, t.getRaw(r)];
        case 1:
          return o = f.sent(), o ? n ? [4, t.remove(r)] : [3, 3] : [2, {
            optOut: !1
          }];
        case 2:
          f.sent(), f.label = 3;
        case 3:
          return i = pt(o.split("."), 6), a = i[0], s = i[1], l = i[2], c = i[3], u = i[4], d = i[5], [2, {
            deviceId: a,
            userId: Mw(s),
            sessionId: El(c),
            lastEventId: El(d),
            lastEventTime: El(u),
            optOut: !!l
          }];
      }
    });
  });
}, El = function(e) {
  var t = parseInt(e, 32);
  if (!isNaN(t))
    return t;
}, Mw = function(e) {
  if (!(!atob || !escape || !e))
    try {
      return decodeURIComponent(escape(atob(e)));
    } catch {
      return;
    }
}, Yn = "[Amplitude]", ef = "".concat(Yn, " Form Started"), Lw = "".concat(Yn, " Form Submitted"), Dw = "".concat(Yn, " File Downloaded"), tf = "session_start", nf = "session_end", Fw = "".concat(Yn, " File Extension"), jw = "".concat(Yn, " File Name"), Bw = "".concat(Yn, " Link ID"), Vw = "".concat(Yn, " Link Text"), zw = "".concat(Yn, " Link URL"), _l = "".concat(Yn, " Form ID"), xl = "".concat(Yn, " Form Name"), Ol = "".concat(Yn, " Form Destination"), ds = "cookie", Hw = "US", Uw = (
  /** @class */
  function(e) {
    xn(t, e);
    function t(n, r, o, i, a, s, l, c, u, d, f, g, h, y, p, C, m, b, w, E, S, _, O, P, $, L, N, k, F, U, A, R, D, B) {
      o === void 0 && (o = new ku()), i === void 0 && (i = {
        domain: "",
        expiration: 365,
        sameSite: "Lax",
        secure: !1,
        upgrade: !0
      }), c === void 0 && (c = 1e3), u === void 0 && (u = 5), d === void 0 && (d = 30), f === void 0 && (f = ds), C === void 0 && (C = new Jg()), m === void 0 && (m = Cn.Warn), w === void 0 && (w = !1), E === void 0 && (E = !1), O === void 0 && (O = ""), P === void 0 && (P = Hw), L === void 0 && (L = 30 * 60 * 1e3), N === void 0 && (N = new cp({ loggerProvider: C })), k === void 0 && (k = {
        ipAddress: !0,
        language: !0,
        platform: !0
      }), F === void 0 && (F = "fetch"), U === void 0 && (U = !1), A === void 0 && (A = !1);
      var M = e.call(this, { apiKey: n, storageProvider: N, transportProvider: up(F) }) || this;
      return M.apiKey = n, M.appVersion = r, M.cookieOptions = i, M.defaultTracking = a, M.autocapture = s, M.flushIntervalMillis = c, M.flushMaxRetries = u, M.flushQueueSize = d, M.identityStorage = f, M.ingestionMetadata = g, M.instanceName = h, M.loggerProvider = C, M.logLevel = m, M.minIdLength = b, M.offline = w, M.partnerId = S, M.plan = _, M.serverUrl = O, M.serverZone = P, M.sessionTimeout = L, M.storageProvider = N, M.trackingOptions = k, M.transport = F, M.useBatch = U, M.fetchRemoteConfig = A, M._optOut = !1, M._cookieStorage = o, M.deviceId = l, M.lastEventId = y, M.lastEventTime = p, M.optOut = E, M.sessionId = $, M.pageCounter = D, M.userId = R, M.debugLogsEnabled = B, M.loggerProvider.enable(B ? Cn.Debug : M.logLevel), M;
    }
    return Object.defineProperty(t.prototype, "cookieStorage", {
      get: function() {
        return this._cookieStorage;
      },
      set: function(n) {
        this._cookieStorage !== n && (this._cookieStorage = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "deviceId", {
      get: function() {
        return this._deviceId;
      },
      set: function(n) {
        this._deviceId !== n && (this._deviceId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "userId", {
      get: function() {
        return this._userId;
      },
      set: function(n) {
        this._userId !== n && (this._userId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sessionId", {
      get: function() {
        return this._sessionId;
      },
      set: function(n) {
        this._sessionId !== n && (this._sessionId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "optOut", {
      get: function() {
        return this._optOut;
      },
      set: function(n) {
        this._optOut !== n && (this._optOut = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      set: function(n) {
        this._lastEventTime !== n && (this._lastEventTime = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventId", {
      get: function() {
        return this._lastEventId;
      },
      set: function(n) {
        this._lastEventId !== n && (this._lastEventId = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "pageCounter", {
      get: function() {
        return this._pageCounter;
      },
      set: function(n) {
        this._pageCounter !== n && (this._pageCounter = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "debugLogsEnabled", {
      set: function(n) {
        this._debugLogsEnabled !== n && (this._debugLogsEnabled = n, this.updateStorage());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateStorage = function() {
      var n = {
        deviceId: this._deviceId,
        userId: this._userId,
        sessionId: this._sessionId,
        optOut: this._optOut,
        lastEventTime: this._lastEventTime,
        lastEventId: this._lastEventId,
        pageCounter: this._pageCounter,
        debugLogsEnabled: this._debugLogsEnabled
      };
      this.cookieStorage.set(rp(this.apiKey), n);
    }, t;
  }(VC)
), Ww = function(e, t, n) {
  return t === void 0 && (t = {}), ve(void 0, void 0, void 0, function() {
    var r, o, i, a, s, l, c, u, d, f, g, h, y, p, C, m, b, w, E, S, _, O, P, $, L, N, k, F, U, A, R, D, B, M, G, H, X, K, J, ie, le, ne, te;
    return de(this, function(re) {
      switch (re.label) {
        case 0:
          return r = t.identityStorage || ds, E = {}, r === ds ? [3, 1] : (i = "", [3, 5]);
        case 1:
          return (_ = (S = t.cookieOptions) === null || S === void 0 ? void 0 : S.domain) !== null && _ !== void 0 ? (a = _, [3, 4]) : [3, 2];
        case 2:
          return [4, Gw()];
        case 3:
          a = re.sent(), re.label = 4;
        case 4:
          i = a, re.label = 5;
        case 5:
          return o = Se.apply(void 0, [(E.domain = i, E.expiration = 365, E.sameSite = "Lax", E.secure = !1, E.upgrade = !0, E), t.cookieOptions]), s = qw(t.identityStorage, o), [4, kw(e, s, (P = (O = t.cookieOptions) === null || O === void 0 ? void 0 : O.upgrade) !== null && P !== void 0 ? P : !0)];
        case 6:
          return l = re.sent(), [4, s.get(rp(e))];
        case 7:
          return c = re.sent(), u = us(), d = (F = (k = (N = (L = ($ = t.deviceId) !== null && $ !== void 0 ? $ : u.ampDeviceId) !== null && L !== void 0 ? L : u.deviceId) !== null && N !== void 0 ? N : c == null ? void 0 : c.deviceId) !== null && k !== void 0 ? k : l.deviceId) !== null && F !== void 0 ? F : ni(), f = (U = c == null ? void 0 : c.lastEventId) !== null && U !== void 0 ? U : l.lastEventId, g = (A = c == null ? void 0 : c.lastEventTime) !== null && A !== void 0 ? A : l.lastEventTime, h = (D = (R = t.optOut) !== null && R !== void 0 ? R : c == null ? void 0 : c.optOut) !== null && D !== void 0 ? D : l.optOut, y = (B = c == null ? void 0 : c.sessionId) !== null && B !== void 0 ? B : l.sessionId, p = (G = (M = t.userId) !== null && M !== void 0 ? M : c == null ? void 0 : c.userId) !== null && G !== void 0 ? G : l.userId, n.previousSessionDeviceId = (H = c == null ? void 0 : c.deviceId) !== null && H !== void 0 ? H : l.deviceId, n.previousSessionUserId = (X = c == null ? void 0 : c.userId) !== null && X !== void 0 ? X : l.userId, C = {
            ipAddress: (J = (K = t.trackingOptions) === null || K === void 0 ? void 0 : K.ipAddress) !== null && J !== void 0 ? J : !0,
            language: (le = (ie = t.trackingOptions) === null || ie === void 0 ? void 0 : ie.language) !== null && le !== void 0 ? le : !0,
            platform: (te = (ne = t.trackingOptions) === null || ne === void 0 ? void 0 : ne.platform) !== null && te !== void 0 ? te : !0
          }, m = c == null ? void 0 : c.pageCounter, b = c == null ? void 0 : c.debugLogsEnabled, t.autocapture !== void 0 && (t.defaultTracking = t.autocapture), w = new Uw(e, t.appVersion, s, o, t.defaultTracking, t.autocapture, d, t.flushIntervalMillis, t.flushMaxRetries, t.flushQueueSize, r, t.ingestionMetadata, t.instanceName, f, g, t.loggerProvider, t.logLevel, t.minIdLength, t.offline, h, t.partnerId, t.plan, t.serverUrl, t.serverZone, y, t.sessionTimeout, t.storageProvider, C, t.transport, t.useBatch, t.fetchRemoteConfig, p, m, b), [4, w.storageProvider.isEnabled()];
        case 8:
          return re.sent() || (w.loggerProvider.warn("Storage provider ".concat(w.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage.")), w.storageProvider = new ku()), [2, w];
      }
    });
  });
}, qw = function(e, t) {
  switch (e === void 0 && (e = ds), t === void 0 && (t = {}), e) {
    case "localStorage":
      return new cp();
    case "sessionStorage":
      return new Rw();
    case "none":
      return new ku();
    case "cookie":
    default:
      return new Pc(Se(Se({}, t), { expirationDays: t.expiration }));
  }
}, up = function(e) {
  return e === "xhr" ? new Nw() : e === "beacon" ? new Aw() : new cw();
}, Gw = function(e) {
  return ve(void 0, void 0, void 0, function() {
    var t, n, r, o, i, i, a, s, l, c;
    return de(this, function(u) {
      switch (u.label) {
        case 0:
          return [4, new Pc().isEnabled()];
        case 1:
          if (!u.sent() || typeof location > "u" || !location.hostname)
            return [2, ""];
          for (t = location.hostname, n = t.split("."), r = [], o = "AMP_TLDTEST", i = n.length - 2; i >= 0; --i)
            r.push(n.slice(i).join("."));
          i = 0, u.label = 2;
        case 2:
          return i < r.length ? (a = r[i], s = { domain: "." + a }, l = new Pc(s), [4, l.set(o, 1)]) : [3, 7];
        case 3:
          return u.sent(), [4, l.get(o)];
        case 4:
          return c = u.sent(), c ? [4, l.remove(o)] : [3, 6];
        case 5:
          return u.sent(), [2, "." + a];
        case 6:
          return i++, [3, 2];
        case 7:
          return [2, ""];
      }
    });
  });
}, Kw = function(e) {
  var t = {};
  for (var n in e) {
    var r = e[n];
    r && (t[n] = r);
  }
  return t;
}, Xw = "[Amplitude] Page Viewed", Yw = function(e) {
  e === void 0 && (e = {});
  var t, n = Un(), r = void 0, o, i, a = e.trackOn, s = e.trackHistoryChanges, l = e.eventType, c = l === void 0 ? Xw : l, u = function(C) {
    var m = C;
    try {
      m = decodeURI(C);
    } catch (b) {
      r == null || r.error("Malformed URI sequence: ", b);
    }
    return m;
  }, d = function() {
    return ve(void 0, void 0, void 0, function() {
      var C, m, b;
      return de(this, function(w) {
        switch (w.label) {
          case 0:
            return C = u(typeof location < "u" && location.href || ""), b = {
              event_type: c
            }, m = [{}], [4, Zw()];
          case 1:
            return [2, (b.event_properties = Se.apply(void 0, [Se.apply(void 0, m.concat([w.sent()])), { "[Amplitude] Page Domain": (
              /* istanbul ignore next */
              typeof location < "u" && location.hostname || ""
            ), "[Amplitude] Page Location": C, "[Amplitude] Page Path": (
              /* istanbul ignore next */
              typeof location < "u" && u(location.pathname) || ""
            ), "[Amplitude] Page Title": (
              /* istanbul ignore next */
              typeof document < "u" && document.title || ""
            ), "[Amplitude] Page URL": C.split("?")[0] }]), b)];
        }
      });
    });
  }, f = function() {
    return typeof a > "u" || typeof a == "function" && a();
  }, g = typeof location < "u" ? location.href : null, h = function() {
    return ve(void 0, void 0, void 0, function() {
      var C, m, b, w;
      return de(this, function(E) {
        switch (E.label) {
          case 0:
            return C = location.href, m = Jw(s, C, g || "") && f(), g = C, m ? (r == null || r.log("Tracking page view event"), t != null ? [3, 1] : [3, 3]) : [3, 4];
          case 1:
            return w = (b = t).track, [4, d()];
          case 2:
            w.apply(b, [E.sent()]), E.label = 3;
          case 3:
            E.label = 4;
          case 4:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, y = function() {
    h();
  }, p = {
    name: "@amplitude/plugin-page-view-tracking-browser",
    type: "enrichment",
    setup: function(C, m) {
      return ve(void 0, void 0, void 0, function() {
        var b, w;
        return de(this, function(E) {
          switch (E.label) {
            case 0:
              return t = m, i = C, r = C.loggerProvider, r.log("Installing @amplitude/plugin-page-view-tracking-browser"), n && (n.addEventListener("popstate", y), o = n.history.pushState, n.history.pushState = new Proxy(n.history.pushState, {
                apply: function(S, _, O) {
                  var P = pt(O, 3), $ = P[0], L = P[1], N = P[2];
                  S.apply(_, [$, L, N]), h();
                }
              })), f() ? (r.log("Tracking page view event"), w = (b = t).track, [4, d()]) : [3, 2];
            case 1:
              w.apply(b, [E.sent()]), E.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    },
    execute: function(C) {
      return ve(void 0, void 0, void 0, function() {
        var m;
        return de(this, function(b) {
          switch (b.label) {
            case 0:
              return a === "attribution" && Qw(C) ? (r == null || r.log("Enriching campaign event to page view event with campaign parameters"), [4, d()]) : [3, 2];
            case 1:
              m = b.sent(), C.event_type = m.event_type, C.event_properties = Se(Se({}, C.event_properties), m.event_properties), b.label = 2;
            case 2:
              return i && C.event_type === c && (i.pageCounter = i.pageCounter ? i.pageCounter + 1 : 1, C.event_properties = Se(Se({}, C.event_properties), { "[Amplitude] Page Counter": i.pageCounter })), [2, C];
          }
        });
      });
    },
    teardown: function() {
      return ve(void 0, void 0, void 0, function() {
        return de(this, function(C) {
          return n && (n.removeEventListener("popstate", y), o && (n.history.pushState = o)), [
            2
            /*return*/
          ];
        });
      });
    }
  };
  return p;
}, Zw = function() {
  return ve(void 0, void 0, void 0, function() {
    var e;
    return de(this, function(t) {
      switch (t.label) {
        case 0:
          return e = Kw, [4, new np().parse()];
        case 1:
          return [2, e.apply(void 0, [t.sent()])];
      }
    });
  });
}, Qw = function(e) {
  if (e.event_type === "$identify" && e.user_properties) {
    var t = e.user_properties, n = t[en.SET] || {}, r = t[en.UNSET] || {}, o = rn(rn([], pt(Object.keys(n)), !1), pt(Object.keys(r)), !1);
    return Object.keys(Ds).every(function(i) {
      return o.includes(i);
    });
  }
  return !1;
}, Jw = function(e, t, n) {
  switch (e) {
    case "pathOnly": {
      if (n == "")
        return !0;
      var r = new URL(t), o = new URL(n), i = r.origin + r.pathname, a = o.origin + o.pathname;
      return i !== a;
    }
    default:
      return t !== n;
  }
}, eS = function() {
  var e, t = [], n = function(c, u, d) {
    c.addEventListener(u, d), t.push({
      element: c,
      type: u,
      handler: d
    });
  }, r = function() {
    t.forEach(function(c) {
      var u = c.element, d = c.type, f = c.handler;
      u == null || u.removeEventListener(d, f);
    }), t = [];
  }, o = "@amplitude/plugin-form-interaction-tracking-browser", i = "enrichment", a = function(c, u) {
    return ve(void 0, void 0, void 0, function() {
      var d;
      return de(this, function(f) {
        return (d = Un()) === null || d === void 0 || d.addEventListener("load", function() {
          if (!u) {
            c.loggerProvider.warn("Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var g = function(y) {
              var p = !1;
              n(y, "change", function() {
                var C;
                p || u.track(ef, (C = {}, C[_l] = wo(y.id), C[xl] = wo(y.name), C[Ol] = y.action, C)), p = !0;
              }), n(y, "submit", function() {
                var C, m;
                p || u.track(ef, (C = {}, C[_l] = wo(y.id), C[xl] = wo(y.name), C[Ol] = y.action, C)), u.track(Lw, (m = {}, m[_l] = wo(y.id), m[xl] = wo(y.name), m[Ol] = y.action, m)), p = !1;
              });
            }, h = Array.from(document.getElementsByTagName("form"));
            h.forEach(g), typeof MutationObserver < "u" && (e = new MutationObserver(function(y) {
              y.forEach(function(p) {
                p.addedNodes.forEach(function(C) {
                  C.nodeName === "FORM" && g(C), "querySelectorAll" in C && typeof C.querySelectorAll == "function" && Array.from(C.querySelectorAll("form")).map(g);
                });
              });
            }), e.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, s = function(c) {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(u) {
        return [2, c];
      });
    });
  }, l = function() {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(c) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: s,
    teardown: l
  };
}, wo = function(e) {
  if (typeof e == "string")
    return e;
}, tS = function() {
  var e, t = [], n = function(c, u, d) {
    c.addEventListener(u, d), t.push({
      element: c,
      type: u,
      handler: d
    });
  }, r = function() {
    t.forEach(function(c) {
      var u = c.element, d = c.type, f = c.handler;
      u == null || u.removeEventListener(d, f);
    }), t = [];
  }, o = "@amplitude/plugin-file-download-tracking-browser", i = "enrichment", a = function(c, u) {
    return ve(void 0, void 0, void 0, function() {
      var d;
      return de(this, function(f) {
        return (d = Un()) === null || d === void 0 || d.addEventListener("load", function() {
          if (!u) {
            c.loggerProvider.warn("File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.");
            return;
          }
          if (!(typeof document > "u")) {
            var g = function(p) {
              var C;
              try {
                C = new URL(p.href, window.location.href);
              } catch {
                return;
              }
              var m = h.exec(C.href), b = m == null ? void 0 : m[1];
              b && n(p, "click", function() {
                var w;
                b && u.track(Dw, (w = {}, w[Fw] = b, w[jw] = C.pathname, w[Bw] = p.id, w[Vw] = p.text, w[zw] = p.href, w));
              });
            }, h = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/, y = Array.from(document.getElementsByTagName("a"));
            y.forEach(g), typeof MutationObserver < "u" && (e = new MutationObserver(function(p) {
              p.forEach(function(C) {
                C.addedNodes.forEach(function(m) {
                  m.nodeName === "A" && g(m), "querySelectorAll" in m && typeof m.querySelectorAll == "function" && Array.from(m.querySelectorAll("a")).map(g);
                });
              });
            }), e.observe(document.body, {
              subtree: !0,
              childList: !0
            }));
          }
        }), [
          2
          /*return*/
        ];
      });
    });
  }, s = function(c) {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(u) {
        return [2, c];
      });
    });
  }, l = function() {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(c) {
        return e == null || e.disconnect(), r(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: o,
    type: i,
    setup: a,
    execute: s,
    teardown: l
  };
}, rf = !1, nS = function(e) {
  if (!(rf || e.defaultTracking !== void 0)) {
    var t = `\`options.defaultTracking\` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to \`options.defaultTracking\`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:

amplitude.init(<YOUR_API_KEY>, {
  defaultTracking: true,
});

Visit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.`;
    e.loggerProvider.warn(t), rf = !0;
  }
}, rS = function() {
  var e = "@amplitude/plugin-network-checker-browser", t = "before", n = Un(), r = [], o = function(l, c) {
    n && (n.addEventListener(l, c), r.push({
      type: l,
      handler: c
    }));
  }, i = function() {
    r.forEach(function(l) {
      var c = l.type, u = l.handler;
      n && n.removeEventListener(c, u);
    }), r = [];
  }, a = function(l, c) {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(u) {
        return typeof navigator > "u" ? (l.loggerProvider.debug("Network connectivity checker plugin is disabled because navigator is not available."), l.offline = !1, [
          2
          /*return*/
        ]) : (l.offline = !navigator.onLine, o("online", function() {
          l.loggerProvider.debug("Network connectivity changed to online."), l.offline = !1, setTimeout(function() {
            c.flush();
          }, l.flushIntervalMillis);
        }), o("offline", function() {
          l.loggerProvider.debug("Network connectivity changed to offline."), l.offline = !0;
        }), [
          2
          /*return*/
        ]);
      });
    });
  }, s = function() {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(l) {
        return i(), [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: e,
    type: t,
    setup: a,
    teardown: s
  };
}, oS = "Network error occurred, remote config fetch failed", iS = "Remote config successfully fetched", aS = "Remote config fetch rejected due to exceeded retry count", of = "Remote config fetch rejected due to timeout after 5 seconds", sS = "Unexpected error occurred", lS = "https://sr-client-cfg.amplitude.com/config", cS = "https://sr-client-cfg.stag2.amplitude.com/config", uS = "https://sr-client-cfg.eu.amplitude.com/config", dS = (
  /** @class */
  function() {
    function e(t) {
      var n = t.localConfig, r = t.configKeys, o = this;
      this.retryTimeout = 1e3, this.attempts = 0, this.sessionTargetingMatch = !1, this.metrics = {}, this.getRemoteConfig = function(i, a, s) {
        return ve(o, void 0, void 0, function() {
          var l, c, u;
          return de(this, function(d) {
            switch (d.label) {
              case 0:
                return l = Date.now(), [4, this.fetchWithTimeout(s)];
              case 1:
                return c = d.sent(), c && (u = c.configs && c.configs[i], u) ? (this.metrics.fetchTimeAPISuccess = Date.now() - l, [2, u[a]]) : (this.metrics.fetchTimeAPIFail = Date.now() - l, [2, void 0]);
            }
          });
        });
      }, this.fetchWithTimeout = function(i) {
        return ve(o, void 0, void 0, function() {
          var a, s, l;
          return de(this, function(c) {
            switch (c.label) {
              case 0:
                return a = new AbortController(), s = setTimeout(function() {
                  return a.abort();
                }, 5e3), [4, this.fetchRemoteConfig(a.signal, i)];
              case 1:
                return l = c.sent(), clearTimeout(s), [2, l];
            }
          });
        });
      }, this.fetchRemoteConfig = function(i, a) {
        return ve(o, void 0, void 0, function() {
          var s, l, c, u, d, f, g, h, y, p, C, m;
          return de(this, function(b) {
            switch (b.label) {
              case 0:
                if (a === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries)
                  return [2, this.completeRequest({ err: aS })];
                if (i.aborted)
                  return [2, this.completeRequest({ err: of })];
                a !== this.lastFetchedSessionId && (this.lastFetchedSessionId = a, this.attempts = 0), b.label = 1;
              case 1:
                b.trys.push([1, 3, , 4]), s = new URLSearchParams({
                  api_key: this.localConfig.apiKey
                });
                try {
                  for (l = Ut(this.configKeys), c = l.next(); !c.done; c = l.next())
                    u = c.value, s.append("config_keys", u);
                } catch (w) {
                  C = { error: w };
                } finally {
                  try {
                    c && !c.done && (m = l.return) && m.call(l);
                  } finally {
                    if (C)
                      throw C.error;
                  }
                }
                return a && s.set("session_id", String(a)), d = {
                  headers: {
                    Accept: "*/*"
                  },
                  method: "GET"
                }, f = "".concat(this.getServerUrl(), "?").concat(s.toString()), this.attempts += 1, [4, fetch(f, Se(Se({}, d), { signal: i }))];
              case 2:
                if (g = b.sent(), g === null)
                  return [2, this.completeRequest({ err: sS })];
                switch (h = new Ls().buildStatus(g.status), h) {
                  case Nt.Success:
                    return this.attempts = 0, [2, this.parseAndStoreConfig(g)];
                  case Nt.Failed:
                    return [2, this.retryFetch(i, a)];
                  default:
                    return [2, this.completeRequest({ err: oS })];
                }
              case 3:
                return y = b.sent(), p = y, i.aborted ? [2, this.completeRequest({ err: of })] : [2, this.completeRequest({ err: p.message })];
              case 4:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, this.retryFetch = function(i, a) {
        return ve(o, void 0, void 0, function() {
          var s = this;
          return de(this, function(l) {
            switch (l.label) {
              case 0:
                return [4, new Promise(function(c) {
                  return setTimeout(c, s.attempts * s.retryTimeout);
                })];
              case 1:
                return l.sent(), [2, this.fetchRemoteConfig(i, a)];
            }
          });
        });
      }, this.parseAndStoreConfig = function(i) {
        return ve(o, void 0, void 0, function() {
          var a;
          return de(this, function(s) {
            switch (s.label) {
              case 0:
                return [4, i.json()];
              case 1:
                return a = s.sent(), this.completeRequest({ success: iS }), [2, a];
            }
          });
        });
      }, this.localConfig = n, this.configKeys = r;
    }
    return e.prototype.getServerUrl = function() {
      return this.localConfig.serverZone === cs.STAGING ? cS : this.localConfig.serverZone === cs.EU ? uS : lS;
    }, e.prototype.completeRequest = function(t) {
      var n = t.err, r = t.success;
      if (n)
        throw new Error(n);
      r && this.localConfig.loggerProvider.log(r);
    }, e;
  }()
), fS = function(e) {
  var t = e.localConfig, n = e.configKeys;
  return ve(void 0, void 0, void 0, function() {
    return de(this, function(r) {
      return [2, new dS({ localConfig: t, configKeys: n })];
    });
  });
}, vS = fS, gS = (
  /** @class */
  function() {
    function e(t) {
      this.config = t, this.config.loggerProvider.debug("Local configuration before merging with remote config", JSON.stringify(this.config, null, 2));
    }
    return e.prototype.initialize = function() {
      return ve(this, void 0, void 0, function() {
        var t;
        return de(this, function(n) {
          switch (n.label) {
            case 0:
              return t = this, [4, vS({
                localConfig: this.config,
                configKeys: ["analyticsSDK"]
              })];
            case 1:
              return t.remoteConfigFetch = n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.generateJoinedConfig = function() {
      var t, n, r, o;
      return ve(this, void 0, void 0, function() {
        var i, a, s;
        return de(this, function(l) {
          switch (l.label) {
            case 0:
              return l.trys.push([0, 3, , 4]), a = this.remoteConfigFetch, a ? [4, this.remoteConfigFetch.getRemoteConfig("analyticsSDK", "browserSDK", this.config.sessionId)] : [3, 2];
            case 1:
              a = l.sent(), l.label = 2;
            case 2:
              return i = a, this.config.loggerProvider.debug("Remote configuration:", JSON.stringify(i, null, 2)), i && "autocapture" in i && (typeof i.autocapture == "boolean" && (this.config.autocapture = i.autocapture), typeof i.autocapture == "object" && (this.config.autocapture === void 0 && (this.config.autocapture = i.autocapture), typeof this.config.autocapture == "boolean" && (this.config.autocapture = Se({ attribution: this.config.autocapture, fileDownloads: this.config.autocapture, formInteractions: this.config.autocapture, pageViews: this.config.autocapture, sessions: this.config.autocapture, elementInteractions: this.config.autocapture }, i.autocapture)), typeof this.config.autocapture == "object" && (this.config.autocapture = Se(Se({}, this.config.autocapture), i.autocapture))), this.config.defaultTracking = this.config.autocapture), this.config.loggerProvider.debug("Joined configuration: ", JSON.stringify(this.config, null, 2)), (t = (o = this.config).requestMetadata) !== null && t !== void 0 || (o.requestMetadata = new tp()), !((n = this.remoteConfigFetch) === null || n === void 0) && n.metrics.fetchTimeAPISuccess && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_success", this.remoteConfigFetch.metrics.fetchTimeAPISuccess), !((r = this.remoteConfigFetch) === null || r === void 0) && r.metrics.fetchTimeAPIFail && this.config.requestMetadata.recordHistogram("remote_config_fetch_time_API_fail", this.remoteConfigFetch.metrics.fetchTimeAPIFail), [3, 4];
            case 3:
              return s = l.sent(), this.config.loggerProvider.error("Failed to fetch remote configuration because of error: ", s), [3, 4];
            case 4:
              return [2, this.config];
          }
        });
      });
    }, e;
  }()
), pS = function(e) {
  return ve(void 0, void 0, void 0, function() {
    var t;
    return de(this, function(n) {
      switch (n.label) {
        case 0:
          return t = new gS(e), [4, t.initialize()];
        case 1:
          return n.sent(), [2, t];
      }
    });
  });
}, hS = "@amplitude/plugin-autocapture-browser", Ic = "[Amplitude] Element Clicked", mS = "[Amplitude] Element Changed", yS = "[Amplitude] Element ID", bS = "[Amplitude] Element Class", dp = "[Amplitude] Element Tag", fp = "[Amplitude] Element Text", CS = "[Amplitude] Element Hierarchy", wS = "[Amplitude] Element Href", SS = "[Amplitude] Element Position Left", ES = "[Amplitude] Element Position Top", _S = "[Amplitude] Element Aria Label", xS = "[Amplitude] Element Attributes", vp = "[Amplitude] Element Selector", OS = "[Amplitude] Element Parent Label", gp = "[Amplitude] Page URL", PS = "[Amplitude] Page Title", IS = "[Amplitude] Viewport Height", TS = "[Amplitude] Viewport Width", Ba = "https://app.amplitude.com", $S = "https://app.eu.amplitude.com", RS = "https://apps.stag2.amplitude.com", NS = {
  US: Ba,
  EU: $S,
  STAGING: RS
}, AS = "https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz", Tc = "amp-visual-tagging-selector-highlight";
function Ot(e) {
  return typeof e == "function";
}
function pp(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Pl = pp(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, o) {
      return o + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function $c(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Fs = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, o, i;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var s = Ut(a), l = s.next(); !l.done; l = s.next()) {
              var c = l.value;
              c.remove(this);
            }
          } catch (y) {
            t = { error: y };
          } finally {
            try {
              l && !l.done && (n = s.return) && n.call(s);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          a.remove(this);
      var u = this.initialTeardown;
      if (Ot(u))
        try {
          u();
        } catch (y) {
          i = y instanceof Pl ? y.errors : [y];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var f = Ut(d), g = f.next(); !g.done; g = f.next()) {
            var h = g.value;
            try {
              af(h);
            } catch (y) {
              i = i ?? [], y instanceof Pl ? i = rn(rn([], pt(i)), pt(y.errors)) : i.push(y);
            }
          }
        } catch (y) {
          r = { error: y };
        } finally {
          try {
            g && !g.done && (o = f.return) && o.call(f);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (i)
        throw new Pl(i);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        af(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && $c(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && $c(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}();
Fs.EMPTY;
function hp(e) {
  return e instanceof Fs || e && "closed" in e && Ot(e.remove) && Ot(e.add) && Ot(e.unsubscribe);
}
function af(e) {
  Ot(e) ? e() : e.unsubscribe();
}
var mp = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, yp = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, rn([e, t], pt(n)));
  },
  clearTimeout: function(e) {
    var t = yp.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function bp(e) {
  yp.setTimeout(function() {
    throw e;
  });
}
function Rc() {
}
function kS(e) {
  e();
}
var Mu = function(e) {
  xn(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, hp(n) && n.add(r)) : r.destination = FS, r;
  }
  return t.create = function(n, r, o) {
    return new Nc(n, r, o);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Fs), MS = Function.prototype.bind;
function Il(e, t) {
  return MS.call(e, t);
}
var LS = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        ya(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        ya(r);
      }
    else
      ya(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        ya(n);
      }
  }, e;
}(), Nc = function(e) {
  xn(t, e);
  function t(n, r, o) {
    var i = e.call(this) || this, a;
    if (Ot(n) || !n)
      a = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: o ?? void 0
      };
    else {
      var s;
      i && mp.useDeprecatedNextContext ? (s = Object.create(n), s.unsubscribe = function() {
        return i.unsubscribe();
      }, a = {
        next: n.next && Il(n.next, s),
        error: n.error && Il(n.error, s),
        complete: n.complete && Il(n.complete, s)
      }) : a = n;
    }
    return i.destination = new LS(a), i;
  }
  return t;
}(Mu);
function ya(e) {
  bp(e);
}
function DS(e) {
  throw e;
}
var FS = {
  closed: !0,
  next: Rc,
  error: DS,
  complete: Rc
}, Lu = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Cp(e) {
  return e;
}
function jS(e) {
  return e.length === 0 ? Cp : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, o) {
      return o(r);
    }, n);
  };
}
var On = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var o = this, i = VS(t) ? t : new Nc(t, n, r);
    return kS(function() {
      var a = o, s = a.operator, l = a.source;
      i.add(s ? s.call(i, l) : l ? o._subscribe(i) : o._trySubscribe(i));
    }), i;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = sf(n), new n(function(o, i) {
      var a = new Nc({
        next: function(s) {
          try {
            t(s);
          } catch (l) {
            i(l), a.unsubscribe();
          }
        },
        error: i,
        complete: o
      });
      r.subscribe(a);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[Lu] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return jS(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = sf(t), new t(function(r, o) {
      var i;
      n.subscribe(function(a) {
        return i = a;
      }, function(a) {
        return o(a);
      }, function() {
        return r(i);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function sf(e) {
  var t;
  return (t = e ?? mp.Promise) !== null && t !== void 0 ? t : Promise;
}
function BS(e) {
  return e && Ot(e.next) && Ot(e.error) && Ot(e.complete);
}
function VS(e) {
  return e && e instanceof Mu || BS(e) && hp(e);
}
function zS(e) {
  return Ot(e == null ? void 0 : e.lift);
}
function Zn(e) {
  return function(t) {
    if (zS(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function En(e, t, n, r, o) {
  return new HS(e, t, n, r, o);
}
var HS = function(e) {
  xn(t, e);
  function t(n, r, o, i, a, s) {
    var l = e.call(this, n) || this;
    return l.onFinalize = a, l.shouldUnsubscribe = s, l._next = r ? function(c) {
      try {
        r(c);
      } catch (u) {
        n.error(u);
      }
    } : e.prototype._next, l._error = i ? function(c) {
      try {
        i(c);
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, l._complete = o ? function() {
      try {
        o();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, l;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(Mu), US = {
  now: function() {
    return Date.now();
  },
  delegate: void 0
}, WS = function(e) {
  xn(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
}(Fs), Ac = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, rn([e, t], pt(n)));
  },
  clearInterval: function(e) {
    var t = Ac.delegate;
    return ((t == null ? void 0 : t.clearInterval) || clearInterval)(e);
  },
  delegate: void 0
}, qS = function(e) {
  xn(t, e);
  function t(n, r) {
    var o = e.call(this, n, r) || this;
    return o.scheduler = n, o.work = r, o.pending = !1, o;
  }
  return t.prototype.schedule = function(n, r) {
    var o;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var i = this.id, a = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(a, i, r)), this.pending = !0, this.delay = r, this.id = (o = this.id) !== null && o !== void 0 ? o : this.requestAsyncId(a, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, o) {
    return o === void 0 && (o = 0), Ac.setInterval(n.flush.bind(n, this), o);
  }, t.prototype.recycleAsyncId = function(n, r, o) {
    if (o === void 0 && (o = 0), o != null && this.delay === o && this.pending === !1)
      return r;
    r != null && Ac.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var o = this._execute(n, r);
    if (o)
      return o;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var o = !1, i;
    try {
      this.work(n);
    } catch (a) {
      o = !0, i = a || new Error("Scheduled action threw falsy error");
    }
    if (o)
      return this.unsubscribe(), i;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, o = n.scheduler, i = o.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, $c(i, this), r != null && (this.id = this.recycleAsyncId(o, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(WS), lf = function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = US.now, e;
}(), GS = function(e) {
  xn(t, e);
  function t(n, r) {
    r === void 0 && (r = lf.now);
    var o = e.call(this, n, r) || this;
    return o.actions = [], o._active = !1, o;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var o;
    this._active = !0;
    do
      if (o = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, o) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw o;
    }
  }, t;
}(lf), js = new GS(qS), KS = js, Du = new On(function(e) {
  return e.complete();
});
function wp(e) {
  return e && Ot(e.schedule);
}
function Sp(e) {
  return e[e.length - 1];
}
function XS(e) {
  return wp(Sp(e)) ? e.pop() : void 0;
}
function YS(e, t) {
  return typeof Sp(e) == "number" ? e.pop() : t;
}
var Fu = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function Ep(e) {
  return Ot(e == null ? void 0 : e.then);
}
function _p(e) {
  return Ot(e[Lu]);
}
function xp(e) {
  return Symbol.asyncIterator && Ot(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function Op(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function ZS() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Pp = ZS();
function Ip(e) {
  return Ot(e == null ? void 0 : e[Pp]);
}
function Tp(e) {
  return pC(this, arguments, function() {
    var n, r, o, i;
    return de(this, function(a) {
      switch (a.label) {
        case 0:
          n = e.getReader(), a.label = 1;
        case 1:
          a.trys.push([1, , 9, 10]), a.label = 2;
        case 2:
          return [4, Do(n.read())];
        case 3:
          return r = a.sent(), o = r.value, i = r.done, i ? [4, Do(void 0)] : [3, 5];
        case 4:
          return [2, a.sent()];
        case 5:
          return [4, Do(o)];
        case 6:
          return [4, a.sent()];
        case 7:
          return a.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function $p(e) {
  return Ot(e == null ? void 0 : e.getReader);
}
function Qn(e) {
  if (e instanceof On)
    return e;
  if (e != null) {
    if (_p(e))
      return QS(e);
    if (Fu(e))
      return JS(e);
    if (Ep(e))
      return eE(e);
    if (xp(e))
      return Rp(e);
    if (Ip(e))
      return tE(e);
    if ($p(e))
      return nE(e);
  }
  throw Op(e);
}
function QS(e) {
  return new On(function(t) {
    var n = e[Lu]();
    if (Ot(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function JS(e) {
  return new On(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function eE(e) {
  return new On(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, bp);
  });
}
function tE(e) {
  return new On(function(t) {
    var n, r;
    try {
      for (var o = Ut(e), i = o.next(); !i.done; i = o.next()) {
        var a = i.value;
        if (t.next(a), t.closed)
          return;
      }
    } catch (s) {
      n = { error: s };
    } finally {
      try {
        i && !i.done && (r = o.return) && r.call(o);
      } finally {
        if (n)
          throw n.error;
      }
    }
    t.complete();
  });
}
function Rp(e) {
  return new On(function(t) {
    rE(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function nE(e) {
  return Rp(Tp(e));
}
function rE(e, t) {
  var n, r, o, i;
  return ve(this, void 0, void 0, function() {
    var a, s;
    return de(this, function(l) {
      switch (l.label) {
        case 0:
          l.trys.push([0, 5, 6, 11]), n = hC(e), l.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = l.sent(), !!r.done)
            return [3, 4];
          if (a = r.value, t.next(a), t.closed)
            return [2];
          l.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return s = l.sent(), o = { error: s }, [3, 11];
        case 6:
          return l.trys.push([6, , 9, 10]), r && !r.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          l.sent(), l.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (o)
            throw o.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Vr(e, t, n, r, o) {
  r === void 0 && (r = 0), o === void 0 && (o = !1);
  var i = t.schedule(function() {
    n(), o ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(i), !o)
    return i;
}
function Np(e, t) {
  return t === void 0 && (t = 0), Zn(function(n, r) {
    n.subscribe(En(r, function(o) {
      return Vr(r, e, function() {
        return r.next(o);
      }, t);
    }, function() {
      return Vr(r, e, function() {
        return r.complete();
      }, t);
    }, function(o) {
      return Vr(r, e, function() {
        return r.error(o);
      }, t);
    }));
  });
}
function Ap(e, t) {
  return t === void 0 && (t = 0), Zn(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function oE(e, t) {
  return Qn(e).pipe(Ap(t), Np(t));
}
function iE(e, t) {
  return Qn(e).pipe(Ap(t), Np(t));
}
function aE(e, t) {
  return new On(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function sE(e, t) {
  return new On(function(n) {
    var r;
    return Vr(n, t, function() {
      r = e[Pp](), Vr(n, t, function() {
        var o, i, a;
        try {
          o = r.next(), i = o.value, a = o.done;
        } catch (s) {
          n.error(s);
          return;
        }
        a ? n.complete() : n.next(i);
      }, 0, !0);
    }), function() {
      return Ot(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function kp(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new On(function(n) {
    Vr(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      Vr(n, t, function() {
        r.next().then(function(o) {
          o.done ? n.complete() : n.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function lE(e, t) {
  return kp(Tp(e), t);
}
function cE(e, t) {
  if (e != null) {
    if (_p(e))
      return oE(e, t);
    if (Fu(e))
      return aE(e, t);
    if (Ep(e))
      return iE(e, t);
    if (xp(e))
      return kp(e, t);
    if (Ip(e))
      return sE(e, t);
    if ($p(e))
      return lE(e, t);
  }
  throw Op(e);
}
function uE(e, t) {
  return t ? cE(e, t) : Qn(e);
}
function Mp(e) {
  return e instanceof Date && !isNaN(e);
}
var dE = pp(function(e) {
  return function(n) {
    n === void 0 && (n = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function fE(e, t) {
  var n = Mp(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, o = n.each, i = n.with, a = i === void 0 ? vE : i, s = n.scheduler, l = s === void 0 ? js : s, c = n.meta, u = c === void 0 ? null : c;
  if (r == null && o == null)
    throw new TypeError("No timeout provided.");
  return Zn(function(d, f) {
    var g, h, y = null, p = 0, C = function(m) {
      h = Vr(f, l, function() {
        try {
          g.unsubscribe(), Qn(a({
            meta: u,
            lastValue: y,
            seen: p
          })).subscribe(f);
        } catch (b) {
          f.error(b);
        }
      }, m);
    };
    g = d.subscribe(En(f, function(m) {
      h == null || h.unsubscribe(), p++, f.next(y = m), o > 0 && C(o);
    }, void 0, void 0, function() {
      h != null && h.closed || h == null || h.unsubscribe(), y = null;
    })), !p && C(r != null ? typeof r == "number" ? r : +r - l.now() : o);
  });
}
function vE(e) {
  throw new dE(e);
}
function rr(e, t) {
  return Zn(function(n, r) {
    var o = 0;
    n.subscribe(En(r, function(i) {
      r.next(e.call(t, i, o++));
    }));
  });
}
var gE = Array.isArray;
function pE(e, t) {
  return gE(t) ? e.apply(void 0, rn([], pt(t))) : e(t);
}
function hE(e) {
  return rr(function(t) {
    return pE(e, t);
  });
}
function mE(e, t, n, r, o, i, a, s) {
  var l = [], c = 0, u = 0, d = !1, f = function() {
    d && !l.length && !c && t.complete();
  }, g = function(y) {
    return c < r ? h(y) : l.push(y);
  }, h = function(y) {
    c++;
    var p = !1;
    Qn(n(y, u++)).subscribe(En(t, function(C) {
      t.next(C);
    }, function() {
      p = !0;
    }, void 0, function() {
      if (p)
        try {
          c--;
          for (var C = function() {
            var m = l.shift();
            a || h(m);
          }; l.length && c < r; )
            C();
          f();
        } catch (m) {
          t.error(m);
        }
    }));
  };
  return e.subscribe(En(t, g, function() {
    d = !0, f();
  })), function() {
  };
}
function Bs(e, t, n) {
  return n === void 0 && (n = 1 / 0), Ot(t) ? Bs(function(r, o) {
    return rr(function(i, a) {
      return t(r, i, o, a);
    })(Qn(e(r, o)));
  }, n) : (typeof t == "number" && (n = t), Zn(function(r, o) {
    return mE(r, o, e, n);
  }));
}
function yE(e) {
  return e === void 0 && (e = 1 / 0), Bs(Cp, e);
}
var bE = ["addListener", "removeListener"], CE = ["addEventListener", "removeEventListener"], wE = ["on", "off"];
function Ii(e, t, n, r) {
  if (Ot(n) && (r = n, n = void 0), r)
    return Ii(e, t, n).pipe(hE(r));
  var o = pt(_E(e) ? CE.map(function(s) {
    return function(l) {
      return e[s](t, l, n);
    };
  }) : SE(e) ? bE.map(cf(e, t)) : EE(e) ? wE.map(cf(e, t)) : [], 2), i = o[0], a = o[1];
  if (!i && Fu(e))
    return Bs(function(s) {
      return Ii(s, t, n);
    })(Qn(e));
  if (!i)
    throw new TypeError("Invalid event target");
  return new On(function(s) {
    var l = function() {
      for (var c = [], u = 0; u < arguments.length; u++)
        c[u] = arguments[u];
      return s.next(1 < c.length ? c : c[0]);
    };
    return i(l), function() {
      return a(l);
    };
  });
}
function cf(e, t) {
  return function(n) {
    return function(r) {
      return e[n](t, r);
    };
  };
}
function SE(e) {
  return Ot(e.addListener) && Ot(e.removeListener);
}
function EE(e) {
  return Ot(e.on) && Ot(e.off);
}
function _E(e) {
  return Ot(e.addEventListener) && Ot(e.removeEventListener);
}
function xE(e, t, n) {
  n === void 0 && (n = KS);
  var r = -1;
  return t != null && (wp(t) ? n = t : r = t), new On(function(o) {
    var i = Mp(e) ? +e - n.now() : e;
    i < 0 && (i = 0);
    var a = 0;
    return n.schedule(function() {
      o.closed || (o.next(a++), 0 <= r ? this.schedule(void 0, r) : o.complete());
    }, i);
  });
}
function Lp() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = XS(e), r = YS(e, 1 / 0), o = e;
  return o.length ? o.length === 1 ? Qn(o[0]) : yE(r)(uE(o, n)) : Du;
}
function zr(e, t) {
  return Zn(function(n, r) {
    var o = 0;
    n.subscribe(En(r, function(i) {
      return e.call(t, i, o++) && r.next(i);
    }));
  });
}
function OE(e) {
  return Zn(function(t, n) {
    var r = [];
    return t.subscribe(En(n, function(o) {
      return r.push(o);
    }, function() {
      n.next(r), n.complete();
    })), Qn(e).subscribe(En(n, function() {
      var o = r;
      r = [], n.next(o);
    }, Rc)), function() {
      r = null;
    };
  });
}
function PE(e, t) {
  return t === void 0 && (t = js), Zn(function(n, r) {
    var o = null, i = null, a = null, s = function() {
      if (o) {
        o.unsubscribe(), o = null;
        var c = i;
        i = null, r.next(c);
      }
    };
    function l() {
      var c = a + e, u = t.now();
      if (u < c) {
        o = this.schedule(void 0, c - u), r.add(o);
        return;
      }
      s();
    }
    n.subscribe(En(r, function(c) {
      i = c, a = t.now(), o || (o = t.schedule(l, e), r.add(o));
    }, function() {
      s(), r.complete();
    }, void 0, function() {
      i = o = null;
    }));
  });
}
function Dp(e) {
  return e <= 0 ? function() {
    return Du;
  } : Zn(function(t, n) {
    var r = 0;
    t.subscribe(En(n, function(o) {
      ++r <= e && (n.next(o), e <= r && n.complete());
    }));
  });
}
function IE(e) {
  return rr(function() {
    return e;
  });
}
function TE(e, t) {
  return Bs(function(n, r) {
    return Qn(e(n, r)).pipe(Dp(1), IE(n));
  });
}
function $E(e, t) {
  t === void 0 && (t = js);
  var n = xE(e, t);
  return TE(function() {
    return n;
  });
}
function RE() {
  return Zn(function(e, t) {
    var n, r = !1;
    e.subscribe(En(t, function(o) {
      var i = n;
      n = o, r && t.next([i, o]), r = !0;
    }));
  });
}
function NE(e, t) {
  return Zn(function(n, r) {
    var o = null, i = 0, a = !1, s = function() {
      return a && !o && r.complete();
    };
    n.subscribe(En(r, function(l) {
      o == null || o.unsubscribe();
      var c = 0, u = i++;
      Qn(e(l, u)).subscribe(o = En(r, function(d) {
        return r.next(t ? t(l, d, u, c++) : d);
      }, function() {
        o = null, s();
      }));
    }, function() {
      a = !0, s();
    }));
  });
}
var ar, ju;
function AE(e, t) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    throw new Error("Can't generate CSS selector for non-element node type.");
  if (e.tagName.toLowerCase() === "html")
    return "html";
  var n = {
    root: document.body,
    idName: function(i) {
      return !0;
    },
    className: function(i) {
      return !0;
    },
    tagName: function(i) {
      return !0;
    },
    attr: function(i, a) {
      return !1;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4
  };
  ar = Se(Se({}, n), t), ju = kE(ar.root, n);
  var r = ba(e, "all", function() {
    return ba(e, "two", function() {
      return ba(e, "one", function() {
        return ba(e, "none");
      });
    });
  });
  if (r) {
    var o = Bp(Vp(r, e));
    return o.length > 0 && (r = o[0]), Vs(r);
  } else
    throw new Error("Selector was not found.");
}
function kE(e, t) {
  return e.nodeType === Node.DOCUMENT_NODE ? e : e === t.root ? e.ownerDocument : e;
}
function ba(e, t, n) {
  for (var r = null, o = [], i = e, a = 0, s = function() {
    var c, u, d = wa(ME(i)) || wa.apply(void 0, rn([], pt(LE(i)), !1)) || wa.apply(void 0, rn([], pt(DE(i)), !1)) || wa(FE(i)) || [ff()], f = jE(i);
    if (t == "all")
      f && (d = d.concat(d.filter(Tl).map(function(C) {
        return Ca(C, f);
      })));
    else if (t == "two")
      d = d.slice(0, 1), f && (d = d.concat(d.filter(Tl).map(function(C) {
        return Ca(C, f);
      })));
    else if (t == "one") {
      var g = pt(d = d.slice(0, 1), 1), h = g[0];
      f && Tl(h) && (d = [Ca(h, f)]);
    } else
      t == "none" && (d = [ff()], f && (d = [Ca(d[0], f)]));
    try {
      for (var y = (c = void 0, Ut(d)), p = y.next(); !p.done; p = y.next()) {
        var h = p.value;
        h.level = a;
      }
    } catch (C) {
      c = { error: C };
    } finally {
      try {
        p && !p.done && (u = y.return) && u.call(y);
      } finally {
        if (c)
          throw c.error;
      }
    }
    if (o.push(d), o.length >= ar.seedMinLength && (r = uf(o, n), r))
      return "break";
    i = i.parentElement, a++;
  }; i; ) {
    var l = s();
    if (l === "break")
      break;
  }
  return r || (r = uf(o, n)), !r && n ? n() : r;
}
function uf(e, t) {
  var n, r, o = e.reduce(function(c, u) {
    return c * u.length;
  }, 1);
  if (o > ar.threshold)
    return t ? t() : null;
  var i = Bp(jp(e));
  try {
    for (var a = Ut(i), s = a.next(); !s.done; s = a.next()) {
      var l = s.value;
      if (Fp(l))
        return l;
    }
  } catch (c) {
    n = { error: c };
  } finally {
    try {
      s && !s.done && (r = a.return) && r.call(a);
    } finally {
      if (n)
        throw n.error;
    }
  }
  return null;
}
function Vs(e) {
  for (var t = e[0], n = t.name, r = 1; r < e.length; r++) {
    var o = e[r].level || 0;
    t.level === o - 1 ? n = "".concat(e[r].name, " > ").concat(n) : n = "".concat(e[r].name, " ").concat(n), t = e[r];
  }
  return n;
}
function df(e) {
  return e.map(function(t) {
    return t.penalty;
  }).reduce(function(t, n) {
    return t + n;
  }, 0);
}
function Fp(e) {
  var t = Vs(e);
  switch (ju.querySelectorAll(t).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(t));
    case 1:
      return !0;
    default:
      return !1;
  }
}
function ME(e) {
  var t = e.getAttribute("id");
  return t && ar.idName(t) ? {
    name: "#" + CSS.escape(t),
    penalty: 0
  } : null;
}
function LE(e) {
  var t = Array.from(e.attributes).filter(function(n) {
    return ar.attr(n.name, n.value);
  });
  return t.map(function(n) {
    return {
      name: "[".concat(CSS.escape(n.name), '="').concat(CSS.escape(n.value), '"]'),
      penalty: 0.5
    };
  });
}
function DE(e) {
  var t = Array.from(e.classList).filter(ar.className);
  return t.map(function(n) {
    return {
      name: "." + CSS.escape(n),
      penalty: 1
    };
  });
}
function FE(e) {
  var t = e.tagName.toLowerCase();
  return ar.tagName(t) ? {
    name: t,
    penalty: 2
  } : null;
}
function ff() {
  return {
    name: "*",
    penalty: 3
  };
}
function jE(e) {
  var t = e.parentNode;
  if (!t)
    return null;
  var n = t.firstChild;
  if (!n)
    return null;
  for (var r = 0; n && (n.nodeType === Node.ELEMENT_NODE && r++, n !== e); )
    n = n.nextSibling;
  return r;
}
function Ca(e, t) {
  return {
    name: e.name + ":nth-child(".concat(t, ")"),
    penalty: e.penalty + 1
  };
}
function Tl(e) {
  return e.name !== "html" && !e.name.startsWith("#");
}
function wa() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = e.filter(BE);
  return n.length > 0 ? n : null;
}
function BE(e) {
  return e != null;
}
function jp(e, t) {
  var n, r, o, i, a, s;
  return t === void 0 && (t = []), de(this, function(l) {
    switch (l.label) {
      case 0:
        if (!(e.length > 0))
          return [3, 9];
        l.label = 1;
      case 1:
        l.trys.push([1, 6, 7, 8]), n = Ut(e[0]), r = n.next(), l.label = 2;
      case 2:
        return r.done ? [3, 5] : (o = r.value, [5, Ut(jp(e.slice(1, e.length), t.concat(o)))]);
      case 3:
        l.sent(), l.label = 4;
      case 4:
        return r = n.next(), [3, 2];
      case 5:
        return [3, 8];
      case 6:
        return i = l.sent(), a = { error: i }, [3, 8];
      case 7:
        try {
          r && !r.done && (s = n.return) && s.call(n);
        } finally {
          if (a)
            throw a.error;
        }
        return [
          7
          /*endfinally*/
        ];
      case 8:
        return [3, 11];
      case 9:
        return [4, t];
      case 10:
        l.sent(), l.label = 11;
      case 11:
        return [
          2
          /*return*/
        ];
    }
  });
}
function Bp(e) {
  return rn([], pt(e), !1).sort(function(t, n) {
    return df(t) - df(n);
  });
}
function Vp(e, t, n) {
  var r, o, i;
  return n === void 0 && (n = {
    counter: 0,
    visited: /* @__PURE__ */ new Map()
  }), de(this, function(a) {
    switch (a.label) {
      case 0:
        if (!(e.length > 2 && e.length > ar.optimizedMinLength))
          return [3, 5];
        r = 1, a.label = 1;
      case 1:
        return r < e.length - 1 ? n.counter > ar.maxNumberOfTries ? [
          2
          /*return*/
        ] : (n.counter += 1, o = rn([], pt(e), !1), o.splice(r, 1), i = Vs(o), n.visited.has(i) ? [
          2
          /*return*/
        ] : Fp(o) && VE(o, t) ? [4, o] : [3, 4]) : [3, 5];
      case 2:
        return a.sent(), n.visited.set(i, !0), [5, Ut(Vp(o, t, n))];
      case 3:
        a.sent(), a.label = 4;
      case 4:
        return r++, [3, 1];
      case 5:
        return [
          2
          /*return*/
        ];
    }
  });
}
function VE(e, t) {
  return ju.querySelector(Vs(e)) === t;
}
var zE = ["input", "select", "textarea"], $l = function(e, t) {
  return function(n, r) {
    var o, i, a, s = e.pageUrlAllowlist, l = e.shouldTrackEventResolver, c = (i = (o = r == null ? void 0 : r.tagName) === null || o === void 0 ? void 0 : o.toLowerCase) === null || i === void 0 ? void 0 : i.call(o);
    if (!c)
      return !1;
    if (l)
      return l(n, r);
    if (!UE(window.location.href, s))
      return !1;
    var u = String(r == null ? void 0 : r.getAttribute("type")) || "";
    if (typeof u == "string")
      switch (u.toLowerCase()) {
        case "hidden":
          return !1;
        case "password":
          return !1;
      }
    if (t) {
      var d = t.some(function(g) {
        var h;
        return !!(!((h = r == null ? void 0 : r.matches) === null || h === void 0) && h.call(r, g));
      });
      if (!d)
        return !1;
    }
    switch (c) {
      case "input":
      case "select":
      case "textarea":
        return n === "change" || n === "click";
      default: {
        var f = (a = window == null ? void 0 : window.getComputedStyle) === null || a === void 0 ? void 0 : a.call(window, r);
        return f && f.getPropertyValue("cursor") === "pointer" && n === "click" ? !0 : n === "click";
      }
    }
  };
}, zp = function(e) {
  if (e == null)
    return !1;
  if (typeof e == "string") {
    var t = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    if (t.test((e || "").replace(/[- ]/g, "")))
      return !1;
    var n = /(^\d{3}-?\d{2}-?\d{4}$)/;
    if (n.test(e))
      return !1;
  }
  return !0;
}, HE = function(e) {
  return !!e && e.nodeType === 3;
}, Hp = function(e) {
  var t, n, r, o = (n = (t = e == null ? void 0 : e.tagName) === null || t === void 0 ? void 0 : t.toLowerCase) === null || n === void 0 ? void 0 : n.call(t), i = e instanceof HTMLElement ? ((r = e.getAttribute("contenteditable")) === null || r === void 0 ? void 0 : r.toLowerCase()) === "true" : !1;
  return !zE.includes(o) && !i;
}, Bu = function(e) {
  var t = "";
  return Hp(e) && e.childNodes && e.childNodes.length && e.childNodes.forEach(function(n) {
    var r = "";
    HE(n) ? n.textContent && (r = n.textContent) : r = Bu(n), t += r.split(/(\s+)/).filter(zp).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
  }), t;
}, Up = function(e, t) {
  var n, r, o = "";
  try {
    return o = AE(e, {
      className: function(u) {
        return u !== Tc;
      },
      maxNumberOfTries: 1e3
    }), o;
  } catch (u) {
    if (t) {
      var i = u;
      t.warn("Failed to get selector with finder, use fallback strategy instead: ".concat(i.toString()));
    }
  }
  var a = (r = (n = e == null ? void 0 : e.tagName) === null || n === void 0 ? void 0 : n.toLowerCase) === null || r === void 0 ? void 0 : r.call(n);
  a && (o = a);
  var s = e.getAttribute("id"), l = e.getAttribute("class");
  if (s)
    o = "#".concat(s);
  else if (l) {
    var c = l.split(" ").filter(function(u) {
      return u !== Tc;
    }).join(".");
    c && (o = "".concat(o, ".").concat(c));
  }
  return o;
}, UE = function(e, t) {
  return !t || !t.length ? !0 : t.some(function(n) {
    return typeof n == "string" ? e === n : e.match(n);
  });
}, WE = function(e, t) {
  return e.getAttributeNames().reduce(function(n, r) {
    if (r.startsWith(t)) {
      var o = r.replace(t, ""), i = e.getAttribute(r);
      o && (n[o] = i || "");
    }
    return n;
  }, {});
}, qE = function(e) {
  return e == null || typeof e == "object" && Object.keys(e).length === 0 || typeof e == "string" && e.trim().length === 0;
}, Wp = function(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    return qE(r) || (t[n] = r), t;
  }, {});
}, qp = function(e) {
  var t = e.parentElement;
  if (!t)
    return "";
  var n;
  try {
    n = t.querySelector(":scope>span,h1,h2,h3,h4,h5,h6");
  } catch {
    n = null;
  }
  if (n) {
    var r = n.textContent || "";
    return zp(r) ? r : "";
  }
  return qp(t);
}, Vu = function(e, t) {
  return e ? t.some(function(n) {
    var r;
    return (r = e == null ? void 0 : e.matches) === null || r === void 0 ? void 0 : r.call(e, n);
  }) ? e : Vu(e == null ? void 0 : e.parentElement, t) : null;
}, GE = function(e, t) {
  var n, r, o;
  if (!e)
    return {};
  var i = (o = (r = e == null ? void 0 : e.tagName) === null || r === void 0 ? void 0 : r.toLowerCase) === null || o === void 0 ? void 0 : o.call(r), a = Up(e, t), s = (n = {}, n[dp] = i, n[fp] = Bu(e), n[vp] = a, n[gp] = window.location.href.split("?")[0], n);
  return Wp(s);
}, KE = function(e) {
  return new Promise(function(t, n) {
    var r;
    try {
      var o = document.createElement("script");
      o.type = "text/javascript", o.async = !0, o.src = e, o.addEventListener("load", function() {
        t({ status: !0 });
      }, { once: !0 }), o.addEventListener("error", function() {
        n({
          status: !1,
          message: "Failed to load the script ".concat(e)
        });
      }), (r = document.head) === null || r === void 0 || r.appendChild(o);
    } catch (i) {
      n(i);
    }
  });
};
function XE() {
  return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var zu = function(e) {
  return !(e.event.target === null || !e.closestTrackedAncestor);
}, YE = (
  /** @class */
  function() {
    function e(t) {
      var n = t === void 0 ? {} : t, r = n.origin, o = r === void 0 ? Ba : r, i = this;
      this.endpoint = Ba, this.requestCallbacks = {}, this.onSelect = function(a) {
        i.notify({ action: "element-selected", data: a });
      }, this.onTrack = function(a, s) {
        a === "selector-mode-changed" ? i.notify({ action: "track-selector-mode-changed", data: s }) : a === "selector-moved" && i.notify({ action: "track-selector-moved", data: s });
      }, this.endpoint = o;
    }
    return e.prototype.notify = function(t) {
      var n, r, o, i;
      (r = (n = this.logger) === null || n === void 0 ? void 0 : n.debug) === null || r === void 0 || r.call(n, "Message sent: ", JSON.stringify(t)), (i = (o = window.opener) === null || o === void 0 ? void 0 : o.postMessage) === null || i === void 0 || i.call(o, t, this.endpoint);
    }, e.prototype.sendRequest = function(t, n, r) {
      var o = this;
      r === void 0 && (r = { timeout: 15e3 });
      var i = XE(), a = {
        id: i,
        action: t,
        args: n
      }, s = new Promise(function(l, c) {
        o.requestCallbacks[i] = { resolve: l, reject: c }, o.notify(a), (r == null ? void 0 : r.timeout) > 0 && setTimeout(function() {
          c(new Error("".concat(t, " timed out (id: ").concat(i, ")"))), delete o.requestCallbacks[i];
        }, r.timeout);
      });
      return s;
    }, e.prototype.handleResponse = function(t) {
      var n;
      if (!this.requestCallbacks[t.id]) {
        (n = this.logger) === null || n === void 0 || n.warn("No callback found for request id: ".concat(t.id));
        return;
      }
      this.requestCallbacks[t.id].resolve(t.responseData), delete this.requestCallbacks[t.id];
    }, e.prototype.setup = function(t) {
      var n = this, r = t === void 0 ? {} : t, o = r.logger, i = r.endpoint, a = r.isElementSelectable, s = r.cssSelectorAllowlist, l = r.actionClickAllowlist;
      this.logger = o, i && this.endpoint === Ba && (this.endpoint = i);
      var c = null;
      window.addEventListener("message", function(u) {
        var d, f, g, h, y;
        if ((f = (d = n.logger) === null || d === void 0 ? void 0 : d.debug) === null || f === void 0 || f.call(d, "Message received: ", JSON.stringify(u)), n.endpoint === u.origin) {
          var p = u == null ? void 0 : u.data, C = p == null ? void 0 : p.action;
          if (C)
            if ("id" in p)
              (h = (g = n.logger) === null || g === void 0 ? void 0 : g.debug) === null || h === void 0 || h.call(g, "Received Response to previous request: ", JSON.stringify(u)), n.handleResponse(p);
            else if (C === "ping")
              n.notify({ action: "pong" });
            else if (C === "initialize-visual-tagging-selector") {
              var m = p == null ? void 0 : p.data;
              KE(AS).then(function() {
                var b;
                c = (b = window == null ? void 0 : window.amplitudeVisualTaggingSelector) === null || b === void 0 ? void 0 : b.call(window, {
                  getEventTagProps: GE,
                  isElementSelectable: function(w) {
                    return a ? a((m == null ? void 0 : m.actionType) || "click", w) : !0;
                  },
                  onTrack: n.onTrack,
                  onSelect: n.onSelect,
                  visualHighlightClass: Tc,
                  messenger: n,
                  cssSelectorAllowlist: s,
                  actionClickAllowlist: l
                }), n.notify({ action: "selector-loaded" });
              }).catch(function() {
                var b;
                (b = n.logger) === null || b === void 0 || b.warn("Failed to initialize visual tagging selector");
              });
            } else
              C === "close-visual-tagging-selector" && ((y = c == null ? void 0 : c.close) === null || y === void 0 || y.call(c));
        }
      }), this.notify({ action: "page-loaded" });
    }, e;
  }()
), ZE = [
  // Already captured elsewhere in the hierarchy object
  "id",
  "class",
  // non-useful and potentially large attribute
  "style",
  // sensitive as prefilled form data may populate this attribute
  "value",
  // DOM events
  "onclick",
  "onchange",
  "oninput",
  "onblur",
  "onsubmit",
  "onfocus",
  "onkeydown",
  "onkeyup",
  "onkeypress",
  // React specific
  "data-reactid",
  "data-react-checksum",
  "data-reactroot"
], QE = ["type"], JE = ["svg", "path", "g"], e1 = ["password", "hidden"], t1 = 128, n1 = 1024;
function r1(e) {
  var t, n, r, o, i, a;
  if (e === null)
    return null;
  var s = String(e.tagName).toLowerCase(), l = {
    tag: s
  }, c = Array.from((o = (r = e.parentElement) === null || r === void 0 ? void 0 : r.children) !== null && o !== void 0 ? o : []);
  c.length && (l.index = c.indexOf(e), l.indexOfType = c.filter(function(w) {
    return w.tagName === e.tagName;
  }).indexOf(e));
  var u = (a = (i = e.previousElementSibling) === null || i === void 0 ? void 0 : i.tagName) === null || a === void 0 ? void 0 : a.toLowerCase();
  u && (l.prevSib = String(u));
  var d = e.getAttribute("id");
  d && (l.id = String(d));
  var f = Array.from(e.classList);
  f.length && (l.classes = f);
  var g = {}, h = Array.from(e.attributes), y = h.filter(function(w) {
    return !ZE.includes(w.name);
  }), p = !Hp(e);
  if (!e1.includes(String(e.getAttribute("type"))) && !JE.includes(s))
    try {
      for (var C = Ut(y), m = C.next(); !m.done; m = C.next()) {
        var b = m.value;
        p && !QE.includes(b.name) || (g[b.name] = String(b.value).substring(0, t1));
      }
    } catch (w) {
      t = { error: w };
    } finally {
      try {
        m && !m.done && (n = C.return) && n.call(C);
      } finally {
        if (t)
          throw t.error;
      }
    }
  return Object.keys(g).length && (l.attrs = g), l;
}
function o1(e) {
  var t = [];
  if (!e)
    return t;
  t.push(e);
  for (var n = e.parentElement; n && n.tagName !== "HTML"; )
    t.push(n), n = n.parentElement;
  return t;
}
var i1 = function(e) {
  var t = [];
  if (!e)
    return [];
  var n = o1(e);
  return t = a1(n.map(function(r) {
    return r1(r);
  }), n1), t;
};
function a1(e, t) {
  for (var n = 0, r = 0; r < e.length; r++) {
    var o = e[r];
    if (o === null)
      n += 4;
    else {
      var i = Va(o);
      n += i ? Array.from(i).length : 4;
    }
    if (n > t)
      return e.slice(0, r);
  }
  return e;
}
function Va(e, t) {
  t === void 0 && (t = !1);
  try {
    if (e == null)
      return t ? "None" : null;
    if (typeof e == "string")
      return t ? (e = e.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r"), e.includes('"') ? "'".concat(e, "'") : e.includes("'") ? '"'.concat(e.replace(/'/g, "\\'"), '"') : "'".concat(e, "'")) : e;
    if (typeof e == "boolean")
      return e ? "True" : "False";
    if (Array.isArray(e)) {
      var n = e.map(function(i) {
        return Va(i, !0);
      });
      return "[".concat(n.join(", "), "]");
    } else if (typeof e == "object") {
      var r = Object.entries(e).filter(function(i) {
        var a = pt(i, 1), s = a[0];
        return s != null;
      }).map(function(i) {
        var a = pt(i, 2), s = a[0], l = a[1];
        return "".concat(String(Va(s, !0)), ": ").concat(String(Va(l, !0)));
      }), o = "{".concat(r.join(", "), "}");
      return o.includes("\\'") && (o = o.replace(/'/g, "'").replace(/'/g, "\\'")), o;
    }
    return e.toString();
  } catch {
    return null;
  }
}
var s1 = 5;
function l1(e) {
  var t = e.amplitude, n = e.allObservables, r = e.options, o = e.shouldTrackEvent, i = n.clickObservable, a = i.pipe(RE(), zr(function(u) {
    var d = pt(u, 2), f = d[0], g = d[1], h = f.event.target !== g.event.target, y = Math.abs(g.event.screenX - f.event.screenX) <= 20 && Math.abs(g.event.screenY - f.event.screenY) <= 20;
    return h && !y;
  })), s = i.pipe(PE(r.debounceTime), rr(function() {
    return "timeout";
  })), l = Lp(a, s), c = i.pipe($E(0), zr(zu), zr(function(u) {
    return o("click", u.closestTrackedAncestor);
  }), OE(l));
  return c.subscribe(function(u) {
    var d, f, g = (u.length >= s1, Ic);
    try {
      for (var h = Ut(u), y = h.next(); !y.done; y = h.next()) {
        var p = y.value;
        t == null || t.track(g, p.targetElementProperties, {
          time: p.timestamp
        });
      }
    } catch (C) {
      d = { error: C };
    } finally {
      try {
        y && !y.done && (f = h.return) && f.call(h);
      } finally {
        if (d)
          throw d.error;
      }
    }
  });
}
function c1(e) {
  var t = e.amplitude, n = e.allObservables, r = e.getEventProperties, o = e.shouldTrackEvent, i = n.changeObservable, a = i.pipe(zr(zu), zr(function(s) {
    return o("change", s.closestTrackedAncestor);
  }));
  return a.subscribe(function(s) {
    t == null || t.track(mS, r("change", s.closestTrackedAncestor));
  });
}
function u1(e) {
  var t = e.amplitude, n = e.allObservables, r = e.options, o = e.getEventProperties, i = e.shouldTrackEvent, a = e.shouldTrackActionClick, s = n.clickObservable, l = n.mutationObservable, c = n.navigateObservable, u = s.pipe(zr(function(h) {
    return !i("click", h.closestTrackedAncestor);
  }), rr(function(h) {
    var y = Vu(h.event.target, r.actionClickAllowlist);
    return h.closestTrackedAncestor = y, h.closestTrackedAncestor !== null && (h.targetElementProperties = o(h.type, h.closestTrackedAncestor)), h;
  }), zr(zu), zr(function(h) {
    return a("click", h.closestTrackedAncestor);
  })), d = [l];
  c && d.push(c);
  var f = Lp.apply(void 0, rn([], pt(d), !1)), g = u.pipe(
    // If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    NE(function(h) {
      return f.pipe(
        Dp(1),
        fE({ first: 500, with: function() {
          return Du;
        } }),
        // in case of timeout, map to empty to prevent any click from being emitted
        rr(function() {
          return h;
        })
      );
    })
  );
  return g.subscribe(function(h) {
    t == null || t.track(Ic, o("click", h.closestTrackedAncestor), {
      time: h.timestamp
    });
  });
}
var Ro;
(function(e) {
  e.ClickObservable = "clickObservable", e.ChangeObservable = "changeObservable", e.NavigateObservable = "navigateObservable", e.MutationObservable = "mutationObservable";
})(Ro || (Ro = {}));
function d1(e) {
  return e.type === "click" || e.type === "change";
}
var f1 = function(e) {
  var t, n, r;
  e === void 0 && (e = {});
  var o = e.dataAttributePrefix, i = o === void 0 ? OC : o, a = e.visualTaggingOptions, s = a === void 0 ? {
    enabled: !0,
    messenger: new YE()
  } : a;
  e.cssSelectorAllowlist = (t = e.cssSelectorAllowlist) !== null && t !== void 0 ? t : xC, e.actionClickAllowlist = (n = e.actionClickAllowlist) !== null && n !== void 0 ? n : PC, e.debounceTime = (r = e.debounceTime) !== null && r !== void 0 ? r : 0;
  var l = hS, c = "enrichment", u = [], d = void 0, f = function() {
    var m, b = Ii(document, "click", { capture: !0 }).pipe(rr(function(_) {
      return h(_, "click");
    })), w = Ii(document, "change", { capture: !0 }).pipe(rr(function(_) {
      return h(_, "change");
    })), E;
    window.navigation && (E = Ii(window.navigation, "navigate").pipe(rr(function(_) {
      return h(_, "navigate");
    })));
    var S = new On(function(_) {
      var O = new MutationObserver(function(P) {
        _.next(P);
      });
      return O.observe(document.body, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
      }), function() {
        return O.disconnect();
      };
    }).pipe(rr(function(_) {
      return h(_, "mutation");
    }));
    return m = {}, m[Ro.ClickObservable] = b, m[Ro.ChangeObservable] = w, // [ObservablesEnum.ErrorObservable]: errorObservable,
    m[Ro.NavigateObservable] = E, m[Ro.MutationObservable] = S, m;
  }, g = function(m, b) {
    var w, E, S, _ = (S = (E = b == null ? void 0 : b.tagName) === null || E === void 0 ? void 0 : E.toLowerCase) === null || S === void 0 ? void 0 : S.call(E), O = typeof b.getBoundingClientRect == "function" ? b.getBoundingClientRect() : { left: null, top: null }, P = b.getAttribute("aria-label"), $ = WE(b, i), L = qp(b), N = Up(b, d), k = (w = {}, w[yS] = b.getAttribute("id") || "", w[bS] = b.getAttribute("class"), w[CS] = i1(b), w[dp] = _, w[fp] = Bu(b), w[SS] = O.left == null ? null : Math.round(O.left), w[ES] = O.top == null ? null : Math.round(O.top), w[_S] = P, w[xS] = $, w[vp] = N, w[OS] = L, w[gp] = window.location.href.split("?")[0], w[PS] = typeof document < "u" && document.title || "", w[IS] = window.innerHeight, w[TS] = window.innerWidth, w);
    return _ === "a" && m === "click" && b instanceof HTMLAnchorElement && (k[wS] = b.href), Wp(k);
  }, h = function(m, b) {
    var w = {
      event: m,
      timestamp: Date.now(),
      type: b
    };
    if (d1(w) && w.event.target !== null) {
      var E = Vu(w.event.target, e.cssSelectorAllowlist);
      return E && (w.closestTrackedAncestor = E, w.targetElementProperties = g(w.type, E)), w;
    }
    return w;
  }, y = function(m, b) {
    return ve(void 0, void 0, void 0, function() {
      var w, E, S, _, O, P, $, L, N, k;
      return de(this, function(F) {
        return d = m.loggerProvider, typeof document > "u" ? [
          2
          /*return*/
        ] : (w = $l(e, e.cssSelectorAllowlist), E = $l(e, e.actionClickAllowlist), S = f(), _ = l1({
          allObservables: S,
          options: e,
          amplitude: b,
          shouldTrackEvent: w
        }), u.push(_), O = c1({
          allObservables: S,
          getEventProperties: g,
          amplitude: b,
          shouldTrackEvent: w
        }), u.push(O), P = u1({
          allObservables: S,
          options: e,
          getEventProperties: g,
          amplitude: b,
          shouldTrackEvent: w,
          shouldTrackActionClick: E
        }), u.push(P), (N = m == null ? void 0 : m.loggerProvider) === null || N === void 0 || N.log("".concat(l, " has been successfully added.")), window.opener && s.enabled && ($ = e.cssSelectorAllowlist, L = e.actionClickAllowlist, (k = s.messenger) === null || k === void 0 || k.setup(Se(Se({ logger: m == null ? void 0 : m.loggerProvider }, (m == null ? void 0 : m.serverZone) && { endpoint: NS[m.serverZone] }), { isElementSelectable: $l(e, rn(rn([], pt($), !1), pt(L), !1)), cssSelectorAllowlist: $, actionClickAllowlist: L }))), [
          2
          /*return*/
        ]);
      });
    });
  }, p = function(m) {
    return ve(void 0, void 0, void 0, function() {
      return de(this, function(b) {
        return [2, m];
      });
    });
  }, C = function() {
    return ve(void 0, void 0, void 0, function() {
      var m, b, w, E, S;
      return de(this, function(_) {
        try {
          for (m = Ut(u), b = m.next(); !b.done; b = m.next())
            w = b.value, w.unsubscribe();
        } catch (O) {
          E = { error: O };
        } finally {
          try {
            b && !b.done && (S = m.return) && S.call(m);
          } finally {
            if (E)
              throw E.error;
          }
        }
        return [
          2
          /*return*/
        ];
      });
    });
  };
  return {
    name: l,
    type: c,
    setup: y,
    execute: p,
    teardown: C
  };
}, v1 = (
  /** @class */
  function(e) {
    xn(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.init = function(n, r, o) {
      n === void 0 && (n = "");
      var i, a;
      return arguments.length > 2 ? (i = r, a = o) : typeof r == "string" ? (i = r, a = void 0) : (i = r == null ? void 0 : r.userId, a = r), vn(this._init(Se(Se({}, a), { userId: i, apiKey: n })));
    }, t.prototype._init = function(n) {
      var r, o, i;
      return ve(this, void 0, void 0, function() {
        var a, s, l, c, u, d, f = this;
        return de(this, function(g) {
          switch (g.label) {
            case 0:
              return this.initializing ? [
                2
                /*return*/
              ] : (this.initializing = !0, [4, Ww(n.apiKey, n, this)]);
            case 1:
              return a = g.sent(), n.fetchRemoteConfig ? [4, pS(a)] : [3, 4];
            case 2:
              return s = g.sent(), [4, s.generateJoinedConfig()];
            case 3:
              a = g.sent(), g.label = 4;
            case 4:
              return [4, e.prototype._init.call(this, a)];
            case 5:
              return g.sent(), this.logBrowserOptions(a), ip(this.config.defaultTracking) ? (l = Ow(this.config), this.webAttribution = new aw(l, this.config), [4, this.webAttribution.init()]) : [3, 7];
            case 6:
              g.sent(), g.label = 7;
            case 7:
              return c = us(), u = Number.isNaN(Number(c.ampSessionId)) ? void 0 : Number(c.ampSessionId), this.setSessionId((i = (o = (r = n.sessionId) !== null && r !== void 0 ? r : u) !== null && o !== void 0 ? o : this.config.sessionId) !== null && i !== void 0 ? i : Date.now()), d = Li(n.instanceName), d.identityStore.setIdentity({
                userId: this.config.userId,
                deviceId: this.config.deviceId
              }), this.config.offline === _C ? [3, 9] : [4, this.add(rS()).promise];
            case 8:
              g.sent(), g.label = 9;
            case 9:
              return [4, this.add(new UC()).promise];
            case 10:
              return g.sent(), [4, this.add(new $w()).promise];
            case 11:
              return g.sent(), [4, this.add(new Cw()).promise];
            case 12:
              return g.sent(), nS(this.config), Sw(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding file download tracking plugin"), [4, this.add(tS()).promise]) : [3, 14];
            case 13:
              g.sent(), g.label = 14;
            case 14:
              return Ew(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding form interaction plugin"), [4, this.add(eS()).promise]) : [3, 16];
            case 15:
              g.sent(), g.label = 16;
            case 16:
              return ap(this.config.defaultTracking) ? (this.config.loggerProvider.debug("Adding page view tracking plugin"), [4, this.add(Yw(xw(this.config))).promise]) : [3, 18];
            case 17:
              g.sent(), g.label = 18;
            case 18:
              return sp(this.config.autocapture) ? (this.config.loggerProvider.debug("Adding user interactions plugin (autocapture plugin)"), [4, this.add(f1(_w(this.config))).promise]) : [3, 20];
            case 19:
              g.sent(), g.label = 20;
            case 20:
              return this.initializing = !1, [4, this.runQueuedFunctions("dispatchQ")];
            case 21:
              return g.sent(), d.eventBridge.setEventReceiver(function(h) {
                f.track(h.eventType, h.eventProperties);
              }), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getUserId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.userId;
    }, t.prototype.setUserId = function(n) {
      if (!this.config) {
        this.q.push(this.setUserId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setUserId: ", n), (n !== this.config.userId || n === void 0) && (this.config.userId = n, yw(n, this.config.instanceName));
    }, t.prototype.getDeviceId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.deviceId;
    }, t.prototype.setDeviceId = function(n) {
      if (!this.config) {
        this.q.push(this.setDeviceId.bind(this, n));
        return;
      }
      this.config.loggerProvider.debug("function setDeviceId: ", n), this.config.deviceId = n, bw(n, this.config.instanceName);
    }, t.prototype.reset = function() {
      this.setDeviceId(ni()), this.setUserId(void 0);
    }, t.prototype.getSessionId = function() {
      var n;
      return (n = this.config) === null || n === void 0 ? void 0 : n.sessionId;
    }, t.prototype.setSessionId = function(n) {
      var r, o = [];
      if (!this.config)
        return this.q.push(this.setSessionId.bind(this, n)), vn(Promise.resolve());
      if (n === this.config.sessionId)
        return vn(Promise.resolve());
      this.config.loggerProvider.debug("function setSessionId: ", n);
      var i = this.getSessionId(), a = this.config.lastEventTime, s = (r = this.config.lastEventId) !== null && r !== void 0 ? r : -1;
      this.config.sessionId = n, this.config.lastEventTime = void 0, this.config.pageCounter = 0, Jd(this.config.defaultTracking) && (i && a && o.push(this.track(nf, void 0, {
        device_id: this.previousSessionDeviceId,
        event_id: ++s,
        session_id: i,
        time: a + 1,
        user_id: this.previousSessionUserId
      }).promise), this.config.lastEventTime = this.config.sessionId);
      var l = this.trackCampaignEventIfNeeded(++s, o);
      return Jd(this.config.defaultTracking) && o.push(this.track(tf, void 0, {
        event_id: l ? ++s : s,
        session_id: this.config.sessionId,
        time: this.config.lastEventTime
      }).promise), this.previousSessionDeviceId = this.config.deviceId, this.previousSessionUserId = this.config.userId, vn(Promise.all(o));
    }, t.prototype.extendSession = function() {
      if (!this.config) {
        this.q.push(this.extendSession.bind(this));
        return;
      }
      this.config.lastEventTime = Date.now();
    }, t.prototype.setTransport = function(n) {
      if (!this.config) {
        this.q.push(this.setTransport.bind(this, n));
        return;
      }
      this.config.transportProvider = up(n);
    }, t.prototype.identify = function(n, r) {
      if (Sl(n)) {
        var o = n._q;
        n._q = [], n = wl(new Mi(), o);
      }
      return r != null && r.user_id && this.setUserId(r.user_id), r != null && r.device_id && this.setDeviceId(r.device_id), e.prototype.identify.call(this, n, r);
    }, t.prototype.groupIdentify = function(n, r, o, i) {
      if (Sl(o)) {
        var a = o._q;
        o._q = [], o = wl(new Mi(), a);
      }
      return e.prototype.groupIdentify.call(this, n, r, o, i);
    }, t.prototype.revenue = function(n, r) {
      if (Sl(n)) {
        var o = n._q;
        n._q = [], n = wl(new jC(), o);
      }
      return e.prototype.revenue.call(this, n, r);
    }, t.prototype.trackCampaignEventIfNeeded = function(n, r) {
      if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign)
        return !1;
      var o = this.webAttribution.generateCampaignEvent(n);
      return r ? r.push(this.track(o).promise) : this.track(o), this.config.loggerProvider.log("Tracking attribution."), !0;
    }, t.prototype.process = function(n) {
      return ve(this, void 0, void 0, function() {
        var r, o, i;
        return de(this, function(a) {
          return r = Date.now(), o = op(this.config.sessionTimeout, this.config.lastEventTime), i = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign(), n.event_type !== tf && n.event_type !== nf && (!n.session_id || n.session_id === this.getSessionId()) && (o || i ? (this.setSessionId(r), i && this.config.loggerProvider.log("Created a new session for new campaign.")) : o || this.trackCampaignEventIfNeeded()), [2, e.prototype.process.call(this, n)];
        });
      });
    }, t.prototype.logBrowserOptions = function(n) {
      try {
        var r = Se(Se({}, n), { apiKey: n.apiKey.substring(0, 10) + "********" });
        this.config.loggerProvider.debug("Initialized Amplitude with BrowserConfig:", JSON.stringify(r));
      } catch (o) {
        this.config.loggerProvider.error("Error logging browser config", o);
      }
    }, t;
  }(FC)
), g1 = function() {
  var e = new v1();
  return {
    init: Bt(e.init.bind(e), "init", Ft(e), jt(e, ["config"])),
    add: Bt(e.add.bind(e), "add", Ft(e), jt(e, ["config.apiKey", "timeline.plugins"])),
    remove: Bt(e.remove.bind(e), "remove", Ft(e), jt(e, ["config.apiKey", "timeline.plugins"])),
    track: Bt(e.track.bind(e), "track", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    logEvent: Bt(e.logEvent.bind(e), "logEvent", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    identify: Bt(e.identify.bind(e), "identify", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    groupIdentify: Bt(e.groupIdentify.bind(e), "groupIdentify", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    setGroup: Bt(e.setGroup.bind(e), "setGroup", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    revenue: Bt(e.revenue.bind(e), "revenue", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    flush: Bt(e.flush.bind(e), "flush", Ft(e), jt(e, ["config.apiKey", "timeline.queue.length"])),
    getUserId: Bt(e.getUserId.bind(e), "getUserId", Ft(e), jt(e, ["config", "config.userId"])),
    setUserId: Bt(e.setUserId.bind(e), "setUserId", Ft(e), jt(e, ["config", "config.userId"])),
    getDeviceId: Bt(e.getDeviceId.bind(e), "getDeviceId", Ft(e), jt(e, ["config", "config.deviceId"])),
    setDeviceId: Bt(e.setDeviceId.bind(e), "setDeviceId", Ft(e), jt(e, ["config", "config.deviceId"])),
    reset: Bt(e.reset.bind(e), "reset", Ft(e), jt(e, ["config", "config.userId", "config.deviceId"])),
    getSessionId: Bt(e.getSessionId.bind(e), "getSessionId", Ft(e), jt(e, ["config"])),
    setSessionId: Bt(e.setSessionId.bind(e), "setSessionId", Ft(e), jt(e, ["config"])),
    extendSession: Bt(e.extendSession.bind(e), "extendSession", Ft(e), jt(e, ["config"])),
    setOptOut: Bt(e.setOptOut.bind(e), "setOptOut", Ft(e), jt(e, ["config"])),
    setTransport: Bt(e.setTransport.bind(e), "setTransport", Ft(e), jt(e, ["config"]))
  };
};
const Ji = g1();
var p1 = Ji.add, h1 = Ji.identify, m1 = Ji.init, y1 = Ji.setUserId, b1 = Ji.track, C1 = function() {
  function e() {
  }
  return e.prototype.getApplicationContext = function() {
    return { versionName: this.versionName, language: w1(), platform: "Web", os: void 0, deviceModel: void 0 };
  }, e;
}(), w1 = function() {
  return typeof navigator < "u" && (navigator.languages && navigator.languages[0] || navigator.language) || "";
}, S1 = function() {
  function e() {
    this.queue = [];
  }
  return e.prototype.logEvent = function(t) {
    this.receiver ? this.receiver(t) : this.queue.length < 512 && this.queue.push(t);
  }, e.prototype.setEventReceiver = function(t) {
    this.receiver = t, this.queue.length > 0 && (this.queue.forEach(function(n) {
      t(n);
    }), this.queue = []);
  }, e;
}(), Fr = function() {
  return Fr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Fr.apply(this, arguments);
};
function za(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return { next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function vf(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return i;
}
var Ha = function(e, t) {
  var n, r, o = ["string", "number", "boolean", "undefined"], i = typeof e, a = typeof t;
  if (i !== a)
    return !1;
  try {
    for (var s = za(o), l = s.next(); !l.done; l = s.next()) {
      var c = l.value;
      if (c === i)
        return e === t;
    }
  } catch (p) {
    n = { error: p };
  } finally {
    try {
      l && !l.done && (r = s.return) && r.call(s);
    } finally {
      if (n)
        throw n.error;
    }
  }
  if (e == null && t == null)
    return !0;
  if (e == null || t == null || e.length !== t.length)
    return !1;
  var u = Array.isArray(e), d = Array.isArray(t);
  if (u !== d)
    return !1;
  if (u && d) {
    for (var f = 0; f < e.length; f++)
      if (!Ha(e[f], t[f]))
        return !1;
  } else {
    var g = Object.keys(e).sort(), h = Object.keys(t).sort();
    if (!Ha(g, h))
      return !1;
    var y = !0;
    return Object.keys(e).forEach(function(p) {
      Ha(e[p], t[p]) || (y = !1);
    }), y;
  }
  return !0;
}, E1 = "$set", _1 = "$unset", x1 = "$clearAll";
Object.entries || (Object.entries = function(e) {
  for (var t = Object.keys(e), n = t.length, r = new Array(n); n--; )
    r[n] = [t[n], e[t[n]]];
  return r;
});
var O1 = function() {
  function e() {
    this.identity = { userProperties: {} }, this.listeners = /* @__PURE__ */ new Set();
  }
  return e.prototype.editIdentity = function() {
    var t = this, n = Fr({}, this.identity.userProperties), r = Fr(Fr({}, this.identity), { userProperties: n });
    return { setUserId: function(o) {
      return r.userId = o, this;
    }, setDeviceId: function(o) {
      return r.deviceId = o, this;
    }, setUserProperties: function(o) {
      return r.userProperties = o, this;
    }, setOptOut: function(o) {
      return r.optOut = o, this;
    }, updateUserProperties: function(o) {
      var i, a, s, l, c, u, d = r.userProperties || {};
      try {
        for (var f = za(Object.entries(o)), g = f.next(); !g.done; g = f.next()) {
          var h = vf(g.value, 2), y = h[0], p = h[1];
          switch (y) {
            case E1:
              try {
                for (var C = (s = void 0, za(Object.entries(p))), m = C.next(); !m.done; m = C.next()) {
                  var b = vf(m.value, 2), w = b[0], E = b[1];
                  d[w] = E;
                }
              } catch (O) {
                s = { error: O };
              } finally {
                try {
                  m && !m.done && (l = C.return) && l.call(C);
                } finally {
                  if (s)
                    throw s.error;
                }
              }
              break;
            case _1:
              try {
                for (var S = (c = void 0, za(Object.keys(p))), _ = S.next(); !_.done; _ = S.next()) {
                  var w = _.value;
                  delete d[w];
                }
              } catch (O) {
                c = { error: O };
              } finally {
                try {
                  _ && !_.done && (u = S.return) && u.call(S);
                } finally {
                  if (c)
                    throw c.error;
                }
              }
              break;
            case x1:
              d = {};
              break;
          }
        }
      } catch (O) {
        i = { error: O };
      } finally {
        try {
          g && !g.done && (a = f.return) && a.call(f);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return r.userProperties = d, this;
    }, commit: function() {
      return t.setIdentity(r), this;
    } };
  }, e.prototype.getIdentity = function() {
    return Fr({}, this.identity);
  }, e.prototype.setIdentity = function(t) {
    var n = Fr({}, this.identity);
    this.identity = Fr({}, t), Ha(n, this.identity) || this.listeners.forEach(function(r) {
      r(t);
    });
  }, e.prototype.addIdentityListener = function(t) {
    this.listeners.add(t);
  }, e.prototype.removeIdentityListener = function(t) {
    this.listeners.delete(t);
  }, e;
}(), hi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : self, P1 = function() {
  function e() {
    this.identityStore = new O1(), this.eventBridge = new S1(), this.applicationContextProvider = new C1();
  }
  return e.getInstance = function(t) {
    return hi.analyticsConnectorInstances || (hi.analyticsConnectorInstances = {}), hi.analyticsConnectorInstances[t] || (hi.analyticsConnectorInstances[t] = new e()), hi.analyticsConnectorInstances[t];
  }, e;
}(), I1 = ["boot"], T1 = "$default_instance";
function $1(e) {
  var t, n, r, o, i, a, s;
  let l = window.engagement, c = { _q: (t = l == null ? void 0 : l._q) != null ? t : [], _configuration: { apiKey: (r = (n = l == null ? void 0 : l._configuration) == null ? void 0 : n.apiKey) != null ? r : "", serverUrl: (o = l == null ? void 0 : l._configuration) == null ? void 0 : o.serverUrl, serverZone: (a = (i = l == null ? void 0 : l._configuration) == null ? void 0 : i.serverZone) != null ? a : "US", options: { ...(s = l == null ? void 0 : l._configuration) == null ? void 0 : s.options } }, _sentry: void 0, init(d, f) {
    var g, h, y;
    if (c._configuration.apiKey) {
      console.log("Engagement SDK has already been initialized. Ignoring additional init call.");
      return;
    }
    c._configuration = { ...c._configuration, ...f, apiKey: d, options: { ...c._configuration.options, ...f == null ? void 0 : f.options } }, (h = (g = c._configuration) == null ? void 0 : g.options) != null && h.logger && c._configuration.options.logger.enable((y = c._configuration.options.logLevel) != null ? y : 2), e();
  }, plugin(d) {
    let f = c.init;
    return { name: "@amplitude/engagement-browser", type: "enrichment", async setup(g, h) {
      var y;
      let p = (y = g.instanceName) != null ? y : T1, C = P1.getInstance(p).identityStore;
      f(g.apiKey, { options: { logLevel: g.logLevel }, ...d, serverZone: g.serverZone }), await window.engagement.boot({ user: () => {
        let m = C.getIdentity();
        return { user_id: h.getUserId(), device_id: h.getDeviceId(), user_properties: m.userProperties, getSessionId: h.getSessionId };
      }, integrations: [{ track: (m) => {
        h.track(m);
      } }] }), C.addIdentityListener((m) => {
        window.engagement._setUserProperties(m.userProperties);
      });
    }, async execute(g) {
      return window.engagement.forwardEvent(g), g;
    } };
  } }, u = c;
  return new Proxy(c, { get: function(d, f) {
    if (f in u)
      return u[f];
    if (f !== "then")
      return f === "gs" ? new Proxy({}, { get: function(g, h) {
        return function() {
          let y = Array.from(arguments), p = `${f}.${h}`;
          y.unshift(p), c._q.push(y);
        };
      } }) : I1.includes(f) ? function() {
        let g = Array.prototype.slice.call(arguments);
        return new Promise((h, y) => {
          g.unshift(f, h, y), c._q.push(g);
        });
      } : function() {
        let g = Array.prototype.slice.call(arguments);
        g.unshift(f), c._q.push(g);
      };
  } });
}
var Gp = () => {
  function e(t) {
    for (let n of t) {
      let r = document.createElement("script");
      r.src = n, r.id = "engagement-sdk-bundle";
      let o = document.querySelector("[nonce]");
      o && r.setAttribute("nonce", o.nonce || o.getAttribute("nonce")), document.getElementsByTagName("head")[0].appendChild(r);
    }
  }
  return $1(() => e(["https://cdn.amplitude.com/engagement-browser/prod/index.min.js.gz"]));
};
window.engagement = Gp();
var Kp = Gp();
window.engagement = Kp;
var { init: _k, plugin: R1 } = Kp;
const N1 = async (e, t = {}) => {
  const n = {};
  for (const r of e) {
    const o = await r();
    Object.assign(n, o);
  }
  return {
    ...n,
    ...t
  };
}, A1 = ({
  clientId: e,
  autocapture: t = !1,
  engagement: n = !1
}) => {
  e && m1(e, {
    autocapture: t
  }), n && p1(R1());
}, k1 = (e) => {
  e && y1(e);
}, M1 = (e) => {
  const t = new Mi();
  for (const [n, r] of Object.entries(e))
    t.set(n, r);
  h1(t);
}, Xp = (...e) => st((n, r) => {
  N1(e, r).then((o) => {
    b1(n, o);
  });
}).current;
function L1() {
  const e = $s();
  At(() => {
    A1({
      clientId: e.getAnalyticsKey(),
      engagement: !0
    }), e.addCallbackAfterSetToken(() => {
      e.getCurrentUser().then((t) => {
        t != null && t.id && k1(t.id), t != null && t.job_title && M1({
          "job title": t.job_title
        });
      });
    });
  }, [e]);
}
function oo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return ee.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(oo(r)) : Kg(r) && r.props ? n = n.concat(oo(r.props.children, t)) : n.push(r));
  }), n;
}
function Di(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function D1(e) {
  return e && Ie(e) === "object" && Di(e.nativeElement) ? e.nativeElement : Di(e) ? e : null;
}
function Ua(e) {
  var t = D1(e);
  if (t)
    return t;
  if (e instanceof ee.Component) {
    var n;
    return (n = _d.findDOMNode) === null || n === void 0 ? void 0 : n.call(_d, e);
  }
  return null;
}
var kc = /* @__PURE__ */ v.createContext(null);
function F1(e) {
  var t = e.children, n = e.onBatchResize, r = v.useRef(0), o = v.useRef([]), i = v.useContext(kc), a = v.useCallback(function(s, l, c) {
    r.current += 1;
    var u = r.current;
    o.current.push({
      size: s,
      element: l,
      data: c
    }), Promise.resolve().then(function() {
      u === r.current && (n == null || n(o.current), o.current = []);
    }), i == null || i(s, l, c);
  }, [n, i]);
  return /* @__PURE__ */ v.createElement(kc.Provider, {
    value: a
  }, t);
}
var Yp = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, t.prototype.set = function(n, r) {
        var o = e(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, o = e(r, n);
        ~o && r.splice(o, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var a = i[o];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), Mc = typeof window < "u" && typeof document < "u" && window.document === document, fs = function() {
  return typeof ir < "u" && ir.Math === Math ? ir : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), j1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(fs) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), B1 = 2;
function V1(e, t) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    j1(i);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - o < B1)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    o = l;
  }
  return s;
}
var z1 = 20, H1 = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], U1 = typeof MutationObserver < "u", W1 = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = V1(this.refresh.bind(this), z1);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !Mc || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), U1 ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !Mc || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, o = H1.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Zp = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(e, o, {
      value: t[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Uo = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || fs;
}, Qp = zs(0, 0, 0, 0);
function vs(e) {
  return parseFloat(e) || 0;
}
function gf(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, o) {
    var i = e["border-" + o + "-width"];
    return r + vs(i);
  }, 0);
}
function q1(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, o = t; r < o.length; r++) {
    var i = o[r], a = e["padding-" + i];
    n[i] = vs(a);
  }
  return n;
}
function G1(e) {
  var t = e.getBBox();
  return zs(0, 0, t.width, t.height);
}
function K1(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return Qp;
  var r = Uo(e).getComputedStyle(e), o = q1(r), i = o.left + o.right, a = o.top + o.bottom, s = vs(r.width), l = vs(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= gf(r, "left", "right") + i), Math.round(l + a) !== n && (l -= gf(r, "top", "bottom") + a)), !Y1(e)) {
    var c = Math.round(s + i) - t, u = Math.round(l + a) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return zs(o.left, o.top, s, l);
}
var X1 = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Uo(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Uo(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function Y1(e) {
  return e === Uo(e).document.documentElement;
}
function Z1(e) {
  return Mc ? X1(e) ? G1(e) : K1(e) : Qp;
}
function Q1(e) {
  var t = e.x, n = e.y, r = e.width, o = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(i.prototype);
  return Zp(a, {
    x: t,
    y: n,
    width: r,
    height: o,
    top: n,
    right: t + r,
    bottom: o + n,
    left: t
  }), a;
}
function zs(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var J1 = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = zs(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = Z1(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), e_ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = Q1(n);
      Zp(this, { target: t, contentRect: r });
    }
    return e;
  }()
), t_ = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new Yp(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Uo(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new J1(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Uo(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new e_(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), Jp = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Yp(), eh = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = W1.getInstance(), r = new t_(t, n, this);
      Jp.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  eh.prototype[e] = function() {
    var t;
    return (t = Jp.get(this))[e].apply(t, arguments);
  };
});
var n_ = function() {
  return typeof fs.ResizeObserver < "u" ? fs.ResizeObserver : eh;
}(), hr = /* @__PURE__ */ new Map();
function th(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = hr.get(r)) === null || n === void 0 || n.forEach(function(o) {
      return o(r);
    });
  });
}
var nh = new n_(th);
z.env.NODE_ENV;
z.env.NODE_ENV;
function r_(e, t) {
  hr.has(e) || (hr.set(e, /* @__PURE__ */ new Set()), nh.observe(e)), hr.get(e).add(t);
}
function o_(e, t) {
  hr.has(e) && (hr.get(e).delete(t), hr.get(e).size || (nh.unobserve(e), hr.delete(e)));
}
function Yt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pf(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ig(r.key), r);
  }
}
function Zt(e, t, n) {
  return t && pf(e.prototype, t), n && pf(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Fi(e, t) {
  return Fi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Fi(e, t);
}
function wr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Fi(e, t);
}
function ji(e) {
  return ji = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ji(e);
}
function Hu() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Hu = function() {
    return !!e;
  })();
}
function Xe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i_(e, t) {
  if (t && (Ie(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Xe(e);
}
function Sr(e) {
  var t = Hu();
  return function() {
    var n, r = ji(e);
    if (t) {
      var o = ji(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return i_(this, n);
  };
}
var a_ = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n() {
    return Yt(this, n), t.apply(this, arguments);
  }
  return Zt(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(v.Component);
function s_(e, t) {
  var n = e.children, r = e.disabled, o = v.useRef(null), i = v.useRef(null), a = v.useContext(kc), s = typeof n == "function", l = s ? n(o) : n, c = v.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ v.isValidElement(l) && Zi(l), d = u ? ks(l) : null, f = Yi(d, o), g = function() {
    var C;
    return Ua(o.current) || // Support `nativeElement` format
    (o.current && Ie(o.current) === "object" ? Ua((C = o.current) === null || C === void 0 ? void 0 : C.nativeElement) : null) || Ua(i.current);
  };
  v.useImperativeHandle(t, function() {
    return g();
  });
  var h = v.useRef(e);
  h.current = e;
  var y = v.useCallback(function(p) {
    var C = h.current, m = C.onResize, b = C.data, w = p.getBoundingClientRect(), E = w.width, S = w.height, _ = p.offsetWidth, O = p.offsetHeight, P = Math.floor(E), $ = Math.floor(S);
    if (c.current.width !== P || c.current.height !== $ || c.current.offsetWidth !== _ || c.current.offsetHeight !== O) {
      var L = {
        width: P,
        height: $,
        offsetWidth: _,
        offsetHeight: O
      };
      c.current = L;
      var N = _ === Math.round(E) ? E : _, k = O === Math.round(S) ? S : O, F = V(V({}, L), {}, {
        offsetWidth: N,
        offsetHeight: k
      });
      a == null || a(F, p, b), m && Promise.resolve().then(function() {
        m(F, p);
      });
    }
  }, []);
  return v.useEffect(function() {
    var p = g();
    return p && !r && r_(p, y), function() {
      return o_(p, y);
    };
  }, [o.current, r]), /* @__PURE__ */ v.createElement(a_, {
    ref: i
  }, u ? /* @__PURE__ */ v.cloneElement(l, {
    ref: f
  }) : l);
}
var rh = /* @__PURE__ */ v.forwardRef(s_);
z.env.NODE_ENV !== "production" && (rh.displayName = "SingleObserver");
var l_ = "rc-observer-key";
function c_(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : oo(n);
  return z.env.NODE_ENV !== "production" && (r.length > 1 ? zo(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && zo(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, i) {
    var a = (o == null ? void 0 : o.key) || "".concat(l_, "-").concat(i);
    return /* @__PURE__ */ v.createElement(rh, Pe({}, e, {
      key: a,
      ref: i === 0 ? t : void 0
    }), o);
  });
}
var uo = /* @__PURE__ */ v.forwardRef(c_);
z.env.NODE_ENV !== "production" && (uo.displayName = "ResizeObserver");
uo.Collection = F1;
function Ur(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function u_(e) {
  if (Array.isArray(e))
    return ic(e);
}
function oh(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function d_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function he(e) {
  return u_(e) || oh(e) || $u(e) || d_();
}
var ih = function(t) {
  return +setTimeout(t, 16);
}, ah = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (ih = function(t) {
  return window.requestAnimationFrame(t);
}, ah = function(t) {
  return window.cancelAnimationFrame(t);
});
var hf = 0, Hs = /* @__PURE__ */ new Map();
function sh(e) {
  Hs.delete(e);
}
var pn = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  hf += 1;
  var r = hf;
  function o(i) {
    if (i === 0)
      sh(r), t();
    else {
      var a = ih(function() {
        o(i - 1);
      });
      Hs.set(r, a);
    }
  }
  return o(n), r;
};
pn.cancel = function(e) {
  var t = Hs.get(e);
  return sh(e), ah(t);
};
z.env.NODE_ENV !== "production" && (pn.ids = function() {
  return Hs;
});
function Bi(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function Vi(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(i, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, l = r.has(i);
    if (gt(!l, "Warning: There may be circular references"), l)
      return !1;
    if (i === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(i);
    var c = s + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(a) || i.length !== a.length)
        return !1;
      for (var u = 0; u < i.length; u++)
        if (!o(i[u], a[u], c))
          return !1;
      return !0;
    }
    if (i && a && Ie(i) === "object" && Ie(a) === "object") {
      var d = Object.keys(i);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return o(i[f], a[f], c);
      });
    }
    return !1;
  }
  return o(e, t);
}
var f_ = "%";
function Lc(e) {
  return e.join(f_);
}
var v_ = /* @__PURE__ */ function() {
  function e(t) {
    Yt(this, e), j(this, "instanceId", void 0), j(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return Zt(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(Lc(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(Lc(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var o = this.cache.get(n), i = r(o);
      i === null ? this.cache.delete(n) : this.cache.set(n, i);
    }
  }]), e;
}(), Wo = "data-token-hash", Wn = "data-css-hash", g_ = "data-cache-path", jr = "__cssinjs_instance__";
function p_() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(Wn, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(o) {
      o[jr] = o[jr] || e, o[jr] === e && document.head.insertBefore(o, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(Wn, "]"))).forEach(function(o) {
      var i = o.getAttribute(Wn);
      if (r[i]) {
        if (o[jr] === e) {
          var a;
          (a = o.parentNode) === null || a === void 0 || a.removeChild(o);
        }
      } else
        r[i] = !0;
    });
  }
  return new v_(e);
}
var Us = /* @__PURE__ */ v.createContext({
  hashPriority: "low",
  cache: p_(),
  defaultCache: !0
});
function h_(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var Uu = /* @__PURE__ */ function() {
  function e() {
    Yt(this, e), j(this, "cache", void 0), j(this, "keys", void 0), j(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return Zt(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, o, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var l;
          a = (l = a) === null || l === void 0 || (l = l.map) === null || l === void 0 ? void 0 : l.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && i && (a.value[1] = this.cacheCallTimes++), (o = a) === null || o === void 0 ? void 0 : o.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var i = this.keys.reduce(function(c, u) {
            var d = Q(c, 2), f = d[1];
            return o.internalGet(u)[1] < f ? [u, o.internalGet(u)[1]] : c;
          }, [this.keys[0], this.cacheCallTimes]), a = Q(i, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var l = this.cache;
      n.forEach(function(c, u) {
        if (u === n.length - 1)
          l.set(c, {
            value: [r, o.cacheCallTimes++]
          });
        else {
          var d = l.get(c);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : l.set(c, {
            map: /* @__PURE__ */ new Map()
          }), l = l.get(c).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var o = n.get(r[0]);
      if (r.length === 1) {
        var i;
        return o.map ? n.set(r[0], {
          map: o.map
        }) : n.delete(r[0]), (i = o.value) === null || i === void 0 ? void 0 : i[0];
      }
      var a = this.deleteByPath(o.map, r.slice(1));
      return (!o.map || o.map.size === 0) && !o.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !h_(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
j(Uu, "MAX_CACHE_SIZE", 20);
j(Uu, "MAX_CACHE_OFFSET", 5);
var mf = 0, lh = /* @__PURE__ */ function() {
  function e(t) {
    Yt(this, e), j(this, "derivatives", void 0), j(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = mf, t.length === 0 && zo(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), mf += 1;
  }
  return Zt(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, o) {
        return o(n, r);
      }, void 0);
    }
  }]), e;
}(), Rl = new Uu();
function Dc(e) {
  var t = Array.isArray(e) ? e : [e];
  return Rl.has(t) || Rl.set(t, new lh(t)), Rl.get(t);
}
var m_ = /* @__PURE__ */ new WeakMap(), Nl = {};
function y_(e, t) {
  for (var n = m_, r = 0; r < t.length; r += 1) {
    var o = t[r];
    n.has(o) || n.set(o, /* @__PURE__ */ new WeakMap()), n = n.get(o);
  }
  return n.has(Nl) || n.set(Nl, e()), n.get(Nl);
}
var yf = /* @__PURE__ */ new WeakMap();
function Ti(e) {
  var t = yf.get(e) || "";
  return t || (Object.keys(e).forEach(function(n) {
    var r = e[n];
    t += n, r instanceof lh ? t += r.id : r && Ie(r) === "object" ? t += Ti(r) : t += r;
  }), t = Bi(t), yf.set(e, t)), t;
}
function bf(e, t) {
  return Bi("".concat(t, "_").concat(Ti(e)));
}
var Fc = gn();
function ke(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function gs(e, t, n) {
  var r, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var a = V(V({}, o), {}, (r = {}, j(r, Wo, t), j(r, Wn, n), r)), s = Object.keys(a).map(function(l) {
    var c = a[l];
    return c ? "".concat(l, '="').concat(c, '"') : null;
  }).filter(function(l) {
    return l;
  }).join(" ");
  return "<style ".concat(s, ">").concat(e, "</style>");
}
var Wa = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, b_ = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(o) {
    var i = Q(o, 2), a = i[0], s = i[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, ch = function(t, n, r) {
  var o = {}, i = {};
  return Object.entries(t).forEach(function(a) {
    var s, l, c = Q(a, 2), u = c[0], d = c[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[u])
      i[u] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(r != null && (l = r.ignore) !== null && l !== void 0 && l[u])) {
      var f, g = Wa(u, r == null ? void 0 : r.prefix);
      o[g] = typeof d == "number" && !(r != null && (f = r.unitless) !== null && f !== void 0 && f[u]) ? "".concat(d, "px") : String(d), i[u] = "var(".concat(g, ")");
    }
  }), [i, b_(o, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, Cf = z.env.NODE_ENV !== "test" && gn() ? v.useLayoutEffect : v.useEffect, nn = function(t, n) {
  var r = v.useRef(!0);
  Cf(function() {
    return t(r.current);
  }, n), Cf(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, wf = function(t, n) {
  nn(function(r) {
    if (!r)
      return t();
  }, n);
}, C_ = V({}, v), Sf = C_.useInsertionEffect, w_ = function(t, n, r) {
  v.useMemo(t, r), nn(function() {
    return n(!0);
  }, r);
}, S_ = Sf ? function(e, t, n) {
  return Sf(function() {
    return e(), t();
  }, n);
} : w_, E_ = V({}, v), __ = E_.useInsertionEffect, x_ = function(t) {
  var n = [], r = !1;
  function o(i) {
    if (r) {
      z.env.NODE_ENV !== "production" && zo(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(i);
  }
  return v.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(i) {
        return i();
      });
    };
  }, t), o;
}, O_ = function() {
  return function(t) {
    t();
  };
}, P_ = typeof __ < "u" ? x_ : O_;
function I_() {
  return !1;
}
var jc = !1;
function T_() {
  return jc;
}
const $_ = z.env.NODE_ENV === "production" ? I_ : T_;
if (z.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var Sa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : null;
  if (Sa && typeof Sa.webpackHotUpdate == "function") {
    var R_ = Sa.webpackHotUpdate;
    Sa.webpackHotUpdate = function() {
      return jc = !0, setTimeout(function() {
        jc = !1;
      }, 0), R_.apply(void 0, arguments);
    };
  }
}
function Wu(e, t, n, r, o) {
  var i = v.useContext(Us), a = i.cache, s = [e].concat(he(t)), l = Lc(s), c = P_([l]), u = $_(), d = function(y) {
    a.opUpdate(l, function(p) {
      var C = p || [void 0, void 0], m = Q(C, 2), b = m[0], w = b === void 0 ? 0 : b, E = m[1], S = E;
      z.env.NODE_ENV !== "production" && E && u && (r == null || r(S, u), S = null);
      var _ = S || n(), O = [w, _];
      return y ? y(O) : O;
    });
  };
  v.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [l]
    /* eslint-enable */
  );
  var f = a.opGet(l);
  z.env.NODE_ENV !== "production" && !f && (d(), f = a.opGet(l));
  var g = f[1];
  return S_(function() {
    o == null || o(g);
  }, function(h) {
    return d(function(y) {
      var p = Q(y, 2), C = p[0], m = p[1];
      return h && C === 0 && (o == null || o(g)), [C + 1, m];
    }), function() {
      a.opUpdate(l, function(y) {
        var p = y || [], C = Q(p, 2), m = C[0], b = m === void 0 ? 0 : m, w = C[1], E = b - 1;
        return E === 0 ? (c(function() {
          (h || !a.opGet(l)) && (r == null || r(w, !1));
        }), null) : [b - 1, w];
      });
    };
  }, [l]), g;
}
var N_ = {}, A_ = z.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", Xr = /* @__PURE__ */ new Map();
function k_(e) {
  Xr.set(e, (Xr.get(e) || 0) + 1);
}
function M_(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(Wo, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[jr] === t) {
        var o;
        (o = r.parentNode) === null || o === void 0 || o.removeChild(r);
      }
    });
  }
}
var L_ = 0;
function D_(e, t) {
  Xr.set(e, (Xr.get(e) || 0) - 1);
  var n = Array.from(Xr.keys()), r = n.filter(function(o) {
    var i = Xr.get(o) || 0;
    return i <= 0;
  });
  n.length - r.length > L_ && r.forEach(function(o) {
    M_(o, t), Xr.delete(o);
  });
}
var F_ = function(t, n, r, o) {
  var i = r.getDerivativeToken(t), a = V(V({}, i), n);
  return o && (a = o(a)), a;
}, uh = "token";
function j_(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Kt(Us), o = r.cache.instanceId, i = r.container, a = n.salt, s = a === void 0 ? "" : a, l = n.override, c = l === void 0 ? N_ : l, u = n.formatToken, d = n.getComputedToken, f = n.cssVar, g = y_(function() {
    return Object.assign.apply(Object, [{}].concat(he(t)));
  }, t), h = Ti(g), y = Ti(c), p = f ? Ti(f) : "", C = Wu(uh, [s, e.id, h, y, p], function() {
    var m, b = d ? d(g, c, e) : F_(g, c, e, u), w = V({}, b), E = "";
    if (f) {
      var S = ch(b, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), _ = Q(S, 2);
      b = _[0], E = _[1];
    }
    var O = bf(b, s);
    b._tokenKey = O, w._tokenKey = bf(w, s);
    var P = (m = f == null ? void 0 : f.key) !== null && m !== void 0 ? m : O;
    b._themeKey = P, k_(P);
    var $ = "".concat(A_, "-").concat(Bi(O));
    return b._hashId = $, [b, $, w, E, (f == null ? void 0 : f.key) || ""];
  }, function(m) {
    D_(m[0]._themeKey, o);
  }, function(m) {
    var b = Q(m, 4), w = b[0], E = b[3];
    if (f && E) {
      var S = mr(E, Bi("css-variables-".concat(w._themeKey)), {
        mark: Wn,
        prepend: "queue",
        attachTo: i,
        priority: -999
      });
      S[jr] = o, S.setAttribute(Wo, w._themeKey);
    }
  });
  return C;
}
var B_ = function(t, n, r) {
  var o = Q(t, 5), i = o[2], a = o[3], s = o[4], l = r || {}, c = l.plain;
  if (!a)
    return null;
  var u = i._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, g = gs(a, s, u, f, c);
  return [d, u, g];
}, V_ = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, dh = "comm", fh = "rule", vh = "decl", z_ = "@import", H_ = "@keyframes", U_ = "@layer", gh = Math.abs, qu = String.fromCharCode;
function ph(e) {
  return e.trim();
}
function qa(e, t, n) {
  return e.replace(t, n);
}
function W_(e, t, n) {
  return e.indexOf(t, n);
}
function jo(e, t) {
  return e.charCodeAt(t) | 0;
}
function qo(e, t, n) {
  return e.slice(t, n);
}
function tr(e) {
  return e.length;
}
function q_(e) {
  return e.length;
}
function Ea(e, t) {
  return t.push(e), e;
}
var Ws = 1, Go = 1, hh = 0, Dn = 0, Vt = 0, ri = "";
function Gu(e, t, n, r, o, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: Ws, column: Go, length: a, return: "", siblings: s };
}
function G_() {
  return Vt;
}
function K_() {
  return Vt = Dn > 0 ? jo(ri, --Dn) : 0, Go--, Vt === 10 && (Go = 1, Ws--), Vt;
}
function qn() {
  return Vt = Dn < hh ? jo(ri, Dn++) : 0, Go++, Vt === 10 && (Go = 1, Ws++), Vt;
}
function Br() {
  return jo(ri, Dn);
}
function Ga() {
  return Dn;
}
function qs(e, t) {
  return qo(ri, e, t);
}
function zi(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function X_(e) {
  return Ws = Go = 1, hh = tr(ri = e), Dn = 0, [];
}
function Y_(e) {
  return ri = "", e;
}
function Al(e) {
  return ph(qs(Dn - 1, Bc(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Z_(e) {
  for (; (Vt = Br()) && Vt < 33; )
    qn();
  return zi(e) > 2 || zi(Vt) > 3 ? "" : " ";
}
function Q_(e, t) {
  for (; --t && qn() && !(Vt < 48 || Vt > 102 || Vt > 57 && Vt < 65 || Vt > 70 && Vt < 97); )
    ;
  return qs(e, Ga() + (t < 6 && Br() == 32 && qn() == 32));
}
function Bc(e) {
  for (; qn(); )
    switch (Vt) {
      case e:
        return Dn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Bc(Vt);
        break;
      case 40:
        e === 41 && Bc(e);
        break;
      case 92:
        qn();
        break;
    }
  return Dn;
}
function J_(e, t) {
  for (; qn() && e + Vt !== 57; )
    if (e + Vt === 84 && Br() === 47)
      break;
  return "/*" + qs(t, Dn - 1) + "*" + qu(e === 47 ? e : qn());
}
function ex(e) {
  for (; !zi(Br()); )
    qn();
  return qs(e, Dn);
}
function tx(e) {
  return Y_(Ka("", null, null, null, [""], e = X_(e), 0, [0], e));
}
function Ka(e, t, n, r, o, i, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, g = 0, h = 0, y = 1, p = 1, C = 1, m = 0, b = "", w = o, E = i, S = r, _ = b; p; )
    switch (h = m, m = qn()) {
      case 40:
        if (h != 108 && jo(_, d - 1) == 58) {
          W_(_ += qa(Al(m), "&", "&\f"), "&\f", gh(c ? s[c - 1] : 0)) != -1 && (C = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Al(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += Z_(h);
        break;
      case 92:
        _ += Q_(Ga() - 1, 7);
        continue;
      case 47:
        switch (Br()) {
          case 42:
          case 47:
            Ea(nx(J_(qn(), Ga()), t, n, l), l), (zi(h || 1) == 5 || zi(Br() || 1) == 5) && tr(_) && qo(_, -1, void 0) !== " " && (_ += " ");
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * y:
        s[c++] = tr(_) * C;
      case 125 * y:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            p = 0;
          case 59 + u:
            C == -1 && (_ = qa(_, /\f/g, "")), g > 0 && (tr(_) - d || y === 0 && h === 47) && Ea(g > 32 ? _f(_ + ";", r, n, d - 1, l) : _f(qa(_, " ", "") + ";", r, n, d - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (Ea(S = Ef(_, t, n, c, u, o, s, b, w = [], E = [], d, i), i), m === 123)
              if (u === 0)
                Ka(_, t, S, S, w, i, d, s, E);
              else {
                switch (f) {
                  case 99:
                    if (jo(_, 3) === 110)
                      break;
                  case 108:
                    if (jo(_, 2) === 97)
                      break;
                  default:
                    u = 0;
                  case 100:
                  case 109:
                  case 115:
                }
                u ? Ka(e, S, S, r && Ea(Ef(e, S, S, 0, 0, o, s, b, o, w = [], d, E), E), o, E, d, s, r ? w : E) : Ka(_, S, S, S, [""], E, 0, s, E);
              }
        }
        c = u = g = 0, y = C = 1, b = _ = "", d = a;
        break;
      case 58:
        d = 1 + tr(_), g = h;
      default:
        if (y < 1) {
          if (m == 123)
            --y;
          else if (m == 125 && y++ == 0 && K_() == 125)
            continue;
        }
        switch (_ += qu(m), m * y) {
          case 38:
            C = u > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[c++] = (tr(_) - 1) * C, C = 1;
            break;
          case 64:
            Br() === 45 && (_ += Al(qn())), f = Br(), u = d = tr(b = _ += ex(Ga())), m++;
            break;
          case 45:
            h === 45 && tr(_) == 2 && (y = 0);
        }
    }
  return i;
}
function Ef(e, t, n, r, o, i, a, s, l, c, u, d) {
  for (var f = o - 1, g = o === 0 ? i : [""], h = q_(g), y = 0, p = 0, C = 0; y < r; ++y)
    for (var m = 0, b = qo(e, f + 1, f = gh(p = a[y])), w = e; m < h; ++m)
      (w = ph(p > 0 ? g[m] + " " + b : qa(b, /&\f/g, g[m]))) && (l[C++] = w);
  return Gu(e, t, n, o === 0 ? fh : s, l, c, u, d);
}
function nx(e, t, n, r) {
  return Gu(e, t, n, dh, qu(G_()), qo(e, 2, -2), 0, r);
}
function _f(e, t, n, r, o) {
  return Gu(e, t, n, vh, qo(e, 0, r), qo(e, r + 1, -1), r, o);
}
function Vc(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function rx(e, t, n, r) {
  switch (e.type) {
    case U_:
      if (e.children.length)
        break;
    case z_:
    case vh:
      return e.return = e.return || e.value;
    case dh:
      return "";
    case H_:
      return e.return = e.value + "{" + Vc(e.children, r) + "}";
    case fh:
      if (!tr(e.value = e.props.join(",")))
        return "";
  }
  return tr(n = Vc(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function mh(e, t) {
  var n = t.path, r = t.parentSelectors;
  gt(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var ox = function(t, n, r) {
  if (t === "content") {
    var o = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, i = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || i.indexOf(n) === -1 && !o.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && mh("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, ix = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && mh("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
}, xf = "data-ant-cssinjs-cache-path", yh = "_FILE_STYLE__", eo, bh = !0;
function ax() {
  if (!eo && (eo = {}, gn())) {
    var e = document.createElement("div");
    e.className = xf, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(o) {
      var i = o.split(":"), a = Q(i, 2), s = a[0], l = a[1];
      eo[s] = l;
    });
    var n = document.querySelector("style[".concat(xf, "]"));
    if (n) {
      var r;
      bh = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function sx(e) {
  return ax(), !!eo[e];
}
function lx(e) {
  var t = eo[e], n = null;
  if (t && gn())
    if (bh)
      n = yh;
    else {
      var r = document.querySelector("style[".concat(Wn, '="').concat(eo[e], '"]'));
      r ? n = r.innerHTML : delete eo[e];
    }
  return [n, t];
}
var Ch = "_skip_check_", wh = "_multi_value_";
function Xa(e) {
  var t = Vc(tx(e), rx);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function cx(e) {
  return Ie(e) === "object" && e && (Ch in e || wh in e);
}
function Of(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), o = n === "low" ? ":where(".concat(r, ")") : r, i = e.split(",").map(function(a) {
    var s, l = a.trim().split(/\s+/), c = l[0] || "", u = ((s = c.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return c = "".concat(u).concat(o).concat(c.slice(u.length)), [c].concat(he(l.slice(1))).join(" ");
  });
  return i.join(",");
}
var ux = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, o = r.root, i = r.injectHash, a = r.parentSelectors, s = n.hashId, l = n.layer, c = n.path, u = n.hashPriority, d = n.transformers, f = d === void 0 ? [] : d, g = n.linters, h = g === void 0 ? [] : g, y = "", p = {};
  function C(w) {
    var E = w.getName(s);
    if (!p[E]) {
      var S = e(w.style, n, {
        root: !1,
        parentSelectors: a
      }), _ = Q(S, 1), O = _[0];
      p[E] = "@keyframes ".concat(w.getName(s)).concat(O);
    }
  }
  function m(w) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return w.forEach(function(S) {
      Array.isArray(S) ? m(S, E) : S && E.push(S);
    }), E;
  }
  var b = m(Array.isArray(t) ? t : [t]);
  return b.forEach(function(w) {
    var E = typeof w == "string" && !o ? {} : w;
    if (typeof E == "string")
      y += "".concat(E, `
`);
    else if (E._keyframe)
      C(E);
    else {
      var S = f.reduce(function(_, O) {
        var P;
        return (O == null || (P = O.visit) === null || P === void 0 ? void 0 : P.call(O, _)) || _;
      }, E);
      Object.keys(S).forEach(function(_) {
        var O = S[_];
        if (Ie(O) === "object" && O && (_ !== "animationName" || !O._keyframe) && !cx(O)) {
          var P = !1, $ = _.trim(), L = !1;
          (o || i) && s ? $.startsWith("@") ? P = !0 : $ === "&" ? $ = Of("", s, u) : $ = Of(_, s, u) : o && !s && ($ === "&" || $ === "") && ($ = "", L = !0);
          var N = e(O, n, {
            root: L,
            injectHash: P,
            parentSelectors: [].concat(he(a), [$])
          }), k = Q(N, 2), F = k[0], U = k[1];
          p = V(V({}, p), U), y += "".concat($).concat(F);
        } else {
          let D = function(B, M) {
            z.env.NODE_ENV !== "production" && (Ie(O) !== "object" || !(O != null && O[Ch])) && [ox, ix].concat(he(h)).forEach(function(X) {
              return X(B, M, {
                path: c,
                hashId: s,
                parentSelectors: a
              });
            });
            var G = B.replace(/[A-Z]/g, function(X) {
              return "-".concat(X.toLowerCase());
            }), H = M;
            !V_[B] && typeof H == "number" && H !== 0 && (H = "".concat(H, "px")), B === "animationName" && M !== null && M !== void 0 && M._keyframe && (C(M), H = M.getName(s)), y += "".concat(G, ":").concat(H, ";");
          };
          var A, R = (A = O == null ? void 0 : O.value) !== null && A !== void 0 ? A : O;
          Ie(O) === "object" && O !== null && O !== void 0 && O[wh] && Array.isArray(R) ? R.forEach(function(B) {
            D(_, B);
          }) : D(_, R);
        }
      });
    }
  }), o ? l && (y && (y = "@layer ".concat(l.name, " {").concat(y, "}")), l.dependencies && (p["@layer ".concat(l.name)] = l.dependencies.map(function(w) {
    return "@layer ".concat(w, ", ").concat(l.name, ";");
  }).join(`
`))) : y = "{".concat(y, "}"), [y, p];
};
function Sh(e, t) {
  return Bi("".concat(e.join("%")).concat(t));
}
function dx() {
  return null;
}
var Eh = "style";
function zc(e, t) {
  var n = e.token, r = e.path, o = e.hashId, i = e.layer, a = e.nonce, s = e.clientOnly, l = e.order, c = l === void 0 ? 0 : l, u = v.useContext(Us), d = u.autoClear, f = u.mock, g = u.defaultCache, h = u.hashPriority, y = u.container, p = u.ssrInline, C = u.transformers, m = u.linters, b = u.cache, w = u.layer, E = n._tokenKey, S = [E];
  w && S.push("layer"), S.push.apply(S, he(r));
  var _ = Fc;
  z.env.NODE_ENV !== "production" && f !== void 0 && (_ = f === "client");
  var O = Wu(
    Eh,
    S,
    // Create cache if needed
    function() {
      var k = S.join("|");
      if (sx(k)) {
        var F = lx(k), U = Q(F, 2), A = U[0], R = U[1];
        if (A)
          return [A, E, R, {}, s, c];
      }
      var D = t(), B = ux(D, {
        hashId: o,
        hashPriority: h,
        layer: w ? i : void 0,
        path: r.join("-"),
        transformers: C,
        linters: m
      }), M = Q(B, 2), G = M[0], H = M[1], X = Xa(G), K = Sh(S, X);
      return [X, E, K, H, s, c];
    },
    // Remove cache if no need
    function(k, F) {
      var U = Q(k, 3), A = U[2];
      (F || d) && Fc && ki(A, {
        mark: Wn
      });
    },
    // Effect: Inject style here
    function(k) {
      var F = Q(k, 4), U = F[0];
      F[1];
      var A = F[2], R = F[3];
      if (_ && U !== yh) {
        var D = {
          mark: Wn,
          prepend: w ? !1 : "queue",
          attachTo: y,
          priority: c
        }, B = typeof a == "function" ? a() : a;
        B && (D.csp = {
          nonce: B
        });
        var M = [], G = [];
        Object.keys(R).forEach(function(X) {
          X.startsWith("@layer") ? M.push(X) : G.push(X);
        }), M.forEach(function(X) {
          mr(Xa(R[X]), "_layer-".concat(X), V(V({}, D), {}, {
            prepend: !0
          }));
        });
        var H = mr(U, A, D);
        H[jr] = b.instanceId, H.setAttribute(Wo, E), z.env.NODE_ENV !== "production" && H.setAttribute(g_, S.join("|")), G.forEach(function(X) {
          mr(Xa(R[X]), "_effect-".concat(X), D);
        });
      }
    }
  ), P = Q(O, 3), $ = P[0], L = P[1], N = P[2];
  return function(k) {
    var F;
    if (!p || _ || !g)
      F = /* @__PURE__ */ v.createElement(dx, null);
    else {
      var U;
      F = /* @__PURE__ */ v.createElement("style", Pe({}, (U = {}, j(U, Wo, L), j(U, Wn, N), U), {
        dangerouslySetInnerHTML: {
          __html: $
        }
      }));
    }
    return /* @__PURE__ */ v.createElement(v.Fragment, null, F, k);
  };
}
var fx = function(t, n, r) {
  var o = Q(t, 6), i = o[0], a = o[1], s = o[2], l = o[3], c = o[4], u = o[5], d = r || {}, f = d.plain;
  if (c)
    return null;
  var g = i, h = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return g = gs(i, a, s, h, f), l && Object.keys(l).forEach(function(y) {
    if (!n[y]) {
      n[y] = !0;
      var p = Xa(l[y]), C = gs(p, a, "_effect-".concat(y), h, f);
      y.startsWith("@layer") ? g = C + g : g += C;
    }
  }), [u, s, g];
}, _h = "cssVar", vx = function(t, n) {
  var r = t.key, o = t.prefix, i = t.unitless, a = t.ignore, s = t.token, l = t.scope, c = l === void 0 ? "" : l, u = Kt(Us), d = u.cache.instanceId, f = u.container, g = s._tokenKey, h = [].concat(he(t.path), [r, c, g]), y = Wu(_h, h, function() {
    var p = n(), C = ch(p, r, {
      prefix: o,
      unitless: i,
      ignore: a,
      scope: c
    }), m = Q(C, 2), b = m[0], w = m[1], E = Sh(h, w);
    return [b, w, E, r];
  }, function(p) {
    var C = Q(p, 3), m = C[2];
    Fc && ki(m, {
      mark: Wn
    });
  }, function(p) {
    var C = Q(p, 3), m = C[1], b = C[2];
    if (m) {
      var w = mr(m, b, {
        mark: Wn,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      w[jr] = d, w.setAttribute(Wo, r);
    }
  });
  return y;
}, gx = function(t, n, r) {
  var o = Q(t, 4), i = o[1], a = o[2], s = o[3], l = r || {}, c = l.plain;
  if (!i)
    return null;
  var u = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, f = gs(i, s, a, d, c);
  return [u, a, f];
}, mi;
mi = {}, j(mi, Eh, fx), j(mi, uh, B_), j(mi, _h, gx);
var _t = /* @__PURE__ */ function() {
  function e(t, n) {
    Yt(this, e), j(this, "name", void 0), j(this, "style", void 0), j(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return Zt(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function So(e) {
  return e.notSplit = !0, e;
}
So(["borderTop", "borderBottom"]), So(["borderTop"]), So(["borderBottom"]), So(["borderLeft", "borderRight"]), So(["borderLeft"]), So(["borderRight"]);
function px(e) {
  return Og(e) || oh(e) || $u(e) || Pg();
}
function or(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function xh(e, t, n, r) {
  if (!t.length)
    return n;
  var o = px(t), i = o[0], a = o.slice(1), s;
  return !e && typeof i == "number" ? s = [] : Array.isArray(e) ? s = he(e) : s = V({}, e), r && n === void 0 && a.length === 1 ? delete s[i][a[0]] : s[i] = xh(s[i], a, n, r), s;
}
function Vn(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !or(e, t.slice(0, -1)) ? e : xh(e, t, n, r);
}
function hx(e) {
  return Ie(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function Pf(e) {
  return Array.isArray(e) ? [] : {};
}
var mx = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function No() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = Pf(t[0]);
  return t.forEach(function(o) {
    function i(a, s) {
      var l = new Set(s), c = or(o, a), u = Array.isArray(c);
      if (u || hx(c)) {
        if (!l.has(c)) {
          l.add(c);
          var d = or(r, a);
          u ? r = Vn(r, a, []) : (!d || Ie(d) !== "object") && (r = Vn(r, a, Pf(c))), mx(c).forEach(function(f) {
            i([].concat(he(a), [f]), l);
          });
        }
      } else
        r = Vn(r, a, c);
    }
    i([]);
  }), r;
}
function Oh() {
}
let fr = null;
function yx() {
  fr = null, Lg();
}
let fo = Oh;
z.env.NODE_ENV !== "production" && (fo = (e, t, n) => {
  gt(e, `[antd: ${t}] ${n}`), z.env.NODE_ENV === "test" && yx();
});
const Ph = /* @__PURE__ */ v.createContext({}), Pn = z.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = v.useContext(Ph), n = (r, o, i) => {
    if (!r)
      if (t === !1 && o === "deprecated") {
        const a = fr;
        fr || (fr = {}), fr[e] = fr[e] || [], fr[e].includes(i || "") || fr[e].push(i || ""), a || console.warn("[antd] There exists deprecated usage in your code:", fr);
      } else
        z.env.NODE_ENV !== "production" && fo(r, e, i);
  };
  return n.deprecated = (r, o, i, a) => {
    n(r, "deprecated", `\`${o}\` is deprecated. Please use \`${i}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = Oh, e;
}, bx = /* @__PURE__ */ Ts(void 0);
var Cx = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, wx = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, Sx = V(V({}, wx), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const Ih = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, If = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, Sx),
  timePickerLocale: Object.assign({}, Ih)
}, yn = "${label} is not a valid ${type}", Gs = {
  locale: "en",
  Pagination: Cx,
  DatePicker: If,
  TimePicker: Ih,
  Calendar: If,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: yn,
        method: yn,
        array: yn,
        object: yn,
        number: yn,
        date: yn,
        boolean: yn,
        integer: yn,
        float: yn,
        regexp: yn,
        email: yn,
        url: yn,
        hex: yn
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
Object.assign({}, Gs.Modal);
let Ya = [];
const Tf = () => Ya.reduce((e, t) => Object.assign(Object.assign({}, e), t), Gs.Modal);
function Ex(e) {
  if (e) {
    const t = Object.assign({}, e);
    return Ya.push(t), Tf(), () => {
      Ya = Ya.filter((n) => n !== t), Tf();
    };
  }
  Object.assign({}, Gs.Modal);
}
const Th = /* @__PURE__ */ Ts(void 0), $h = "internalMark", Rh = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (z.env.NODE_ENV !== "production") {
    const i = Pn("LocaleProvider");
    z.env.NODE_ENV !== "production" && i(r === $h, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  v.useEffect(() => Ex(t == null ? void 0 : t.Modal), [t]);
  const o = v.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ v.createElement(Th.Provider, {
    value: o
  }, n);
};
z.env.NODE_ENV !== "production" && (Rh.displayName = "LocaleProvider");
const Nh = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, Hi = Object.assign(Object.assign({}, Nh), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
function _x(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: o,
    colorWarning: i,
    colorError: a,
    colorInfo: s,
    colorPrimary: l,
    colorBgBase: c,
    colorTextBase: u
  } = e, d = n(l), f = n(o), g = n(i), h = n(a), y = n(s), p = r(c, u), C = e.colorLink || e.colorInfo, m = n(C), b = new Tt(h[1]).mix(new Tt(h[3]), 50).toHexString();
  return Object.assign(Object.assign({}, p), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: h[1],
    colorErrorBgHover: h[2],
    colorErrorBgFilledHover: b,
    colorErrorBgActive: h[3],
    colorErrorBorder: h[3],
    colorErrorBorderHover: h[4],
    colorErrorHover: h[5],
    colorError: h[6],
    colorErrorActive: h[7],
    colorErrorTextHover: h[8],
    colorErrorText: h[9],
    colorErrorTextActive: h[10],
    colorWarningBg: g[1],
    colorWarningBgHover: g[2],
    colorWarningBorder: g[3],
    colorWarningBorderHover: g[4],
    colorWarningHover: g[4],
    colorWarning: g[6],
    colorWarningActive: g[7],
    colorWarningTextHover: g[8],
    colorWarningText: g[9],
    colorWarningTextActive: g[10],
    colorInfoBg: y[1],
    colorInfoBgHover: y[2],
    colorInfoBorder: y[3],
    colorInfoBorderHover: y[4],
    colorInfoHover: y[4],
    colorInfo: y[6],
    colorInfoActive: y[7],
    colorInfoTextHover: y[8],
    colorInfoText: y[9],
    colorInfoTextActive: y[10],
    colorLinkHover: m[4],
    colorLink: m[6],
    colorLinkActive: m[7],
    colorBgMask: new Tt("#000").setA(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const xx = (e) => {
  let t = e, n = e, r = e, o = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: o
  };
};
function Ox(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, xx(r));
}
const Px = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
function Za(e) {
  return (e + 8) / e;
}
function Ix(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const o = r - 1, i = e * Math.pow(Math.E, o / 5), a = r > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: Za(n)
  }));
}
const Tx = (e) => {
  const t = Ix(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), o = n[1], i = n[0], a = n[2], s = r[1], l = r[0], c = r[2];
  return {
    fontSizeSM: i,
    fontSize: o,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: c,
    lineHeightSM: l,
    fontHeight: Math.round(s * o),
    fontHeightLG: Math.round(c * a),
    fontHeightSM: Math.round(l * i),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
function $x(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const kn = (e, t) => new Tt(e).setA(t).toRgbString(), yi = (e, t) => new Tt(e).darken(t).toHexString(), Rx = (e) => {
  const t = Ai(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, Nx = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: kn(r, 0.88),
    colorTextSecondary: kn(r, 0.65),
    colorTextTertiary: kn(r, 0.45),
    colorTextQuaternary: kn(r, 0.25),
    colorFill: kn(r, 0.15),
    colorFillSecondary: kn(r, 0.06),
    colorFillTertiary: kn(r, 0.04),
    colorFillQuaternary: kn(r, 0.02),
    colorBgSolid: kn(r, 1),
    colorBgSolidHover: kn(r, 0.75),
    colorBgSolidActive: kn(r, 0.95),
    colorBgLayout: yi(n, 4),
    colorBgContainer: yi(n, 0),
    colorBgElevated: yi(n, 0),
    colorBgSpotlight: kn(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: yi(n, 15),
    colorBorderSecondary: yi(n, 6)
  };
};
function Ax(e) {
  yl.pink = yl.magenta, bl.pink = bl.magenta;
  const t = Object.keys(Nh).map((n) => {
    const r = e[n] === yl[n] ? bl[n] : Ai(e[n]);
    return new Array(10).fill(1).reduce((o, i, a) => (o[`${n}-${a + 1}`] = r[a], o[`${n}${a + 1}`] = r[a], o), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), _x(e, {
    generateColorPalettes: Rx,
    generateNeutralColorPalettes: Nx
  })), Tx(e.fontSize)), $x(e)), Px(e)), Ox(e));
}
const Ah = Dc(Ax), Hc = {
  token: Hi,
  override: {
    override: Hi
  },
  hashed: !0
}, kh = /* @__PURE__ */ ee.createContext(Hc), Ui = "ant", Ks = "anticon", kx = (e, t) => t || (e ? `${Ui}-${e}` : Ui), kt = /* @__PURE__ */ v.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: kx,
  iconPrefixCls: Ks
}), Mx = `-ant-${Date.now()}-${Math.random()}`;
function Lx(e, t) {
  const n = {}, r = (a, s) => {
    let l = a.clone();
    return l = (s == null ? void 0 : s(l)) || l, l.toRgbString();
  }, o = (a, s) => {
    const l = new Tt(a), c = Ai(l.toRgbString());
    n[`${s}-color`] = r(l), n[`${s}-color-disabled`] = c[1], n[`${s}-color-hover`] = c[4], n[`${s}-color-active`] = c[6], n[`${s}-color-outline`] = l.clone().setA(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = c[0], n[`${s}-color-deprecated-border`] = c[2];
  };
  if (t.primaryColor) {
    o(t.primaryColor, "primary");
    const a = new Tt(t.primaryColor), s = Ai(a.toRgbString());
    s.forEach((c, u) => {
      n[`primary-${u + 1}`] = c;
    }), n["primary-color-deprecated-l-35"] = r(a, (c) => c.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (c) => c.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (c) => c.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (c) => c.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (c) => c.setA(c.a * 0.12));
    const l = new Tt(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(l, (c) => c.setA(c.a * 0.3)), n["primary-color-active-deprecated-d-02"] = r(l, (c) => c.darken(2));
  }
  return t.successColor && o(t.successColor, "success"), t.warningColor && o(t.warningColor, "warning"), t.errorColor && o(t.errorColor, "error"), t.infoColor && o(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function Dx(e, t) {
  const n = Lx(e, t);
  gn() ? mr(n, `${Mx}-dynamic-theme`) : z.env.NODE_ENV !== "production" && fo(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const ps = /* @__PURE__ */ v.createContext(!1), Fx = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = v.useContext(ps);
  return /* @__PURE__ */ v.createElement(ps.Provider, {
    value: n ?? r
  }, t);
}, Ko = /* @__PURE__ */ v.createContext(void 0), jx = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = v.useContext(Ko);
  return /* @__PURE__ */ v.createElement(Ko.Provider, {
    value: n || r
  }, t);
};
function Bx() {
  const e = Kt(ps), t = Kt(Ko);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var Mh = /* @__PURE__ */ Zt(function e() {
  Yt(this, e);
}), Lh = "CALC_UNIT", Vx = new RegExp(Lh, "g");
function kl(e) {
  return typeof e == "number" ? "".concat(e).concat(Lh) : e;
}
var zx = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n(r, o) {
    var i;
    Yt(this, n), i = t.call(this), j(Xe(i), "result", ""), j(Xe(i), "unitlessCssVar", void 0), j(Xe(i), "lowPriority", void 0);
    var a = Ie(r);
    return i.unitlessCssVar = o, r instanceof n ? i.result = "(".concat(r.result, ")") : a === "number" ? i.result = kl(r) : a === "string" && (i.result = r), i;
  }
  return Zt(n, [{
    key: "add",
    value: function(o) {
      return o instanceof n ? this.result = "".concat(this.result, " + ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " + ").concat(kl(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof n ? this.result = "".concat(this.result, " - ").concat(o.getResult()) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " - ").concat(kl(o))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof n ? this.result = "".concat(this.result, " * ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " * ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(o) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), o instanceof n ? this.result = "".concat(this.result, " / ").concat(o.getResult(!0)) : (typeof o == "number" || typeof o == "string") && (this.result = "".concat(this.result, " / ").concat(o)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(o) {
      return this.lowPriority || o ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(o) {
      var i = this, a = o || {}, s = a.unit, l = !0;
      return typeof s == "boolean" ? l = s : Array.from(this.unitlessCssVar).some(function(c) {
        return i.result.includes(c);
      }) && (l = !1), this.result = this.result.replace(Vx, l ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(Mh), Hx = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n(r) {
    var o;
    return Yt(this, n), o = t.call(this), j(Xe(o), "result", 0), r instanceof n ? o.result = r.result : typeof r == "number" && (o.result = r), o;
  }
  return Zt(n, [{
    key: "add",
    value: function(o) {
      return o instanceof n ? this.result += o.result : typeof o == "number" && (this.result += o), this;
    }
  }, {
    key: "sub",
    value: function(o) {
      return o instanceof n ? this.result -= o.result : typeof o == "number" && (this.result -= o), this;
    }
  }, {
    key: "mul",
    value: function(o) {
      return o instanceof n ? this.result *= o.result : typeof o == "number" && (this.result *= o), this;
    }
  }, {
    key: "div",
    value: function(o) {
      return o instanceof n ? this.result /= o.result : typeof o == "number" && (this.result /= o), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(Mh), Ux = function(t, n) {
  var r = t === "css" ? zx : Hx;
  return function(o) {
    return new r(o, n);
  };
}, $f = function(t, n) {
  return "".concat([n, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function sn(e) {
  var t = v.useRef();
  t.current = e;
  var n = v.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return n;
}
function Wi(e) {
  var t = v.useRef(!1), n = v.useState(e), r = Q(n, 2), o = r[0], i = r[1];
  v.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, l) {
    l && t.current || i(s);
  }
  return [o, a];
}
function Ml(e) {
  return e !== void 0;
}
function to(e, t) {
  var n = t || {}, r = n.defaultValue, o = n.value, i = n.onChange, a = n.postState, s = Wi(function() {
    return Ml(o) ? o : Ml(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), l = Q(s, 2), c = l[0], u = l[1], d = o !== void 0 ? o : c, f = a ? a(d) : d, g = sn(i), h = Wi([d]), y = Q(h, 2), p = y[0], C = y[1];
  wf(function() {
    var b = p[0];
    c !== b && g(c, b);
  }, [p]), wf(function() {
    Ml(o) || u(o);
  }, [o]);
  var m = sn(function(b, w) {
    u(b, w), C([d], w);
  });
  return [f, m];
}
function Rf(e, t, n, r) {
  var o = V({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    var i = r.deprecatedTokens;
    i.forEach(function(s) {
      var l = Q(s, 2), c = l[0], u = l[1];
      if (z.env.NODE_ENV !== "production" && gt(!(o != null && o[c]), "Component Token `".concat(String(c), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(u), "` instead.")), o != null && o[c] || o != null && o[u]) {
        var d;
        (d = o[u]) !== null && d !== void 0 || (o[u] = o == null ? void 0 : o[c]);
      }
    });
  }
  var a = V(V({}, n), o);
  return Object.keys(a).forEach(function(s) {
    a[s] === t[s] && delete a[s];
  }), a;
}
var Dh = z.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", Uc = !0;
function hn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!Dh)
    return Object.assign.apply(Object, [{}].concat(t));
  Uc = !1;
  var r = {};
  return t.forEach(function(o) {
    if (Ie(o) === "object") {
      var i = Object.keys(o);
      i.forEach(function(a) {
        Object.defineProperty(r, a, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return o[a];
          }
        });
      });
    }
  }), Uc = !0, r;
}
var Nf = {};
function Wx() {
}
var qx = function(t) {
  var n, r = t, o = Wx;
  return Dh && typeof Proxy < "u" && (n = /* @__PURE__ */ new Set(), r = new Proxy(t, {
    get: function(a, s) {
      if (Uc) {
        var l;
        (l = n) === null || l === void 0 || l.add(s);
      }
      return a[s];
    }
  }), o = function(a, s) {
    var l;
    Nf[a] = {
      global: Array.from(n),
      component: V(V({}, (l = Nf[a]) === null || l === void 0 ? void 0 : l.component), s)
    };
  }), {
    token: r,
    keys: n,
    flush: o
  };
};
function Af(e, t, n) {
  if (typeof n == "function") {
    var r;
    return n(hn(t, (r = t[e]) !== null && r !== void 0 ? r : {}));
  }
  return n ?? {};
}
function Gx(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return "max(".concat(r.map(function(i) {
        return ke(i);
      }).join(","), ")");
    },
    min: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return "min(".concat(r.map(function(i) {
        return ke(i);
      }).join(","), ")");
    }
  };
}
var Kx = 1e3 * 60 * 10, Xx = /* @__PURE__ */ function() {
  function e() {
    Yt(this, e), j(this, "map", /* @__PURE__ */ new Map()), j(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), j(this, "nextID", 0), j(this, "lastAccessBeat", /* @__PURE__ */ new Map()), j(this, "accessBeat", 0);
  }
  return Zt(e, [{
    key: "set",
    value: function(n, r) {
      this.clear();
      var o = this.getCompositeKey(n);
      this.map.set(o, r), this.lastAccessBeat.set(o, Date.now());
    }
  }, {
    key: "get",
    value: function(n) {
      var r = this.getCompositeKey(n), o = this.map.get(r);
      return this.lastAccessBeat.set(r, Date.now()), this.accessBeat += 1, o;
    }
  }, {
    key: "getCompositeKey",
    value: function(n) {
      var r = this, o = n.map(function(i) {
        return i && Ie(i) === "object" ? "obj_".concat(r.getObjectID(i)) : "".concat(Ie(i), "_").concat(i);
      });
      return o.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(n) {
      if (this.objectIDMap.has(n))
        return this.objectIDMap.get(n);
      var r = this.nextID;
      return this.objectIDMap.set(n, r), this.nextID += 1, r;
    }
  }, {
    key: "clear",
    value: function() {
      var n = this;
      if (this.accessBeat > 1e4) {
        var r = Date.now();
        this.lastAccessBeat.forEach(function(o, i) {
          r - o > Kx && (n.map.delete(i), n.lastAccessBeat.delete(i));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), kf = new Xx();
function Yx(e, t) {
  return ee.useMemo(function() {
    var n = kf.get(t);
    if (n)
      return n;
    var r = e();
    return kf.set(t, r), r;
  }, t);
}
var Zx = function() {
  return {};
};
function Qx(e) {
  var t = e.useCSP, n = t === void 0 ? Zx : t, r = e.useToken, o = e.usePrefix, i = e.getResetStyles, a = e.getCommonStyle, s = e.getCompUnitless;
  function l(f, g, h, y) {
    var p = Array.isArray(f) ? f[0] : f;
    function C(O) {
      return "".concat(String(p)).concat(O.slice(0, 1).toUpperCase()).concat(O.slice(1));
    }
    var m = (y == null ? void 0 : y.unitless) || {}, b = typeof s == "function" ? s(f) : {}, w = V(V({}, b), {}, j({}, C("zIndexPopup"), !0));
    Object.keys(m).forEach(function(O) {
      w[C(O)] = m[O];
    });
    var E = V(V({}, y), {}, {
      unitless: w,
      prefixToken: C
    }), S = u(f, g, h, E), _ = c(p, h, E);
    return function(O) {
      var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : O, $ = S(O, P), L = Q($, 2), N = L[1], k = _(P), F = Q(k, 2), U = F[0], A = F[1];
      return [U, N, A];
    };
  }
  function c(f, g, h) {
    var y = h.unitless, p = h.injectStyle, C = p === void 0 ? !0 : p, m = h.prefixToken, b = h.ignore, w = function(_) {
      var O = _.rootCls, P = _.cssVar, $ = P === void 0 ? {} : P, L = r(), N = L.realToken;
      return vx({
        path: [f],
        prefix: $.prefix,
        key: $.key,
        unitless: y,
        ignore: b,
        token: N,
        scope: O
      }, function() {
        var k = Af(f, N, g), F = Rf(f, N, k, {
          deprecatedTokens: h == null ? void 0 : h.deprecatedTokens
        });
        return Object.keys(k).forEach(function(U) {
          F[m(U)] = F[U], delete F[U];
        }), F;
      }), null;
    }, E = function(_) {
      var O = r(), P = O.cssVar;
      return [function($) {
        return C && P ? /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(w, {
          rootCls: _,
          cssVar: P,
          component: f
        }), $) : $;
      }, P == null ? void 0 : P.key];
    };
    return E;
  }
  function u(f, g, h) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, p = Array.isArray(f) ? f : [f, f], C = Q(p, 1), m = C[0], b = p.join("-"), w = e.layer || {
      name: "antd"
    };
    return function(E) {
      var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : E, _ = r(), O = _.theme, P = _.realToken, $ = _.hashId, L = _.token, N = _.cssVar, k = o(), F = k.rootPrefixCls, U = k.iconPrefixCls, A = n(), R = N ? "css" : "js", D = Yx(function() {
        var K = /* @__PURE__ */ new Set();
        return N && Object.keys(y.unitless || {}).forEach(function(J) {
          K.add(Wa(J, N.prefix)), K.add(Wa(J, $f(m, N.prefix)));
        }), Ux(R, K);
      }, [R, m, N == null ? void 0 : N.prefix]), B = Gx(R), M = B.max, G = B.min, H = {
        theme: O,
        token: L,
        hashId: $,
        nonce: function() {
          return A.nonce;
        },
        clientOnly: y.clientOnly,
        layer: w,
        // antd is always at top of styles
        order: y.order || -999
      };
      typeof i == "function" && zc(V(V({}, H), {}, {
        clientOnly: !1,
        path: ["Shared", F]
      }), function() {
        return i(L, {
          prefix: {
            rootPrefixCls: F,
            iconPrefixCls: U
          },
          csp: A
        });
      });
      var X = zc(V(V({}, H), {}, {
        path: [b, E, U]
      }), function() {
        if (y.injectStyle === !1)
          return [];
        var K = qx(L), J = K.token, ie = K.flush, le = Af(m, P, h), ne = ".".concat(E), te = Rf(m, P, le, {
          deprecatedTokens: y.deprecatedTokens
        });
        N && le && Ie(le) === "object" && Object.keys(le).forEach(function(De) {
          le[De] = "var(".concat(Wa(De, $f(m, N.prefix)), ")");
        });
        var re = hn(J, {
          componentCls: ne,
          prefixCls: E,
          iconCls: ".".concat(U),
          antCls: ".".concat(F),
          calc: D,
          // @ts-ignore
          max: M,
          // @ts-ignore
          min: G
        }, N ? le : te), _e = g(re, {
          hashId: $,
          prefixCls: E,
          rootPrefixCls: F,
          iconPrefixCls: U
        });
        ie(m, te);
        var me = typeof a == "function" ? a(re, E, S, y.resetFont) : null;
        return [y.resetStyle === !1 ? null : me, _e];
      });
      return [X, $];
    };
  }
  function d(f, g, h) {
    var y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, p = u(f, g, h, V({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, y)), C = function(b) {
      var w = b.prefixCls, E = b.rootCls, S = E === void 0 ? w : E;
      return p(w, S), null;
    };
    return z.env.NODE_ENV !== "production" && (C.displayName = "SubStyle_".concat(String(Array.isArray(f) ? f.join(".") : f))), C;
  }
  return {
    genStyleHooks: l,
    genSubStyleComponent: d,
    genComponentStyleHook: u
  };
}
const io = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], Jx = "5.23.2";
function Ll(e) {
  return e >= 0 && e <= 255;
}
function _a(e, t) {
  const {
    r: n,
    g: r,
    b: o,
    a: i
  } = new Tt(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: a,
    g: s,
    b: l
  } = new Tt(t).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const u = Math.round((n - a * (1 - c)) / c), d = Math.round((r - s * (1 - c)) / c), f = Math.round((o - l * (1 - c)) / c);
    if (Ll(u) && Ll(d) && Ll(f))
      return new Tt({
        r: u,
        g: d,
        b: f,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new Tt({
    r: n,
    g: r,
    b: o,
    a: 1
  }).toRgbString();
}
var eO = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Fh(e) {
  const {
    override: t
  } = e, n = eO(e, ["override"]), r = Object.assign({}, t);
  Object.keys(Hi).forEach((f) => {
    delete r[f];
  });
  const o = Object.assign(Object.assign({}, n), r), i = 480, a = 576, s = 768, l = 992, c = 1200, u = 1600;
  if (o.motion === !1) {
    const f = "0s";
    o.motionDurationFast = f, o.motionDurationMid = f, o.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: _a(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: _a(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: _a(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 3,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: _a(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: l - 1,
    screenLG: l,
    screenLGMin: l,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Tt("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Tt("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Tt("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var Mf = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const jh = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, tO = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, nO = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, Bh = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: o
  } = t, i = Mf(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: o
  });
  return a = Fh(a), i && Object.entries(i).forEach((s) => {
    let [l, c] = s;
    const {
      theme: u
    } = c, d = Mf(c, ["theme"]);
    let f = d;
    u && (f = Bh(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[l] = f;
  }), a;
};
function sr() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: o
  } = ee.useContext(kh), i = `${Jx}-${t || ""}`, a = n || Ah, [s, l, c] = j_(a, [Hi, e], {
    salt: i,
    override: r,
    getComputedToken: Bh,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Fh,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: jh,
      ignore: tO,
      preserve: nO
    }
  });
  return [a, c, t ? l : "", s, o];
}
const rO = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, oi = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, Ku = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), Lf = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), oO = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), iO = (e, t, n, r) => {
  const o = `[class^="${t}"], [class*=" ${t}"]`, i = n ? `.${n}` : o, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [o]: a
    })
  };
}, Vh = (e, t) => ({
  outline: `${ke(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: t ?? 1,
  transition: "outline-offset 0s, outline 0s"
}), zh = (e, t) => ({
  "&:focus-visible": Object.assign({}, Vh(e, t))
}), Hh = (e) => ({
  [`.${e}`]: Object.assign(Object.assign({}, Ku()), {
    [`.${e} .${e}-icon`]: {
      display: "block"
    }
  })
}), {
  genStyleHooks: Er,
  genComponentStyleHook: aO,
  genSubStyleComponent: Uh
} = Qx({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = Kt(kt);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, o] = sr();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: o
    };
  },
  useCSP: () => {
    const {
      csp: e
    } = Kt(kt);
    return e ?? {};
  },
  getResetStyles: (e, t) => {
    var n;
    return [{
      "&": oO(e)
    }, Hh((n = t == null ? void 0 : t.prefix.iconPrefixCls) !== null && n !== void 0 ? n : Ks)];
  },
  getCommonStyle: iO,
  getCompUnitless: () => jh
});
function sO(e, t) {
  return io.reduce((n, r) => {
    const o = e[`${r}1`], i = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: o,
      lightBorderColor: i,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const lO = (e, t) => {
  const [n, r] = sr();
  return zc({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [Hh(e)]);
}, cO = Object.assign({}, v), {
  useId: Df
} = cO, uO = () => "", dO = typeof Df > "u" ? uO : Df;
function fO(e, t, n) {
  var r, o;
  const i = Pn("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, Hc), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : Hc.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, l = dO();
  if (z.env.NODE_ENV !== "production") {
    const c = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((o = a.cssVar) === null || o === void 0) && o.key) || l);
    z.env.NODE_ENV !== "production" && i(!c || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return As(() => {
    var c, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((h) => {
      d[h] = Object.assign(Object.assign({}, d[h]), e.components[h]);
    });
    const f = `css-var-${l.replace(/:/g, "")}`, g = ((c = a.cssVar) !== null && c !== void 0 ? c : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: g
    });
  }, [a, s], (c, u) => c.some((d, f) => {
    const g = u[f];
    return !Vi(d, g, !0);
  }));
}
var vO = ["children"], Wh = /* @__PURE__ */ v.createContext({});
function gO(e) {
  var t = e.children, n = ht(e, vO);
  return /* @__PURE__ */ v.createElement(Wh.Provider, {
    value: n
  }, t);
}
var pO = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n() {
    return Yt(this, n), t.apply(this, arguments);
  }
  return Zt(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(v.Component);
function hO(e) {
  var t = v.useReducer(function(s) {
    return s + 1;
  }, 0), n = Q(t, 2), r = n[1], o = v.useRef(e), i = sn(function() {
    return o.current;
  }), a = sn(function(s) {
    o.current = typeof s == "function" ? s(o.current) : s, r();
  });
  return [i, a];
}
var Ar = "none", xa = "appear", Oa = "enter", Pa = "leave", Ff = "none", zn = "prepare", Ao = "start", ko = "active", Xu = "end", qh = "prepared";
function jf(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function mO(e, t) {
  var n = {
    animationend: jf("Animation", "AnimationEnd"),
    transitionend: jf("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var yO = mO(gn(), typeof window < "u" ? window : {}), Gh = {};
if (gn()) {
  var bO = document.createElement("div");
  Gh = bO.style;
}
var Ia = {};
function Kh(e) {
  if (Ia[e])
    return Ia[e];
  var t = yO[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, o = 0; o < r; o += 1) {
      var i = n[o];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in Gh)
        return Ia[e] = t[i], Ia[e];
    }
  return "";
}
var Xh = Kh("animationend"), Yh = Kh("transitionend"), Zh = !!(Xh && Yh), Bf = Xh || "animationend", Vf = Yh || "transitionend";
function zf(e, t) {
  if (!e)
    return null;
  if (Ie(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const CO = function(e) {
  var t = st();
  function n(o) {
    o && (o.removeEventListener(Vf, e), o.removeEventListener(Bf, e));
  }
  function r(o) {
    t.current && t.current !== o && n(t.current), o && o !== t.current && (o.addEventListener(Vf, e), o.addEventListener(Bf, e), t.current = o);
  }
  return v.useEffect(function() {
    return function() {
      n(t.current);
    };
  }, []), [r, n];
};
var Qh = gn() ? My : At;
const wO = function() {
  var e = v.useRef(null);
  function t() {
    pn.cancel(e.current);
  }
  function n(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = pn(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : n(r, o - 1);
    });
    e.current = i;
  }
  return v.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var SO = [zn, Ao, ko, Xu], EO = [zn, qh], Jh = !1, _O = !0;
function em(e) {
  return e === ko || e === Xu;
}
const xO = function(e, t, n) {
  var r = Wi(Ff), o = Q(r, 2), i = o[0], a = o[1], s = wO(), l = Q(s, 2), c = l[0], u = l[1];
  function d() {
    a(zn, !0);
  }
  var f = t ? EO : SO;
  return Qh(function() {
    if (i !== Ff && i !== Xu) {
      var g = f.indexOf(i), h = f[g + 1], y = n(i);
      y === Jh ? a(h, !0) : h && c(function(p) {
        function C() {
          p.isCanceled() || a(h, !0);
        }
        y === !0 ? C() : Promise.resolve(y).then(C);
      });
    }
  }, [e, i]), v.useEffect(function() {
    return function() {
      u();
    };
  }, []), [d, i];
};
function OO(e, t, n, r) {
  var o = r.motionEnter, i = o === void 0 ? !0 : o, a = r.motionAppear, s = a === void 0 ? !0 : a, l = r.motionLeave, c = l === void 0 ? !0 : l, u = r.motionDeadline, d = r.motionLeaveImmediately, f = r.onAppearPrepare, g = r.onEnterPrepare, h = r.onLeavePrepare, y = r.onAppearStart, p = r.onEnterStart, C = r.onLeaveStart, m = r.onAppearActive, b = r.onEnterActive, w = r.onLeaveActive, E = r.onAppearEnd, S = r.onEnterEnd, _ = r.onLeaveEnd, O = r.onVisibleChanged, P = Wi(), $ = Q(P, 2), L = $[0], N = $[1], k = hO(Ar), F = Q(k, 2), U = F[0], A = F[1], R = Wi(null), D = Q(R, 2), B = D[0], M = D[1], G = U(), H = st(!1), X = st(null);
  function K() {
    return n();
  }
  var J = st(!1);
  function ie() {
    A(Ar), M(null, !0);
  }
  var le = sn(function(xe) {
    var He = U();
    if (He !== Ar) {
      var ye = K();
      if (!(xe && !xe.deadline && xe.target !== ye)) {
        var it = J.current, Me;
        He === xa && it ? Me = E == null ? void 0 : E(ye, xe) : He === Oa && it ? Me = S == null ? void 0 : S(ye, xe) : He === Pa && it && (Me = _ == null ? void 0 : _(ye, xe)), it && Me !== !1 && ie();
      }
    }
  }), ne = CO(le), te = Q(ne, 1), re = te[0], _e = function(He) {
    switch (He) {
      case xa:
        return j(j(j({}, zn, f), Ao, y), ko, m);
      case Oa:
        return j(j(j({}, zn, g), Ao, p), ko, b);
      case Pa:
        return j(j(j({}, zn, h), Ao, C), ko, w);
      default:
        return {};
    }
  }, me = v.useMemo(function() {
    return _e(G);
  }, [G]), De = xO(G, !e, function(xe) {
    if (xe === zn) {
      var He = me[zn];
      return He ? He(K()) : Jh;
    }
    if (Re in me) {
      var ye;
      M(((ye = me[Re]) === null || ye === void 0 ? void 0 : ye.call(me, K(), null)) || null);
    }
    return Re === ko && G !== Ar && (re(K()), u > 0 && (clearTimeout(X.current), X.current = setTimeout(function() {
      le({
        deadline: !0
      });
    }, u))), Re === qh && ie(), _O;
  }), oe = Q(De, 2), Te = oe[0], Re = oe[1], Ye = em(Re);
  J.current = Ye;
  var Fe = st(null);
  Qh(function() {
    if (!(H.current && Fe.current === t)) {
      N(t);
      var xe = H.current;
      H.current = !0;
      var He;
      !xe && t && s && (He = xa), xe && t && i && (He = Oa), (xe && !t && c || !xe && d && !t && c) && (He = Pa);
      var ye = _e(He);
      He && (e || ye[zn]) ? (A(He), Te()) : A(Ar), Fe.current = t;
    }
  }, [t]), At(function() {
    // Cancel appear
    (G === xa && !s || // Cancel enter
    G === Oa && !i || // Cancel leave
    G === Pa && !c) && A(Ar);
  }, [s, i, c]), At(function() {
    return function() {
      H.current = !1, clearTimeout(X.current);
    };
  }, []);
  var Ze = v.useRef(!1);
  At(function() {
    L && (Ze.current = !0), L !== void 0 && G === Ar && ((Ze.current || L) && (O == null || O(L)), Ze.current = !0);
  }, [L, G]);
  var nt = B;
  return me[zn] && Re === Ao && (nt = V({
    transition: "none"
  }, nt)), [G, Re, nt, L ?? t];
}
function PO(e) {
  var t = e;
  Ie(e) === "object" && (t = e.transitionSupport);
  function n(o, i) {
    return !!(o.motionName && t && i !== !1);
  }
  var r = /* @__PURE__ */ v.forwardRef(function(o, i) {
    var a = o.visible, s = a === void 0 ? !0 : a, l = o.removeOnLeave, c = l === void 0 ? !0 : l, u = o.forceRender, d = o.children, f = o.motionName, g = o.leavedClassName, h = o.eventProps, y = v.useContext(Wh), p = y.motion, C = n(o, p), m = st(), b = st();
    function w() {
      try {
        return m.current instanceof HTMLElement ? m.current : Ua(b.current);
      } catch {
        return null;
      }
    }
    var E = OO(C, s, w, o), S = Q(E, 4), _ = S[0], O = S[1], P = S[2], $ = S[3], L = v.useRef($);
    $ && (L.current = !0);
    var N = v.useCallback(function(D) {
      m.current = D, Au(i, D);
    }, [i]), k, F = V(V({}, h), {}, {
      visible: s
    });
    if (!d)
      k = null;
    else if (_ === Ar)
      $ ? k = d(V({}, F), N) : !c && L.current && g ? k = d(V(V({}, F), {}, {
        className: g
      }), N) : u || !c && !g ? k = d(V(V({}, F), {}, {
        style: {
          display: "none"
        }
      }), N) : k = null;
    else {
      var U;
      O === zn ? U = "prepare" : em(O) ? U = "active" : O === Ao && (U = "start");
      var A = zf(f, "".concat(_, "-").concat(U));
      k = d(V(V({}, F), {}, {
        className: se(zf(f, _), j(j({}, A, A && U), f, typeof f == "string")),
        style: P
      }), N);
    }
    if (/* @__PURE__ */ v.isValidElement(k) && Zi(k)) {
      var R = ks(k);
      R || (k = /* @__PURE__ */ v.cloneElement(k, {
        ref: N
      }));
    }
    return /* @__PURE__ */ v.createElement(pO, {
      ref: b
    }, k);
  });
  return r.displayName = "CSSMotion", r;
}
const ii = PO(Zh);
var Wc = "add", qc = "keep", Gc = "remove", Dl = "removed";
function IO(e) {
  var t;
  return e && Ie(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, V(V({}, t), {}, {
    key: String(t.key)
  });
}
function Kc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(IO);
}
function TO() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, o = t.length, i = Kc(e), a = Kc(t);
  i.forEach(function(c) {
    for (var u = !1, d = r; d < o; d += 1) {
      var f = a[d];
      if (f.key === c.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(g) {
          return V(V({}, g), {}, {
            status: Wc
          });
        })), r = d), n.push(V(V({}, f), {}, {
          status: qc
        })), r += 1, u = !0;
        break;
      }
    }
    u || n.push(V(V({}, c), {}, {
      status: Gc
    }));
  }), r < o && (n = n.concat(a.slice(r).map(function(c) {
    return V(V({}, c), {}, {
      status: Wc
    });
  })));
  var s = {};
  n.forEach(function(c) {
    var u = c.key;
    s[u] = (s[u] || 0) + 1;
  });
  var l = Object.keys(s).filter(function(c) {
    return s[c] > 1;
  });
  return l.forEach(function(c) {
    n = n.filter(function(u) {
      var d = u.key, f = u.status;
      return d !== c || f !== Gc;
    }), n.forEach(function(u) {
      u.key === c && (u.status = qc);
    });
  }), n;
}
var $O = ["component", "children", "onVisibleChanged", "onAllRemoved"], RO = ["status"], NO = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function AO(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ii, n = /* @__PURE__ */ function(r) {
    wr(i, r);
    var o = Sr(i);
    function i() {
      var a;
      Yt(this, i);
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      return a = o.call.apply(o, [this].concat(l)), j(Xe(a), "state", {
        keyEntities: []
      }), j(Xe(a), "removeKey", function(u) {
        a.setState(function(d) {
          var f = d.keyEntities.map(function(g) {
            return g.key !== u ? g : V(V({}, g), {}, {
              status: Dl
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var d = a.state.keyEntities, f = d.filter(function(g) {
            var h = g.status;
            return h !== Dl;
          }).length;
          f === 0 && a.props.onAllRemoved && a.props.onAllRemoved();
        });
      }), a;
    }
    return Zt(i, [{
      key: "render",
      value: function() {
        var s = this, l = this.state.keyEntities, c = this.props, u = c.component, d = c.children, f = c.onVisibleChanged;
        c.onAllRemoved;
        var g = ht(c, $O), h = u || v.Fragment, y = {};
        return NO.forEach(function(p) {
          y[p] = g[p], delete g[p];
        }), delete g.keys, /* @__PURE__ */ v.createElement(h, g, l.map(function(p, C) {
          var m = p.status, b = ht(p, RO), w = m === Wc || m === qc;
          return /* @__PURE__ */ v.createElement(t, Pe({}, y, {
            key: b.key,
            visible: w,
            eventProps: b,
            onVisibleChanged: function(S) {
              f == null || f(S, {
                key: b.key
              }), S || s.removeKey(b.key);
            }
          }), function(E, S) {
            return d(V(V({}, E), {}, {
              index: C
            }), S);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, l) {
        var c = s.keys, u = l.keyEntities, d = Kc(c), f = TO(u, d);
        return {
          keyEntities: f.filter(function(g) {
            var h = u.find(function(y) {
              var p = y.key;
              return g.key === p;
            });
            return !(h && h.status === Dl && g.status === Gc);
          })
        };
      }
    }]), i;
  }(v.Component);
  return j(n, "defaultProps", {
    component: "div"
  }), n;
}
const kO = AO(Zh);
function MO(e) {
  const {
    children: t
  } = e, [, n] = sr(), {
    motion: r
  } = n, o = v.useRef(!1);
  return o.current = o.current || r === !1, o.current ? /* @__PURE__ */ v.createElement(gO, {
    motion: r
  }, t) : t;
}
const tm = /* @__PURE__ */ v.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return Pn("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
z.env.NODE_ENV !== "production" && (tm.displayName = "PropWarning");
const LO = z.env.NODE_ENV !== "production" ? tm : () => null;
var DO = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let Xc = !1;
const FO = z.env.NODE_ENV !== "production" ? (e) => {
  z.env.NODE_ENV !== "production" && fo(!Xc, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), jO = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let hs, nm, rm, om;
function Qa() {
  return hs || Ui;
}
function BO() {
  return nm || Ks;
}
function VO(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const zO = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: o
  } = e;
  t !== void 0 && (hs = t), n !== void 0 && (nm = n), "holderRender" in e && (om = o), r && (VO(r) ? (z.env.NODE_ENV !== "production" && fo(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), Dx(Qa(), r)) : rm = r);
}, im = () => ({
  getPrefixCls: (e, t) => t || (e ? `${Qa()}-${e}` : Qa()),
  getIconPrefixCls: BO,
  getRootPrefixCls: () => hs || Qa(),
  getTheme: () => rm,
  holderRender: om
}), HO = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    form: a,
    locale: s,
    componentSize: l,
    direction: c,
    space: u,
    splitter: d,
    virtual: f,
    dropdownMatchSelectWidth: g,
    popupMatchSelectWidth: h,
    popupOverflow: y,
    legacyLocale: p,
    parentContext: C,
    iconPrefixCls: m,
    theme: b,
    componentDisabled: w,
    segmented: E,
    statistic: S,
    spin: _,
    calendar: O,
    carousel: P,
    cascader: $,
    collapse: L,
    typography: N,
    checkbox: k,
    descriptions: F,
    divider: U,
    drawer: A,
    skeleton: R,
    steps: D,
    image: B,
    layout: M,
    list: G,
    mentions: H,
    modal: X,
    progress: K,
    result: J,
    slider: ie,
    breadcrumb: le,
    menu: ne,
    pagination: te,
    input: re,
    textArea: _e,
    empty: me,
    badge: De,
    radio: oe,
    rate: Te,
    switch: Re,
    transfer: Ye,
    avatar: Fe,
    message: Ze,
    tag: nt,
    table: xe,
    card: He,
    tabs: ye,
    timeline: it,
    timePicker: Me,
    upload: Ve,
    notification: lt,
    tree: yt,
    colorPicker: mt,
    datePicker: Ne,
    rangePicker: Ue,
    flex: x,
    wave: T,
    dropdown: q,
    warning: W,
    tour: Y,
    tooltip: ce,
    popover: fe,
    popconfirm: je,
    floatButtonGroup: Be,
    variant: ze,
    inputNumber: et,
    treeSelect: Ke
  } = e, Je = v.useCallback((ct, ut) => {
    const {
      prefixCls: Wt
    } = e;
    if (ut)
      return ut;
    const I = Wt || C.getPrefixCls("");
    return ct ? `${I}-${ct}` : I;
  }, [C.getPrefixCls, e.prefixCls]), Pt = m || C.iconPrefixCls || Ks, rt = n || C.csp;
  lO(Pt, rt);
  const we = fO(b, C.theme, {
    prefixCls: Je("")
  });
  z.env.NODE_ENV !== "production" && (Xc = Xc || !!we);
  const ge = {
    csp: rt,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    locale: s || p,
    direction: c,
    space: u,
    splitter: d,
    virtual: f,
    popupMatchSelectWidth: h ?? g,
    popupOverflow: y,
    getPrefixCls: Je,
    iconPrefixCls: Pt,
    theme: we,
    segmented: E,
    statistic: S,
    spin: _,
    calendar: O,
    carousel: P,
    cascader: $,
    collapse: L,
    typography: N,
    checkbox: k,
    descriptions: F,
    divider: U,
    drawer: A,
    skeleton: R,
    steps: D,
    image: B,
    input: re,
    textArea: _e,
    layout: M,
    list: G,
    mentions: H,
    modal: X,
    progress: K,
    result: J,
    slider: ie,
    breadcrumb: le,
    menu: ne,
    pagination: te,
    empty: me,
    badge: De,
    radio: oe,
    rate: Te,
    switch: Re,
    transfer: Ye,
    avatar: Fe,
    message: Ze,
    tag: nt,
    table: xe,
    card: He,
    tabs: ye,
    timeline: it,
    timePicker: Me,
    upload: Ve,
    notification: lt,
    tree: yt,
    colorPicker: mt,
    datePicker: Ne,
    rangePicker: Ue,
    flex: x,
    wave: T,
    dropdown: q,
    warning: W,
    tour: Y,
    tooltip: ce,
    popover: fe,
    popconfirm: je,
    floatButtonGroup: Be,
    variant: ze,
    inputNumber: et,
    treeSelect: Ke
  };
  z.env.NODE_ENV !== "production" && Pn("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const Ee = Object.assign({}, C);
  Object.keys(ge).forEach((ct) => {
    ge[ct] !== void 0 && (Ee[ct] = ge[ct]);
  }), jO.forEach((ct) => {
    const ut = e[ct];
    ut && (Ee[ct] = ut);
  }), typeof r < "u" && (Ee.button = Object.assign({
    autoInsertSpace: r
  }, Ee.button));
  const ot = As(() => Ee, Ee, (ct, ut) => {
    const Wt = Object.keys(ct), I = Object.keys(ut);
    return Wt.length !== I.length || Wt.some((Z) => ct[Z] !== ut[Z]);
  }), xt = v.useMemo(() => ({
    prefixCls: Pt,
    csp: rt
  }), [Pt, rt]);
  let bt = /* @__PURE__ */ v.createElement(v.Fragment, null, /* @__PURE__ */ v.createElement(LO, {
    dropdownMatchSelectWidth: g
  }), t);
  const Dt = v.useMemo(() => {
    var ct, ut, Wt, I;
    return No(((ct = Gs.Form) === null || ct === void 0 ? void 0 : ct.defaultValidateMessages) || {}, ((Wt = (ut = ot.locale) === null || ut === void 0 ? void 0 : ut.Form) === null || Wt === void 0 ? void 0 : Wt.defaultValidateMessages) || {}, ((I = ot.form) === null || I === void 0 ? void 0 : I.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [ot, a == null ? void 0 : a.validateMessages]);
  Object.keys(Dt).length > 0 && (bt = /* @__PURE__ */ v.createElement(bx.Provider, {
    value: Dt
  }, bt)), s && (bt = /* @__PURE__ */ v.createElement(Rh, {
    locale: s,
    _ANT_MARK__: $h
  }, bt)), (Pt || rt) && (bt = /* @__PURE__ */ v.createElement(Tu.Provider, {
    value: xt
  }, bt)), l && (bt = /* @__PURE__ */ v.createElement(jx, {
    size: l
  }, bt)), bt = /* @__PURE__ */ v.createElement(MO, null, bt);
  const jn = v.useMemo(() => {
    const ct = we || {}, {
      algorithm: ut,
      token: Wt,
      components: I,
      cssVar: Z
    } = ct, ae = DO(ct, ["algorithm", "token", "components", "cssVar"]), be = ut && (!Array.isArray(ut) || ut.length > 0) ? Dc(ut) : Ah, Oe = {};
    Object.entries(I || {}).forEach(($e) => {
      let [Le, Ct] = $e;
      const Qe = Object.assign({}, Ct);
      "algorithm" in Qe && (Qe.algorithm === !0 ? Qe.theme = be : (Array.isArray(Qe.algorithm) || typeof Qe.algorithm == "function") && (Qe.theme = Dc(Qe.algorithm)), delete Qe.algorithm), Oe[Le] = Qe;
    });
    const We = Object.assign(Object.assign({}, Hi), Wt);
    return Object.assign(Object.assign({}, ae), {
      theme: be,
      token: We,
      components: Oe,
      override: Object.assign({
        override: We
      }, Oe),
      cssVar: Z
    });
  }, [we]);
  return b && (bt = /* @__PURE__ */ v.createElement(kh.Provider, {
    value: jn
  }, bt)), ot.warning && (bt = /* @__PURE__ */ v.createElement(Ph.Provider, {
    value: ot.warning
  }, bt)), w !== void 0 && (bt = /* @__PURE__ */ v.createElement(Fx, {
    disabled: w
  }, bt)), /* @__PURE__ */ v.createElement(kt.Provider, {
    value: ot
  }, bt);
}, Wr = (e) => {
  const t = v.useContext(kt), n = v.useContext(Th);
  return /* @__PURE__ */ v.createElement(HO, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
Wr.ConfigContext = kt;
Wr.SizeContext = Ko;
Wr.config = zO;
Wr.useConfig = Bx;
Object.defineProperty(Wr, "SizeContext", {
  get: () => (z.env.NODE_ENV !== "production" && fo(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Ko)
});
z.env.NODE_ENV !== "production" && (Wr.displayName = "ConfigProvider");
var UO = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, WO = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, qO = "".concat(UO, " ").concat(WO).split(/[\s\n]+/), GO = "aria-", KO = "data-";
function Hf(e, t) {
  return e.indexOf(t) === 0;
}
function XO(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = V({}, t);
  var r = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (n.aria && (o === "role" || Hf(o, GO)) || // Data
    n.data && Hf(o, KO) || // Attr
    n.attr && qO.includes(o)) && (r[o] = e[o]);
  }), r;
}
function am(e) {
  return e && /* @__PURE__ */ ee.isValidElement(e) && e.type === ee.Fragment;
}
const YO = (e, t, n) => /* @__PURE__ */ ee.isValidElement(e) ? /* @__PURE__ */ ee.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
function _r(e, t) {
  return YO(e, e, t);
}
const ea = (e) => {
  const [, , , , t] = sr();
  return t ? `${e}-css-var` : "";
};
var Ce = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Ce.F1 && n <= Ce.F12)
      return !1;
    switch (n) {
      case Ce.ALT:
      case Ce.CAPS_LOCK:
      case Ce.CONTEXT_MENU:
      case Ce.CTRL:
      case Ce.DOWN:
      case Ce.END:
      case Ce.ESC:
      case Ce.HOME:
      case Ce.INSERT:
      case Ce.LEFT:
      case Ce.MAC_FF_META:
      case Ce.META:
      case Ce.NUMLOCK:
      case Ce.NUM_CENTER:
      case Ce.PAGE_DOWN:
      case Ce.PAGE_UP:
      case Ce.PAUSE:
      case Ce.PRINT_SCREEN:
      case Ce.RIGHT:
      case Ce.SHIFT:
      case Ce.UP:
      case Ce.WIN_KEY:
      case Ce.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Ce.ZERO && t <= Ce.NINE || t >= Ce.NUM_ZERO && t <= Ce.NUM_MULTIPLY || t >= Ce.A && t <= Ce.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Ce.SPACE:
      case Ce.QUESTION_MARK:
      case Ce.NUM_PLUS:
      case Ce.NUM_MINUS:
      case Ce.NUM_PERIOD:
      case Ce.NUM_DIVISION:
      case Ce.SEMICOLON:
      case Ce.DASH:
      case Ce.EQUALS:
      case Ce.COMMA:
      case Ce.PERIOD:
      case Ce.SLASH:
      case Ce.APOSTROPHE:
      case Ce.SINGLE_QUOTE:
      case Ce.OPEN_SQUARE_BRACKET:
      case Ce.BACKSLASH:
      case Ce.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, sm = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, o = e.className, i = e.duration, a = i === void 0 ? 4.5 : i, s = e.showProgress, l = e.pauseOnHover, c = l === void 0 ? !0 : l, u = e.eventKey, d = e.content, f = e.closable, g = e.closeIcon, h = g === void 0 ? "x" : g, y = e.props, p = e.onClick, C = e.onNoticeClose, m = e.times, b = e.hovering, w = v.useState(!1), E = Q(w, 2), S = E[0], _ = E[1], O = v.useState(0), P = Q(O, 2), $ = P[0], L = P[1], N = v.useState(0), k = Q(N, 2), F = k[0], U = k[1], A = b || S, R = a > 0 && s, D = function() {
    C(u);
  }, B = function(J) {
    (J.key === "Enter" || J.code === "Enter" || J.keyCode === Ce.ENTER) && D();
  };
  v.useEffect(function() {
    if (!A && a > 0) {
      var K = Date.now() - F, J = setTimeout(function() {
        D();
      }, a * 1e3 - F);
      return function() {
        c && clearTimeout(J), U(Date.now() - K);
      };
    }
  }, [a, A, m]), v.useEffect(function() {
    if (!A && R && (c || F === 0)) {
      var K = performance.now(), J, ie = function le() {
        cancelAnimationFrame(J), J = requestAnimationFrame(function(ne) {
          var te = ne + F - K, re = Math.min(te / (a * 1e3), 1);
          L(re * 100), re < 1 && le();
        });
      };
      return ie(), function() {
        c && cancelAnimationFrame(J);
      };
    }
  }, [a, F, A, R, m]);
  var M = v.useMemo(function() {
    return Ie(f) === "object" && f !== null ? f : f ? {
      closeIcon: h
    } : {};
  }, [f, h]), G = XO(M, !0), H = 100 - (!$ || $ < 0 ? 0 : $ > 100 ? 100 : $), X = "".concat(n, "-notice");
  return /* @__PURE__ */ v.createElement("div", Pe({}, y, {
    ref: t,
    className: se(X, o, j({}, "".concat(X, "-closable"), f)),
    style: r,
    onMouseEnter: function(J) {
      var ie;
      _(!0), y == null || (ie = y.onMouseEnter) === null || ie === void 0 || ie.call(y, J);
    },
    onMouseLeave: function(J) {
      var ie;
      _(!1), y == null || (ie = y.onMouseLeave) === null || ie === void 0 || ie.call(y, J);
    },
    onClick: p
  }), /* @__PURE__ */ v.createElement("div", {
    className: "".concat(X, "-content")
  }, d), f && /* @__PURE__ */ v.createElement("a", Pe({
    tabIndex: 0,
    className: "".concat(X, "-close"),
    onKeyDown: B,
    "aria-label": "Close"
  }, G, {
    onClick: function(J) {
      J.preventDefault(), J.stopPropagation(), D();
    }
  }), M.closeIcon), R && /* @__PURE__ */ v.createElement("progress", {
    className: "".concat(X, "-progress"),
    max: "100",
    value: H
  }, H + "%"));
}), lm = /* @__PURE__ */ ee.createContext({}), ZO = function(t) {
  var n = t.children, r = t.classNames;
  return /* @__PURE__ */ ee.createElement(lm.Provider, {
    value: {
      classNames: r
    }
  }, n);
}, Uf = 8, Wf = 3, qf = 16, QO = function(t) {
  var n = {
    offset: Uf,
    threshold: Wf,
    gap: qf
  };
  if (t && Ie(t) === "object") {
    var r, o, i;
    n.offset = (r = t.offset) !== null && r !== void 0 ? r : Uf, n.threshold = (o = t.threshold) !== null && o !== void 0 ? o : Wf, n.gap = (i = t.gap) !== null && i !== void 0 ? i : qf;
  }
  return [!!t, n];
}, JO = ["className", "style", "classNames", "styles"], cm = function(t) {
  var n = t.configList, r = t.placement, o = t.prefixCls, i = t.className, a = t.style, s = t.motion, l = t.onAllNoticeRemoved, c = t.onNoticeClose, u = t.stack, d = Kt(lm), f = d.classNames, g = st({}), h = Ht(null), y = Q(h, 2), p = y[0], C = y[1], m = Ht([]), b = Q(m, 2), w = b[0], E = b[1], S = n.map(function(A) {
    return {
      config: A,
      key: String(A.key)
    };
  }), _ = QO(u), O = Q(_, 2), P = O[0], $ = O[1], L = $.offset, N = $.threshold, k = $.gap, F = P && (w.length > 0 || S.length <= N), U = typeof s == "function" ? s(r) : s;
  return At(function() {
    P && w.length > 1 && E(function(A) {
      return A.filter(function(R) {
        return S.some(function(D) {
          var B = D.key;
          return R === B;
        });
      });
    });
  }, [w, S, P]), At(function() {
    var A;
    if (P && g.current[(A = S[S.length - 1]) === null || A === void 0 ? void 0 : A.key]) {
      var R;
      C(g.current[(R = S[S.length - 1]) === null || R === void 0 ? void 0 : R.key]);
    }
  }, [S, P]), /* @__PURE__ */ ee.createElement(kO, Pe({
    key: r,
    className: se(o, "".concat(o, "-").concat(r), f == null ? void 0 : f.list, i, j(j({}, "".concat(o, "-stack"), !!P), "".concat(o, "-stack-expanded"), F)),
    style: a,
    keys: S,
    motionAppear: !0
  }, U, {
    onAllRemoved: function() {
      l(r);
    }
  }), function(A, R) {
    var D = A.config, B = A.className, M = A.style, G = A.index, H = D, X = H.key, K = H.times, J = String(X), ie = D, le = ie.className, ne = ie.style, te = ie.classNames, re = ie.styles, _e = ht(ie, JO), me = S.findIndex(function(it) {
      return it.key === J;
    }), De = {};
    if (P) {
      var oe = S.length - 1 - (me > -1 ? me : G - 1), Te = r === "top" || r === "bottom" ? "-50%" : "0";
      if (oe > 0) {
        var Re, Ye, Fe;
        De.height = F ? (Re = g.current[J]) === null || Re === void 0 ? void 0 : Re.offsetHeight : p == null ? void 0 : p.offsetHeight;
        for (var Ze = 0, nt = 0; nt < oe; nt++) {
          var xe;
          Ze += ((xe = g.current[S[S.length - 1 - nt].key]) === null || xe === void 0 ? void 0 : xe.offsetHeight) + k;
        }
        var He = (F ? Ze : oe * L) * (r.startsWith("top") ? 1 : -1), ye = !F && p !== null && p !== void 0 && p.offsetWidth && (Ye = g.current[J]) !== null && Ye !== void 0 && Ye.offsetWidth ? ((p == null ? void 0 : p.offsetWidth) - L * 2 * (oe < 3 ? oe : 3)) / ((Fe = g.current[J]) === null || Fe === void 0 ? void 0 : Fe.offsetWidth) : 1;
        De.transform = "translate3d(".concat(Te, ", ").concat(He, "px, 0) scaleX(").concat(ye, ")");
      } else
        De.transform = "translate3d(".concat(Te, ", 0, 0)");
    }
    return /* @__PURE__ */ ee.createElement("div", {
      ref: R,
      className: se("".concat(o, "-notice-wrapper"), B, te == null ? void 0 : te.wrapper),
      style: V(V(V({}, M), De), re == null ? void 0 : re.wrapper),
      onMouseEnter: function() {
        return E(function(Me) {
          return Me.includes(J) ? Me : [].concat(he(Me), [J]);
        });
      },
      onMouseLeave: function() {
        return E(function(Me) {
          return Me.filter(function(Ve) {
            return Ve !== J;
          });
        });
      }
    }, /* @__PURE__ */ ee.createElement(sm, Pe({}, _e, {
      ref: function(Me) {
        me > -1 ? g.current[J] = Me : delete g.current[J];
      },
      prefixCls: o,
      classNames: te,
      styles: re,
      className: se(le, f == null ? void 0 : f.notice),
      style: ne,
      times: K,
      key: X,
      eventKey: X,
      onNoticeClose: c,
      hovering: P && w.length > 0
    })));
  });
};
z.env.NODE_ENV !== "production" && (cm.displayName = "NoticeList");
var um = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-notification" : n, o = e.container, i = e.motion, a = e.maxCount, s = e.className, l = e.style, c = e.onAllRemoved, u = e.stack, d = e.renderNotifications, f = v.useState([]), g = Q(f, 2), h = g[0], y = g[1], p = function(P) {
    var $, L = h.find(function(N) {
      return N.key === P;
    });
    L == null || ($ = L.onClose) === null || $ === void 0 || $.call(L), y(function(N) {
      return N.filter(function(k) {
        return k.key !== P;
      });
    });
  };
  v.useImperativeHandle(t, function() {
    return {
      open: function(P) {
        y(function($) {
          var L = he($), N = L.findIndex(function(U) {
            return U.key === P.key;
          }), k = V({}, P);
          if (N >= 0) {
            var F;
            k.times = (((F = $[N]) === null || F === void 0 ? void 0 : F.times) || 0) + 1, L[N] = k;
          } else
            k.times = 0, L.push(k);
          return a > 0 && L.length > a && (L = L.slice(-a)), L;
        });
      },
      close: function(P) {
        p(P);
      },
      destroy: function() {
        y([]);
      }
    };
  });
  var C = v.useState({}), m = Q(C, 2), b = m[0], w = m[1];
  v.useEffect(function() {
    var O = {};
    h.forEach(function(P) {
      var $ = P.placement, L = $ === void 0 ? "topRight" : $;
      L && (O[L] = O[L] || [], O[L].push(P));
    }), Object.keys(b).forEach(function(P) {
      O[P] = O[P] || [];
    }), w(O);
  }, [h]);
  var E = function(P) {
    w(function($) {
      var L = V({}, $), N = L[P] || [];
      return N.length || delete L[P], L;
    });
  }, S = v.useRef(!1);
  if (v.useEffect(function() {
    Object.keys(b).length > 0 ? S.current = !0 : S.current && (c == null || c(), S.current = !1);
  }, [b]), !o)
    return null;
  var _ = Object.keys(b);
  return /* @__PURE__ */ bg(/* @__PURE__ */ v.createElement(v.Fragment, null, _.map(function(O) {
    var P = b[O], $ = /* @__PURE__ */ v.createElement(cm, {
      key: O,
      configList: P,
      placement: O,
      prefixCls: r,
      className: s == null ? void 0 : s(O),
      style: l == null ? void 0 : l(O),
      motion: i,
      onNoticeClose: p,
      onAllNoticeRemoved: E,
      stack: u
    });
    return d ? d($, {
      prefixCls: r,
      key: O
    }) : $;
  })), o);
});
z.env.NODE_ENV !== "production" && (um.displayName = "Notifications");
var eP = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], tP = function() {
  return document.body;
}, Gf = 0;
function nP() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(o) {
    o && Object.keys(o).forEach(function(i) {
      var a = o[i];
      a !== void 0 && (e[i] = a);
    });
  }), e;
}
function rP() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, n = t === void 0 ? tP : t, r = e.motion, o = e.prefixCls, i = e.maxCount, a = e.className, s = e.style, l = e.onAllRemoved, c = e.stack, u = e.renderNotifications, d = ht(e, eP), f = v.useState(), g = Q(f, 2), h = g[0], y = g[1], p = v.useRef(), C = /* @__PURE__ */ v.createElement(um, {
    container: h,
    ref: p,
    prefixCls: o,
    motion: r,
    maxCount: i,
    className: a,
    style: s,
    onAllRemoved: l,
    stack: c,
    renderNotifications: u
  }), m = v.useState([]), b = Q(m, 2), w = b[0], E = b[1], S = v.useMemo(function() {
    return {
      open: function(O) {
        var P = nP(d, O);
        (P.key === null || P.key === void 0) && (P.key = "rc-notification-".concat(Gf), Gf += 1), E(function($) {
          return [].concat(he($), [{
            type: "open",
            config: P
          }]);
        });
      },
      close: function(O) {
        E(function(P) {
          return [].concat(he(P), [{
            type: "close",
            key: O
          }]);
        });
      },
      destroy: function() {
        E(function(O) {
          return [].concat(he(O), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return v.useEffect(function() {
    y(n());
  }), v.useEffect(function() {
    p.current && w.length && (w.forEach(function(_) {
      switch (_.type) {
        case "open":
          p.current.open(_.config);
          break;
        case "close":
          p.current.close(_.key);
          break;
        case "destroy":
          p.current.destroy();
          break;
      }
    }), E(function(_) {
      return _.filter(function(O) {
        return !w.includes(O);
      });
    }));
  }, [w]), [S, C];
}
const Yu = /* @__PURE__ */ ee.createContext(void 0);
z.env.NODE_ENV !== "production" && (Yu.displayName = "zIndexContext");
const vr = 100, oP = 10, dm = vr * oP, iP = dm + vr, fm = {
  Modal: vr,
  Drawer: vr,
  Popover: vr,
  Popconfirm: vr,
  Tooltip: vr,
  Tour: vr,
  FloatButton: vr
}, aP = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function sP(e) {
  return e in fm;
}
const vm = (e, t) => {
  const [, n] = sr(), r = ee.useContext(Yu), o = sP(e);
  let i;
  if (t !== void 0)
    i = [t, t];
  else {
    let a = r ?? 0;
    o ? a += // Use preset token zIndex by default but not stack when has parent container
    (r ? 0 : n.zIndexPopupBase) + // Container offset
    fm[e] : a += aP[e], i = [r === void 0 ? t : a, a];
  }
  if (z.env.NODE_ENV !== "production") {
    const a = Pn(e), s = n.zIndexPopupBase + iP, l = i[0] || 0;
    z.env.NODE_ENV !== "production" && a(t !== void 0 || l <= s, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return i;
};
function dn() {
  dn = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, o = Object.defineProperty || function(A, R, D) {
    A[R] = D.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, a = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", l = i.toStringTag || "@@toStringTag";
  function c(A, R, D) {
    return Object.defineProperty(A, R, {
      value: D,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[R];
  }
  try {
    c({}, "");
  } catch {
    c = function(D, B, M) {
      return D[B] = M;
    };
  }
  function u(A, R, D, B) {
    var M = R && R.prototype instanceof C ? R : C, G = Object.create(M.prototype), H = new F(B || []);
    return o(G, "_invoke", {
      value: $(A, D, H)
    }), G;
  }
  function d(A, R, D) {
    try {
      return {
        type: "normal",
        arg: A.call(R, D)
      };
    } catch (B) {
      return {
        type: "throw",
        arg: B
      };
    }
  }
  t.wrap = u;
  var f = "suspendedStart", g = "suspendedYield", h = "executing", y = "completed", p = {};
  function C() {
  }
  function m() {
  }
  function b() {
  }
  var w = {};
  c(w, a, function() {
    return this;
  });
  var E = Object.getPrototypeOf, S = E && E(E(U([])));
  S && S !== n && r.call(S, a) && (w = S);
  var _ = b.prototype = C.prototype = Object.create(w);
  function O(A) {
    ["next", "throw", "return"].forEach(function(R) {
      c(A, R, function(D) {
        return this._invoke(R, D);
      });
    });
  }
  function P(A, R) {
    function D(M, G, H, X) {
      var K = d(A[M], A, G);
      if (K.type !== "throw") {
        var J = K.arg, ie = J.value;
        return ie && Ie(ie) == "object" && r.call(ie, "__await") ? R.resolve(ie.__await).then(function(le) {
          D("next", le, H, X);
        }, function(le) {
          D("throw", le, H, X);
        }) : R.resolve(ie).then(function(le) {
          J.value = le, H(J);
        }, function(le) {
          return D("throw", le, H, X);
        });
      }
      X(K.arg);
    }
    var B;
    o(this, "_invoke", {
      value: function(G, H) {
        function X() {
          return new R(function(K, J) {
            D(G, H, K, J);
          });
        }
        return B = B ? B.then(X, X) : X();
      }
    });
  }
  function $(A, R, D) {
    var B = f;
    return function(M, G) {
      if (B === h)
        throw Error("Generator is already running");
      if (B === y) {
        if (M === "throw")
          throw G;
        return {
          value: e,
          done: !0
        };
      }
      for (D.method = M, D.arg = G; ; ) {
        var H = D.delegate;
        if (H) {
          var X = L(H, D);
          if (X) {
            if (X === p)
              continue;
            return X;
          }
        }
        if (D.method === "next")
          D.sent = D._sent = D.arg;
        else if (D.method === "throw") {
          if (B === f)
            throw B = y, D.arg;
          D.dispatchException(D.arg);
        } else
          D.method === "return" && D.abrupt("return", D.arg);
        B = h;
        var K = d(A, R, D);
        if (K.type === "normal") {
          if (B = D.done ? y : g, K.arg === p)
            continue;
          return {
            value: K.arg,
            done: D.done
          };
        }
        K.type === "throw" && (B = y, D.method = "throw", D.arg = K.arg);
      }
    };
  }
  function L(A, R) {
    var D = R.method, B = A.iterator[D];
    if (B === e)
      return R.delegate = null, D === "throw" && A.iterator.return && (R.method = "return", R.arg = e, L(A, R), R.method === "throw") || D !== "return" && (R.method = "throw", R.arg = new TypeError("The iterator does not provide a '" + D + "' method")), p;
    var M = d(B, A.iterator, R.arg);
    if (M.type === "throw")
      return R.method = "throw", R.arg = M.arg, R.delegate = null, p;
    var G = M.arg;
    return G ? G.done ? (R[A.resultName] = G.value, R.next = A.nextLoc, R.method !== "return" && (R.method = "next", R.arg = e), R.delegate = null, p) : G : (R.method = "throw", R.arg = new TypeError("iterator result is not an object"), R.delegate = null, p);
  }
  function N(A) {
    var R = {
      tryLoc: A[0]
    };
    1 in A && (R.catchLoc = A[1]), 2 in A && (R.finallyLoc = A[2], R.afterLoc = A[3]), this.tryEntries.push(R);
  }
  function k(A) {
    var R = A.completion || {};
    R.type = "normal", delete R.arg, A.completion = R;
  }
  function F(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(N, this), this.reset(!0);
  }
  function U(A) {
    if (A || A === "") {
      var R = A[a];
      if (R)
        return R.call(A);
      if (typeof A.next == "function")
        return A;
      if (!isNaN(A.length)) {
        var D = -1, B = function M() {
          for (; ++D < A.length; )
            if (r.call(A, D))
              return M.value = A[D], M.done = !1, M;
          return M.value = e, M.done = !0, M;
        };
        return B.next = B;
      }
    }
    throw new TypeError(Ie(A) + " is not iterable");
  }
  return m.prototype = b, o(_, "constructor", {
    value: b,
    configurable: !0
  }), o(b, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = c(b, l, "GeneratorFunction"), t.isGeneratorFunction = function(A) {
    var R = typeof A == "function" && A.constructor;
    return !!R && (R === m || (R.displayName || R.name) === "GeneratorFunction");
  }, t.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, b) : (A.__proto__ = b, c(A, l, "GeneratorFunction")), A.prototype = Object.create(_), A;
  }, t.awrap = function(A) {
    return {
      __await: A
    };
  }, O(P.prototype), c(P.prototype, s, function() {
    return this;
  }), t.AsyncIterator = P, t.async = function(A, R, D, B, M) {
    M === void 0 && (M = Promise);
    var G = new P(u(A, R, D, B), M);
    return t.isGeneratorFunction(R) ? G : G.next().then(function(H) {
      return H.done ? H.value : G.next();
    });
  }, O(_), c(_, l, "Generator"), c(_, a, function() {
    return this;
  }), c(_, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(A) {
    var R = Object(A), D = [];
    for (var B in R)
      D.push(B);
    return D.reverse(), function M() {
      for (; D.length; ) {
        var G = D.pop();
        if (G in R)
          return M.value = G, M.done = !1, M;
      }
      return M.done = !0, M;
    };
  }, t.values = U, F.prototype = {
    constructor: F,
    reset: function(R) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(k), !R)
        for (var D in this)
          D.charAt(0) === "t" && r.call(this, D) && !isNaN(+D.slice(1)) && (this[D] = e);
    },
    stop: function() {
      this.done = !0;
      var R = this.tryEntries[0].completion;
      if (R.type === "throw")
        throw R.arg;
      return this.rval;
    },
    dispatchException: function(R) {
      if (this.done)
        throw R;
      var D = this;
      function B(J, ie) {
        return H.type = "throw", H.arg = R, D.next = J, ie && (D.method = "next", D.arg = e), !!ie;
      }
      for (var M = this.tryEntries.length - 1; M >= 0; --M) {
        var G = this.tryEntries[M], H = G.completion;
        if (G.tryLoc === "root")
          return B("end");
        if (G.tryLoc <= this.prev) {
          var X = r.call(G, "catchLoc"), K = r.call(G, "finallyLoc");
          if (X && K) {
            if (this.prev < G.catchLoc)
              return B(G.catchLoc, !0);
            if (this.prev < G.finallyLoc)
              return B(G.finallyLoc);
          } else if (X) {
            if (this.prev < G.catchLoc)
              return B(G.catchLoc, !0);
          } else {
            if (!K)
              throw Error("try statement without catch or finally");
            if (this.prev < G.finallyLoc)
              return B(G.finallyLoc);
          }
        }
      }
    },
    abrupt: function(R, D) {
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var M = this.tryEntries[B];
        if (M.tryLoc <= this.prev && r.call(M, "finallyLoc") && this.prev < M.finallyLoc) {
          var G = M;
          break;
        }
      }
      G && (R === "break" || R === "continue") && G.tryLoc <= D && D <= G.finallyLoc && (G = null);
      var H = G ? G.completion : {};
      return H.type = R, H.arg = D, G ? (this.method = "next", this.next = G.finallyLoc, p) : this.complete(H);
    },
    complete: function(R, D) {
      if (R.type === "throw")
        throw R.arg;
      return R.type === "break" || R.type === "continue" ? this.next = R.arg : R.type === "return" ? (this.rval = this.arg = R.arg, this.method = "return", this.next = "end") : R.type === "normal" && D && (this.next = D), p;
    },
    finish: function(R) {
      for (var D = this.tryEntries.length - 1; D >= 0; --D) {
        var B = this.tryEntries[D];
        if (B.finallyLoc === R)
          return this.complete(B.completion, B.afterLoc), k(B), p;
      }
    },
    catch: function(R) {
      for (var D = this.tryEntries.length - 1; D >= 0; --D) {
        var B = this.tryEntries[D];
        if (B.tryLoc === R) {
          var M = B.completion;
          if (M.type === "throw") {
            var G = M.arg;
            k(B);
          }
          return G;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(R, D, B) {
      return this.delegate = {
        iterator: U(R),
        resultName: D,
        nextLoc: B
      }, this.method === "next" && (this.arg = e), p;
    }
  }, t;
}
function Kf(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a), l = s.value;
  } catch (c) {
    return void n(c);
  }
  s.done ? t(l) : Promise.resolve(l).then(r, o);
}
function vo(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(t, n);
      function a(l) {
        Kf(i, r, o, a, s, "next", l);
      }
      function s(l) {
        Kf(i, r, o, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
var ta = V({}, yg), lP = ta.version, Fl = ta.render, cP = ta.unmountComponentAtNode, Xs;
try {
  var uP = Number((lP || "").split(".")[0]);
  uP >= 18 && (Xs = ta.createRoot);
} catch {
}
function Xf(e) {
  var t = ta.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && Ie(t) === "object" && (t.usingClientEntryPoint = e);
}
var ms = "__rc_react_root__";
function dP(e, t) {
  Xf(!0);
  var n = t[ms] || Xs(t);
  Xf(!1), n.render(e), t[ms] = n;
}
function fP(e, t) {
  Fl == null || Fl(e, t);
}
function vP(e, t) {
  if (Xs) {
    dP(e, t);
    return;
  }
  fP(e, t);
}
function gP(e) {
  return Yc.apply(this, arguments);
}
function Yc() {
  return Yc = vo(/* @__PURE__ */ dn().mark(function e(t) {
    return dn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = t[ms]) === null || o === void 0 || o.unmount(), delete t[ms];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), Yc.apply(this, arguments);
}
function pP(e) {
  cP(e);
}
function hP(e) {
  return Zc.apply(this, arguments);
}
function Zc() {
  return Zc = vo(/* @__PURE__ */ dn().mark(function e(t) {
    return dn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (Xs === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", gP(t));
          case 2:
            pP(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), Zc.apply(this, arguments);
}
const mP = (e, t) => {
  if (z.env.NODE_ENV !== "production") {
    const n = parseInt(v.version.split(".")[0], 10), r = Object.keys(yg);
    z.env.NODE_ENV !== "production" && fo(n < 19 || r.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.");
  }
  return vP(e, t), () => hP(t);
};
let yP = mP;
function gm() {
  return yP;
}
const jl = () => ({
  height: 0,
  opacity: 0
}), Yf = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, bP = (e) => ({
  height: e ? e.offsetHeight : 0
}), Bl = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", CP = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ui}-motion-collapse`,
    onAppearStart: jl,
    onEnterStart: jl,
    onAppearActive: Yf,
    onEnterActive: Yf,
    onLeaveStart: bP,
    onLeaveActive: jl,
    onAppearEnd: Bl,
    onEnterEnd: Bl,
    onLeaveEnd: Bl,
    motionDeadline: 500
  };
}, pm = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, Zu = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect(), i = o.width, a = o.height;
      if (i || a)
        return !0;
    }
  }
  return !1;
}, wP = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, SP = aO("Wave", (e) => [wP(e)]), hm = `${Ui}-wave-target`;
function Vl(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function EP(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return Vl(t) ? t : Vl(n) ? n : Vl(r) ? r : null;
}
function zl(e) {
  return Number.isNaN(e) ? 0 : e;
}
const _P = (e) => {
  const {
    className: t,
    target: n,
    component: r,
    registerUnmount: o
  } = e, i = v.useRef(null), a = v.useRef(null);
  v.useEffect(() => {
    a.current = o();
  }, []);
  const [s, l] = v.useState(null), [c, u] = v.useState([]), [d, f] = v.useState(0), [g, h] = v.useState(0), [y, p] = v.useState(0), [C, m] = v.useState(0), [b, w] = v.useState(!1), E = {
    left: d,
    top: g,
    width: y,
    height: C,
    borderRadius: c.map((O) => `${O}px`).join(" ")
  };
  s && (E["--wave-color"] = s);
  function S() {
    const O = getComputedStyle(n);
    l(EP(n));
    const P = O.position === "static", {
      borderLeftWidth: $,
      borderTopWidth: L
    } = O;
    f(P ? n.offsetLeft : zl(-parseFloat($))), h(P ? n.offsetTop : zl(-parseFloat(L))), p(n.offsetWidth), m(n.offsetHeight);
    const {
      borderTopLeftRadius: N,
      borderTopRightRadius: k,
      borderBottomLeftRadius: F,
      borderBottomRightRadius: U
    } = O;
    u([N, k, U, F].map((A) => zl(parseFloat(A))));
  }
  if (v.useEffect(() => {
    if (n) {
      const O = pn(() => {
        S(), w(!0);
      });
      let P;
      return typeof ResizeObserver < "u" && (P = new ResizeObserver(S), P.observe(n)), () => {
        pn.cancel(O), P == null || P.disconnect();
      };
    }
  }, []), !b)
    return null;
  const _ = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(hm));
  return /* @__PURE__ */ v.createElement(ii, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (O, P) => {
      var $, L;
      if (P.deadline || P.propertyName === "opacity") {
        const N = ($ = i.current) === null || $ === void 0 ? void 0 : $.parentElement;
        (L = a.current) === null || L === void 0 || L.call(a).then(() => {
          N == null || N.remove();
        });
      }
      return !1;
    }
  }, (O, P) => {
    let {
      className: $
    } = O;
    return /* @__PURE__ */ v.createElement("div", {
      ref: Xi(i, P),
      className: se(t, $, {
        "wave-quick": _
      }),
      style: E
    });
  });
}, xP = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const o = document.createElement("div");
  o.style.position = "absolute", o.style.left = "0px", o.style.top = "0px", e == null || e.insertBefore(o, e == null ? void 0 : e.firstChild);
  const i = gm();
  let a = null;
  function s() {
    return a;
  }
  a = i(/* @__PURE__ */ v.createElement(_P, Object.assign({}, t, {
    target: e,
    registerUnmount: s
  })), o);
}, OP = (e, t, n) => {
  const {
    wave: r
  } = v.useContext(kt), [, o, i] = sr(), a = sn((c) => {
    const u = e.current;
    if (r != null && r.disabled || !u)
      return;
    const d = u.querySelector(`.${hm}`) || u, {
      showEffect: f
    } = r || {};
    (f || xP)(d, {
      className: t,
      token: o,
      component: n,
      event: c,
      hashId: i
    });
  }), s = v.useRef(null);
  return (c) => {
    pn.cancel(s.current), s.current = pn(() => {
      a(c);
    });
  };
}, mm = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: o
  } = Kt(kt), i = st(null), a = o("wave"), [, s] = SP(a), l = OP(i, se(a, s), r);
  if (ee.useEffect(() => {
    const u = i.current;
    if (!u || u.nodeType !== 1 || n)
      return;
    const d = (f) => {
      !Zu(f.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || l(f);
    };
    return u.addEventListener("click", d, !0), () => {
      u.removeEventListener("click", d, !0);
    };
  }, [n]), !/* @__PURE__ */ ee.isValidElement(t))
    return t ?? null;
  const c = Zi(t) ? Xi(ks(t), i) : i;
  return _r(t, {
    ref: c
  });
};
z.env.NODE_ENV !== "production" && (mm.displayName = "Wave");
const ym = (e) => {
  const t = ee.useContext(Ko);
  return ee.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, bm = /* @__PURE__ */ v.createContext(null), PP = (e, t) => {
  const n = v.useContext(bm), r = v.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: o,
      isFirstItem: i,
      isLastItem: a
    } = n, s = o === "vertical" ? "-vertical-" : "-";
    return se(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: i,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, IP = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ v.createElement(bm.Provider, {
    value: null
  }, t);
};
var TP = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Cm = /* @__PURE__ */ v.createContext(void 0), $P = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = v.useContext(kt), {
    prefixCls: r,
    size: o,
    className: i
  } = e, a = TP(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , l] = sr();
  let c = "";
  switch (o) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
  }
  if (z.env.NODE_ENV !== "production") {
    const d = Pn("Button.Group");
    z.env.NODE_ENV !== "production" && d(!o || ["large", "small", "middle"].includes(o), "usage", "Invalid prop `size`.");
  }
  const u = se(s, {
    [`${s}-${c}`]: c,
    [`${s}-rtl`]: n === "rtl"
  }, i, l);
  return /* @__PURE__ */ v.createElement(Cm.Provider, {
    value: o
  }, /* @__PURE__ */ v.createElement("div", Object.assign({}, a, {
    className: u
  })));
}, Zf = /^[\u4E00-\u9FA5]{2}$/, Qc = Zf.test.bind(Zf);
function Qf(e) {
  return typeof e == "string";
}
function Ta(e) {
  return e === "text" || e === "link";
}
function RP(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && Qf(e.type) && Qc(e.props.children) ? _r(e, {
    children: e.props.children.split("").join(n)
  }) : Qf(e) ? Qc(e) ? /* @__PURE__ */ ee.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ ee.createElement("span", null, e) : am(e) ? /* @__PURE__ */ ee.createElement("span", null, e) : e;
}
function NP(e, t) {
  let n = !1;
  const r = [];
  return ee.Children.forEach(e, (o) => {
    const i = typeof o, a = i === "string" || i === "number";
    if (n && a) {
      const s = r.length - 1, l = r[s];
      r[s] = `${l}${o}`;
    } else
      r.push(o);
    n = a;
  }), ee.Children.map(r, (o) => RP(o, t));
}
["default", "primary", "danger"].concat(he(io));
const Jc = /* @__PURE__ */ lo((e, t) => {
  const {
    className: n,
    style: r,
    children: o,
    prefixCls: i
  } = e, a = se(`${i}-icon`, n);
  return /* @__PURE__ */ ee.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, o);
}), Jf = /* @__PURE__ */ lo((e, t) => {
  const {
    prefixCls: n,
    className: r,
    style: o,
    iconClassName: i
  } = e, a = se(`${n}-loading-icon`, r);
  return /* @__PURE__ */ ee.createElement(Jc, {
    prefixCls: n,
    className: a,
    style: o,
    ref: t
  }, /* @__PURE__ */ ee.createElement(Ns, {
    className: i
  }));
}), Hl = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), Ul = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), AP = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: o,
    style: i,
    mount: a
  } = e, s = !!n;
  return r ? /* @__PURE__ */ ee.createElement(Jf, {
    prefixCls: t,
    className: o,
    style: i
  }) : /* @__PURE__ */ ee.createElement(ii, {
    visible: s,
    // Used for minus flex gap style only
    motionName: `${t}-loading-icon-motion`,
    motionAppear: !a,
    motionEnter: !a,
    motionLeave: !a,
    removeOnLeave: !0,
    onAppearStart: Hl,
    onAppearActive: Ul,
    onEnterStart: Hl,
    onEnterActive: Ul,
    onLeaveStart: Ul,
    onLeaveActive: Hl
  }, (l, c) => {
    let {
      className: u,
      style: d
    } = l;
    const f = Object.assign(Object.assign({}, i), d);
    return /* @__PURE__ */ ee.createElement(Jf, {
      prefixCls: t,
      className: se(o, u),
      style: f,
      ref: c
    });
  });
}, ev = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), kP = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: o,
    colorErrorHover: i
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      ev(`${t}-primary`, o),
      ev(`${t}-danger`, i)
    ]
  };
};
var MP = ["b"], LP = ["v"], Wl = function(t) {
  return Math.round(Number(t || 0));
}, DP = function(t) {
  if (t instanceof Tt)
    return t;
  if (t && Ie(t) === "object" && "h" in t && "b" in t) {
    var n = t, r = n.b, o = ht(n, MP);
    return V(V({}, o), {}, {
      v: r
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, Cr = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n(r) {
    return Yt(this, n), t.call(this, DP(r));
  }
  return Zt(n, [{
    key: "toHsbString",
    value: function() {
      var o = this.toHsb(), i = Wl(o.s * 100), a = Wl(o.b * 100), s = Wl(o.h), l = o.a, c = "hsb(".concat(s, ", ").concat(i, "%, ").concat(a, "%)"), u = "hsba(".concat(s, ", ").concat(i, "%, ").concat(a, "%, ").concat(l.toFixed(l === 0 ? 0 : 2), ")");
      return l === 1 ? c : u;
    }
  }, {
    key: "toHsb",
    value: function() {
      var o = this.toHsv(), i = o.v, a = ht(o, LP);
      return V(V({}, a), {}, {
        b: i,
        a: this.a
      });
    }
  }]), n;
}(Tt), FP = "rc-color-picker", Bo = function(t) {
  return t instanceof Cr ? t : new Cr(t);
}, jP = Bo("#1677ff"), wm = function(t) {
  var n = t.offset, r = t.targetRef, o = t.containerRef, i = t.color, a = t.type, s = o.current.getBoundingClientRect(), l = s.width, c = s.height, u = r.current.getBoundingClientRect(), d = u.width, f = u.height, g = d / 2, h = f / 2, y = (n.x + g) / l, p = 1 - (n.y + h) / c, C = i.toHsb(), m = y, b = (n.x + g) / l * 360;
  if (a)
    switch (a) {
      case "hue":
        return Bo(V(V({}, C), {}, {
          h: b <= 0 ? 0 : b
        }));
      case "alpha":
        return Bo(V(V({}, C), {}, {
          a: m <= 0 ? 0 : m
        }));
    }
  return Bo({
    h: C.h,
    s: y <= 0 ? 0 : y,
    b: p >= 1 ? 1 : p,
    a: C.a
  });
}, Sm = function(t, n) {
  var r = t.toHsb();
  switch (n) {
    case "hue":
      return {
        x: r.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    default:
      return {
        x: r.s * 100,
        y: (1 - r.b) * 100
      };
  }
}, BP = function(t) {
  var n = t.color, r = t.prefixCls, o = t.className, i = t.style, a = t.onClick, s = "".concat(r, "-color-block");
  return /* @__PURE__ */ ee.createElement("div", {
    className: se(s, o),
    style: i,
    onClick: a
  }, /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(s, "-inner"),
    style: {
      background: n
    }
  }));
};
function VP(e) {
  var t = "touches" in e ? e.touches[0] : e, n = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, r = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - n,
    pageY: t.pageY - r
  };
}
function Em(e) {
  var t = e.targetRef, n = e.containerRef, r = e.direction, o = e.onDragChange, i = e.onDragChangeComplete, a = e.calculate, s = e.color, l = e.disabledDrag, c = Ht({
    x: 0,
    y: 0
  }), u = Q(c, 2), d = u[0], f = u[1], g = st(null), h = st(null);
  At(function() {
    f(a());
  }, [s]), At(function() {
    return function() {
      document.removeEventListener("mousemove", g.current), document.removeEventListener("mouseup", h.current), document.removeEventListener("touchmove", g.current), document.removeEventListener("touchend", h.current), g.current = null, h.current = null;
    };
  }, []);
  var y = function(w) {
    var E = VP(w), S = E.pageX, _ = E.pageY, O = n.current.getBoundingClientRect(), P = O.x, $ = O.y, L = O.width, N = O.height, k = t.current.getBoundingClientRect(), F = k.width, U = k.height, A = F / 2, R = U / 2, D = Math.max(0, Math.min(S - P, L)) - A, B = Math.max(0, Math.min(_ - $, N)) - R, M = {
      x: D,
      y: r === "x" ? d.y : B
    };
    if (F === 0 && U === 0 || F !== U)
      return !1;
    o == null || o(M);
  }, p = function(w) {
    w.preventDefault(), y(w);
  }, C = function(w) {
    w.preventDefault(), document.removeEventListener("mousemove", g.current), document.removeEventListener("mouseup", h.current), document.removeEventListener("touchmove", g.current), document.removeEventListener("touchend", h.current), g.current = null, h.current = null, i == null || i();
  }, m = function(w) {
    document.removeEventListener("mousemove", g.current), document.removeEventListener("mouseup", h.current), !l && (y(w), document.addEventListener("mousemove", p), document.addEventListener("mouseup", C), document.addEventListener("touchmove", p), document.addEventListener("touchend", C), g.current = p, h.current = C);
  };
  return [d, m];
}
var _m = function(t) {
  var n = t.size, r = n === void 0 ? "default" : n, o = t.color, i = t.prefixCls;
  return /* @__PURE__ */ ee.createElement("div", {
    className: se("".concat(i, "-handler"), j({}, "".concat(i, "-handler-sm"), r === "small")),
    style: {
      backgroundColor: o
    }
  });
}, xm = function(t) {
  var n = t.children, r = t.style, o = t.prefixCls;
  return /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(o, "-palette"),
    style: V({
      position: "relative"
    }, r)
  }, n);
}, Om = /* @__PURE__ */ lo(function(e, t) {
  var n = e.children, r = e.x, o = e.y;
  return /* @__PURE__ */ ee.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(r, "%"),
      top: "".concat(o, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, n);
}), zP = function(t) {
  var n = t.color, r = t.onChange, o = t.prefixCls, i = t.onChangeComplete, a = t.disabled, s = st(), l = st(), c = st(n), u = sn(function(y) {
    var p = wm({
      offset: y,
      targetRef: l,
      containerRef: s,
      color: n
    });
    c.current = p, r(p);
  }), d = Em({
    color: n,
    containerRef: s,
    targetRef: l,
    calculate: function() {
      return Sm(n);
    },
    onDragChange: u,
    onDragChangeComplete: function() {
      return i == null ? void 0 : i(c.current);
    },
    disabledDrag: a
  }), f = Q(d, 2), g = f[0], h = f[1];
  return /* @__PURE__ */ ee.createElement("div", {
    ref: s,
    className: "".concat(o, "-select"),
    onMouseDown: h,
    onTouchStart: h
  }, /* @__PURE__ */ ee.createElement(xm, {
    prefixCls: o
  }, /* @__PURE__ */ ee.createElement(Om, {
    x: g.x,
    y: g.y,
    ref: l
  }, /* @__PURE__ */ ee.createElement(_m, {
    color: n.toRgbString(),
    prefixCls: o
  })), /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(o, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(n.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, HP = function(t, n) {
  var r = to(t, {
    value: n
  }), o = Q(r, 2), i = o[0], a = o[1], s = Kn(function() {
    return Bo(i);
  }, [i]);
  return [s, a];
}, UP = function(t) {
  var n = t.colors, r = t.children, o = t.direction, i = o === void 0 ? "to right" : o, a = t.type, s = t.prefixCls, l = Kn(function() {
    return n.map(function(c, u) {
      var d = Bo(c);
      return a === "alpha" && u === n.length - 1 && (d = new Cr(d.setA(1))), d.toRgbString();
    }).join(",");
  }, [n, a]);
  return /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(s, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(i, ", ").concat(l, ")")
    }
  }, r);
}, WP = function(t) {
  var n = t.prefixCls, r = t.colors, o = t.disabled, i = t.onChange, a = t.onChangeComplete, s = t.color, l = t.type, c = st(), u = st(), d = st(s), f = function(E) {
    return l === "hue" ? E.getHue() : E.a * 100;
  }, g = sn(function(w) {
    var E = wm({
      offset: w,
      targetRef: u,
      containerRef: c,
      color: s,
      type: l
    });
    d.current = E, i(f(E));
  }), h = Em({
    color: s,
    targetRef: u,
    containerRef: c,
    calculate: function() {
      return Sm(s, l);
    },
    onDragChange: g,
    onDragChangeComplete: function() {
      a(f(d.current));
    },
    direction: "x",
    disabledDrag: o
  }), y = Q(h, 2), p = y[0], C = y[1], m = ee.useMemo(function() {
    if (l === "hue") {
      var w = s.toHsb();
      w.s = 1, w.b = 1, w.a = 1;
      var E = new Cr(w);
      return E;
    }
    return s;
  }, [s, l]), b = ee.useMemo(function() {
    return r.map(function(w) {
      return "".concat(w.color, " ").concat(w.percent, "%");
    });
  }, [r]);
  return /* @__PURE__ */ ee.createElement("div", {
    ref: c,
    className: se("".concat(n, "-slider"), "".concat(n, "-slider-").concat(l)),
    onMouseDown: C,
    onTouchStart: C
  }, /* @__PURE__ */ ee.createElement(xm, {
    prefixCls: n
  }, /* @__PURE__ */ ee.createElement(Om, {
    x: p.x,
    y: p.y,
    ref: u
  }, /* @__PURE__ */ ee.createElement(_m, {
    size: "small",
    color: m.toHexString(),
    prefixCls: n
  })), /* @__PURE__ */ ee.createElement(UP, {
    colors: b,
    type: l,
    prefixCls: n
  })));
};
function qP(e) {
  return v.useMemo(function() {
    var t = e || {}, n = t.slider;
    return [n || WP];
  }, [e]);
}
var GP = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], KP = /* @__PURE__ */ lo(function(e, t) {
  var n = e.value, r = e.defaultValue, o = e.prefixCls, i = o === void 0 ? FP : o, a = e.onChange, s = e.onChangeComplete, l = e.className, c = e.style, u = e.panelRender, d = e.disabledAlpha, f = d === void 0 ? !1 : d, g = e.disabled, h = g === void 0 ? !1 : g, y = e.components, p = qP(y), C = Q(p, 1), m = C[0], b = HP(r || jP, n), w = Q(b, 2), E = w[0], S = w[1], _ = Kn(function() {
    return E.setA(1).toRgbString();
  }, [E]), O = function(B, M) {
    n || S(B), a == null || a(B, M);
  }, P = function(B) {
    return new Cr(E.setHue(B));
  }, $ = function(B) {
    return new Cr(E.setA(B / 100));
  }, L = function(B) {
    O(P(B), {
      type: "hue",
      value: B
    });
  }, N = function(B) {
    O($(B), {
      type: "alpha",
      value: B
    });
  }, k = function(B) {
    s && s(P(B));
  }, F = function(B) {
    s && s($(B));
  }, U = se("".concat(i, "-panel"), l, j({}, "".concat(i, "-panel-disabled"), h)), A = {
    prefixCls: i,
    disabled: h,
    color: E
  }, R = /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(zP, Pe({
    onChange: O
  }, A, {
    onChangeComplete: s
  })), /* @__PURE__ */ ee.createElement("div", {
    className: "".concat(i, "-slider-container")
  }, /* @__PURE__ */ ee.createElement("div", {
    className: se("".concat(i, "-slider-group"), j({}, "".concat(i, "-slider-group-disabled-alpha"), f))
  }, /* @__PURE__ */ ee.createElement(m, Pe({}, A, {
    type: "hue",
    colors: GP,
    min: 0,
    max: 359,
    value: E.getHue(),
    onChange: L,
    onChangeComplete: k
  })), !f && /* @__PURE__ */ ee.createElement(m, Pe({}, A, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: _
    }],
    min: 0,
    max: 100,
    value: E.a * 100,
    onChange: N,
    onChangeComplete: F
  }))), /* @__PURE__ */ ee.createElement(BP, {
    color: E.toRgbString(),
    prefixCls: i
  })));
  return /* @__PURE__ */ ee.createElement("div", {
    className: U,
    style: c,
    ref: t
  }, typeof u == "function" ? u(R) : R);
});
z.env.NODE_ENV !== "production" && (KP.displayName = "ColorPicker");
const XP = (e, t) => (e == null ? void 0 : e.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6)) || "", YP = (e, t) => e ? XP(e, t) : "";
let ZP = /* @__PURE__ */ function() {
  function e(t) {
    Yt(this, e);
    var n;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (n = t.colors) === null || n === void 0 ? void 0 : n.map((o) => ({
        color: new e(o.color),
        percent: o.percent
      })), this.cleared = t.cleared;
      return;
    }
    const r = Array.isArray(t);
    r && t.length ? (this.colors = t.map((o) => {
      let {
        color: i,
        percent: a
      } = o;
      return {
        color: new e(i),
        percent: a
      };
    }), this.metaColor = new Cr(this.colors[0].color.metaColor)) : this.metaColor = new Cr(r ? "" : t), (!t || r && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return Zt(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return YP(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: n
      } = this;
      return n ? `linear-gradient(90deg, ${n.map((o) => `${o.color.toRgbString()} ${o.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(n) {
      return !n || this.isGradient() !== n.isGradient() ? !1 : this.isGradient() ? this.colors.length === n.colors.length && this.colors.every((r, o) => {
        const i = n.colors[o];
        return r.percent === i.percent && r.color.equals(i.color);
      }) : this.toHexString() === n.toHexString();
    }
  }]);
}();
const QP = (e) => ({
  [e.componentCls]: {
    // For common/openAnimation
    [`${e.antCls}-motion-collapse-legacy`]: {
      overflow: "hidden",
      "&-active": {
        transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
      }
    },
    [`${e.antCls}-motion-collapse`]: {
      overflow: "hidden",
      transition: `height ${e.motionDurationMid} ${e.motionEaseInOut},
        opacity ${e.motionDurationMid} ${e.motionEaseInOut} !important`
    }
  }
}), JP = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), eI = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), Pm = function(e, t, n, r) {
  const i = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${i}${e}-enter,
      ${i}${e}-appear
    `]: Object.assign(Object.assign({}, JP(r)), {
      animationPlayState: "paused"
    }),
    [`${i}${e}-leave`]: Object.assign(Object.assign({}, eI(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${i}${e}-enter${e}-enter-active,
      ${i}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${i}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, tI = new _t("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), nI = new _t("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), rI = new _t("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), oI = new _t("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), iI = new _t("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), aI = new _t("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), sI = new _t("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), lI = new _t("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), cI = {
  "slide-up": {
    inKeyframes: tI,
    outKeyframes: nI
  },
  "slide-down": {
    inKeyframes: rI,
    outKeyframes: oI
  },
  "slide-left": {
    inKeyframes: iI,
    outKeyframes: aI
  },
  "slide-right": {
    inKeyframes: sI,
    outKeyframes: lI
  }
}, tv = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = cI[t];
  return [Pm(r, o, i, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, uI = new _t("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), dI = new _t("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), nv = new _t("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), rv = new _t("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), fI = new _t("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), vI = new _t("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), gI = new _t("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), pI = new _t("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), hI = new _t("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), mI = new _t("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), yI = new _t("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), bI = new _t("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), CI = {
  zoom: {
    inKeyframes: uI,
    outKeyframes: dI
  },
  "zoom-big": {
    inKeyframes: nv,
    outKeyframes: rv
  },
  "zoom-big-fast": {
    inKeyframes: nv,
    outKeyframes: rv
  },
  "zoom-left": {
    inKeyframes: gI,
    outKeyframes: pI
  },
  "zoom-right": {
    inKeyframes: hI,
    outKeyframes: mI
  },
  "zoom-up": {
    inKeyframes: fI,
    outKeyframes: vI
  },
  "zoom-down": {
    inKeyframes: yI,
    outKeyframes: bI
  }
}, Qu = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: o,
    outKeyframes: i
  } = CI[t];
  return [Pm(r, o, i, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, wI = (e, t) => {
  const {
    r: n,
    g: r,
    b: o,
    a: i
  } = e.toRgb(), a = new Cr(e.toRgbString()).onBackground(t).toHsv();
  return i <= 0.5 ? a.v > 0.5 : n * 0.299 + r * 0.587 + o * 0.114 > 192;
}, Im = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n
  } = e;
  return hn(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: n
  });
}, Tm = (e) => {
  var t, n, r, o, i, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, l = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, c = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, u = (o = e.contentLineHeight) !== null && o !== void 0 ? o : Za(s), d = (i = e.contentLineHeightSM) !== null && i !== void 0 ? i : Za(l), f = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : Za(c), g = wI(new ZP(e.colorBgSolid), "#fff") ? "#000" : "#fff";
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: g,
    contentFontSize: s,
    contentFontSizeSM: l,
    contentFontSizeLG: c,
    contentLineHeight: u,
    contentLineHeightSM: d,
    contentLineHeightLG: f,
    paddingBlock: Math.max((e.controlHeight - s * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - l * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - c * f) / 2 - e.lineWidth, 0)
  };
}, SI = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r,
    opacityLoading: o,
    motionDurationSlow: i,
    motionEaseInOut: a,
    marginXS: s,
    calc: l
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${ke(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${t}-icon > svg`]: Ku(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": zh(e),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${t}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${t}-compact-item`]: {
          flex: "none"
        },
        [`&${t}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${t}-loading`]: {
        opacity: o,
        cursor: "default"
      },
      [`${t}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((c) => `${c} ${i} ${a}`).join(",")
      },
      // iconPosition
      [`&:not(${t}-icon-end)`]: {
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: l(s).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: l(s).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: l(s).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: l(s).mul(-1).equal()
          }
        }
      }
    }
  };
}, $m = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), EI = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), _I = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), xI = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), Ju = (e, t, n, r, o, i, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, $m(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: o || void 0,
      borderColor: i || void 0
    }
  })
}), OI = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, xI(e))
}), PI = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), Ys = (e, t, n, r) => {
  const i = r && ["link", "text"].includes(r) ? PI : OI;
  return Object.assign(Object.assign({}, i(e)), $m(e.componentCls, t, n));
}, Zs = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: n
  }, Ys(e, r, o))
}), Qs = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: n
  }, Ys(e, r, o))
}), Js = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), el = (e, t, n, r) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, Ys(e, n, r))
}), Hr = (e, t, n, r, o) => ({
  [`&${e.componentCls}-variant-${n}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, Ys(e, r, o, n))
}), II = (e) => {
  const {
    componentCls: t
  } = e;
  return io.reduce((n, r) => {
    const o = e[`${r}6`], i = e[`${r}1`], a = e[`${r}5`], s = e[`${r}2`], l = e[`${r}3`], c = e[`${r}7`], u = `0 ${ke(e.controlOutlineWidth)} 0 ${e[`${r}1`]}`;
    return Object.assign(Object.assign({}, n), {
      [`&${t}-color-${r}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: o,
        boxShadow: u
      }, Zs(e, e.colorTextLightSolid, o, {
        background: a
      }, {
        background: c
      })), Qs(e, o, e.colorBgContainer, {
        color: a,
        borderColor: a,
        background: e.colorBgContainer
      }, {
        color: c,
        borderColor: c,
        background: e.colorBgContainer
      })), Js(e)), el(e, i, {
        background: s
      }, {
        background: l
      })), Hr(e, o, "link", {
        color: a
      }, {
        color: c
      })), Hr(e, o, "text", {
        color: a,
        background: i
      }, {
        color: c,
        background: l
      }))
    });
  }, {});
}, TI = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, Zs(e, e.solidTextColor, e.colorBgSolid, {
  color: e.solidTextColor,
  background: e.colorBgSolidHover
}, {
  color: e.solidTextColor,
  background: e.colorBgSolidActive
})), Js(e)), el(e, e.colorFillTertiary, {
  background: e.colorFillSecondary
}, {
  background: e.colorFill
})), Hr(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), Ju(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), $I = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, Qs(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), Js(e)), el(e, e.colorPrimaryBg, {
  background: e.colorPrimaryBgHover
}, {
  background: e.colorPrimaryBorder
})), Hr(e, e.colorLink, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), Ju(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), RI = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, Zs(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), Qs(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), Js(e)), el(e, e.colorErrorBg, {
  background: e.colorErrorBgFilledHover
}, {
  background: e.colorErrorBgActive
})), Hr(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), Hr(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), Ju(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), NI = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-color-default`]: TI(e),
    [`${t}-color-primary`]: $I(e),
    [`${t}-color-dangerous`]: RI(e)
  }, II(e));
}, AI = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, Qs(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), Hr(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), Zs(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), Hr(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), ed = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: o,
    borderRadius: i,
    buttonPaddingHorizontal: a,
    iconCls: s,
    buttonPaddingVertical: l,
    buttonIconOnlyFontSize: c
  } = e;
  return [
    {
      [t]: {
        fontSize: o,
        height: r,
        padding: `${ke(l)} ${ke(a)}`,
        borderRadius: i,
        [`&${n}-icon-only`]: {
          width: r,
          [s]: {
            fontSize: c
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: EI(e)
    },
    {
      [`${n}${n}-round${t}`]: _I(e)
    }
  ];
}, kI = (e) => {
  const t = hn(e, {
    fontSize: e.contentFontSize
  });
  return ed(t, e.componentCls);
}, MI = (e) => {
  const t = hn(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return ed(t, `${e.componentCls}-sm`);
}, LI = (e) => {
  const t = hn(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return ed(t, `${e.componentCls}-lg`);
}, DI = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, FI = Er("Button", (e) => {
  const t = Im(e);
  return [
    // Shared
    SI(t),
    // Size
    kI(t),
    MI(t),
    LI(t),
    // Block
    DI(t),
    // Color
    NI(t),
    // https://github.com/ant-design/ant-design/issues/50969
    AI(t),
    // Button Group
    kP(t)
  ];
}, Tm, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function jI(e, t, n) {
  const {
    focusElCls: r,
    focus: o,
    borderElCls: i
  } = n, a = i ? "> *" : "", s = ["hover", o ? "focus" : null, "active"].filter(Boolean).map((l) => `&:${l} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function BI(e, t, n) {
  const {
    borderElCls: r
  } = n, o = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${o}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${o}, &${e}-sm ${o}, &${e}-lg ${o}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function VI(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, jI(e, r, t)), BI(n, r, t))
  };
}
function zI(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function HI(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function UI(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, zI(e, t)), HI(e.componentCls, t))
  };
}
const WI = (e) => {
  const {
    componentCls: t,
    colorPrimaryHover: n,
    lineWidth: r,
    calc: o
  } = e, i = o(r).mul(-1).equal(), a = (s) => {
    const l = `${t}-compact${s ? "-vertical" : ""}-item${t}-primary:not([disabled])`;
    return {
      [`${l} + ${l}::before`]: {
        position: "absolute",
        top: s ? i : 0,
        insetInlineStart: s ? 0 : i,
        backgroundColor: n,
        content: '""',
        width: s ? "100%" : r,
        height: s ? r : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, a()), a(!0));
}, qI = Uh(["Button", "compact"], (e) => {
  const t = Im(e);
  return [
    // Space Compact
    VI(t),
    UI(t),
    WI(t)
  ];
}, Tm);
var GI = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function KI(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const XI = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  link: ["primary", "link"],
  text: ["default", "text"]
}, YI = /* @__PURE__ */ ee.forwardRef((e, t) => {
  var n, r, o, i;
  const {
    loading: a = !1,
    prefixCls: s,
    color: l,
    variant: c,
    type: u,
    danger: d = !1,
    shape: f = "default",
    size: g,
    styles: h,
    disabled: y,
    className: p,
    rootClassName: C,
    children: m,
    icon: b,
    iconPosition: w = "start",
    ghost: E = !1,
    block: S = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: _ = "button",
    classNames: O,
    style: P = {},
    autoInsertSpace: $,
    autoFocus: L
  } = e, N = GI(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), k = u || "default", [F, U] = Kn(() => {
    if (l && c)
      return [l, c];
    const T = XI[k] || [];
    return d ? ["danger", T[1]] : T;
  }, [u, l, c, d]), R = F === "danger" ? "dangerous" : F, {
    getPrefixCls: D,
    direction: B,
    button: M
  } = Kt(kt), G = (n = $ ?? (M == null ? void 0 : M.autoInsertSpace)) !== null && n !== void 0 ? n : !0, H = D("btn", s), [X, K, J] = FI(H), ie = Kt(ps), le = y ?? ie, ne = Kt(Cm), te = Kn(() => KI(a), [a]), [re, _e] = Ht(te.loading), [me, De] = Ht(!1), oe = st(null), Te = Yi(t, oe), Re = Ly.count(m) === 1 && !b && !Ta(U), Ye = st(!0);
  ee.useEffect(() => (Ye.current = !1, () => {
    Ye.current = !0;
  }), []), At(() => {
    let T = null;
    te.delay > 0 ? T = setTimeout(() => {
      T = null, _e(!0);
    }, te.delay) : _e(te.loading);
    function q() {
      T && (clearTimeout(T), T = null);
    }
    return q;
  }, [te]), At(() => {
    if (!oe.current || !G)
      return;
    const T = oe.current.textContent || "";
    Re && Qc(T) ? me || De(!0) : me && De(!1);
  }), At(() => {
    L && oe.current && oe.current.focus();
  }, []);
  const Fe = ee.useCallback((T) => {
    var q;
    if (re || le) {
      T.preventDefault();
      return;
    }
    (q = e.onClick) === null || q === void 0 || q.call(e, T);
  }, [e.onClick, re, le]);
  if (z.env.NODE_ENV !== "production") {
    const T = Pn("Button");
    z.env.NODE_ENV !== "production" && T(!(typeof b == "string" && b.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${b}\` at https://ant.design/components/icon`), z.env.NODE_ENV !== "production" && T(!(E && Ta(U)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: Ze,
    compactItemClassnames: nt
  } = PP(H, B), xe = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, He = ym((T) => {
    var q, W;
    return (W = (q = g ?? Ze) !== null && q !== void 0 ? q : ne) !== null && W !== void 0 ? W : T;
  }), ye = He && (r = xe[He]) !== null && r !== void 0 ? r : "", it = re ? "loading" : b, Me = Ur(N, ["navigate"]), Ve = se(H, K, J, {
    [`${H}-${f}`]: f !== "default" && f,
    // line(253 - 254): Compatible with versions earlier than 5.21.0
    [`${H}-${k}`]: k,
    [`${H}-dangerous`]: d,
    [`${H}-color-${R}`]: R,
    [`${H}-variant-${U}`]: U,
    [`${H}-${ye}`]: ye,
    [`${H}-icon-only`]: !m && m !== 0 && !!it,
    [`${H}-background-ghost`]: E && !Ta(U),
    [`${H}-loading`]: re,
    [`${H}-two-chinese-chars`]: me && G && !re,
    [`${H}-block`]: S,
    [`${H}-rtl`]: B === "rtl",
    [`${H}-icon-end`]: w === "end"
  }, nt, p, C, M == null ? void 0 : M.className), lt = Object.assign(Object.assign({}, M == null ? void 0 : M.style), P), yt = se(O == null ? void 0 : O.icon, (o = M == null ? void 0 : M.classNames) === null || o === void 0 ? void 0 : o.icon), mt = Object.assign(Object.assign({}, (h == null ? void 0 : h.icon) || {}), ((i = M == null ? void 0 : M.styles) === null || i === void 0 ? void 0 : i.icon) || {}), Ne = b && !re ? /* @__PURE__ */ ee.createElement(Jc, {
    prefixCls: H,
    className: yt,
    style: mt
  }, b) : typeof a == "object" && a.icon ? /* @__PURE__ */ ee.createElement(Jc, {
    prefixCls: H,
    className: yt,
    style: mt
  }, a.icon) : /* @__PURE__ */ ee.createElement(AP, {
    existIcon: !!b,
    prefixCls: H,
    loading: re,
    mount: Ye.current
  }), Ue = m || m === 0 ? NP(m, Re && G) : null;
  if (Me.href !== void 0)
    return X(/* @__PURE__ */ ee.createElement("a", Object.assign({}, Me, {
      className: se(Ve, {
        [`${H}-disabled`]: le
      }),
      href: le ? void 0 : Me.href,
      style: lt,
      onClick: Fe,
      ref: Te,
      tabIndex: le ? -1 : 0
    }), Ne, Ue));
  let x = /* @__PURE__ */ ee.createElement("button", Object.assign({}, N, {
    type: _,
    className: Ve,
    style: lt,
    onClick: Fe,
    disabled: le,
    ref: Te
  }), Ne, Ue, nt && /* @__PURE__ */ ee.createElement(qI, {
    prefixCls: H
  }));
  return Ta(U) || (x = /* @__PURE__ */ ee.createElement(mm, {
    component: "Button",
    disabled: re
  }, x)), X(x);
}), tl = YI;
tl.Group = $P;
tl.__ANT_BUTTON = !0;
z.env.NODE_ENV !== "production" && (tl.displayName = "Button");
var Rm = /* @__PURE__ */ v.createContext(null), ov = [];
function ZI(e, t) {
  var n = v.useState(function() {
    if (!gn())
      return null;
    var h = document.createElement("div");
    return z.env.NODE_ENV !== "production" && t && h.setAttribute("data-debug", t), h;
  }), r = Q(n, 1), o = r[0], i = v.useRef(!1), a = v.useContext(Rm), s = v.useState(ov), l = Q(s, 2), c = l[0], u = l[1], d = a || (i.current ? void 0 : function(h) {
    u(function(y) {
      var p = [h].concat(he(y));
      return p;
    });
  });
  function f() {
    o.parentElement || document.body.appendChild(o), i.current = !0;
  }
  function g() {
    var h;
    (h = o.parentElement) === null || h === void 0 || h.removeChild(o), i.current = !1;
  }
  return nn(function() {
    return e ? a ? a(f) : f() : g(), g;
  }, [e]), nn(function() {
    c.length && (c.forEach(function(h) {
      return h();
    }), u(ov));
  }, [c]), [o, d];
}
function QI(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var o, i;
  if (e) {
    var a = getComputedStyle(e);
    r.scrollbarColor = a.scrollbarColor, r.scrollbarWidth = a.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), l = parseInt(s.width, 10), c = parseInt(s.height, 10);
    try {
      var u = l ? "width: ".concat(s.width, ";") : "", d = c ? "height: ".concat(s.height, ";") : "";
      mr(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(d, `
}`), t);
    } catch (h) {
      console.error(h), o = l, i = c;
    }
  }
  document.body.appendChild(n);
  var f = e && o && !isNaN(o) ? o : n.offsetWidth - n.clientWidth, g = e && i && !isNaN(i) ? i : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), ki(t), {
    width: f,
    height: g
  };
}
function JI(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : QI(e);
}
function eT() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var tT = "rc-util-locker-".concat(Date.now()), iv = 0;
function nT(e) {
  var t = !!e, n = v.useState(function() {
    return iv += 1, "".concat(tT, "_").concat(iv);
  }), r = Q(n, 1), o = r[0];
  nn(function() {
    if (t) {
      var i = JI(document.body).width, a = eT();
      mr(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(i, "px);") : "", `
}`), o);
    } else
      ki(o);
    return function() {
      ki(o);
    };
  }, [t, o]);
}
var rT = !1;
function oT(e) {
  return rT;
}
var av = function(t) {
  return t === !1 ? !1 : !gn() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, td = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, o = e.getContainer, i = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, l = e.children, c = v.useState(n), u = Q(c, 2), d = u[0], f = u[1], g = d || n;
  z.env.NODE_ENV !== "production" && gt(gn() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), v.useEffect(function() {
    (s || n) && f(n);
  }, [n, s]);
  var h = v.useState(function() {
    return av(o);
  }), y = Q(h, 2), p = y[0], C = y[1];
  v.useEffect(function() {
    var N = av(o);
    C(N ?? null);
  });
  var m = ZI(g && !p, i), b = Q(m, 2), w = b[0], E = b[1], S = p ?? w;
  nT(r && n && gn() && (S === w || S === document.body));
  var _ = null;
  if (l && Zi(l) && t) {
    var O = l;
    _ = O.ref;
  }
  var P = Yi(_, t);
  if (!g || !gn() || p === void 0)
    return null;
  var $ = S === !1 || oT(), L = l;
  return t && (L = /* @__PURE__ */ v.cloneElement(l, {
    ref: P
  })), /* @__PURE__ */ v.createElement(Rm.Provider, {
    value: E
  }, $ ? L : /* @__PURE__ */ bg(L, S));
});
z.env.NODE_ENV !== "production" && (td.displayName = "Portal");
function iT() {
  var e = V({}, v);
  return e.useId;
}
var sv = 0, lv = iT();
const aT = lv ? (
  // Use React `useId`
  function(t) {
    var n = lv();
    return t || (z.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = v.useState("ssr-id"), r = Q(n, 2), o = r[0], i = r[1];
    return v.useEffect(function() {
      var a = sv;
      sv += 1, i("rc_unique_".concat(a));
    }, []), t || (z.env.NODE_ENV === "test" ? "test-id" : o);
  }
);
var Qr = "RC_FORM_INTERNAL_HOOKS", Et = function() {
  gt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Xo = /* @__PURE__ */ v.createContext({
  getFieldValue: Et,
  getFieldsValue: Et,
  getFieldError: Et,
  getFieldWarning: Et,
  getFieldsError: Et,
  isFieldsTouched: Et,
  isFieldTouched: Et,
  isFieldValidating: Et,
  isFieldsValidating: Et,
  resetFields: Et,
  setFields: Et,
  setFieldValue: Et,
  setFieldsValue: Et,
  validateFields: Et,
  submit: Et,
  getInternalHooks: function() {
    return Et(), {
      dispatch: Et,
      initEntityValue: Et,
      registerField: Et,
      useSubscribe: Et,
      setInitialValues: Et,
      destroyForm: Et,
      setCallbacks: Et,
      registerWatch: Et,
      getFields: Et,
      setValidateMessages: Et,
      setPreserve: Et,
      getInitialValue: Et
    };
  }
}), ys = /* @__PURE__ */ v.createContext(null);
function eu(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function sT(e) {
  return e && !!e._init;
}
function tu() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var nu = tu();
function lT(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function cT(e, t, n) {
  if (Hu())
    return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var o = new (e.bind.apply(e, r))();
  return n && Fi(o, n.prototype), o;
}
function ru(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ru = function(r) {
    if (r === null || !lT(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r))
        return t.get(r);
      t.set(r, o);
    }
    function o() {
      return cT(r, arguments, ji(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Fi(o, r);
  }, ru(e);
}
var uT = /%[sdj%]/g, Nm = function() {
};
typeof z < "u" && z.env && z.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (Nm = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function ou(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Sn(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var o = 0, i = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(uT, function(s) {
      if (s === "%%")
        return "%";
      if (o >= i)
        return s;
      switch (s) {
        case "%s":
          return String(n[o++]);
        case "%d":
          return Number(n[o++]);
        case "%j":
          try {
            return JSON.stringify(n[o++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function dT(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Xt(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || dT(t) && typeof e == "string" && !e);
}
function fT(e, t, n) {
  var r = [], o = 0, i = e.length;
  function a(s) {
    r.push.apply(r, he(s || [])), o++, o === i && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function cv(e, t, n) {
  var r = 0, o = e.length;
  function i(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < o ? t(e[s], i) : n([]);
  }
  i([]);
}
function vT(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, he(e[n] || []));
  }), t;
}
var uv = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n(r, o) {
    var i;
    return Yt(this, n), i = t.call(this, "Async Validation Error"), j(Xe(i), "errors", void 0), j(Xe(i), "fields", void 0), i.errors = r, i.fields = o, i;
  }
  return Zt(n);
}(/* @__PURE__ */ ru(Error));
function gT(e, t, n, r, o) {
  if (t.first) {
    var i = new Promise(function(f, g) {
      var h = function(C) {
        return r(C), C.length ? g(new uv(C, ou(C))) : f(o);
      }, y = vT(e);
      cv(y, n, h);
    });
    return i.catch(function(f) {
      return f;
    }), i;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, c = 0, u = [], d = new Promise(function(f, g) {
    var h = function(p) {
      if (u.push.apply(u, p), c++, c === l)
        return r(u), u.length ? g(new uv(u, ou(u))) : f(o);
    };
    s.length || (r(u), f(o)), s.forEach(function(y) {
      var p = e[y];
      a.indexOf(y) !== -1 ? cv(p, n, h) : fT(p, n, h);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function pT(e) {
  return !!(e && e.message !== void 0);
}
function hT(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function dv(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = hT(t, e.fullFields) : r = t[n.field || e.fullField], pT(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function fv(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        Ie(r) === "object" && Ie(e[n]) === "object" ? e[n] = V(V({}, e[n]), r) : e[n] = r;
      }
  }
  return e;
}
var Eo = "enum", mT = function(t, n, r, o, i) {
  t[Eo] = Array.isArray(t[Eo]) ? t[Eo] : [], t[Eo].indexOf(n) === -1 && o.push(Sn(i.messages[Eo], t.fullField, t[Eo].join(", ")));
}, yT = function(t, n, r, o, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || o.push(Sn(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || o.push(Sn(i.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, bT = function(t, n, r, o, i) {
  var a = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", c = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = n, d = null, f = typeof n == "number", g = typeof n == "string", h = Array.isArray(n);
  if (f ? d = "number" : g ? d = "string" : h && (d = "array"), !d)
    return !1;
  h && (u = n.length), g && (u = n.replace(c, "_").length), a ? u !== t.len && o.push(Sn(i.messages[d].len, t.fullField, t.len)) : s && !l && u < t.min ? o.push(Sn(i.messages[d].min, t.fullField, t.min)) : l && !s && u > t.max ? o.push(Sn(i.messages[d].max, t.fullField, t.max)) : s && l && (u < t.min || u > t.max) && o.push(Sn(i.messages[d].range, t.fullField, t.min, t.max));
}, Am = function(t, n, r, o, i, a) {
  t.required && (!r.hasOwnProperty(t.field) || Xt(n, a || t.type)) && o.push(Sn(i.messages.required, t.fullField));
}, $a;
const CT = function() {
  if ($a)
    return $a;
  var e = "[a-fA-F\\d:]", t = function(S) {
    return S && S.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", o = [
    "(?:".concat(r, ":){7}(?:").concat(r, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(r, ":){6}(?:").concat(n, "|:").concat(r, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(r, ":){5}(?::").concat(n, "|(?::").concat(r, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(r, ":){4}(?:(?::").concat(r, "){0,1}:").concat(n, "|(?::").concat(r, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(r, ":){3}(?:(?::").concat(r, "){0,2}:").concat(n, "|(?::").concat(r, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(r, ":){2}(?:(?::").concat(r, "){0,3}:").concat(n, "|(?::").concat(r, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(r, ":){1}(?:(?::").concat(r, "){0,4}:").concat(n, "|(?::").concat(r, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(r, "){0,5}:").concat(n, "|(?::").concat(r, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], i = "(?:%[0-9a-zA-Z]{1,})?", a = "(?:".concat(o.join("|"), ")").concat(i), s = new RegExp("(?:^".concat(n, "$)|(?:^").concat(a, "$)")), l = new RegExp("^".concat(n, "$")), c = new RegExp("^".concat(a, "$")), u = function(S) {
    return S && S.exact ? s : new RegExp("(?:".concat(t(S)).concat(n).concat(t(S), ")|(?:").concat(t(S)).concat(a).concat(t(S), ")"), "g");
  };
  u.v4 = function(E) {
    return E && E.exact ? l : new RegExp("".concat(t(E)).concat(n).concat(t(E)), "g");
  }, u.v6 = function(E) {
    return E && E.exact ? c : new RegExp("".concat(t(E)).concat(a).concat(t(E)), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", g = u.v4().source, h = u.v6().source, y = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", p = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", C = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', w = "(?:".concat(d, "|www\\.)").concat(f, "(?:localhost|").concat(g, "|").concat(h, "|").concat(y).concat(p).concat(C, ")").concat(m).concat(b);
  return $a = new RegExp("(?:^".concat(w, "$)"), "i"), $a;
};
var vv = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, _i = {
  integer: function(t) {
    return _i.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return _i.number(t) && !_i.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return Ie(t) === "object" && !_i.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(vv.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(CT());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(vv.hex);
  }
}, wT = function(t, n, r, o, i) {
  if (t.required && n === void 0) {
    Am(t, n, r, o, i);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? _i[s](n) || o.push(Sn(i.messages.types[s], t.fullField, t.type)) : s && Ie(n) !== t.type && o.push(Sn(i.messages.types[s], t.fullField, t.type));
}, ST = function(t, n, r, o, i) {
  (/^\s+$/.test(n) || n === "") && o.push(Sn(i.messages.whitespace, t.fullField));
};
const tt = {
  required: Am,
  whitespace: ST,
  type: wT,
  range: bT,
  enum: mT,
  pattern: yT
};
var ET = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i);
  }
  r(a);
}, _T = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    tt.required(t, n, o, a, i, "array"), n != null && (tt.type(t, n, o, a, i), tt.range(t, n, o, a, i));
  }
  r(a);
}, xT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && tt.type(t, n, o, a, i);
  }
  r(a);
}, OT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n, "date") && !t.required)
      return r();
    if (tt.required(t, n, o, a, i), !Xt(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), tt.type(t, l, o, a, i), l && tt.range(t, l.getTime(), o, a, i);
    }
  }
  r(a);
}, PT = "enum", IT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && tt[PT](t, n, o, a, i);
  }
  r(a);
}, TT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && (tt.type(t, n, o, a, i), tt.range(t, n, o, a, i));
  }
  r(a);
}, $T = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && (tt.type(t, n, o, a, i), tt.range(t, n, o, a, i));
  }
  r(a);
}, RT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && tt.type(t, n, o, a, i);
  }
  r(a);
}, NT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && (tt.type(t, n, o, a, i), tt.range(t, n, o, a, i));
  }
  r(a);
}, AT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), n !== void 0 && tt.type(t, n, o, a, i);
  }
  r(a);
}, kT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n, "string") && !t.required)
      return r();
    tt.required(t, n, o, a, i), Xt(n, "string") || tt.pattern(t, n, o, a, i);
  }
  r(a);
}, MT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n) && !t.required)
      return r();
    tt.required(t, n, o, a, i), Xt(n) || tt.type(t, n, o, a, i);
  }
  r(a);
}, LT = function(t, n, r, o, i) {
  var a = [], s = Array.isArray(n) ? "array" : Ie(n);
  tt.required(t, n, o, a, i, s), r(a);
}, DT = function(t, n, r, o, i) {
  var a = [], s = t.required || !t.required && o.hasOwnProperty(t.field);
  if (s) {
    if (Xt(n, "string") && !t.required)
      return r();
    tt.required(t, n, o, a, i, "string"), Xt(n, "string") || (tt.type(t, n, o, a, i), tt.range(t, n, o, a, i), tt.pattern(t, n, o, a, i), t.whitespace === !0 && tt.whitespace(t, n, o, a, i));
  }
  r(a);
}, ql = function(t, n, r, o, i) {
  var a = t.type, s = [], l = t.required || !t.required && o.hasOwnProperty(t.field);
  if (l) {
    if (Xt(n, a) && !t.required)
      return r();
    tt.required(t, n, o, s, i, a), Xt(n, a) || tt.type(t, n, o, s, i);
  }
  r(s);
};
const $i = {
  string: DT,
  method: RT,
  number: NT,
  boolean: xT,
  regexp: MT,
  integer: $T,
  float: TT,
  array: _T,
  object: AT,
  enum: IT,
  pattern: kT,
  date: OT,
  url: ql,
  hex: ql,
  email: ql,
  required: LT,
  any: ET
};
var na = /* @__PURE__ */ function() {
  function e(t) {
    Yt(this, e), j(this, "rules", null), j(this, "_messages", nu), this.define(t);
  }
  return Zt(e, [{
    key: "define",
    value: function(n) {
      var r = this;
      if (!n)
        throw new Error("Cannot configure a schema with no rules");
      if (Ie(n) !== "object" || Array.isArray(n))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(n).forEach(function(o) {
        var i = n[o];
        r.rules[o] = Array.isArray(i) ? i : [i];
      });
    }
  }, {
    key: "messages",
    value: function(n) {
      return n && (this._messages = fv(tu(), n)), this._messages;
    }
  }, {
    key: "validate",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, a = n, s = o, l = i;
      if (typeof s == "function" && (l = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return l && l(null, a), Promise.resolve(a);
      function c(h) {
        var y = [], p = {};
        function C(b) {
          if (Array.isArray(b)) {
            var w;
            y = (w = y).concat.apply(w, he(b));
          } else
            y.push(b);
        }
        for (var m = 0; m < h.length; m++)
          C(h[m]);
        y.length ? (p = ou(y), l(y, p)) : l(null, a);
      }
      if (s.messages) {
        var u = this.messages();
        u === nu && (u = tu()), fv(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var d = {}, f = s.keys || Object.keys(this.rules);
      f.forEach(function(h) {
        var y = r.rules[h], p = a[h];
        y.forEach(function(C) {
          var m = C;
          typeof m.transform == "function" && (a === n && (a = V({}, a)), p = a[h] = m.transform(p), p != null && (m.type = m.type || (Array.isArray(p) ? "array" : Ie(p)))), typeof m == "function" ? m = {
            validator: m
          } : m = V({}, m), m.validator = r.getValidationMethod(m), m.validator && (m.field = h, m.fullField = m.fullField || h, m.type = r.getType(m), d[h] = d[h] || [], d[h].push({
            rule: m,
            value: p,
            source: a,
            field: h
          }));
        });
      });
      var g = {};
      return gT(d, s, function(h, y) {
        var p = h.rule, C = (p.type === "object" || p.type === "array") && (Ie(p.fields) === "object" || Ie(p.defaultField) === "object");
        C = C && (p.required || !p.required && h.value), p.field = h.field;
        function m(_, O) {
          return V(V({}, O), {}, {
            fullField: "".concat(p.fullField, ".").concat(_),
            fullFields: p.fullFields ? [].concat(he(p.fullFields), [_]) : [_]
          });
        }
        function b() {
          var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], O = Array.isArray(_) ? _ : [_];
          !s.suppressWarning && O.length && e.warning("async-validator:", O), O.length && p.message !== void 0 && (O = [].concat(p.message));
          var P = O.map(dv(p, a));
          if (s.first && P.length)
            return g[p.field] = 1, y(P);
          if (!C)
            y(P);
          else {
            if (p.required && !h.value)
              return p.message !== void 0 ? P = [].concat(p.message).map(dv(p, a)) : s.error && (P = [s.error(p, Sn(s.messages.required, p.field))]), y(P);
            var $ = {};
            p.defaultField && Object.keys(h.value).map(function(k) {
              $[k] = p.defaultField;
            }), $ = V(V({}, $), h.rule.fields);
            var L = {};
            Object.keys($).forEach(function(k) {
              var F = $[k], U = Array.isArray(F) ? F : [F];
              L[k] = U.map(m.bind(null, k));
            });
            var N = new e(L);
            N.messages(s.messages), h.rule.options && (h.rule.options.messages = s.messages, h.rule.options.error = s.error), N.validate(h.value, h.rule.options || s, function(k) {
              var F = [];
              P && P.length && F.push.apply(F, he(P)), k && k.length && F.push.apply(F, he(k)), y(F.length ? F : null);
            });
          }
        }
        var w;
        if (p.asyncValidator)
          w = p.asyncValidator(p, h.value, b, h.source, s);
        else if (p.validator) {
          try {
            w = p.validator(p, h.value, b, h.source, s);
          } catch (_) {
            var E, S;
            (E = (S = console).error) === null || E === void 0 || E.call(S, _), s.suppressValidatorError || setTimeout(function() {
              throw _;
            }, 0), b(_.message);
          }
          w === !0 ? b() : w === !1 ? b(typeof p.message == "function" ? p.message(p.fullField || p.field) : p.message || "".concat(p.fullField || p.field, " fails")) : w instanceof Array ? b(w) : w instanceof Error && b(w.message);
        }
        w && w.then && w.then(function() {
          return b();
        }, function(_) {
          return b(_);
        });
      }, function(h) {
        c(h);
      }, a);
    }
  }, {
    key: "getType",
    value: function(n) {
      if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !$i.hasOwnProperty(n.type))
        throw new Error(Sn("Unknown rule type %s", n.type));
      return n.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(n) {
      if (typeof n.validator == "function")
        return n.validator;
      var r = Object.keys(n), o = r.indexOf("message");
      return o !== -1 && r.splice(o, 1), r.length === 1 && r[0] === "required" ? $i.required : $i[this.getType(n)] || void 0;
    }
  }]), e;
}();
j(na, "register", function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  $i[t] = n;
});
j(na, "warning", Nm);
j(na, "messages", nu);
j(na, "validators", $i);
var bn = "'${name}' is not a valid ${type}", km = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: bn,
    method: bn,
    array: bn,
    object: bn,
    number: bn,
    date: bn,
    boolean: bn,
    integer: bn,
    float: bn,
    regexp: bn,
    email: bn,
    url: bn,
    hex: bn
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, gv = na;
function FT(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(n) {
    if (n.startsWith("\\"))
      return n.slice(1);
    var r = n.slice(2, -1);
    return t[r];
  });
}
var pv = "CODE_LOGIC_ERROR";
function iu(e, t, n, r, o) {
  return au.apply(this, arguments);
}
function au() {
  return au = vo(/* @__PURE__ */ dn().mark(function e(t, n, r, o, i) {
    var a, s, l, c, u, d, f, g, h;
    return dn().wrap(function(p) {
      for (; ; )
        switch (p.prev = p.next) {
          case 0:
            return a = V({}, r), delete a.ruleIndex, gv.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (C) {
                return console.error(C), Promise.reject(pv);
              }
            }), l = null, a && a.type === "array" && a.defaultField && (l = a.defaultField, delete a.defaultField), c = new gv(j({}, t, [a])), u = No(km, o.validateMessages), c.messages(u), d = [], p.prev = 10, p.next = 13, Promise.resolve(c.validate(j({}, t, n), V({}, o)));
          case 13:
            p.next = 18;
            break;
          case 15:
            p.prev = 15, p.t0 = p.catch(10), p.t0.errors && (d = p.t0.errors.map(function(C, m) {
              var b = C.message, w = b === pv ? u.default : b;
              return /* @__PURE__ */ v.isValidElement(w) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ v.cloneElement(w, {
                  key: "error_".concat(m)
                })
              ) : w;
            }));
          case 18:
            if (!(!d.length && l)) {
              p.next = 23;
              break;
            }
            return p.next = 21, Promise.all(n.map(function(C, m) {
              return iu("".concat(t, ".").concat(m), C, l, o, i);
            }));
          case 21:
            return f = p.sent, p.abrupt("return", f.reduce(function(C, m) {
              return [].concat(he(C), he(m));
            }, []));
          case 23:
            return g = V(V({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, i), h = d.map(function(C) {
              return typeof C == "string" ? FT(C, g) : C;
            }), p.abrupt("return", h);
          case 26:
          case "end":
            return p.stop();
        }
    }, e, null, [[10, 15]]);
  })), au.apply(this, arguments);
}
function jT(e, t, n, r, o, i) {
  var a = e.join("."), s = n.map(function(u, d) {
    var f = u.validator, g = V(V({}, u), {}, {
      ruleIndex: d
    });
    return f && (g.validator = function(h, y, p) {
      var C = !1, m = function() {
        for (var E = arguments.length, S = new Array(E), _ = 0; _ < E; _++)
          S[_] = arguments[_];
        Promise.resolve().then(function() {
          gt(!C, "Your validator function has already return a promise. `callback` will be ignored."), C || p.apply(void 0, S);
        });
      }, b = f(h, y, m);
      C = b && typeof b.then == "function" && typeof b.catch == "function", gt(C, "`callback` is deprecated. Please return a promise instead."), C && b.then(function() {
        p();
      }).catch(function(w) {
        p(w || " ");
      });
    }), g;
  }).sort(function(u, d) {
    var f = u.warningOnly, g = u.ruleIndex, h = d.warningOnly, y = d.ruleIndex;
    return !!f == !!h ? g - y : f ? 1 : -1;
  }), l;
  if (o === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var u = vo(/* @__PURE__ */ dn().mark(function d(f, g) {
        var h, y, p;
        return dn().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                h = 0;
              case 1:
                if (!(h < s.length)) {
                  m.next = 12;
                  break;
                }
                return y = s[h], m.next = 5, iu(a, t, y, r, i);
              case 5:
                if (p = m.sent, !p.length) {
                  m.next = 9;
                  break;
                }
                return g([{
                  errors: p,
                  rule: y
                }]), m.abrupt("return");
              case 9:
                h += 1, m.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return m.stop();
            }
        }, d);
      }));
      return function(d, f) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var c = s.map(function(u) {
      return iu(a, t, u, r, i).then(function(d) {
        return {
          errors: d,
          rule: u
        };
      });
    });
    l = (o ? VT(c) : BT(c)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return l.catch(function(u) {
    return u;
  }), l;
}
function BT(e) {
  return su.apply(this, arguments);
}
function su() {
  return su = vo(/* @__PURE__ */ dn().mark(function e(t) {
    return dn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(o) {
              var i, a = (i = []).concat.apply(i, he(o));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), su.apply(this, arguments);
}
function VT(e) {
  return lu.apply(this, arguments);
}
function lu() {
  return lu = vo(/* @__PURE__ */ dn().mark(function e(t) {
    var n;
    return dn().wrap(function(o) {
      for (; ; )
        switch (o.prev = o.next) {
          case 0:
            return n = 0, o.abrupt("return", new Promise(function(i) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && i([s]), n += 1, n === t.length && i([]);
                });
              });
            }));
          case 2:
          case "end":
            return o.stop();
        }
    }, e);
  })), lu.apply(this, arguments);
}
function Lt(e) {
  return eu(e);
}
function hv(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var o = or(e, r);
    n = Vn(n, r, o);
  }), n;
}
function Vo(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return Mm(t, r, n);
  });
}
function Mm(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, o) {
    return e[o] === r;
  });
}
function zT(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || Ie(e) !== "object" || Ie(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), o = new Set([].concat(n, r));
  return he(o).every(function(i) {
    var a = e[i], s = t[i];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function HT(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && Ie(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function mv(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var o = e[t], i = t - n;
  return i > 0 ? [].concat(he(e.slice(0, n)), [o], he(e.slice(n, t)), he(e.slice(t + 1, r))) : i < 0 ? [].concat(he(e.slice(0, t)), he(e.slice(t + 1, n + 1)), [o], he(e.slice(n + 1, r))) : e;
}
var UT = ["name"], Mn = [];
function Gl(e, t, n, r, o, i) {
  return typeof e == "function" ? e(t, n, "source" in i ? {
    source: i.source
  } : {}) : r !== o;
}
var nd = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n(r) {
    var o;
    if (Yt(this, n), o = t.call(this, r), j(Xe(o), "state", {
      resetCount: 0
    }), j(Xe(o), "cancelRegisterFunc", null), j(Xe(o), "mounted", !1), j(Xe(o), "touched", !1), j(Xe(o), "dirty", !1), j(Xe(o), "validatePromise", void 0), j(Xe(o), "prevValidating", void 0), j(Xe(o), "errors", Mn), j(Xe(o), "warnings", Mn), j(Xe(o), "cancelRegister", function() {
      var l = o.props, c = l.preserve, u = l.isListField, d = l.name;
      o.cancelRegisterFunc && o.cancelRegisterFunc(u, c, Lt(d)), o.cancelRegisterFunc = null;
    }), j(Xe(o), "getNamePath", function() {
      var l = o.props, c = l.name, u = l.fieldContext, d = u.prefixName, f = d === void 0 ? [] : d;
      return c !== void 0 ? [].concat(he(f), he(c)) : [];
    }), j(Xe(o), "getRules", function() {
      var l = o.props, c = l.rules, u = c === void 0 ? [] : c, d = l.fieldContext;
      return u.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), j(Xe(o), "refresh", function() {
      o.mounted && o.setState(function(l) {
        var c = l.resetCount;
        return {
          resetCount: c + 1
        };
      });
    }), j(Xe(o), "metaCache", null), j(Xe(o), "triggerMetaEvent", function(l) {
      var c = o.props.onMetaChange;
      if (c) {
        var u = V(V({}, o.getMeta()), {}, {
          destroy: l
        });
        Vi(o.metaCache, u) || c(u), o.metaCache = u;
      } else
        o.metaCache = null;
    }), j(Xe(o), "onStoreChange", function(l, c, u) {
      var d = o.props, f = d.shouldUpdate, g = d.dependencies, h = g === void 0 ? [] : g, y = d.onReset, p = u.store, C = o.getNamePath(), m = o.getValue(l), b = o.getValue(p), w = c && Vo(c, C);
      switch (u.type === "valueUpdate" && u.source === "external" && !Vi(m, b) && (o.touched = !0, o.dirty = !0, o.validatePromise = null, o.errors = Mn, o.warnings = Mn, o.triggerMetaEvent()), u.type) {
        case "reset":
          if (!c || w) {
            o.touched = !1, o.dirty = !1, o.validatePromise = void 0, o.errors = Mn, o.warnings = Mn, o.triggerMetaEvent(), y == null || y(), o.refresh();
            return;
          }
          break;
        case "remove": {
          if (f && Gl(f, l, p, m, b, u)) {
            o.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var E = u.data;
          if (w) {
            "touched" in E && (o.touched = E.touched), "validating" in E && !("originRCField" in E) && (o.validatePromise = E.validating ? Promise.resolve([]) : null), "errors" in E && (o.errors = E.errors || Mn), "warnings" in E && (o.warnings = E.warnings || Mn), o.dirty = !0, o.triggerMetaEvent(), o.reRender();
            return;
          } else if ("value" in E && Vo(c, C, !0)) {
            o.reRender();
            return;
          }
          if (f && !C.length && Gl(f, l, p, m, b, u)) {
            o.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var S = h.map(Lt);
          if (S.some(function(_) {
            return Vo(u.relatedFields, _);
          })) {
            o.reRender();
            return;
          }
          break;
        }
        default:
          if (w || (!h.length || C.length || f) && Gl(f, l, p, m, b, u)) {
            o.reRender();
            return;
          }
          break;
      }
      f === !0 && o.reRender();
    }), j(Xe(o), "validateRules", function(l) {
      var c = o.getNamePath(), u = o.getValue(), d = l || {}, f = d.triggerName, g = d.validateOnly, h = g === void 0 ? !1 : g, y = Promise.resolve().then(/* @__PURE__ */ vo(/* @__PURE__ */ dn().mark(function p() {
        var C, m, b, w, E, S, _;
        return dn().wrap(function(P) {
          for (; ; )
            switch (P.prev = P.next) {
              case 0:
                if (o.mounted) {
                  P.next = 2;
                  break;
                }
                return P.abrupt("return", []);
              case 2:
                if (C = o.props, m = C.validateFirst, b = m === void 0 ? !1 : m, w = C.messageVariables, E = C.validateDebounce, S = o.getRules(), f && (S = S.filter(function($) {
                  return $;
                }).filter(function($) {
                  var L = $.validateTrigger;
                  if (!L)
                    return !0;
                  var N = eu(L);
                  return N.includes(f);
                })), !(E && f)) {
                  P.next = 10;
                  break;
                }
                return P.next = 8, new Promise(function($) {
                  setTimeout($, E);
                });
              case 8:
                if (o.validatePromise === y) {
                  P.next = 10;
                  break;
                }
                return P.abrupt("return", []);
              case 10:
                return _ = jT(c, u, S, l, b, w), _.catch(function($) {
                  return $;
                }).then(function() {
                  var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Mn;
                  if (o.validatePromise === y) {
                    var L;
                    o.validatePromise = null;
                    var N = [], k = [];
                    (L = $.forEach) === null || L === void 0 || L.call($, function(F) {
                      var U = F.rule.warningOnly, A = F.errors, R = A === void 0 ? Mn : A;
                      U ? k.push.apply(k, he(R)) : N.push.apply(N, he(R));
                    }), o.errors = N, o.warnings = k, o.triggerMetaEvent(), o.reRender();
                  }
                }), P.abrupt("return", _);
              case 13:
              case "end":
                return P.stop();
            }
        }, p);
      })));
      return h || (o.validatePromise = y, o.dirty = !0, o.errors = Mn, o.warnings = Mn, o.triggerMetaEvent(), o.reRender()), y;
    }), j(Xe(o), "isFieldValidating", function() {
      return !!o.validatePromise;
    }), j(Xe(o), "isFieldTouched", function() {
      return o.touched;
    }), j(Xe(o), "isFieldDirty", function() {
      if (o.dirty || o.props.initialValue !== void 0)
        return !0;
      var l = o.props.fieldContext, c = l.getInternalHooks(Qr), u = c.getInitialValue;
      return u(o.getNamePath()) !== void 0;
    }), j(Xe(o), "getErrors", function() {
      return o.errors;
    }), j(Xe(o), "getWarnings", function() {
      return o.warnings;
    }), j(Xe(o), "isListField", function() {
      return o.props.isListField;
    }), j(Xe(o), "isList", function() {
      return o.props.isList;
    }), j(Xe(o), "isPreserve", function() {
      return o.props.preserve;
    }), j(Xe(o), "getMeta", function() {
      o.prevValidating = o.isFieldValidating();
      var l = {
        touched: o.isFieldTouched(),
        validating: o.prevValidating,
        errors: o.errors,
        warnings: o.warnings,
        name: o.getNamePath(),
        validated: o.validatePromise === null
      };
      return l;
    }), j(Xe(o), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var c = o.getMeta();
        return V(V({}, o.getOnlyChild(l(o.getControlled(), c, o.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = oo(l);
      return u.length !== 1 || !/* @__PURE__ */ v.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), j(Xe(o), "getValue", function(l) {
      var c = o.props.fieldContext.getFieldsValue, u = o.getNamePath();
      return or(l || c(!0), u);
    }), j(Xe(o), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = o.props, u = c.name, d = c.trigger, f = c.validateTrigger, g = c.getValueFromEvent, h = c.normalize, y = c.valuePropName, p = c.getValueProps, C = c.fieldContext, m = f !== void 0 ? f : C.validateTrigger, b = o.getNamePath(), w = C.getInternalHooks, E = C.getFieldsValue, S = w(Qr), _ = S.dispatch, O = o.getValue(), P = p || function(F) {
        return j({}, y, F);
      }, $ = l[d], L = u !== void 0 ? P(O) : {};
      z.env.NODE_ENV !== "production" && L && Object.keys(L).forEach(function(F) {
        gt(typeof L[F] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(F, ")"));
      });
      var N = V(V({}, l), L);
      N[d] = function() {
        o.touched = !0, o.dirty = !0, o.triggerMetaEvent();
        for (var F, U = arguments.length, A = new Array(U), R = 0; R < U; R++)
          A[R] = arguments[R];
        g ? F = g.apply(void 0, A) : F = HT.apply(void 0, [y].concat(A)), h && (F = h(F, O, E(!0))), F !== O && _({
          type: "updateValue",
          namePath: b,
          value: F
        }), $ && $.apply(void 0, A);
      };
      var k = eu(m || []);
      return k.forEach(function(F) {
        var U = N[F];
        N[F] = function() {
          U && U.apply(void 0, arguments);
          var A = o.props.rules;
          A && A.length && _({
            type: "validateField",
            namePath: b,
            triggerName: F
          });
        };
      }), N;
    }), r.fieldContext) {
      var i = r.fieldContext.getInternalHooks, a = i(Qr), s = a.initEntityValue;
      s(Xe(o));
    }
    return o;
  }
  return Zt(n, [{
    key: "componentDidMount",
    value: function() {
      var o = this.props, i = o.shouldUpdate, a = o.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, l = s(Qr), c = l.registerField;
        this.cancelRegisterFunc = c(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var o = this.state.resetCount, i = this.props.children, a = this.getOnlyChild(i), s = a.child, l = a.isFunction, c;
      return l ? c = s : /* @__PURE__ */ v.isValidElement(s) ? c = /* @__PURE__ */ v.cloneElement(s, this.getControlled(s.props)) : (gt(!s, "`children` of Field is not validate ReactElement."), c = s), /* @__PURE__ */ v.createElement(v.Fragment, {
        key: o
      }, c);
    }
  }]), n;
}(v.Component);
j(nd, "contextType", Xo);
j(nd, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function Lm(e) {
  var t, n = e.name, r = ht(e, UT), o = v.useContext(Xo), i = v.useContext(ys), a = n !== void 0 ? Lt(n) : void 0, s = (t = r.isListField) !== null && t !== void 0 ? t : !!i, l = "keep";
  return s || (l = "_".concat((a || []).join("_"))), z.env.NODE_ENV !== "production" && r.preserve === !1 && s && a.length <= 1 && gt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ v.createElement(nd, Pe({
    key: l,
    name: a,
    isListField: s
  }, r, {
    fieldContext: o
  }));
}
function WT(e) {
  var t = e.name, n = e.initialValue, r = e.children, o = e.rules, i = e.validateTrigger, a = e.isListField, s = v.useContext(Xo), l = v.useContext(ys), c = v.useRef({
    keys: [],
    id: 0
  }), u = c.current, d = v.useMemo(function() {
    var y = Lt(s.prefixName) || [];
    return [].concat(he(y), he(Lt(t)));
  }, [s.prefixName, t]), f = v.useMemo(function() {
    return V(V({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), g = v.useMemo(function() {
    return {
      getKey: function(p) {
        var C = d.length, m = p[C];
        return [u.keys[m], p.slice(C + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return gt(!1, "Form.List only accepts function as children."), null;
  var h = function(p, C, m) {
    var b = m.source;
    return b === "internal" ? !1 : p !== C;
  };
  return /* @__PURE__ */ v.createElement(ys.Provider, {
    value: g
  }, /* @__PURE__ */ v.createElement(Xo.Provider, {
    value: f
  }, /* @__PURE__ */ v.createElement(Lm, {
    name: [],
    shouldUpdate: h,
    rules: o,
    validateTrigger: i,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!l
  }, function(y, p) {
    var C = y.value, m = C === void 0 ? [] : C, b = y.onChange, w = s.getFieldValue, E = function() {
      var P = w(d || []);
      return P || [];
    }, S = {
      add: function(P, $) {
        var L = E();
        $ >= 0 && $ <= L.length ? (u.keys = [].concat(he(u.keys.slice(0, $)), [u.id], he(u.keys.slice($))), b([].concat(he(L.slice(0, $)), [P], he(L.slice($))))) : (z.env.NODE_ENV !== "production" && ($ < 0 || $ > L.length) && gt(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(he(u.keys), [u.id]), b([].concat(he(L), [P]))), u.id += 1;
      },
      remove: function(P) {
        var $ = E(), L = new Set(Array.isArray(P) ? P : [P]);
        L.size <= 0 || (u.keys = u.keys.filter(function(N, k) {
          return !L.has(k);
        }), b($.filter(function(N, k) {
          return !L.has(k);
        })));
      },
      move: function(P, $) {
        if (P !== $) {
          var L = E();
          P < 0 || P >= L.length || $ < 0 || $ >= L.length || (u.keys = mv(u.keys, P, $), b(mv(L, P, $)));
        }
      }
    }, _ = m || [];
    return Array.isArray(_) || (_ = [], z.env.NODE_ENV !== "production" && gt(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), r(_.map(function(O, P) {
      var $ = u.keys[P];
      return $ === void 0 && (u.keys[P] = u.id, $ = u.keys[P], u.id += 1), {
        name: P,
        key: $,
        isListField: !0
      };
    }), S, p);
  })));
}
function qT(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(o, i) {
    e.forEach(function(a, s) {
      a.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        n -= 1, r[s] = l, !(n > 0) && (t && i(r), o(r));
      });
    });
  }) : Promise.resolve([]);
}
var Dm = "__@field_split__";
function Kl(e) {
  return e.map(function(t) {
    return "".concat(Ie(t), ":").concat(t);
  }).join(Dm);
}
var _o = /* @__PURE__ */ function() {
  function e() {
    Yt(this, e), j(this, "kvs", /* @__PURE__ */ new Map());
  }
  return Zt(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(Kl(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(Kl(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var o = this.get(n), i = r(o);
      i ? this.set(n, i) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(Kl(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return he(this.kvs.entries()).map(function(r) {
        var o = Q(r, 2), i = o[0], a = o[1], s = i.split(Dm);
        return n({
          key: s.map(function(l) {
            var c = l.match(/^([^:]*):(.*)$/), u = Q(c, 3), d = u[1], f = u[2];
            return d === "number" ? Number(f) : f;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var o = r.key, i = r.value;
        return n[o.join(".")] = i, null;
      }), n;
    }
  }]), e;
}(), GT = ["name"], KT = /* @__PURE__ */ Zt(function e(t) {
  var n = this;
  Yt(this, e), j(this, "formHooked", !1), j(this, "forceRootUpdate", void 0), j(this, "subscribable", !0), j(this, "store", {}), j(this, "fieldEntities", []), j(this, "initialValues", {}), j(this, "callbacks", {}), j(this, "validateMessages", null), j(this, "preserve", null), j(this, "lastValidatePromise", null), j(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), j(this, "getInternalHooks", function(r) {
    return r === Qr ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (gt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), j(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), j(this, "prevWithoutPreserves", null), j(this, "setInitialValues", function(r, o) {
    if (n.initialValues = r || {}, o) {
      var i, a = No(r, n.store);
      (i = n.prevWithoutPreserves) === null || i === void 0 || i.map(function(s) {
        var l = s.key;
        a = Vn(a, l, or(r, l));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), j(this, "destroyForm", function(r) {
    if (r)
      n.updateStore({});
    else {
      var o = new _o();
      n.getFieldEntities(!0).forEach(function(i) {
        n.isMergedPreserve(i.isPreserve()) || o.set(i.getNamePath(), !0);
      }), n.prevWithoutPreserves = o;
    }
  }), j(this, "getInitialValue", function(r) {
    var o = or(n.initialValues, r);
    return r.length ? No(o) : o;
  }), j(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), j(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), j(this, "setPreserve", function(r) {
    n.preserve = r;
  }), j(this, "watchList", []), j(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(o) {
        return o !== r;
      });
    };
  }), j(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var o = n.getFieldsValue(), i = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(o, i, r);
      });
    }
  }), j(this, "timeoutId", null), j(this, "warningUnhooked", function() {
    z.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || gt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), j(this, "updateStore", function(r) {
    n.store = r;
  }), j(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(o) {
      return o.getNamePath().length;
    }) : n.fieldEntities;
  }), j(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, o = new _o();
    return n.getFieldEntities(r).forEach(function(i) {
      var a = i.getNamePath();
      o.set(a, i);
    }), o;
  }), j(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var o = n.getFieldsMap(!0);
    return r.map(function(i) {
      var a = Lt(i);
      return o.get(a) || {
        INVALIDATE_NAME_PATH: Lt(i)
      };
    });
  }), j(this, "getFieldsValue", function(r, o) {
    n.warningUnhooked();
    var i, a, s;
    if (r === !0 || Array.isArray(r) ? (i = r, a = o) : r && Ie(r) === "object" && (s = r.strict, a = r.filter), i === !0 && !a)
      return n.store;
    var l = n.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), c = [];
    return l.forEach(function(u) {
      var d, f, g = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var h, y;
        if ((h = (y = u).isList) !== null && h !== void 0 && h.call(y))
          return;
      } else if (!i && (d = (f = u).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!a)
        c.push(g);
      else {
        var p = "getMeta" in u ? u.getMeta() : null;
        a(p) && c.push(g);
      }
    }), hv(n.store, c.map(Lt));
  }), j(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var o = Lt(r);
    return or(n.store, o);
  }), j(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntitiesForNamePathList(r);
    return o.map(function(i, a) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: Lt(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), j(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var o = Lt(r), i = n.getFieldsError([o])[0];
    return i.errors;
  }), j(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var o = Lt(r), i = n.getFieldsError([o])[0];
    return i.warnings;
  }), j(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    var a = o[0], s = o[1], l, c = !1;
    o.length === 0 ? l = null : o.length === 1 ? Array.isArray(a) ? (l = a.map(Lt), c = !1) : (l = null, c = a) : (l = a.map(Lt), c = s);
    var u = n.getFieldEntities(!0), d = function(p) {
      return p.isFieldTouched();
    };
    if (!l)
      return c ? u.every(function(y) {
        return d(y) || y.isList();
      }) : u.some(d);
    var f = new _o();
    l.forEach(function(y) {
      f.set(y, []);
    }), u.forEach(function(y) {
      var p = y.getNamePath();
      l.forEach(function(C) {
        C.every(function(m, b) {
          return p[b] === m;
        }) && f.update(C, function(m) {
          return [].concat(he(m), [y]);
        });
      });
    });
    var g = function(p) {
      return p.some(d);
    }, h = f.map(function(y) {
      var p = y.value;
      return p;
    });
    return c ? h.every(g) : h.some(g);
  }), j(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), j(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var o = n.getFieldEntities();
    if (!r)
      return o.some(function(a) {
        return a.isFieldValidating();
      });
    var i = r.map(Lt);
    return o.some(function(a) {
      var s = a.getNamePath();
      return Vo(i, s) && a.isFieldValidating();
    });
  }), j(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), j(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = new _o(), i = n.getFieldEntities(!0);
    i.forEach(function(l) {
      var c = l.props.initialValue, u = l.getNamePath();
      if (c !== void 0) {
        var d = o.get(u) || /* @__PURE__ */ new Set();
        d.add({
          entity: l,
          value: c
        }), o.set(u, d);
      }
    });
    var a = function(c) {
      c.forEach(function(u) {
        var d = u.props.initialValue;
        if (d !== void 0) {
          var f = u.getNamePath(), g = n.getInitialValue(f);
          if (g !== void 0)
            gt(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var h = o.get(f);
            if (h && h.size > 1)
              gt(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (h) {
              var y = n.getFieldValue(f), p = u.isListField();
              !p && (!r.skipExist || y === void 0) && n.updateStore(Vn(n.store, f, he(h)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(l) {
      var c = o.get(l);
      if (c) {
        var u;
        (u = s).push.apply(u, he(he(c).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = i, a(s);
  }), j(this, "resetFields", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (!r) {
      n.updateStore(No(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(o, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var i = r.map(Lt);
    i.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(Vn(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: i
    }), n.notifyObservers(o, i, {
      type: "reset"
    }), n.notifyWatch(i);
  }), j(this, "setFields", function(r) {
    n.warningUnhooked();
    var o = n.store, i = [];
    r.forEach(function(a) {
      var s = a.name, l = ht(a, GT), c = Lt(s);
      i.push(c), "value" in l && n.updateStore(Vn(n.store, c, l.value)), n.notifyObservers(o, [c], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(i);
  }), j(this, "getFields", function() {
    var r = n.getFieldEntities(!0), o = r.map(function(i) {
      var a = i.getNamePath(), s = i.getMeta(), l = V(V({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return o;
  }), j(this, "initEntityValue", function(r) {
    var o = r.props.initialValue;
    if (o !== void 0) {
      var i = r.getNamePath(), a = or(n.store, i);
      a === void 0 && n.updateStore(Vn(n.store, i, o));
    }
  }), j(this, "isMergedPreserve", function(r) {
    var o = r !== void 0 ? r : n.preserve;
    return o ?? !0;
  }), j(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var o = r.getNamePath();
    if (n.notifyWatch([o]), r.props.initialValue !== void 0) {
      var i = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(i, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || l.length > 1)) {
        var c = a ? void 0 : n.getInitialValue(o);
        if (o.length && n.getFieldValue(o) !== c && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !Mm(d.getNamePath(), o)
          );
        })) {
          var u = n.store;
          n.updateStore(Vn(u, o, c, !0)), n.notifyObservers(u, [o], {
            type: "remove"
          }), n.triggerDependenciesUpdate(u, o);
        }
      }
      n.notifyWatch([o]);
    };
  }), j(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var o = r.namePath, i = r.value;
        n.updateValue(o, i);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), j(this, "notifyObservers", function(r, o, i) {
    if (n.subscribable) {
      var a = V(V({}, i), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var l = s.onStoreChange;
        l(r, o, a);
      });
    } else
      n.forceRootUpdate();
  }), j(this, "triggerDependenciesUpdate", function(r, o) {
    var i = n.getDependencyChildrenFields(o);
    return i.length && n.validateFields(i), n.notifyObservers(r, i, {
      type: "dependenciesUpdate",
      relatedFields: [o].concat(he(i))
    }), i;
  }), j(this, "updateValue", function(r, o) {
    var i = Lt(r), a = n.store;
    n.updateStore(Vn(n.store, i, o)), n.notifyObservers(a, [i], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([i]);
    var s = n.triggerDependenciesUpdate(a, i), l = n.callbacks.onValuesChange;
    if (l) {
      var c = hv(n.store, [i]);
      l(c, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([i].concat(he(s)));
  }), j(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var o = n.store;
    if (r) {
      var i = No(n.store, r);
      n.updateStore(i);
    }
    n.notifyObservers(o, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), j(this, "setFieldValue", function(r, o) {
    n.setFields([{
      name: r,
      value: o,
      errors: [],
      warnings: []
    }]);
  }), j(this, "getDependencyChildrenFields", function(r) {
    var o = /* @__PURE__ */ new Set(), i = [], a = new _o();
    n.getFieldEntities().forEach(function(l) {
      var c = l.props.dependencies;
      (c || []).forEach(function(u) {
        var d = Lt(u);
        a.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(l), f;
        });
      });
    });
    var s = function l(c) {
      var u = a.get(c) || /* @__PURE__ */ new Set();
      u.forEach(function(d) {
        if (!o.has(d)) {
          o.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (i.push(f), l(f));
        }
      });
    };
    return s(r), i;
  }), j(this, "triggerOnFieldsChange", function(r, o) {
    var i = n.callbacks.onFieldsChange;
    if (i) {
      var a = n.getFields();
      if (o) {
        var s = new _o();
        o.forEach(function(c) {
          var u = c.name, d = c.errors;
          s.set(u, d);
        }), a.forEach(function(c) {
          c.errors = s.get(c.name) || c.errors;
        });
      }
      var l = a.filter(function(c) {
        var u = c.name;
        return Vo(r, u);
      });
      l.length && i(l, a);
    }
  }), j(this, "validateFields", function(r, o) {
    n.warningUnhooked();
    var i, a;
    Array.isArray(r) || typeof r == "string" || typeof o == "string" ? (i = r, a = o) : a = r;
    var s = !!i, l = s ? i.map(Lt) : [], c = [], u = String(Date.now()), d = /* @__PURE__ */ new Set(), f = a || {}, g = f.recursive, h = f.dirty;
    n.getFieldEntities(!0).forEach(function(m) {
      if (s || l.push(m.getNamePath()), !(!m.props.rules || !m.props.rules.length) && !(h && !m.isFieldDirty())) {
        var b = m.getNamePath();
        if (d.add(b.join(u)), !s || Vo(l, b, g)) {
          var w = m.validateRules(V({
            validateMessages: V(V({}, km), n.validateMessages)
          }, a));
          c.push(w.then(function() {
            return {
              name: b,
              errors: [],
              warnings: []
            };
          }).catch(function(E) {
            var S, _ = [], O = [];
            return (S = E.forEach) === null || S === void 0 || S.call(E, function(P) {
              var $ = P.rule.warningOnly, L = P.errors;
              $ ? O.push.apply(O, he(L)) : _.push.apply(_, he(L));
            }), _.length ? Promise.reject({
              name: b,
              errors: _,
              warnings: O
            }) : {
              name: b,
              errors: _,
              warnings: O
            };
          }));
        }
      }
    });
    var y = qT(c);
    n.lastValidatePromise = y, y.catch(function(m) {
      return m;
    }).then(function(m) {
      var b = m.map(function(w) {
        var E = w.name;
        return E;
      });
      n.notifyObservers(n.store, b, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(b, m);
    });
    var p = y.then(function() {
      return n.lastValidatePromise === y ? Promise.resolve(n.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(m) {
      var b = m.filter(function(w) {
        return w && w.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(l),
        errorFields: b,
        outOfDate: n.lastValidatePromise !== y
      });
    });
    p.catch(function(m) {
      return m;
    });
    var C = l.filter(function(m) {
      return d.has(m.join(u));
    });
    return n.triggerOnFieldsChange(C), p;
  }), j(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var o = n.callbacks.onFinish;
      if (o)
        try {
          o(r);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(r) {
      var o = n.callbacks.onFinishFailed;
      o && o(r);
    });
  }), this.forceRootUpdate = t;
});
function Fm(e) {
  var t = v.useRef(), n = v.useState({}), r = Q(n, 2), o = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        o({});
      }, a = new KT(i);
      t.current = a.getForm();
    }
  return [t.current];
}
var cu = /* @__PURE__ */ v.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), XT = function(t) {
  var n = t.validateMessages, r = t.onFormChange, o = t.onFormFinish, i = t.children, a = v.useContext(cu), s = v.useRef({});
  return /* @__PURE__ */ v.createElement(cu.Provider, {
    value: V(V({}, a), {}, {
      validateMessages: V(V({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(c, u) {
        r && r(c, {
          changedFields: u,
          forms: s.current
        }), a.triggerFormChange(c, u);
      },
      triggerFormFinish: function(c, u) {
        o && o(c, {
          values: u,
          forms: s.current
        }), a.triggerFormFinish(c, u);
      },
      registerForm: function(c, u) {
        c && (s.current = V(V({}, s.current), {}, j({}, c, u))), a.registerForm(c, u);
      },
      unregisterForm: function(c) {
        var u = V({}, s.current);
        delete u[c], s.current = u, a.unregisterForm(c);
      }
    })
  }, i);
}, YT = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], ZT = function(t, n) {
  var r = t.name, o = t.initialValues, i = t.fields, a = t.form, s = t.preserve, l = t.children, c = t.component, u = c === void 0 ? "form" : c, d = t.validateMessages, f = t.validateTrigger, g = f === void 0 ? "onChange" : f, h = t.onValuesChange, y = t.onFieldsChange, p = t.onFinish, C = t.onFinishFailed, m = t.clearOnDestroy, b = ht(t, YT), w = v.useRef(null), E = v.useContext(cu), S = Fm(a), _ = Q(S, 1), O = _[0], P = O.getInternalHooks(Qr), $ = P.useSubscribe, L = P.setInitialValues, N = P.setCallbacks, k = P.setValidateMessages, F = P.setPreserve, U = P.destroyForm;
  v.useImperativeHandle(n, function() {
    return V(V({}, O), {}, {
      nativeElement: w.current
    });
  }), v.useEffect(function() {
    return E.registerForm(r, O), function() {
      E.unregisterForm(r);
    };
  }, [E, O, r]), k(V(V({}, E.validateMessages), d)), N({
    onValuesChange: h,
    onFieldsChange: function(K) {
      if (E.triggerFormChange(r, K), y) {
        for (var J = arguments.length, ie = new Array(J > 1 ? J - 1 : 0), le = 1; le < J; le++)
          ie[le - 1] = arguments[le];
        y.apply(void 0, [K].concat(ie));
      }
    },
    onFinish: function(K) {
      E.triggerFormFinish(r, K), p && p(K);
    },
    onFinishFailed: C
  }), F(s);
  var A = v.useRef(null);
  L(o, !A.current), A.current || (A.current = !0), v.useEffect(
    function() {
      return function() {
        return U(m);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var R, D = typeof l == "function";
  if (D) {
    var B = O.getFieldsValue(!0);
    R = l(B, O);
  } else
    R = l;
  $(!D);
  var M = v.useRef();
  v.useEffect(function() {
    zT(M.current || [], i || []) || O.setFields(i || []), M.current = i;
  }, [i, O]);
  var G = v.useMemo(function() {
    return V(V({}, O), {}, {
      validateTrigger: g
    });
  }, [O, g]), H = /* @__PURE__ */ v.createElement(ys.Provider, {
    value: null
  }, /* @__PURE__ */ v.createElement(Xo.Provider, {
    value: G
  }, R));
  return u === !1 ? H : /* @__PURE__ */ v.createElement(u, Pe({}, b, {
    ref: w,
    onSubmit: function(K) {
      K.preventDefault(), K.stopPropagation(), O.submit();
    },
    onReset: function(K) {
      var J;
      K.preventDefault(), O.resetFields(), (J = b.onReset) === null || J === void 0 || J.call(b, K);
    }
  }), H);
};
function yv(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var QT = z.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = st(t);
  gt(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function JT() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], o = t[1], i = o === void 0 ? {} : o, a = sT(i) ? {
    form: i
  } : i, s = a.form, l = Ht(), c = Q(l, 2), u = c[0], d = c[1], f = Kn(function() {
    return yv(u);
  }, [u]), g = st(f);
  g.current = f;
  var h = Kt(Xo), y = s || h, p = y && y._init;
  z.env.NODE_ENV !== "production" && gt(t.length === 2 ? s ? p : !0 : p, "useWatch requires a form instance since it can not auto detect from context.");
  var C = Lt(r), m = st(C);
  return m.current = C, QT(C), At(
    function() {
      if (p) {
        var b = y.getFieldsValue, w = y.getInternalHooks, E = w(Qr), S = E.registerWatch, _ = function(L, N) {
          var k = a.preserve ? N : L;
          return typeof r == "function" ? r(k) : or(k, m.current);
        }, O = S(function($, L) {
          var N = _($, L), k = yv(N);
          g.current !== k && (g.current = k, d(N));
        }), P = _(b(), b(!0));
        return u !== P && d(P), O;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [p]
  ), u;
}
var e$ = /* @__PURE__ */ v.forwardRef(ZT), ra = e$;
ra.FormProvider = XT;
ra.Field = Lm;
ra.List = WT;
ra.useForm = Fm;
ra.useWatch = JT;
const uu = /* @__PURE__ */ v.createContext({});
z.env.NODE_ENV !== "production" && (uu.displayName = "FormItemInputContext");
const t$ = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const o = v.useContext(uu), i = v.useMemo(() => {
    const a = Object.assign({}, o);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, o]);
  return /* @__PURE__ */ v.createElement(uu.Provider, {
    value: i
  }, t);
}, n$ = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let o = r;
  return n && (o = /* @__PURE__ */ ee.createElement(t$, {
    override: !0,
    status: !0
  }, o)), t && (o = /* @__PURE__ */ ee.createElement(IP, null, o)), o;
}, r$ = (e) => {
  const {
    componentCls: t,
    notificationMarginEdge: n,
    animationMaxHeight: r
  } = e, o = `${t}-notice`, i = new _t("antNotificationFadeIn", {
    "0%": {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  }), a = new _t("antNotificationTopFadeIn", {
    "0%": {
      top: -r,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  }), s = new _t("antNotificationBottomFadeIn", {
    "0%": {
      bottom: e.calc(r).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  }), l = new _t("antNotificationLeftFadeIn", {
    "0%": {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    "100%": {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return {
    [t]: {
      [`&${t}-top, &${t}-bottom`]: {
        marginInline: 0,
        [o]: {
          marginInline: "auto auto"
        }
      },
      [`&${t}-top`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: a
        }
      },
      [`&${t}-bottom`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: s
        }
      },
      [`&${t}-topRight, &${t}-bottomRight`]: {
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: i
        }
      },
      [`&${t}-topLeft, &${t}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: !0
        },
        marginLeft: {
          value: n,
          _skip_check_: !0
        },
        [o]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationName: l
        }
      }
    }
  };
}, o$ = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"], i$ = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
}, a$ = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    [`${n}-${t}`]: {
      [`&${n}-stack > ${n}-notice-wrapper`]: {
        [t.startsWith("top") ? "top" : "bottom"]: 0,
        [i$[t]]: {
          value: 0,
          _skip_check_: !0
        }
      }
    }
  };
}, s$ = (e) => {
  const t = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    t[`&:nth-last-child(${n + 1})`] = {
      overflow: "hidden",
      [`& > ${e.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${e.motionDurationMid}`
      }
    };
  return Object.assign({
    [`&:not(:nth-last-child(-n+${e.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, t);
}, l$ = (e) => {
  const t = {};
  for (let n = 1; n < e.notificationStackLayer; n++)
    t[`&:nth-last-child(${n + 1})`] = {
      background: e.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  return Object.assign({}, t);
}, c$ = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-stack`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({
        transition: `all ${e.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, s$(e))
    },
    [`${t}-stack:not(${t}-stack-expanded)`]: {
      [`& > ${t}-notice-wrapper`]: Object.assign({}, l$(e))
    },
    [`${t}-stack${t}-stack-expanded`]: {
      [`& > ${t}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${e.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: e.margin,
          width: "100%",
          insetInline: 0,
          bottom: e.calc(e.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, o$.map((n) => a$(e, n)).reduce((n, r) => Object.assign(Object.assign({}, n), r), {}));
}, jm = (e) => {
  const {
    iconCls: t,
    componentCls: n,
    // .ant-notification
    boxShadow: r,
    fontSizeLG: o,
    notificationMarginBottom: i,
    borderRadiusLG: a,
    colorSuccess: s,
    colorInfo: l,
    colorWarning: c,
    colorError: u,
    colorTextHeading: d,
    notificationBg: f,
    notificationPadding: g,
    notificationMarginEdge: h,
    notificationProgressBg: y,
    notificationProgressHeight: p,
    fontSize: C,
    lineHeight: m,
    width: b,
    notificationIconSize: w,
    colorText: E
  } = e, S = `${n}-notice`;
  return {
    position: "relative",
    marginBottom: i,
    marginInlineStart: "auto",
    background: f,
    borderRadius: a,
    boxShadow: r,
    [S]: {
      padding: g,
      width: b,
      maxWidth: `calc(100vw - ${ke(e.calc(h).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight: m,
      wordWrap: "break-word"
    },
    [`${S}-message`]: {
      marginBottom: e.marginXS,
      color: d,
      fontSize: o,
      lineHeight: e.lineHeightLG
    },
    [`${S}-description`]: {
      fontSize: C,
      color: E
    },
    [`${S}-closable ${S}-message`]: {
      paddingInlineEnd: e.paddingLG
    },
    [`${S}-with-icon ${S}-message`]: {
      marginBottom: e.marginXS,
      marginInlineStart: e.calc(e.marginSM).add(w).equal(),
      fontSize: o
    },
    [`${S}-with-icon ${S}-description`]: {
      marginInlineStart: e.calc(e.marginSM).add(w).equal(),
      fontSize: C
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${S}-icon`]: {
      position: "absolute",
      fontSize: w,
      lineHeight: 1,
      // icon-font
      [`&-success${t}`]: {
        color: s
      },
      [`&-info${t}`]: {
        color: l
      },
      [`&-warning${t}`]: {
        color: c
      },
      [`&-error${t}`]: {
        color: u
      }
    },
    [`${S}-close`]: Object.assign({
      position: "absolute",
      top: e.notificationPaddingVertical,
      insetInlineEnd: e.notificationPaddingHorizontal,
      color: e.colorIcon,
      outline: "none",
      width: e.notificationCloseButtonSize,
      height: e.notificationCloseButtonSize,
      borderRadius: e.borderRadiusSM,
      transition: `background-color ${e.motionDurationMid}, color ${e.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: e.colorIconHover,
        backgroundColor: e.colorBgTextHover
      },
      "&:active": {
        backgroundColor: e.colorBgTextActive
      }
    }, zh(e)),
    [`${S}-progress`]: {
      position: "absolute",
      display: "block",
      appearance: "none",
      WebkitAppearance: "none",
      inlineSize: `calc(100% - ${ke(a)} * 2)`,
      left: {
        _skip_check_: !0,
        value: a
      },
      right: {
        _skip_check_: !0,
        value: a
      },
      bottom: 0,
      blockSize: p,
      border: 0,
      "&, &::-webkit-progress-bar": {
        borderRadius: a,
        backgroundColor: "rgba(0, 0, 0, 0.04)"
      },
      "&::-moz-progress-bar": {
        background: y
      },
      "&::-webkit-progress-value": {
        borderRadius: a,
        background: y
      }
    },
    [`${S}-btn`]: {
      float: "right",
      marginTop: e.marginSM
    }
  };
}, u$ = (e) => {
  const {
    componentCls: t,
    // .ant-notification
    notificationMarginBottom: n,
    notificationMarginEdge: r,
    motionDurationMid: o,
    motionEaseInOut: i
  } = e, a = `${t}-notice`, s = new _t("antNotificationFadeOut", {
    "0%": {
      maxHeight: e.animationMaxHeight,
      marginBottom: n
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, oi(e)), {
        position: "fixed",
        zIndex: e.zIndexPopup,
        marginRight: {
          value: r,
          _skip_check_: !0
        },
        [`${t}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${t}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${t}-fade-enter, ${t}-fade-appear`]: {
          animationDuration: e.motionDurationMid,
          animationTimingFunction: i,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${t}-fade-leave`]: {
          animationTimingFunction: i,
          animationFillMode: "both",
          animationDuration: o,
          animationPlayState: "paused"
        },
        [`${t}-fade-enter${t}-fade-enter-active, ${t}-fade-appear${t}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${t}-fade-leave${t}-fade-leave-active`]: {
          animationName: s,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${a}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${a}-wrapper`]: Object.assign({}, jm(e))
      }
    }
  ];
}, Bm = (e) => ({
  zIndexPopup: e.zIndexPopupBase + dm + 50,
  width: 384
}), Vm = (e) => {
  const t = e.paddingMD, n = e.paddingLG;
  return hn(e, {
    notificationBg: e.colorBgElevated,
    notificationPaddingVertical: t,
    notificationPaddingHorizontal: n,
    notificationIconSize: e.calc(e.fontSizeLG).mul(e.lineHeightLG).equal(),
    notificationCloseButtonSize: e.calc(e.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: e.margin,
    notificationPadding: `${ke(e.paddingMD)} ${ke(e.paddingContentHorizontalLG)}`,
    notificationMarginEdge: e.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3,
    notificationProgressHeight: 2,
    notificationProgressBg: `linear-gradient(90deg, ${e.colorPrimaryBorderHover}, ${e.colorPrimary})`
  });
}, zm = Er("Notification", (e) => {
  const t = Vm(e);
  return [u$(t), r$(t), c$(t)];
}, Bm), d$ = Uh(["Notification", "PurePanel"], (e) => {
  const t = `${e.componentCls}-notice`, n = Vm(e);
  return {
    [`${t}-pure-panel`]: Object.assign(Object.assign({}, jm(n)), {
      width: n.width,
      maxWidth: `calc(100vw - ${ke(e.calc(n.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, Bm);
var f$ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function rd(e, t) {
  return t === null || t === !1 ? null : t || /* @__PURE__ */ v.createElement(Ug, {
    className: `${e}-close-icon`
  });
}
const v$ = {
  success: zg,
  info: Gg,
  error: Hg,
  warning: qg
}, Hm = (e) => {
  const {
    prefixCls: t,
    icon: n,
    type: r,
    message: o,
    description: i,
    btn: a,
    role: s = "alert"
  } = e;
  let l = null;
  return n ? l = /* @__PURE__ */ v.createElement("span", {
    className: `${t}-icon`
  }, n) : r && (l = /* @__PURE__ */ v.createElement(v$[r] || null, {
    className: se(`${t}-icon`, `${t}-icon-${r}`)
  })), /* @__PURE__ */ v.createElement("div", {
    className: se({
      [`${t}-with-icon`]: l
    }),
    role: s
  }, l, /* @__PURE__ */ v.createElement("div", {
    className: `${t}-message`
  }, o), /* @__PURE__ */ v.createElement("div", {
    className: `${t}-description`
  }, i), a && /* @__PURE__ */ v.createElement("div", {
    className: `${t}-btn`
  }, a));
}, g$ = (e) => {
  const {
    prefixCls: t,
    className: n,
    icon: r,
    type: o,
    message: i,
    description: a,
    btn: s,
    closable: l = !0,
    closeIcon: c,
    className: u
  } = e, d = f$(e, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon", "className"]), {
    getPrefixCls: f
  } = v.useContext(kt), g = t || f("notification"), h = `${g}-notice`, y = ea(g), [p, C, m] = zm(g, y);
  return p(/* @__PURE__ */ v.createElement("div", {
    className: se(`${h}-pure-panel`, C, n, m, y)
  }, /* @__PURE__ */ v.createElement(d$, {
    prefixCls: g
  }), /* @__PURE__ */ v.createElement(sm, Object.assign({}, d, {
    prefixCls: g,
    eventKey: "pure",
    duration: null,
    closable: l,
    className: se({
      notificationClassName: u
    }),
    closeIcon: rd(g, c),
    content: /* @__PURE__ */ v.createElement(Hm, {
      prefixCls: h,
      icon: r,
      type: o,
      message: i,
      description: a,
      btn: s
    })
  }))));
};
function p$(e, t, n) {
  let r;
  switch (e) {
    case "top":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: t,
        bottom: "auto"
      };
      break;
    case "topLeft":
      r = {
        left: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "topRight":
      r = {
        right: 0,
        top: t,
        bottom: "auto"
      };
      break;
    case "bottom":
      r = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom: n
      };
      break;
    case "bottomLeft":
      r = {
        left: 0,
        top: "auto",
        bottom: n
      };
      break;
    default:
      r = {
        right: 0,
        top: "auto",
        bottom: n
      };
      break;
  }
  return r;
}
function h$(e) {
  return {
    motionName: `${e}-fade`
  };
}
var m$ = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const bv = 24, y$ = 4.5, b$ = "topRight", C$ = (e) => {
  let {
    children: t,
    prefixCls: n
  } = e;
  const r = ea(n), [o, i, a] = zm(n, r);
  return o(/* @__PURE__ */ ee.createElement(ZO, {
    classNames: {
      list: se(i, a, r)
    }
  }, t));
}, w$ = (e, t) => {
  let {
    prefixCls: n,
    key: r
  } = t;
  return /* @__PURE__ */ ee.createElement(C$, {
    prefixCls: n,
    key: r
  }, e);
}, S$ = /* @__PURE__ */ ee.forwardRef((e, t) => {
  const {
    top: n,
    bottom: r,
    prefixCls: o,
    getContainer: i,
    maxCount: a,
    rtl: s,
    onAllRemoved: l,
    stack: c,
    duration: u,
    pauseOnHover: d = !0,
    showProgress: f
  } = e, {
    getPrefixCls: g,
    getPopupContainer: h,
    notification: y,
    direction: p
  } = Kt(kt), [, C] = sr(), m = o || g("notification"), b = (O) => p$(O, n ?? bv, r ?? bv), w = () => se({
    [`${m}-rtl`]: s ?? p === "rtl"
  }), E = () => h$(m), [S, _] = rP({
    prefixCls: m,
    style: b,
    className: w,
    motion: E,
    closable: !0,
    closeIcon: rd(m),
    duration: u ?? y$,
    getContainer: () => (i == null ? void 0 : i()) || (h == null ? void 0 : h()) || document.body,
    maxCount: a,
    pauseOnHover: d,
    showProgress: f,
    onAllRemoved: l,
    renderNotifications: w$,
    stack: c === !1 ? !1 : {
      threshold: typeof c == "object" ? c == null ? void 0 : c.threshold : void 0,
      offset: 8,
      gap: C.margin
    }
  });
  return ee.useImperativeHandle(t, () => Object.assign(Object.assign({}, S), {
    prefixCls: m,
    notification: y
  })), _;
});
function Um(e) {
  const t = ee.useRef(null), n = Pn("Notification");
  return [ee.useMemo(() => {
    const o = (l) => {
      var c;
      if (!t.current) {
        z.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        return;
      }
      const {
        open: u,
        prefixCls: d,
        notification: f
      } = t.current, g = `${d}-notice`, {
        message: h,
        description: y,
        icon: p,
        type: C,
        btn: m,
        className: b,
        style: w,
        role: E = "alert",
        closeIcon: S,
        closable: _
      } = l, O = m$(l, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon", "closable"]), P = rd(g, typeof S < "u" ? S : f == null ? void 0 : f.closeIcon);
      return u(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (c = e == null ? void 0 : e.placement) !== null && c !== void 0 ? c : b$
      }, O), {
        content: /* @__PURE__ */ ee.createElement(Hm, {
          prefixCls: g,
          icon: p,
          type: C,
          message: h,
          description: y,
          btn: m,
          role: E
        }),
        className: se(C && `${g}-${C}`, b, f == null ? void 0 : f.className),
        style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), w),
        closeIcon: P,
        closable: _ ?? !!P
      }));
    }, a = {
      open: o,
      destroy: (l) => {
        var c, u;
        l !== void 0 ? (c = t.current) === null || c === void 0 || c.close(l) : (u = t.current) === null || u === void 0 || u.destroy();
      }
    };
    return ["success", "info", "warning", "error"].forEach((l) => {
      a[l] = (c) => o(Object.assign(Object.assign({}, c), {
        type: l
      }));
    }), a;
  }, []), /* @__PURE__ */ ee.createElement(S$, Object.assign({
    key: "notification-holder"
  }, e, {
    ref: t
  }))];
}
function E$(e) {
  return Um(e);
}
const _$ = /* @__PURE__ */ ee.createContext({}), x$ = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var O$ = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], xo = void 0;
function P$(e, t) {
  var n = e.prefixCls, r = e.invalidate, o = e.item, i = e.renderItem, a = e.responsive, s = e.responsiveDisabled, l = e.registerSize, c = e.itemKey, u = e.className, d = e.style, f = e.children, g = e.display, h = e.order, y = e.component, p = y === void 0 ? "div" : y, C = ht(e, O$), m = a && !g;
  function b(O) {
    l(c, O);
  }
  v.useEffect(function() {
    return function() {
      b(null);
    };
  }, []);
  var w = i && o !== xo ? i(o, {
    index: h
  }) : f, E;
  r || (E = {
    opacity: m ? 0 : 1,
    height: m ? 0 : xo,
    overflowY: m ? "hidden" : xo,
    order: a ? h : xo,
    pointerEvents: m ? "none" : xo,
    position: m ? "absolute" : xo
  });
  var S = {};
  m && (S["aria-hidden"] = !0);
  var _ = /* @__PURE__ */ v.createElement(p, Pe({
    className: se(!r && n, u),
    style: V(V({}, E), d)
  }, S, C, {
    ref: t
  }), w);
  return a && (_ = /* @__PURE__ */ v.createElement(uo, {
    onResize: function(P) {
      var $ = P.offsetWidth;
      b($);
    },
    disabled: s
  }, _)), _;
}
var Ri = /* @__PURE__ */ v.forwardRef(P$);
Ri.displayName = "Item";
function I$(e) {
  if (typeof MessageChannel > "u")
    pn(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function T$() {
  var e = v.useRef(null), t = function(r) {
    e.current || (e.current = [], I$(function() {
      zy(function() {
        e.current.forEach(function(o) {
          o();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function bi(e, t) {
  var n = v.useState(t), r = Q(n, 2), o = r[0], i = r[1], a = sn(function(s) {
    e(function() {
      i(s);
    });
  });
  return [o, a];
}
var bs = /* @__PURE__ */ ee.createContext(null), $$ = ["component"], R$ = ["className"], N$ = ["className"], A$ = function(t, n) {
  var r = v.useContext(bs);
  if (!r) {
    var o = t.component, i = o === void 0 ? "div" : o, a = ht(t, $$);
    return /* @__PURE__ */ v.createElement(i, Pe({}, a, {
      ref: n
    }));
  }
  var s = r.className, l = ht(r, R$), c = t.className, u = ht(t, N$);
  return /* @__PURE__ */ v.createElement(bs.Provider, {
    value: null
  }, /* @__PURE__ */ v.createElement(Ri, Pe({
    ref: n,
    className: se(s, c)
  }, l, u)));
}, Wm = /* @__PURE__ */ v.forwardRef(A$);
Wm.displayName = "RawItem";
var k$ = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], qm = "responsive", Gm = "invalidate";
function M$(e) {
  return "+ ".concat(e.length, " ...");
}
function L$(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, o = e.data, i = o === void 0 ? [] : o, a = e.renderItem, s = e.renderRawItem, l = e.itemKey, c = e.itemWidth, u = c === void 0 ? 10 : c, d = e.ssr, f = e.style, g = e.className, h = e.maxCount, y = e.renderRest, p = e.renderRawRest, C = e.suffix, m = e.component, b = m === void 0 ? "div" : m, w = e.itemComponent, E = e.onVisibleChange, S = ht(e, k$), _ = d === "full", O = T$(), P = bi(O, null), $ = Q(P, 2), L = $[0], N = $[1], k = L || 0, F = bi(O, /* @__PURE__ */ new Map()), U = Q(F, 2), A = U[0], R = U[1], D = bi(O, 0), B = Q(D, 2), M = B[0], G = B[1], H = bi(O, 0), X = Q(H, 2), K = X[0], J = X[1], ie = bi(O, 0), le = Q(ie, 2), ne = le[0], te = le[1], re = Ht(null), _e = Q(re, 2), me = _e[0], De = _e[1], oe = Ht(null), Te = Q(oe, 2), Re = Te[0], Ye = Te[1], Fe = v.useMemo(function() {
    return Re === null && _ ? Number.MAX_SAFE_INTEGER : Re || 0;
  }, [Re, L]), Ze = Ht(!1), nt = Q(Ze, 2), xe = nt[0], He = nt[1], ye = "".concat(r, "-item"), it = Math.max(M, K), Me = h === qm, Ve = i.length && Me, lt = h === Gm, yt = Ve || typeof h == "number" && i.length > h, mt = Kn(function() {
    var we = i;
    return Ve ? L === null && _ ? we = i : we = i.slice(0, Math.min(i.length, k / u)) : typeof h == "number" && (we = i.slice(0, h)), we;
  }, [i, u, L, h, Ve]), Ne = Kn(function() {
    return Ve ? i.slice(Fe + 1) : i.slice(mt.length);
  }, [i, mt, Ve, Fe]), Ue = wn(function(we, ge) {
    var Ee;
    return typeof l == "function" ? l(we) : (Ee = l && (we == null ? void 0 : we[l])) !== null && Ee !== void 0 ? Ee : ge;
  }, [l]), x = wn(a || function(we) {
    return we;
  }, [a]);
  function T(we, ge, Ee) {
    Re === we && (ge === void 0 || ge === me) || (Ye(we), Ee || (He(we < i.length - 1), E == null || E(we)), ge !== void 0 && De(ge));
  }
  function q(we, ge) {
    N(ge.clientWidth);
  }
  function W(we, ge) {
    R(function(Ee) {
      var ot = new Map(Ee);
      return ge === null ? ot.delete(we) : ot.set(we, ge), ot;
    });
  }
  function Y(we, ge) {
    J(ge), G(K);
  }
  function ce(we, ge) {
    te(ge);
  }
  function fe(we) {
    return A.get(Ue(mt[we], we));
  }
  nn(function() {
    if (k && typeof it == "number" && mt) {
      var we = ne, ge = mt.length, Ee = ge - 1;
      if (!ge) {
        T(0, null);
        return;
      }
      for (var ot = 0; ot < ge; ot += 1) {
        var xt = fe(ot);
        if (_ && (xt = xt || 0), xt === void 0) {
          T(ot - 1, void 0, !0);
          break;
        }
        if (we += xt, // Only one means `totalWidth` is the final width
        Ee === 0 && we <= k || // Last two width will be the final width
        ot === Ee - 1 && we + fe(Ee) <= k) {
          T(Ee, null);
          break;
        } else if (we + it > k) {
          T(ot - 1, we - xt - ne + K);
          break;
        }
      }
      C && fe(0) + ne > k && De(null);
    }
  }, [k, A, K, ne, Ue, mt]);
  var je = xe && !!Ne.length, Be = {};
  me !== null && Ve && (Be = {
    position: "absolute",
    left: me,
    top: 0
  });
  var ze = {
    prefixCls: ye,
    responsive: Ve,
    component: w,
    invalidate: lt
  }, et = s ? function(we, ge) {
    var Ee = Ue(we, ge);
    return /* @__PURE__ */ v.createElement(bs.Provider, {
      key: Ee,
      value: V(V({}, ze), {}, {
        order: ge,
        item: we,
        itemKey: Ee,
        registerSize: W,
        display: ge <= Fe
      })
    }, s(we, ge));
  } : function(we, ge) {
    var Ee = Ue(we, ge);
    return /* @__PURE__ */ v.createElement(Ri, Pe({}, ze, {
      order: ge,
      key: Ee,
      item: we,
      renderItem: x,
      itemKey: Ee,
      registerSize: W,
      display: ge <= Fe
    }));
  }, Ke = {
    order: je ? Fe : Number.MAX_SAFE_INTEGER,
    className: "".concat(ye, "-rest"),
    registerSize: Y,
    display: je
  }, Je = y || M$, Pt = p ? /* @__PURE__ */ v.createElement(bs.Provider, {
    value: V(V({}, ze), Ke)
  }, p(Ne)) : /* @__PURE__ */ v.createElement(Ri, Pe({}, ze, Ke), typeof Je == "function" ? Je(Ne) : Je), rt = /* @__PURE__ */ v.createElement(b, Pe({
    className: se(!lt && r, g),
    style: f,
    ref: t
  }, S), mt.map(et), yt ? Pt : null, C && /* @__PURE__ */ v.createElement(Ri, Pe({}, ze, {
    responsive: Me,
    responsiveDisabled: !Ve,
    order: Fe,
    className: "".concat(ye, "-suffix"),
    registerSize: ce,
    display: !0,
    style: Be
  }), C));
  return Me ? /* @__PURE__ */ v.createElement(uo, {
    onResize: q,
    disabled: !Ve
  }, rt) : rt;
}
var yr = /* @__PURE__ */ v.forwardRef(L$);
yr.displayName = "Overflow";
yr.Item = Wm;
yr.RESPONSIVE = qm;
yr.INVALIDATE = Gm;
function D$(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, o = e.arrowPos, i = r || {}, a = i.className, s = i.content, l = o.x, c = l === void 0 ? 0 : l, u = o.y, d = u === void 0 ? 0 : u, f = v.useRef();
  if (!n || !n.points)
    return null;
  var g = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var h = n.points[0], y = n.points[1], p = h[0], C = h[1], m = y[0], b = y[1];
    p === m || !["t", "b"].includes(p) ? g.top = d : p === "t" ? g.top = 0 : g.bottom = 0, C === b || !["l", "r"].includes(C) ? g.left = c : C === "l" ? g.left = 0 : g.right = 0;
  }
  return /* @__PURE__ */ v.createElement("div", {
    ref: f,
    className: se("".concat(t, "-arrow"), a),
    style: g
  }, s);
}
function F$(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, o = e.mask, i = e.motion;
  return o ? /* @__PURE__ */ v.createElement(ii, Pe({}, i, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ v.createElement("div", {
      style: {
        zIndex: r
      },
      className: se("".concat(t, "-mask"), s)
    });
  }) : null;
}
var Km = /* @__PURE__ */ v.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
z.env.NODE_ENV !== "production" && (Km.displayName = "PopupContent");
var Xm = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, o = e.prefixCls, i = e.style, a = e.target, s = e.onVisibleChanged, l = e.open, c = e.keepDom, u = e.fresh, d = e.onClick, f = e.mask, g = e.arrow, h = e.arrowPos, y = e.align, p = e.motion, C = e.maskMotion, m = e.forceRender, b = e.getPopupContainer, w = e.autoDestroy, E = e.portal, S = e.zIndex, _ = e.onMouseEnter, O = e.onMouseLeave, P = e.onPointerEnter, $ = e.onPointerDownCapture, L = e.ready, N = e.offsetX, k = e.offsetY, F = e.offsetR, U = e.offsetB, A = e.onAlign, R = e.onPrepare, D = e.stretch, B = e.targetWidth, M = e.targetHeight, G = typeof n == "function" ? n() : n, H = l || c, X = (b == null ? void 0 : b.length) > 0, K = v.useState(!b || !X), J = Q(K, 2), ie = J[0], le = J[1];
  if (nn(function() {
    !ie && X && a && le(!0);
  }, [ie, X, a]), !ie)
    return null;
  var ne = "auto", te = {
    left: "-1000vw",
    top: "-1000vh",
    right: ne,
    bottom: ne
  };
  if (L || !l) {
    var re, _e = y.points, me = y.dynamicInset || ((re = y._experimental) === null || re === void 0 ? void 0 : re.dynamicInset), De = me && _e[0][1] === "r", oe = me && _e[0][0] === "b";
    De ? (te.right = F, te.left = ne) : (te.left = N, te.right = ne), oe ? (te.bottom = U, te.top = ne) : (te.top = k, te.bottom = ne);
  }
  var Te = {};
  return D && (D.includes("height") && M ? Te.height = M : D.includes("minHeight") && M && (Te.minHeight = M), D.includes("width") && B ? Te.width = B : D.includes("minWidth") && B && (Te.minWidth = B)), l || (Te.pointerEvents = "none"), /* @__PURE__ */ v.createElement(E, {
    open: m || H,
    getContainer: b && function() {
      return b(a);
    },
    autoDestroy: w
  }, /* @__PURE__ */ v.createElement(F$, {
    prefixCls: o,
    open: l,
    zIndex: S,
    mask: f,
    motion: C
  }), /* @__PURE__ */ v.createElement(uo, {
    onResize: A,
    disabled: !l
  }, function(Re) {
    return /* @__PURE__ */ v.createElement(ii, Pe({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: m,
      leavedClassName: "".concat(o, "-hidden")
    }, p, {
      onAppearPrepare: R,
      onEnterPrepare: R,
      visible: l,
      onVisibleChanged: function(Fe) {
        var Ze;
        p == null || (Ze = p.onVisibleChanged) === null || Ze === void 0 || Ze.call(p, Fe), s(Fe);
      }
    }), function(Ye, Fe) {
      var Ze = Ye.className, nt = Ye.style, xe = se(o, Ze, r);
      return /* @__PURE__ */ v.createElement("div", {
        ref: Xi(Re, t, Fe),
        className: xe,
        style: V(V(V(V({
          "--arrow-x": "".concat(h.x || 0, "px"),
          "--arrow-y": "".concat(h.y || 0, "px")
        }, te), Te), nt), {}, {
          boxSizing: "border-box",
          zIndex: S
        }, i),
        onMouseEnter: _,
        onMouseLeave: O,
        onPointerEnter: P,
        onClick: d,
        onPointerDownCapture: $
      }, g && /* @__PURE__ */ v.createElement(D$, {
        prefixCls: o,
        arrow: g,
        arrowPos: h,
        align: y
      }), /* @__PURE__ */ v.createElement(Km, {
        cache: !l && !u
      }, G));
    });
  }));
});
z.env.NODE_ENV !== "production" && (Xm.displayName = "Popup");
var Ym = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, o = Zi(n), i = v.useCallback(function(s) {
    Au(t, r ? r(s) : s);
  }, [r]), a = Yi(i, ks(n));
  return o ? /* @__PURE__ */ v.cloneElement(n, {
    ref: a
  }) : n;
});
z.env.NODE_ENV !== "production" && (Ym.displayName = "TriggerWrapper");
var Cv = /* @__PURE__ */ v.createContext(null);
function wv(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function j$(e, t, n, r) {
  return v.useMemo(function() {
    var o = wv(n ?? t), i = wv(r ?? t), a = new Set(o), s = new Set(i);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
function B$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function V$(e, t, n, r) {
  for (var o = n.points, i = Object.keys(e), a = 0; a < i.length; a += 1) {
    var s, l = i[a];
    if (B$((s = e[l]) === null || s === void 0 ? void 0 : s.points, o, r))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
function Sv(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function oa(e) {
  return e.ownerDocument.defaultView;
}
function du(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var o = oa(n).getComputedStyle(n), i = o.overflowX, a = o.overflowY, s = o.overflow;
    [i, a, s].some(function(l) {
      return r.includes(l);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function qi(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function Ci(e) {
  return qi(parseFloat(e), 0);
}
function Ev(e, t) {
  var n = V({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var o = oa(r).getComputedStyle(r), i = o.overflow, a = o.overflowClipMargin, s = o.borderTopWidth, l = o.borderBottomWidth, c = o.borderLeftWidth, u = o.borderRightWidth, d = r.getBoundingClientRect(), f = r.offsetHeight, g = r.clientHeight, h = r.offsetWidth, y = r.clientWidth, p = Ci(s), C = Ci(l), m = Ci(c), b = Ci(u), w = qi(Math.round(d.width / h * 1e3) / 1e3), E = qi(Math.round(d.height / f * 1e3) / 1e3), S = (h - y - m - b) * w, _ = (f - g - p - C) * E, O = p * E, P = C * E, $ = m * w, L = b * w, N = 0, k = 0;
      if (i === "clip") {
        var F = Ci(a);
        N = F * w, k = F * E;
      }
      var U = d.x + $ - N, A = d.y + O - k, R = U + d.width + 2 * N - $ - L - S, D = A + d.height + 2 * k - O - P - _;
      n.left = Math.max(n.left, U), n.top = Math.max(n.top, A), n.right = Math.min(n.right, R), n.bottom = Math.min(n.bottom, D);
    }
  }), n;
}
function _v(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function xv(e, t) {
  var n = t || [], r = Q(n, 2), o = r[0], i = r[1];
  return [_v(e.width, o), _v(e.height, i)];
}
function Ov() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function Oo(e, t) {
  var n = t[0], r = t[1], o, i;
  return n === "t" ? i = e.y : n === "b" ? i = e.y + e.height : i = e.y + e.height / 2, r === "l" ? o = e.x : r === "r" ? o = e.x + e.width : o = e.x + e.width / 2, {
    x: o,
    y: i
  };
}
function $r(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, o) {
    return o === t ? n[r] || "c" : r;
  }).join("");
}
function z$(e, t, n, r, o, i, a) {
  var s = v.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: o[r] || {}
  }), l = Q(s, 2), c = l[0], u = l[1], d = v.useRef(0), f = v.useMemo(function() {
    return t ? du(t) : [];
  }, [t]), g = v.useRef({}), h = function() {
    g.current = {};
  };
  e || h();
  var y = sn(function() {
    if (t && n && e) {
      let An = function(Co, Ir) {
        var Tr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : it, di = K.x + Co, da = K.y + Ir, vl = di + De, gl = da + me, pl = Math.max(di, Tr.left), pe = Math.max(da, Tr.top), Ae = Math.min(vl, Tr.right), $t = Math.min(gl, Tr.bottom);
        return Math.max(0, (Ae - pl) * ($t - pe));
      }, ua = function() {
        Oe = K.y + Ee, We = Oe + me, $e = K.x + ge, Le = $e + De;
      };
      var m, b, w, E, S = t, _ = S.ownerDocument, O = oa(S), P = O.getComputedStyle(S), $ = P.width, L = P.height, N = P.position, k = S.style.left, F = S.style.top, U = S.style.right, A = S.style.bottom, R = S.style.overflow, D = V(V({}, o[r]), i), B = _.createElement("div");
      (m = S.parentElement) === null || m === void 0 || m.appendChild(B), B.style.left = "".concat(S.offsetLeft, "px"), B.style.top = "".concat(S.offsetTop, "px"), B.style.position = N, B.style.height = "".concat(S.offsetHeight, "px"), B.style.width = "".concat(S.offsetWidth, "px"), S.style.left = "0", S.style.top = "0", S.style.right = "auto", S.style.bottom = "auto", S.style.overflow = "hidden";
      var M;
      if (Array.isArray(n))
        M = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var G, H, X = n.getBoundingClientRect();
        X.x = (G = X.x) !== null && G !== void 0 ? G : X.left, X.y = (H = X.y) !== null && H !== void 0 ? H : X.top, M = {
          x: X.x,
          y: X.y,
          width: X.width,
          height: X.height
        };
      }
      var K = S.getBoundingClientRect();
      K.x = (b = K.x) !== null && b !== void 0 ? b : K.left, K.y = (w = K.y) !== null && w !== void 0 ? w : K.top;
      var J = _.documentElement, ie = J.clientWidth, le = J.clientHeight, ne = J.scrollWidth, te = J.scrollHeight, re = J.scrollTop, _e = J.scrollLeft, me = K.height, De = K.width, oe = M.height, Te = M.width, Re = {
        left: 0,
        top: 0,
        right: ie,
        bottom: le
      }, Ye = {
        left: -_e,
        top: -re,
        right: ne - _e,
        bottom: te - re
      }, Fe = D.htmlRegion, Ze = "visible", nt = "visibleFirst";
      Fe !== "scroll" && Fe !== nt && (Fe = Ze);
      var xe = Fe === nt, He = Ev(Ye, f), ye = Ev(Re, f), it = Fe === Ze ? ye : He, Me = xe ? ye : it;
      S.style.left = "auto", S.style.top = "auto", S.style.right = "0", S.style.bottom = "0";
      var Ve = S.getBoundingClientRect();
      S.style.left = k, S.style.top = F, S.style.right = U, S.style.bottom = A, S.style.overflow = R, (E = S.parentElement) === null || E === void 0 || E.removeChild(B);
      var lt = qi(Math.round(De / parseFloat($) * 1e3) / 1e3), yt = qi(Math.round(me / parseFloat(L) * 1e3) / 1e3);
      if (lt === 0 || yt === 0 || Di(n) && !Zu(n))
        return;
      var mt = D.offset, Ne = D.targetOffset, Ue = xv(K, mt), x = Q(Ue, 2), T = x[0], q = x[1], W = xv(M, Ne), Y = Q(W, 2), ce = Y[0], fe = Y[1];
      M.x -= ce, M.y -= fe;
      var je = D.points || [], Be = Q(je, 2), ze = Be[0], et = Be[1], Ke = Ov(et), Je = Ov(ze), Pt = Oo(M, Ke), rt = Oo(K, Je), we = V({}, D), ge = Pt.x - rt.x + T, Ee = Pt.y - rt.y + q, ot = An(ge, Ee), xt = An(ge, Ee, ye), bt = Oo(M, ["t", "l"]), Dt = Oo(K, ["t", "l"]), jn = Oo(M, ["b", "r"]), ct = Oo(K, ["b", "r"]), ut = D.overflow || {}, Wt = ut.adjustX, I = ut.adjustY, Z = ut.shiftX, ae = ut.shiftY, be = function(Ir) {
        return typeof Ir == "boolean" ? Ir : Ir >= 0;
      }, Oe, We, $e, Le;
      ua();
      var Ct = be(I), Qe = Je[0] === Ke[0];
      if (Ct && Je[0] === "t" && (We > Me.bottom || g.current.bt)) {
        var qe = Ee;
        Qe ? qe -= me - oe : qe = bt.y - ct.y - q;
        var qt = An(ge, qe), In = An(ge, qe, ye);
        // Of course use larger one
        qt > ot || qt === ot && (!xe || // Choose recommend one
        In >= xt) ? (g.current.bt = !0, Ee = qe, q = -q, we.points = [$r(Je, 0), $r(Ke, 0)]) : g.current.bt = !1;
      }
      if (Ct && Je[0] === "b" && (Oe < Me.top || g.current.tb)) {
        var on = Ee;
        Qe ? on += me - oe : on = jn.y - Dt.y - q;
        var Mt = An(ge, on), Jn = An(ge, on, ye);
        // Of course use larger one
        Mt > ot || Mt === ot && (!xe || // Choose recommend one
        Jn >= xt) ? (g.current.tb = !0, Ee = on, q = -q, we.points = [$r(Je, 0), $r(Ke, 0)]) : g.current.tb = !1;
      }
      var Tn = be(Wt), er = Je[1] === Ke[1];
      if (Tn && Je[1] === "l" && (Le > Me.right || g.current.rl)) {
        var cr = ge;
        er ? cr -= De - Te : cr = bt.x - ct.x - T;
        var go = An(cr, Ee), xr = An(cr, Ee, ye);
        // Of course use larger one
        go > ot || go === ot && (!xe || // Choose recommend one
        xr >= xt) ? (g.current.rl = !0, ge = cr, T = -T, we.points = [$r(Je, 1), $r(Ke, 1)]) : g.current.rl = !1;
      }
      if (Tn && Je[1] === "r" && ($e < Me.left || g.current.lr)) {
        var $n = ge;
        er ? $n += De - Te : $n = jn.x - Dt.x - T;
        var ur = An($n, Ee), po = An($n, Ee, ye);
        // Of course use larger one
        ur > ot || ur === ot && (!xe || // Choose recommend one
        po >= xt) ? (g.current.lr = !0, ge = $n, T = -T, we.points = [$r(Je, 1), $r(Ke, 1)]) : g.current.lr = !1;
      }
      ua();
      var Rn = Z === !0 ? 0 : Z;
      typeof Rn == "number" && ($e < ye.left && (ge -= $e - ye.left - T, M.x + Te < ye.left + Rn && (ge += M.x - ye.left + Te - Rn)), Le > ye.right && (ge -= Le - ye.right - T, M.x > ye.right - Rn && (ge += M.x - ye.right + Rn)));
      var mn = ae === !0 ? 0 : ae;
      typeof mn == "number" && (Oe < ye.top && (Ee -= Oe - ye.top - q, M.y + oe < ye.top + mn && (Ee += M.y - ye.top + oe - mn)), We > ye.bottom && (Ee -= We - ye.bottom - q, M.y > ye.bottom - mn && (Ee += M.y - ye.bottom + mn)));
      var dr = K.x + ge, Or = dr + De, Nn = K.y + Ee, li = Nn + me, ho = M.x, ci = ho + Te, wt = M.y, at = wt + oe, St = Math.max(dr, ho), an = Math.min(Or, ci), Qt = (St + an) / 2, Pr = Qt - dr, qr = Math.max(Nn, wt), mo = Math.min(li, at), yo = (qr + mo) / 2, bo = yo - Nn;
      a == null || a(t, we);
      var Bn = Ve.right - K.x - (ge + K.width), fn = Ve.bottom - K.y - (Ee + K.height);
      lt === 1 && (ge = Math.round(ge), Bn = Math.round(Bn)), yt === 1 && (Ee = Math.round(Ee), fn = Math.round(fn));
      var ui = {
        ready: !0,
        offsetX: ge / lt,
        offsetY: Ee / yt,
        offsetR: Bn / lt,
        offsetB: fn / yt,
        arrowX: Pr / lt,
        arrowY: bo / yt,
        scaleX: lt,
        scaleY: yt,
        align: we
      };
      u(ui);
    }
  }), p = function() {
    d.current += 1;
    var b = d.current;
    Promise.resolve().then(function() {
      d.current === b && y();
    });
  }, C = function() {
    u(function(b) {
      return V(V({}, b), {}, {
        ready: !1
      });
    });
  };
  return nn(C, [r]), nn(function() {
    e || C();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, p];
}
function H$(e, t, n, r, o) {
  nn(function() {
    if (e && t && n) {
      let d = function() {
        r(), o();
      };
      var i = t, a = n, s = du(i), l = du(a), c = oa(a), u = new Set([c].concat(he(s), he(l)));
      return u.forEach(function(f) {
        f.addEventListener("scroll", d, {
          passive: !0
        });
      }), c.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        u.forEach(function(f) {
          f.removeEventListener("scroll", d), c.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function U$(e, t, n, r, o, i, a, s) {
  var l = v.useRef(e);
  l.current = e;
  var c = v.useRef(!1);
  v.useEffect(function() {
    if (t && r && (!o || i)) {
      var d = function() {
        c.current = !1;
      }, f = function(w) {
        var E;
        l.current && !a(((E = w.composedPath) === null || E === void 0 || (E = E.call(w)) === null || E === void 0 ? void 0 : E[0]) || w.target) && !c.current && s(!1);
      }, g = oa(r);
      g.addEventListener("pointerdown", d, !0), g.addEventListener("mousedown", f, !0), g.addEventListener("contextmenu", f, !0);
      var h = ls(n);
      if (h && (h.addEventListener("mousedown", f, !0), h.addEventListener("contextmenu", f, !0)), z.env.NODE_ENV !== "production") {
        var y, p, C = n == null || (y = n.getRootNode) === null || y === void 0 ? void 0 : y.call(n), m = (p = r.getRootNode) === null || p === void 0 ? void 0 : p.call(r);
        zo(C === m, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        g.removeEventListener("pointerdown", d, !0), g.removeEventListener("mousedown", f, !0), g.removeEventListener("contextmenu", f, !0), h && (h.removeEventListener("mousedown", f, !0), h.removeEventListener("contextmenu", f, !0));
      };
    }
  }, [t, n, r, o, i]);
  function u() {
    c.current = !0;
  }
  return u;
}
var W$ = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function q$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : td, t = /* @__PURE__ */ v.forwardRef(function(n, r) {
    var o = n.prefixCls, i = o === void 0 ? "rc-trigger-popup" : o, a = n.children, s = n.action, l = s === void 0 ? "hover" : s, c = n.showAction, u = n.hideAction, d = n.popupVisible, f = n.defaultPopupVisible, g = n.onPopupVisibleChange, h = n.afterPopupVisibleChange, y = n.mouseEnterDelay, p = n.mouseLeaveDelay, C = p === void 0 ? 0.1 : p, m = n.focusDelay, b = n.blurDelay, w = n.mask, E = n.maskClosable, S = E === void 0 ? !0 : E, _ = n.getPopupContainer, O = n.forceRender, P = n.autoDestroy, $ = n.destroyPopupOnHide, L = n.popup, N = n.popupClassName, k = n.popupStyle, F = n.popupPlacement, U = n.builtinPlacements, A = U === void 0 ? {} : U, R = n.popupAlign, D = n.zIndex, B = n.stretch, M = n.getPopupClassNameFromAlign, G = n.fresh, H = n.alignPoint, X = n.onPopupClick, K = n.onPopupAlign, J = n.arrow, ie = n.popupMotion, le = n.maskMotion, ne = n.popupTransitionName, te = n.popupAnimation, re = n.maskTransitionName, _e = n.maskAnimation, me = n.className, De = n.getTriggerDOMNode, oe = ht(n, W$), Te = P || $ || !1, Re = v.useState(!1), Ye = Q(Re, 2), Fe = Ye[0], Ze = Ye[1];
    nn(function() {
      Ze(x$());
    }, []);
    var nt = v.useRef({}), xe = v.useContext(Cv), He = v.useMemo(function() {
      return {
        registerSubPopup: function(Ae, $t) {
          nt.current[Ae] = $t, xe == null || xe.registerSubPopup(Ae, $t);
        }
      };
    }, [xe]), ye = aT(), it = v.useState(null), Me = Q(it, 2), Ve = Me[0], lt = Me[1], yt = v.useRef(null), mt = sn(function(pe) {
      yt.current = pe, Di(pe) && Ve !== pe && lt(pe), xe == null || xe.registerSubPopup(ye, pe);
    }), Ne = v.useState(null), Ue = Q(Ne, 2), x = Ue[0], T = Ue[1], q = v.useRef(null), W = sn(function(pe) {
      Di(pe) && x !== pe && (T(pe), q.current = pe);
    }), Y = v.Children.only(a), ce = (Y == null ? void 0 : Y.props) || {}, fe = {}, je = sn(function(pe) {
      var Ae, $t, Gt = x;
      return (Gt == null ? void 0 : Gt.contains(pe)) || ((Ae = ls(Gt)) === null || Ae === void 0 ? void 0 : Ae.host) === pe || pe === Gt || (Ve == null ? void 0 : Ve.contains(pe)) || (($t = ls(Ve)) === null || $t === void 0 ? void 0 : $t.host) === pe || pe === Ve || Object.values(nt.current).some(function(Rt) {
        return (Rt == null ? void 0 : Rt.contains(pe)) || pe === Rt;
      });
    }), Be = Sv(i, ie, te, ne), ze = Sv(i, le, _e, re), et = v.useState(f || !1), Ke = Q(et, 2), Je = Ke[0], Pt = Ke[1], rt = d ?? Je, we = sn(function(pe) {
      d === void 0 && Pt(pe);
    });
    nn(function() {
      Pt(d || !1);
    }, [d]);
    var ge = v.useRef(rt);
    ge.current = rt;
    var Ee = v.useRef([]);
    Ee.current = [];
    var ot = sn(function(pe) {
      var Ae;
      we(pe), ((Ae = Ee.current[Ee.current.length - 1]) !== null && Ae !== void 0 ? Ae : rt) !== pe && (Ee.current.push(pe), g == null || g(pe));
    }), xt = v.useRef(), bt = function() {
      clearTimeout(xt.current);
    }, Dt = function(Ae) {
      var $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      bt(), $t === 0 ? ot(Ae) : xt.current = setTimeout(function() {
        ot(Ae);
      }, $t * 1e3);
    };
    v.useEffect(function() {
      return bt;
    }, []);
    var jn = v.useState(!1), ct = Q(jn, 2), ut = ct[0], Wt = ct[1];
    nn(function(pe) {
      (!pe || rt) && Wt(!0);
    }, [rt]);
    var I = v.useState(null), Z = Q(I, 2), ae = Z[0], be = Z[1], Oe = v.useState(null), We = Q(Oe, 2), $e = We[0], Le = We[1], Ct = function(Ae) {
      Le([Ae.clientX, Ae.clientY]);
    }, Qe = z$(rt, Ve, H && $e !== null ? $e : x, F, A, R, K), qe = Q(Qe, 11), qt = qe[0], In = qe[1], on = qe[2], Mt = qe[3], Jn = qe[4], Tn = qe[5], er = qe[6], cr = qe[7], go = qe[8], xr = qe[9], $n = qe[10], ur = j$(Fe, l, c, u), po = Q(ur, 2), Rn = po[0], mn = po[1], dr = Rn.has("click"), Or = mn.has("click") || mn.has("contextMenu"), Nn = sn(function() {
      ut || $n();
    }), li = function() {
      ge.current && H && Or && Dt(!1);
    };
    H$(rt, x, Ve, Nn, li), nn(function() {
      Nn();
    }, [$e, F]), nn(function() {
      rt && !(A != null && A[F]) && Nn();
    }, [JSON.stringify(R)]);
    var ho = v.useMemo(function() {
      var pe = V$(A, i, xr, H);
      return se(pe, M == null ? void 0 : M(xr));
    }, [xr, M, A, i, H]);
    v.useImperativeHandle(r, function() {
      return {
        nativeElement: q.current,
        popupElement: yt.current,
        forceAlign: Nn
      };
    });
    var ci = v.useState(0), wt = Q(ci, 2), at = wt[0], St = wt[1], an = v.useState(0), Qt = Q(an, 2), Pr = Qt[0], qr = Qt[1], mo = function() {
      if (B && x) {
        var Ae = x.getBoundingClientRect();
        St(Ae.width), qr(Ae.height);
      }
    }, yo = function() {
      mo(), Nn();
    }, bo = function(Ae) {
      Wt(!1), $n(), h == null || h(Ae);
    }, Bn = function() {
      return new Promise(function(Ae) {
        mo(), be(function() {
          return Ae;
        });
      });
    };
    nn(function() {
      ae && ($n(), ae(), be(null));
    }, [ae]);
    function fn(pe, Ae, $t, Gt) {
      fe[pe] = function(Rt) {
        var fa;
        Gt == null || Gt(Rt), Dt(Ae, $t);
        for (var hl = arguments.length, wd = new Array(hl > 1 ? hl - 1 : 0), va = 1; va < hl; va++)
          wd[va - 1] = arguments[va];
        (fa = ce[pe]) === null || fa === void 0 || fa.call.apply(fa, [ce, Rt].concat(wd));
      };
    }
    (dr || Or) && (fe.onClick = function(pe) {
      var Ae;
      ge.current && Or ? Dt(!1) : !ge.current && dr && (Ct(pe), Dt(!0));
      for (var $t = arguments.length, Gt = new Array($t > 1 ? $t - 1 : 0), Rt = 1; Rt < $t; Rt++)
        Gt[Rt - 1] = arguments[Rt];
      (Ae = ce.onClick) === null || Ae === void 0 || Ae.call.apply(Ae, [ce, pe].concat(Gt));
    });
    var ui = U$(rt, Or, x, Ve, w, S, je, Dt), An = Rn.has("hover"), ua = mn.has("hover"), Co, Ir;
    An && (fn("onMouseEnter", !0, y, function(pe) {
      Ct(pe);
    }), fn("onPointerEnter", !0, y, function(pe) {
      Ct(pe);
    }), Co = function(Ae) {
      (rt || ut) && Ve !== null && Ve !== void 0 && Ve.contains(Ae.target) && Dt(!0, y);
    }, H && (fe.onMouseMove = function(pe) {
      var Ae;
      (Ae = ce.onMouseMove) === null || Ae === void 0 || Ae.call(ce, pe);
    })), ua && (fn("onMouseLeave", !1, C), fn("onPointerLeave", !1, C), Ir = function() {
      Dt(!1, C);
    }), Rn.has("focus") && fn("onFocus", !0, m), mn.has("focus") && fn("onBlur", !1, b), Rn.has("contextMenu") && (fe.onContextMenu = function(pe) {
      var Ae;
      ge.current && mn.has("contextMenu") ? Dt(!1) : (Ct(pe), Dt(!0)), pe.preventDefault();
      for (var $t = arguments.length, Gt = new Array($t > 1 ? $t - 1 : 0), Rt = 1; Rt < $t; Rt++)
        Gt[Rt - 1] = arguments[Rt];
      (Ae = ce.onContextMenu) === null || Ae === void 0 || Ae.call.apply(Ae, [ce, pe].concat(Gt));
    }), me && (fe.className = se(ce.className, me));
    var Tr = V(V({}, ce), fe), di = {}, da = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    da.forEach(function(pe) {
      oe[pe] && (di[pe] = function() {
        for (var Ae, $t = arguments.length, Gt = new Array($t), Rt = 0; Rt < $t; Rt++)
          Gt[Rt] = arguments[Rt];
        (Ae = Tr[pe]) === null || Ae === void 0 || Ae.call.apply(Ae, [Tr].concat(Gt)), oe[pe].apply(oe, Gt);
      });
    });
    var vl = /* @__PURE__ */ v.cloneElement(Y, V(V({}, Tr), di)), gl = {
      x: Tn,
      y: er
    }, pl = J ? V({}, J !== !0 ? J : {}) : null;
    return /* @__PURE__ */ v.createElement(v.Fragment, null, /* @__PURE__ */ v.createElement(uo, {
      disabled: !rt,
      ref: W,
      onResize: yo
    }, /* @__PURE__ */ v.createElement(Ym, {
      getTriggerDOMNode: De
    }, vl)), /* @__PURE__ */ v.createElement(Cv.Provider, {
      value: He
    }, /* @__PURE__ */ v.createElement(Xm, {
      portal: e,
      ref: mt,
      prefixCls: i,
      popup: L,
      className: se(N, ho),
      style: k,
      target: x,
      onMouseEnter: Co,
      onMouseLeave: Ir,
      onPointerEnter: Co,
      zIndex: D,
      open: rt,
      keepDom: ut,
      fresh: G,
      onClick: X,
      onPointerDownCapture: ui,
      mask: w,
      motion: Be,
      maskMotion: ze,
      onVisibleChanged: bo,
      onPrepare: Bn,
      forceRender: O,
      autoDestroy: Te,
      getPopupContainer: _,
      align: xr,
      arrow: pl,
      arrowPos: gl,
      ready: qt,
      offsetX: In,
      offsetY: on,
      offsetR: Mt,
      offsetB: Jn,
      onAlign: Nn,
      stretch: B,
      targetWidth: at / cr,
      targetHeight: Pr / go
    })));
  });
  return z.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const Zm = q$(td), Qm = ["xxl", "xl", "lg", "md", "sm", "xs"], G$ = (e) => ({
  xs: `(max-width: ${e.screenXSMax}px)`,
  sm: `(min-width: ${e.screenSM}px)`,
  md: `(min-width: ${e.screenMD}px)`,
  lg: `(min-width: ${e.screenLG}px)`,
  xl: `(min-width: ${e.screenXL}px)`,
  xxl: `(min-width: ${e.screenXXL}px)`
}), K$ = (e) => {
  const t = e, n = [].concat(Qm).reverse();
  return n.forEach((r, o) => {
    const i = r.toUpperCase(), a = `screen${i}Min`, s = `screen${i}`;
    if (!(t[a] <= t[s]))
      throw new Error(`${a}<=${s} fails : !(${t[a]}<=${t[s]})`);
    if (o < n.length - 1) {
      const l = `screen${i}Max`;
      if (!(t[s] <= t[l]))
        throw new Error(`${s}<=${l} fails : !(${t[s]}<=${t[l]})`);
      const u = `screen${n[o + 1].toUpperCase()}Min`;
      if (!(t[l] <= t[u]))
        throw new Error(`${l}<=${u} fails : !(${t[l]}<=${t[u]})`);
    }
  }), e;
};
function X$() {
  const [, e] = sr(), t = G$(K$(e));
  return ee.useMemo(() => {
    const n = /* @__PURE__ */ new Map();
    let r = -1, o = {};
    return {
      matchHandlers: {},
      dispatch(i) {
        return o = i, n.forEach((a) => a(o)), n.size >= 1;
      },
      subscribe(i) {
        return n.size || this.register(), r += 1, n.set(r, i), i(o), r;
      },
      unsubscribe(i) {
        n.delete(i), n.size || this.unregister();
      },
      unregister() {
        Object.keys(t).forEach((i) => {
          const a = t[i], s = this.matchHandlers[a];
          s == null || s.mql.removeListener(s == null ? void 0 : s.listener);
        }), n.clear();
      },
      register() {
        Object.keys(t).forEach((i) => {
          const a = t[i], s = (c) => {
            let {
              matches: u
            } = c;
            this.dispatch(Object.assign(Object.assign({}, o), {
              [i]: u
            }));
          }, l = window.matchMedia(a);
          l.addListener(s), this.matchHandlers[a] = {
            mql: l,
            listener: s
          }, s(l);
        });
      },
      responsiveMap: t
    };
  }, [e]);
}
function Y$() {
  const [, e] = v.useReducer((t) => t + 1, 0);
  return e;
}
function Z$() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  const t = st({}), n = Y$(), r = X$();
  return nn(() => {
    const o = r.subscribe((i) => {
      t.current = i, e && n();
    });
    return () => r.unsubscribe(o);
  }, []), t.current;
}
const fu = /* @__PURE__ */ v.createContext({}), Q$ = (e) => {
  const {
    antCls: t,
    componentCls: n,
    iconCls: r,
    avatarBg: o,
    avatarColor: i,
    containerSize: a,
    containerSizeLG: s,
    containerSizeSM: l,
    textFontSize: c,
    textFontSizeLG: u,
    textFontSizeSM: d,
    borderRadius: f,
    borderRadiusLG: g,
    borderRadiusSM: h,
    lineWidth: y,
    lineType: p
  } = e, C = (m, b, w) => ({
    width: m,
    height: m,
    borderRadius: "50%",
    [`&${n}-square`]: {
      borderRadius: w
    },
    [`&${n}-icon`]: {
      fontSize: b,
      [`> ${r}`]: {
        margin: 0
      }
    }
  });
  return {
    [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, oi(e)), {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden",
      color: i,
      whiteSpace: "nowrap",
      textAlign: "center",
      verticalAlign: "middle",
      background: o,
      border: `${ke(y)} ${p} transparent`,
      "&-image": {
        background: "transparent"
      },
      [`${t}-image-img`]: {
        display: "block"
      }
    }), C(a, c, f)), {
      "&-lg": Object.assign({}, C(s, u, g)),
      "&-sm": Object.assign({}, C(l, d, h)),
      "> img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    })
  };
}, J$ = (e) => {
  const {
    componentCls: t,
    groupBorderColor: n,
    groupOverlapping: r,
    groupSpace: o
  } = e;
  return {
    [`${t}-group`]: {
      display: "inline-flex",
      [t]: {
        borderColor: n
      },
      "> *:not(:first-child)": {
        marginInlineStart: r
      }
    },
    [`${t}-group-popover`]: {
      [`${t} + ${t}`]: {
        marginInlineStart: o
      }
    }
  };
}, eR = (e) => {
  const {
    controlHeight: t,
    controlHeightLG: n,
    controlHeightSM: r,
    fontSize: o,
    fontSizeLG: i,
    fontSizeXL: a,
    fontSizeHeading3: s,
    marginXS: l,
    marginXXS: c,
    colorBorderBg: u
  } = e;
  return {
    containerSize: t,
    containerSizeLG: n,
    containerSizeSM: r,
    textFontSize: Math.round((i + a) / 2),
    textFontSizeLG: s,
    textFontSizeSM: o,
    groupSpace: c,
    groupOverlapping: -l,
    groupBorderColor: u
  };
}, Jm = Er("Avatar", (e) => {
  const {
    colorTextLightSolid: t,
    colorTextPlaceholder: n
  } = e, r = hn(e, {
    avatarBg: n,
    avatarColor: t
  });
  return [Q$(r), J$(r)];
}, eR);
var tR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const nR = (e, t) => {
  const [n, r] = v.useState(1), [o, i] = v.useState(!1), [a, s] = v.useState(!0), l = v.useRef(null), c = v.useRef(null), u = Xi(t, l), {
    getPrefixCls: d,
    avatar: f
  } = v.useContext(kt), g = v.useContext(fu), h = () => {
    if (!c.current || !l.current)
      return;
    const ne = c.current.offsetWidth, te = l.current.offsetWidth;
    if (ne !== 0 && te !== 0) {
      const {
        gap: re = 4
      } = e;
      re * 2 < te && r(te - re * 2 < ne ? (te - re * 2) / ne : 1);
    }
  };
  v.useEffect(() => {
    i(!0);
  }, []), v.useEffect(() => {
    s(!0), r(1);
  }, [e.src]), v.useEffect(h, [e.gap]);
  const y = () => {
    const {
      onError: ne
    } = e;
    (ne == null ? void 0 : ne()) !== !1 && s(!1);
  }, {
    prefixCls: p,
    shape: C,
    size: m,
    src: b,
    srcSet: w,
    icon: E,
    className: S,
    rootClassName: _,
    alt: O,
    draggable: P,
    children: $,
    crossOrigin: L
  } = e, N = tR(e, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "rootClassName", "alt", "draggable", "children", "crossOrigin"]), k = ym((ne) => {
    var te, re;
    return (re = (te = m ?? (g == null ? void 0 : g.size)) !== null && te !== void 0 ? te : ne) !== null && re !== void 0 ? re : "default";
  }), F = Object.keys(typeof k == "object" ? k || {} : {}).some((ne) => ["xs", "sm", "md", "lg", "xl", "xxl"].includes(ne)), U = Z$(F), A = v.useMemo(() => {
    if (typeof k != "object")
      return {};
    const ne = Qm.find((re) => U[re]), te = k[ne];
    return te ? {
      width: te,
      height: te,
      fontSize: te && (E || $) ? te / 2 : 18
    } : {};
  }, [U, k]);
  if (z.env.NODE_ENV !== "production") {
    const ne = Pn("Avatar");
    z.env.NODE_ENV !== "production" && ne(!(typeof E == "string" && E.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${E}\` at https://ant.design/components/icon`);
  }
  const R = d("avatar", p), D = ea(R), [B, M, G] = Jm(R, D), H = se({
    [`${R}-lg`]: k === "large",
    [`${R}-sm`]: k === "small"
  }), X = /* @__PURE__ */ v.isValidElement(b), K = C || (g == null ? void 0 : g.shape) || "circle", J = se(R, H, f == null ? void 0 : f.className, `${R}-${K}`, {
    [`${R}-image`]: X || b && a,
    [`${R}-icon`]: !!E
  }, G, D, S, _, M), ie = typeof k == "number" ? {
    width: k,
    height: k,
    fontSize: E ? k / 2 : 18
  } : {};
  let le;
  if (typeof b == "string" && a)
    le = /* @__PURE__ */ v.createElement("img", {
      src: b,
      draggable: P,
      srcSet: w,
      onError: y,
      alt: O,
      crossOrigin: L
    });
  else if (X)
    le = b;
  else if (E)
    le = E;
  else if (o || n !== 1) {
    const ne = `scale(${n})`, te = {
      msTransform: ne,
      WebkitTransform: ne,
      transform: ne
    };
    le = /* @__PURE__ */ v.createElement(uo, {
      onResize: h
    }, /* @__PURE__ */ v.createElement("span", {
      className: `${R}-string`,
      ref: c,
      style: Object.assign({}, te)
    }, $));
  } else
    le = /* @__PURE__ */ v.createElement("span", {
      className: `${R}-string`,
      style: {
        opacity: 0
      },
      ref: c
    }, $);
  return delete N.onError, delete N.gap, B(/* @__PURE__ */ v.createElement("span", Object.assign({}, N, {
    style: Object.assign(Object.assign(Object.assign(Object.assign({}, ie), A), f == null ? void 0 : f.style), N.style),
    className: J,
    ref: u
  }), le));
}, od = /* @__PURE__ */ v.forwardRef(nR);
z.env.NODE_ENV !== "production" && (od.displayName = "Avatar");
const Cs = (e) => e ? typeof e == "function" ? e() : e : null;
function id(e) {
  var t = e.children, n = e.prefixCls, r = e.id, o = e.overlayInnerStyle, i = e.bodyClassName, a = e.className, s = e.style;
  return /* @__PURE__ */ v.createElement("div", {
    className: se("".concat(n, "-content"), a),
    style: s
  }, /* @__PURE__ */ v.createElement("div", {
    className: se("".concat(n, "-inner"), i),
    id: r,
    role: "tooltip",
    style: o
  }, typeof t == "function" ? t() : t));
}
var Po = {
  shiftX: 64,
  adjustY: 1
}, Io = {
  adjustX: 1,
  shiftY: !0
}, Ln = [0, 0], rR = {
  left: {
    points: ["cr", "cl"],
    overflow: Io,
    offset: [-4, 0],
    targetOffset: Ln
  },
  right: {
    points: ["cl", "cr"],
    overflow: Io,
    offset: [4, 0],
    targetOffset: Ln
  },
  top: {
    points: ["bc", "tc"],
    overflow: Po,
    offset: [0, -4],
    targetOffset: Ln
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Po,
    offset: [0, 4],
    targetOffset: Ln
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Po,
    offset: [0, -4],
    targetOffset: Ln
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Io,
    offset: [-4, 0],
    targetOffset: Ln
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Po,
    offset: [0, -4],
    targetOffset: Ln
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Io,
    offset: [4, 0],
    targetOffset: Ln
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Po,
    offset: [0, 4],
    targetOffset: Ln
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Io,
    offset: [4, 0],
    targetOffset: Ln
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Po,
    offset: [0, 4],
    targetOffset: Ln
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Io,
    offset: [-4, 0],
    targetOffset: Ln
  }
}, oR = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "classNames", "styles"], iR = function(t, n) {
  var r = t.overlayClassName, o = t.trigger, i = o === void 0 ? ["hover"] : o, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, l = t.mouseLeaveDelay, c = l === void 0 ? 0.1 : l, u = t.overlayStyle, d = t.prefixCls, f = d === void 0 ? "rc-tooltip" : d, g = t.children, h = t.onVisibleChange, y = t.afterVisibleChange, p = t.transitionName, C = t.animation, m = t.motion, b = t.placement, w = b === void 0 ? "right" : b, E = t.align, S = E === void 0 ? {} : E, _ = t.destroyTooltipOnHide, O = _ === void 0 ? !1 : _, P = t.defaultVisible, $ = t.getTooltipContainer, L = t.overlayInnerStyle;
  t.arrowContent;
  var N = t.overlay, k = t.id, F = t.showArrow, U = F === void 0 ? !0 : F, A = t.classNames, R = t.styles, D = ht(t, oR), B = st(null);
  Iu(n, function() {
    return B.current;
  });
  var M = V({}, D);
  "visible" in t && (M.popupVisible = t.visible);
  var G = function() {
    return /* @__PURE__ */ v.createElement(id, {
      key: "content",
      prefixCls: f,
      id: k,
      bodyClassName: A == null ? void 0 : A.body,
      overlayInnerStyle: V(V({}, L), R == null ? void 0 : R.body)
    }, N);
  };
  return /* @__PURE__ */ v.createElement(Zm, Pe({
    popupClassName: se(r, A == null ? void 0 : A.root),
    prefixCls: f,
    popup: G,
    action: i,
    builtinPlacements: rR,
    popupPlacement: w,
    ref: B,
    popupAlign: S,
    getPopupContainer: $,
    onPopupVisibleChange: h,
    afterPopupVisibleChange: y,
    popupTransitionName: p,
    popupAnimation: C,
    popupMotion: m,
    defaultPopupVisible: P,
    autoDestroy: O,
    mouseLeaveDelay: c,
    popupStyle: V(V({}, u), R == null ? void 0 : R.root),
    mouseEnterDelay: s,
    arrow: U
  }, M), g);
};
const aR = /* @__PURE__ */ lo(iR);
function e0(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, o = t / 2, i = 0, a = o, s = r * 1 / Math.sqrt(2), l = o - r * (1 - 1 / Math.sqrt(2)), c = o - n * (1 / Math.sqrt(2)), u = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), d = 2 * o - c, f = u, g = 2 * o - s, h = l, y = 2 * o - i, p = a, C = o * Math.sqrt(2) + r * (Math.sqrt(2) - 2), m = r * (Math.sqrt(2) - 1), b = `polygon(${m}px 100%, 50% ${m}px, ${2 * o - m}px 100%, ${m}px 100%)`, w = `path('M ${i} ${a} A ${r} ${r} 0 0 0 ${s} ${l} L ${c} ${u} A ${n} ${n} 0 0 1 ${d} ${f} L ${g} ${h} A ${r} ${r} 0 0 0 ${y} ${p} Z')`;
  return {
    arrowShadowWidth: C,
    arrowPath: w,
    arrowPolygon: b
  };
}
const sR = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: o,
    arrowPath: i,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: l
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: l(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [o, i]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${ke(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, t0 = 8;
function ad(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? t0 : r
  };
}
function Ra(e, t) {
  return e ? t : {};
}
function n0(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: o,
    arrowOffsetVertical: i,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: l = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, sR(e, t, o)), {
        "&:before": {
          background: t
        }
      })]
    }, Ra(!!l.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${ke(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Ra(!!l.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${ke(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Ra(!!l.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: i
      }
    })), Ra(!!l.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: i
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: i
      }
    }))
  };
}
function lR(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const o = r && typeof r == "object" ? r : {}, i = {};
  switch (e) {
    case "top":
    case "bottom":
      i.shiftX = t.arrowOffsetHorizontal * 2 + n, i.shiftY = !0, i.adjustY = !0;
      break;
    case "left":
    case "right":
      i.shiftY = t.arrowOffsetVertical * 2 + n, i.shiftX = !0, i.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, i), o);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const Pv = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, cR = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, uR = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function dR(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: o,
    borderRadius: i,
    visibleFirst: a
  } = e, s = t / 2, l = {};
  return Object.keys(Pv).forEach((c) => {
    const u = r && cR[c] || Pv[c], d = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (l[c] = d, uR.has(c) && (d.autoArrow = !1), c) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - o;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + o;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - o;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + o;
        break;
    }
    const f = ad({
      contentRadius: i,
      limitVerticalRadius: !0
    });
    if (r)
      switch (c) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -f.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = f.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -f.arrowOffsetHorizontal * 2 + s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = f.arrowOffsetHorizontal * 2 - s;
          break;
      }
    d.overflow = lR(c, f, t, n), a && (d.htmlRegion = "visibleFirst");
  }), l;
}
const fR = (e) => {
  const {
    calc: t,
    componentCls: n,
    // ant-tooltip
    tooltipMaxWidth: r,
    tooltipColor: o,
    tooltipBg: i,
    tooltipBorderRadius: a,
    zIndexPopup: s,
    controlHeight: l,
    boxShadowSecondary: c,
    paddingSM: u,
    paddingXS: d,
    arrowOffsetHorizontal: f,
    sizePopupArrow: g
  } = e, h = t(a).add(g).add(f).equal(), y = t(a).mul(2).add(g).equal();
  return [
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign({}, oi(e)), {
        position: "absolute",
        zIndex: s,
        display: "block",
        width: "max-content",
        maxWidth: r,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": i,
        // Wrapper for the tooltip content
        [`${n}-inner`]: {
          minWidth: y,
          minHeight: l,
          padding: `${ke(e.calc(u).div(2).equal())} ${ke(d)}`,
          color: o,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: i,
          borderRadius: a,
          boxShadow: c,
          boxSizing: "border-box"
        },
        // Align placement should have another min width
        [["&-placement-topLeft", "&-placement-topRight", "&-placement-bottomLeft", "&-placement-bottomRight"].join(",")]: {
          minWidth: h
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${n}-inner`]: {
            borderRadius: e.min(a, t0)
          }
        },
        [`${n}-content`]: {
          position: "relative"
        }
      }), sO(e, (p, C) => {
        let {
          darkColor: m
        } = C;
        return {
          [`&${n}-${p}`]: {
            [`${n}-inner`]: {
              backgroundColor: m
            },
            [`${n}-arrow`]: {
              "--antd-arrow-background-color": m
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    n0(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${n}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, vR = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, ad({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), e0(hn(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), r0 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return Er("Tooltip", (r) => {
    const {
      borderRadius: o,
      colorTextLightSolid: i,
      colorBgSpotlight: a
    } = r, s = hn(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: i,
      tooltipBorderRadius: o,
      tooltipBg: a
    });
    return [fR(s), Qu(r, "zoom-big-fast")];
  }, vR, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, gR = io.map((e) => `${e}-inverse`);
function pR(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(he(gR), he(io)).includes(e) : io.includes(e);
}
function o0(e, t) {
  const n = pR(t), r = se({
    [`${e}-${t}`]: t && n
  }), o = {}, i = {};
  return t && !n && (o.background = t, i["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: o,
    arrowStyle: i
  };
}
const hR = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: o,
    color: i,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = v.useContext(kt), l = s("tooltip", t), [c, u, d] = r0(l), f = o0(l, i), g = f.arrowStyle, h = Object.assign(Object.assign({}, a), f.overlayStyle), y = se(u, d, l, `${l}-pure`, `${l}-placement-${r}`, n, f.className);
  return c(/* @__PURE__ */ v.createElement("div", {
    className: y,
    style: g
  }, /* @__PURE__ */ v.createElement("div", {
    className: `${l}-arrow`
  }), /* @__PURE__ */ v.createElement(id, Object.assign({}, e, {
    className: u,
    prefixCls: l,
    overlayInnerStyle: h
  }), o)));
};
var mR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const yR = /* @__PURE__ */ v.forwardRef((e, t) => {
  var n, r, o, i, a, s;
  const {
    prefixCls: l,
    openClassName: c,
    getTooltipContainer: u,
    color: d,
    overlayInnerStyle: f,
    children: g,
    afterOpenChange: h,
    afterVisibleChange: y,
    destroyTooltipOnHide: p,
    arrow: C = !0,
    title: m,
    overlay: b,
    builtinPlacements: w,
    arrowPointAtCenter: E = !1,
    autoAdjustOverflow: S = !0
  } = e, _ = !!C, [, O] = sr(), {
    getPopupContainer: P,
    getPrefixCls: $,
    direction: L,
    tooltip: N
  } = v.useContext(kt), k = Pn("Tooltip"), F = v.useRef(null), U = () => {
    var Ne;
    (Ne = F.current) === null || Ne === void 0 || Ne.forceAlign();
  };
  v.useImperativeHandle(t, () => {
    var Ne;
    return {
      forceAlign: U,
      forcePopupAlign: () => {
        k.deprecated(!1, "forcePopupAlign", "forceAlign"), U();
      },
      nativeElement: (Ne = F.current) === null || Ne === void 0 ? void 0 : Ne.nativeElement
    };
  }), z.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"], ["overlayStyle", "styles={{ root: {} }}"], ["overlayInnerStyle", "styles={{ body: {} }}"], ["overlayClassName", "classNames={{ root: {} }}"]].forEach((Ne) => {
    let [Ue, x] = Ne;
    k.deprecated(!(Ue in e), Ue, x);
  }), z.env.NODE_ENV !== "production" && k(!p || typeof p == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), z.env.NODE_ENV !== "production" && k(!C || typeof C == "boolean" || !("arrowPointAtCenter" in C), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [A, R] = to(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), D = !m && !b && m !== 0, B = (Ne) => {
    var Ue, x;
    R(D ? !1 : Ne), D || ((Ue = e.onOpenChange) === null || Ue === void 0 || Ue.call(e, Ne), (x = e.onVisibleChange) === null || x === void 0 || x.call(e, Ne));
  }, M = v.useMemo(() => {
    var Ne, Ue;
    let x = E;
    return typeof C == "object" && (x = (Ue = (Ne = C.pointAtCenter) !== null && Ne !== void 0 ? Ne : C.arrowPointAtCenter) !== null && Ue !== void 0 ? Ue : E), w || dR({
      arrowPointAtCenter: x,
      autoAdjustOverflow: S,
      arrowWidth: _ ? O.sizePopupArrow : 0,
      borderRadius: O.borderRadius,
      offset: O.marginXXS,
      visibleFirst: !0
    });
  }, [E, C, w, O]), G = v.useMemo(() => m === 0 ? m : b || m || "", [b, m]), H = /* @__PURE__ */ v.createElement(n$, {
    space: !0
  }, typeof G == "function" ? G() : G), {
    getPopupContainer: X,
    placement: K = "top",
    mouseEnterDelay: J = 0.1,
    mouseLeaveDelay: ie = 0.1,
    overlayStyle: le,
    rootClassName: ne,
    overlayClassName: te,
    styles: re,
    classNames: _e
  } = e, me = mR(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName", "overlayClassName", "styles", "classNames"]), De = $("tooltip", l), oe = $(), Te = e["data-popover-inject"];
  let Re = A;
  !("open" in e) && !("visible" in e) && D && (Re = !1);
  const Ye = /* @__PURE__ */ v.isValidElement(g) && !am(g) ? g : /* @__PURE__ */ v.createElement("span", null, g), Fe = Ye.props, Ze = !Fe.className || typeof Fe.className == "string" ? se(Fe.className, c || `${De}-open`) : Fe.className, [nt, xe, He] = r0(De, !Te), ye = o0(De, d), it = ye.arrowStyle, Me = se(te, {
    [`${De}-rtl`]: L === "rtl"
  }, ye.className, ne, xe, He, N == null ? void 0 : N.className, (o = N == null ? void 0 : N.classNames) === null || o === void 0 ? void 0 : o.root, _e == null ? void 0 : _e.root), Ve = se((i = N == null ? void 0 : N.classNames) === null || i === void 0 ? void 0 : i.body, _e == null ? void 0 : _e.body), [lt, yt] = vm("Tooltip", me.zIndex), mt = /* @__PURE__ */ v.createElement(aR, Object.assign({}, me, {
    zIndex: lt,
    showArrow: _,
    placement: K,
    mouseEnterDelay: J,
    mouseLeaveDelay: ie,
    prefixCls: De,
    classNames: {
      root: Me,
      body: Ve
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, it), (a = N == null ? void 0 : N.styles) === null || a === void 0 ? void 0 : a.root), N == null ? void 0 : N.style), le), re == null ? void 0 : re.root),
      body: Object.assign(Object.assign(Object.assign(Object.assign({}, (s = N == null ? void 0 : N.styles) === null || s === void 0 ? void 0 : s.body), f), re == null ? void 0 : re.body), ye.overlayStyle)
    },
    getTooltipContainer: X || u || P,
    ref: F,
    builtinPlacements: M,
    overlay: H,
    visible: Re,
    onVisibleChange: B,
    afterVisibleChange: h ?? y,
    arrowContent: /* @__PURE__ */ v.createElement("span", {
      className: `${De}-arrow-content`
    }),
    motion: {
      motionName: pm(oe, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!p
  }), Re ? _r(Ye, {
    className: Ze
  }) : Ye);
  return nt(/* @__PURE__ */ v.createElement(Yu.Provider, {
    value: yt
  }, mt));
}), ia = yR;
z.env.NODE_ENV !== "production" && (ia.displayName = "Tooltip");
ia._InternalPanelDoNotUseOrYouWillBeFired = hR;
const bR = (e) => {
  const {
    componentCls: t,
    popoverColor: n,
    titleMinWidth: r,
    fontWeightStrong: o,
    innerPadding: i,
    boxShadowSecondary: a,
    colorTextHeading: s,
    borderRadiusLG: l,
    zIndexPopup: c,
    titleMarginBottom: u,
    colorBgElevated: d,
    popoverBg: f,
    titleBorderBottom: g,
    innerContentPadding: h,
    titlePadding: y
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, oi(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: c,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "--antd-arrow-background-color": d,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: f,
          backgroundClip: "padding-box",
          borderRadius: l,
          boxShadow: a,
          padding: i
        },
        [`${t}-title`]: {
          minWidth: r,
          marginBottom: u,
          color: s,
          fontWeight: o,
          borderBottom: g,
          padding: y
        },
        [`${t}-inner-content`]: {
          color: n,
          padding: h
        }
      })
    },
    // Arrow Style
    n0(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, CR = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: io.map((n) => {
      const r = e[`${n}6`];
      return {
        [`&${t}-${n}`]: {
          "--antd-arrow-background-color": r,
          [`${t}-inner`]: {
            backgroundColor: r
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, wR = (e) => {
  const {
    lineWidth: t,
    controlHeight: n,
    fontHeight: r,
    padding: o,
    wireframe: i,
    zIndexPopupBase: a,
    borderRadiusLG: s,
    marginXS: l,
    lineType: c,
    colorSplit: u,
    paddingSM: d
  } = e, f = n - r, g = f / 2, h = f / 2 - t, y = o;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: a + 30
  }, e0(e)), ad({
    contentRadius: s,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: i ? 0 : 12,
    titleMarginBottom: i ? 0 : l,
    titlePadding: i ? `${g}px ${y}px ${h}px` : 0,
    titleBorderBottom: i ? `${t}px ${c} ${u}` : "none",
    innerContentPadding: i ? `${d}px ${y}px` : 0
  });
}, i0 = Er("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: n
  } = e, r = hn(e, {
    popoverBg: t,
    popoverColor: n
  });
  return [bR(r), CR(r), Qu(r, "zoom-big")];
}, wR, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var SR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const a0 = (e) => {
  let {
    title: t,
    content: n,
    prefixCls: r
  } = e;
  return !t && !n ? null : /* @__PURE__ */ v.createElement(v.Fragment, null, t && /* @__PURE__ */ v.createElement("div", {
    className: `${r}-title`
  }, t), n && /* @__PURE__ */ v.createElement("div", {
    className: `${r}-inner-content`
  }, n));
}, ER = (e) => {
  const {
    hashId: t,
    prefixCls: n,
    className: r,
    style: o,
    placement: i = "top",
    title: a,
    content: s,
    children: l
  } = e, c = Cs(a), u = Cs(s), d = se(t, n, `${n}-pure`, `${n}-placement-${i}`, r);
  return /* @__PURE__ */ v.createElement("div", {
    className: d,
    style: o
  }, /* @__PURE__ */ v.createElement("div", {
    className: `${n}-arrow`
  }), /* @__PURE__ */ v.createElement(id, Object.assign({}, e, {
    className: t,
    prefixCls: n
  }), l || /* @__PURE__ */ v.createElement(a0, {
    prefixCls: n,
    title: c,
    content: u
  })));
}, _R = (e) => {
  const {
    prefixCls: t,
    className: n
  } = e, r = SR(e, ["prefixCls", "className"]), {
    getPrefixCls: o
  } = v.useContext(kt), i = o("popover", t), [a, s, l] = i0(i);
  return a(/* @__PURE__ */ v.createElement(ER, Object.assign({}, r, {
    prefixCls: i,
    hashId: s,
    className: se(n, l)
  })));
};
var xR = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const OR = /* @__PURE__ */ v.forwardRef((e, t) => {
  var n, r, o, i, a, s;
  const {
    prefixCls: l,
    title: c,
    content: u,
    overlayClassName: d,
    placement: f = "top",
    trigger: g = "hover",
    children: h,
    mouseEnterDelay: y = 0.1,
    mouseLeaveDelay: p = 0.1,
    onOpenChange: C,
    overlayStyle: m = {},
    styles: b,
    classNames: w
  } = e, E = xR(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle", "styles", "classNames"]), {
    popover: S,
    getPrefixCls: _
  } = v.useContext(kt), O = _("popover", l), [P, $, L] = i0(O), N = _(), k = se(d, $, L, (n = S == null ? void 0 : S.classNames) === null || n === void 0 ? void 0 : n.root, w == null ? void 0 : w.root), F = se((r = S == null ? void 0 : S.classNames) === null || r === void 0 ? void 0 : r.body, w == null ? void 0 : w.body), [U, A] = to(!1, {
    value: (o = e.open) !== null && o !== void 0 ? o : e.visible,
    defaultValue: (i = e.defaultOpen) !== null && i !== void 0 ? i : e.defaultVisible
  }), R = (H, X) => {
    A(H, !0), C == null || C(H, X);
  }, D = (H) => {
    H.keyCode === Ce.ESC && R(!1, H);
  }, B = (H) => {
    R(H);
  }, M = Cs(c), G = Cs(u);
  return P(/* @__PURE__ */ v.createElement(ia, Object.assign({
    placement: f,
    trigger: g,
    mouseEnterDelay: y,
    mouseLeaveDelay: p
  }, E, {
    prefixCls: O,
    classNames: {
      root: k,
      body: F
    },
    styles: {
      root: Object.assign(Object.assign(Object.assign(Object.assign({}, (a = S == null ? void 0 : S.styles) === null || a === void 0 ? void 0 : a.root), S == null ? void 0 : S.style), m), b == null ? void 0 : b.root),
      body: Object.assign(Object.assign({}, (s = S == null ? void 0 : S.styles) === null || s === void 0 ? void 0 : s.body), b == null ? void 0 : b.body)
    },
    ref: t,
    open: U,
    onOpenChange: B,
    overlay: M || G ? /* @__PURE__ */ v.createElement(a0, {
      prefixCls: O,
      title: M,
      content: G
    }) : null,
    transitionName: pm(N, "zoom-big", E.transitionName),
    "data-popover-inject": !0
  }), _r(h, {
    onKeyDown: (H) => {
      var X, K;
      /* @__PURE__ */ v.isValidElement(h) && ((K = h == null ? void 0 : (X = h.props).onKeyDown) === null || K === void 0 || K.call(X, H)), D(H);
    }
  })));
}), nl = OR;
nl._InternalPanelDoNotUseOrYouWillBeFired = _R;
z.env.NODE_ENV !== "production" && (nl.displayName = "Popover");
const Iv = (e) => {
  const {
    size: t,
    shape: n
  } = v.useContext(fu), r = v.useMemo(() => ({
    size: e.size || t,
    shape: e.shape || n
  }), [e.size, e.shape, t, n]);
  return /* @__PURE__ */ v.createElement(fu.Provider, {
    value: r
  }, e.children);
}, PR = (e) => {
  var t, n, r, o;
  const {
    getPrefixCls: i,
    direction: a
  } = v.useContext(kt), {
    prefixCls: s,
    className: l,
    rootClassName: c,
    style: u,
    maxCount: d,
    maxStyle: f,
    size: g,
    shape: h,
    maxPopoverPlacement: y,
    maxPopoverTrigger: p,
    children: C,
    max: m
  } = e;
  if (z.env.NODE_ENV !== "production") {
    const k = Pn("Avatar.Group");
    k.deprecated(!d, "maxCount", "max={{ count: number }}"), k.deprecated(!f, "maxStyle", "max={{ style: CSSProperties }}"), k.deprecated(!y, "maxPopoverPlacement", "max={{ popover: PopoverProps }}"), k.deprecated(!p, "maxPopoverTrigger", "max={{ popover: PopoverProps }}");
  }
  const b = i("avatar", s), w = `${b}-group`, E = ea(b), [S, _, O] = Jm(b, E), P = se(w, {
    [`${w}-rtl`]: a === "rtl"
  }, O, E, l, c, _), $ = oo(C).map((k, F) => _r(k, {
    // eslint-disable-next-line react/no-array-index-key
    key: `avatar-key-${F}`
  })), L = (m == null ? void 0 : m.count) || d, N = $.length;
  if (L && L < N) {
    const k = $.slice(0, L), F = $.slice(L, N), U = (m == null ? void 0 : m.style) || f, A = ((t = m == null ? void 0 : m.popover) === null || t === void 0 ? void 0 : t.trigger) || p || "hover", R = ((n = m == null ? void 0 : m.popover) === null || n === void 0 ? void 0 : n.placement) || y || "top", D = Object.assign(Object.assign({
      content: F
    }, m == null ? void 0 : m.popover), {
      classNames: {
        root: se(`${w}-popover`, (o = (r = m == null ? void 0 : m.popover) === null || r === void 0 ? void 0 : r.classNames) === null || o === void 0 ? void 0 : o.root)
      },
      placement: R,
      trigger: A
    });
    return k.push(/* @__PURE__ */ v.createElement(nl, Object.assign({
      key: "avatar-popover-key",
      destroyTooltipOnHide: !0
    }, D), /* @__PURE__ */ v.createElement(od, {
      style: U
    }, `+${N - L}`))), S(/* @__PURE__ */ v.createElement(Iv, {
      shape: h,
      size: g
    }, /* @__PURE__ */ v.createElement("div", {
      className: P,
      style: u
    }, k)));
  }
  return S(/* @__PURE__ */ v.createElement(Iv, {
    shape: h,
    size: g
  }, /* @__PURE__ */ v.createElement("div", {
    className: P,
    style: u
  }, $)));
}, s0 = od;
s0.Group = PR;
var l0 = /* @__PURE__ */ v.createContext(null);
function c0(e, t) {
  return e === void 0 ? null : "".concat(e, "-").concat(t);
}
function u0(e) {
  var t = v.useContext(l0);
  return c0(t, e);
}
var IR = ["children", "locked"], Xn = /* @__PURE__ */ v.createContext(null);
function TR(e, t) {
  var n = V({}, e);
  return Object.keys(t).forEach(function(r) {
    var o = t[r];
    o !== void 0 && (n[r] = o);
  }), n;
}
function Gi(e) {
  var t = e.children, n = e.locked, r = ht(e, IR), o = v.useContext(Xn), i = As(function() {
    return TR(o, r);
  }, [o, r], function(a, s) {
    return !n && (a[0] !== s[0] || !Vi(a[1], s[1], !0));
  });
  return /* @__PURE__ */ v.createElement(Xn.Provider, {
    value: i
  }, t);
}
var $R = [], d0 = /* @__PURE__ */ v.createContext(null);
function rl() {
  return v.useContext(d0);
}
var f0 = /* @__PURE__ */ v.createContext($R);
function ai(e) {
  var t = v.useContext(f0);
  return v.useMemo(function() {
    return e !== void 0 ? [].concat(he(t), [e]) : t;
  }, [t, e]);
}
var v0 = /* @__PURE__ */ v.createContext(null), sd = /* @__PURE__ */ v.createContext({});
function Tv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  if (Zu(e)) {
    var n = e.nodeName.toLowerCase(), r = (
      // Focusable element
      ["input", "select", "textarea", "button"].includes(n) || // Editable element
      e.isContentEditable || // Anchor with href element
      n === "a" && !!e.getAttribute("href")
    ), o = e.getAttribute("tabindex"), i = Number(o), a = null;
    return o && !Number.isNaN(i) ? a = i : r && a === null && (a = 0), r && e.disabled && (a = null), a !== null && (a >= 0 || t && a < 0);
  }
  return !1;
}
function RR(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = he(e.querySelectorAll("*")).filter(function(r) {
    return Tv(r, t);
  });
  return Tv(e, t) && n.unshift(e), n;
}
var vu = Ce.LEFT, gu = Ce.RIGHT, pu = Ce.UP, Ja = Ce.DOWN, es = Ce.ENTER, g0 = Ce.ESC, wi = Ce.HOME, Si = Ce.END, $v = [pu, Ja, vu, gu];
function NR(e, t, n, r) {
  var o, i = "prev", a = "next", s = "children", l = "parent";
  if (e === "inline" && r === es)
    return {
      inlineTrigger: !0
    };
  var c = j(j({}, pu, i), Ja, a), u = j(j(j(j({}, vu, n ? a : i), gu, n ? i : a), Ja, s), es, s), d = j(j(j(j(j(j({}, pu, i), Ja, a), es, s), g0, l), vu, n ? s : l), gu, n ? l : s), f = {
    inline: c,
    horizontal: u,
    vertical: d,
    inlineSub: c,
    horizontalSub: d,
    verticalSub: d
  }, g = (o = f["".concat(e).concat(t ? "" : "Sub")]) === null || o === void 0 ? void 0 : o[r];
  switch (g) {
    case i:
      return {
        offset: -1,
        sibling: !0
      };
    case a:
      return {
        offset: 1,
        sibling: !0
      };
    case l:
      return {
        offset: -1,
        sibling: !1
      };
    case s:
      return {
        offset: 1,
        sibling: !1
      };
    default:
      return null;
  }
}
function AR(e) {
  for (var t = e; t; ) {
    if (t.getAttribute("data-menu-list"))
      return t;
    t = t.parentElement;
  }
  return null;
}
function kR(e, t) {
  for (var n = e || document.activeElement; n; ) {
    if (t.has(n))
      return n;
    n = n.parentElement;
  }
  return null;
}
function ld(e, t) {
  var n = RR(e, !0);
  return n.filter(function(r) {
    return t.has(r);
  });
}
function Rv(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
  if (!e)
    return null;
  var o = ld(e, t), i = o.length, a = o.findIndex(function(s) {
    return n === s;
  });
  return r < 0 ? a === -1 ? a = i - 1 : a -= 1 : r > 0 && (a += 1), a = (a + i) % i, o[a];
}
var hu = function(t, n) {
  var r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return t.forEach(function(a) {
    var s = document.querySelector("[data-menu-id='".concat(c0(n, a), "']"));
    s && (r.add(s), i.set(s, a), o.set(a, s));
  }), {
    elements: r,
    key2element: o,
    element2key: i
  };
};
function MR(e, t, n, r, o, i, a, s, l, c) {
  var u = v.useRef(), d = v.useRef();
  d.current = t;
  var f = function() {
    pn.cancel(u.current);
  };
  return v.useEffect(function() {
    return function() {
      f();
    };
  }, []), function(g) {
    var h = g.which;
    if ([].concat($v, [es, g0, wi, Si]).includes(h)) {
      var y = i(), p = hu(y, r), C = p, m = C.elements, b = C.key2element, w = C.element2key, E = b.get(t), S = kR(E, m), _ = w.get(S), O = NR(e, a(_, !0).length === 1, n, h);
      if (!O && h !== wi && h !== Si)
        return;
      ($v.includes(h) || [wi, Si].includes(h)) && g.preventDefault();
      var P = function(R) {
        if (R) {
          var D = R, B = R.querySelector("a");
          B != null && B.getAttribute("href") && (D = B);
          var M = w.get(R);
          s(M), f(), u.current = pn(function() {
            d.current === M && D.focus();
          });
        }
      };
      if ([wi, Si].includes(h) || O.sibling || !S) {
        var $;
        !S || e === "inline" ? $ = o.current : $ = AR(S);
        var L, N = ld($, m);
        h === wi ? L = N[0] : h === Si ? L = N[N.length - 1] : L = Rv($, m, S, O.offset), P(L);
      } else if (O.inlineTrigger)
        l(_);
      else if (O.offset > 0)
        l(_, !0), f(), u.current = pn(function() {
          p = hu(y, r);
          var A = S.getAttribute("aria-controls"), R = document.getElementById(A), D = Rv(R, p.elements);
          P(D);
        }, 5);
      else if (O.offset < 0) {
        var k = a(_, !0), F = k[k.length - 2], U = b.get(F);
        l(F, !1), P(U);
      }
    }
    c == null || c(g);
  };
}
function LR(e) {
  Promise.resolve().then(e);
}
var cd = "__RC_UTIL_PATH_SPLIT__", Nv = function(t) {
  return t.join(cd);
}, DR = function(t) {
  return t.split(cd);
}, mu = "rc-menu-more";
function FR() {
  var e = v.useState({}), t = Q(e, 2), n = t[1], r = st(/* @__PURE__ */ new Map()), o = st(/* @__PURE__ */ new Map()), i = v.useState([]), a = Q(i, 2), s = a[0], l = a[1], c = st(0), u = st(!1), d = function() {
    u.current || n({});
  }, f = wn(function(b, w) {
    z.env.NODE_ENV !== "production" && gt(!r.current.has(b), "Duplicated key '".concat(b, "' used in Menu by path [").concat(w.join(" > "), "]"));
    var E = Nv(w);
    o.current.set(E, b), r.current.set(b, E), c.current += 1;
    var S = c.current;
    LR(function() {
      S === c.current && d();
    });
  }, []), g = wn(function(b, w) {
    var E = Nv(w);
    o.current.delete(E), r.current.delete(b);
  }, []), h = wn(function(b) {
    l(b);
  }, []), y = wn(function(b, w) {
    var E = r.current.get(b) || "", S = DR(E);
    return w && s.includes(S[0]) && S.unshift(mu), S;
  }, [s]), p = wn(function(b, w) {
    return b.filter(function(E) {
      return E !== void 0;
    }).some(function(E) {
      var S = y(E, !0);
      return S.includes(w);
    });
  }, [y]), C = function() {
    var w = he(r.current.keys());
    return s.length && w.push(mu), w;
  }, m = wn(function(b) {
    var w = "".concat(r.current.get(b)).concat(cd), E = /* @__PURE__ */ new Set();
    return he(o.current.keys()).forEach(function(S) {
      S.startsWith(w) && E.add(o.current.get(S));
    }), E;
  }, []);
  return v.useEffect(function() {
    return function() {
      u.current = !0;
    };
  }, []), {
    // Register
    registerPath: f,
    unregisterPath: g,
    refreshOverflowKeys: h,
    // Util
    isSubPathKey: p,
    getKeyPath: y,
    getKeys: C,
    getSubPathKeys: m
  };
}
function xi(e) {
  var t = v.useRef(e);
  t.current = e;
  var n = v.useCallback(function() {
    for (var r, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(i));
  }, []);
  return e ? n : void 0;
}
var jR = Math.random().toFixed(5).toString().slice(2), Av = 0;
function BR(e) {
  var t = to(e, {
    value: e
  }), n = Q(t, 2), r = n[0], o = n[1];
  return v.useEffect(function() {
    Av += 1;
    var i = z.env.NODE_ENV === "test" ? "test" : "".concat(jR, "-").concat(Av);
    o("rc-menu-uuid-".concat(i));
  }, []), r;
}
function p0(e, t, n, r) {
  var o = v.useContext(Xn), i = o.activeKey, a = o.onActive, s = o.onInactive, l = {
    active: i === e
  };
  return t || (l.onMouseEnter = function(c) {
    n == null || n({
      key: e,
      domEvent: c
    }), a(e);
  }, l.onMouseLeave = function(c) {
    r == null || r({
      key: e,
      domEvent: c
    }), s(e);
  }), l;
}
function h0(e) {
  var t = v.useContext(Xn), n = t.mode, r = t.rtl, o = t.inlineIndent;
  if (n !== "inline")
    return null;
  var i = e;
  return r ? {
    paddingRight: i * o
  } : {
    paddingLeft: i * o
  };
}
function m0(e) {
  var t = e.icon, n = e.props, r = e.children, o;
  return t === null || t === !1 ? null : (typeof t == "function" ? o = /* @__PURE__ */ v.createElement(t, V({}, n)) : typeof t != "boolean" && (o = t), o || r || null);
}
var VR = ["item"];
function ws(e) {
  var t = e.item, n = ht(e, VR);
  return Object.defineProperty(n, "item", {
    get: function() {
      return gt(!1, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future."), t;
    }
  }), n;
}
var zR = ["title", "attribute", "elementRef"], HR = ["style", "className", "eventKey", "warnKey", "disabled", "itemIcon", "children", "role", "onMouseEnter", "onMouseLeave", "onClick", "onKeyDown", "onFocus"], UR = ["active"], WR = /* @__PURE__ */ function(e) {
  wr(n, e);
  var t = Sr(n);
  function n() {
    return Yt(this, n), t.apply(this, arguments);
  }
  return Zt(n, [{
    key: "render",
    value: function() {
      var o = this.props, i = o.title, a = o.attribute, s = o.elementRef, l = ht(o, zR), c = Ur(l, ["eventKey", "popupClassName", "popupOffset", "onTitleClick"]);
      return gt(!a, "`attribute` of Menu.Item is deprecated. Please pass attribute directly."), /* @__PURE__ */ v.createElement(yr.Item, Pe({}, a, {
        title: typeof i == "string" ? i : void 0
      }, c, {
        ref: s
      }));
    }
  }]), n;
}(v.Component), qR = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.style, r = e.className, o = e.eventKey, i = e.warnKey, a = e.disabled, s = e.itemIcon, l = e.children, c = e.role, u = e.onMouseEnter, d = e.onMouseLeave, f = e.onClick, g = e.onKeyDown, h = e.onFocus, y = ht(e, HR), p = u0(o), C = v.useContext(Xn), m = C.prefixCls, b = C.onItemClick, w = C.disabled, E = C.overflowDisabled, S = C.itemIcon, _ = C.selectedKeys, O = C.onActive, P = v.useContext(sd), $ = P._internalRenderMenuItem, L = "".concat(m, "-item"), N = v.useRef(), k = v.useRef(), F = w || a, U = Yi(t, k), A = ai(o);
  z.env.NODE_ENV !== "production" && i && gt(!1, "MenuItem should not leave undefined `key`.");
  var R = function(re) {
    return {
      key: o,
      // Note: For legacy code is reversed which not like other antd component
      keyPath: he(A).reverse(),
      item: N.current,
      domEvent: re
    };
  }, D = s || S, B = p0(o, F, u, d), M = B.active, G = ht(B, UR), H = _.includes(o), X = h0(A.length), K = function(re) {
    if (!F) {
      var _e = R(re);
      f == null || f(ws(_e)), b(_e);
    }
  }, J = function(re) {
    if (g == null || g(re), re.which === Ce.ENTER) {
      var _e = R(re);
      f == null || f(ws(_e)), b(_e);
    }
  }, ie = function(re) {
    O(o), h == null || h(re);
  }, le = {};
  e.role === "option" && (le["aria-selected"] = H);
  var ne = /* @__PURE__ */ v.createElement(WR, Pe({
    ref: N,
    elementRef: U,
    role: c === null ? "none" : c || "menuitem",
    tabIndex: a ? null : -1,
    "data-menu-id": E && p ? null : p
  }, Ur(y, ["extra"]), G, le, {
    component: "li",
    "aria-disabled": a,
    style: V(V({}, X), n),
    className: se(L, j(j(j({}, "".concat(L, "-active"), M), "".concat(L, "-selected"), H), "".concat(L, "-disabled"), F), r),
    onClick: K,
    onKeyDown: J,
    onFocus: ie
  }), l, /* @__PURE__ */ v.createElement(m0, {
    props: V(V({}, e), {}, {
      isSelected: H
    }),
    icon: D
  }));
  return $ && (ne = $(ne, e, {
    selected: H
  })), ne;
});
function GR(e, t) {
  var n = e.eventKey, r = rl(), o = ai(n);
  return v.useEffect(function() {
    if (r)
      return r.registerPath(n, o), function() {
        r.unregisterPath(n, o);
      };
  }, [o]), r ? null : /* @__PURE__ */ v.createElement(qR, Pe({}, e, {
    ref: t
  }));
}
const ol = /* @__PURE__ */ v.forwardRef(GR);
var KR = ["className", "children"], XR = function(t, n) {
  var r = t.className, o = t.children, i = ht(t, KR), a = v.useContext(Xn), s = a.prefixCls, l = a.mode, c = a.rtl;
  return /* @__PURE__ */ v.createElement("ul", Pe({
    className: se(s, c && "".concat(s, "-rtl"), "".concat(s, "-sub"), "".concat(s, "-").concat(l === "inline" ? "inline" : "vertical"), r),
    role: "menu"
  }, i, {
    "data-menu-list": !0,
    ref: n
  }), o);
}, ud = /* @__PURE__ */ v.forwardRef(XR);
ud.displayName = "SubMenuList";
function dd(e, t) {
  return oo(e).map(function(n, r) {
    if (/* @__PURE__ */ v.isValidElement(n)) {
      var o, i, a = n.key, s = (o = (i = n.props) === null || i === void 0 ? void 0 : i.eventKey) !== null && o !== void 0 ? o : a, l = s == null;
      l && (s = "tmp_key-".concat([].concat(he(t), [r]).join("-")));
      var c = {
        key: s,
        eventKey: s
      };
      return z.env.NODE_ENV !== "production" && l && (c.warnKey = !0), /* @__PURE__ */ v.cloneElement(n, c);
    }
    return n;
  });
}
var ln = {
  adjustX: 1,
  adjustY: 1
}, YR = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ln
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ln
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ln
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ln
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ln
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ln
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ln
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ln
  }
}, ZR = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: ln
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ln
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ln
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ln
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: ln
  },
  rightBottom: {
    points: ["br", "bl"],
    overflow: ln
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: ln
  },
  leftBottom: {
    points: ["bl", "br"],
    overflow: ln
  }
};
function y0(e, t, n) {
  if (t)
    return t;
  if (n)
    return n[e] || n.other;
}
var QR = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
function JR(e) {
  var t = e.prefixCls, n = e.visible, r = e.children, o = e.popup, i = e.popupStyle, a = e.popupClassName, s = e.popupOffset, l = e.disabled, c = e.mode, u = e.onVisibleChange, d = v.useContext(Xn), f = d.getPopupContainer, g = d.rtl, h = d.subMenuOpenDelay, y = d.subMenuCloseDelay, p = d.builtinPlacements, C = d.triggerSubMenuAction, m = d.forceSubMenuRender, b = d.rootClassName, w = d.motion, E = d.defaultMotions, S = v.useState(!1), _ = Q(S, 2), O = _[0], P = _[1], $ = V(g ? V({}, ZR) : V({}, YR), p), L = QR[c], N = y0(c, w, E), k = v.useRef(N);
  c !== "inline" && (k.current = N);
  var F = V(V({}, k.current), {}, {
    leavedClassName: "".concat(t, "-hidden"),
    removeOnLeave: !1,
    motionAppear: !0
  }), U = v.useRef();
  return v.useEffect(function() {
    return U.current = pn(function() {
      P(n);
    }), function() {
      pn.cancel(U.current);
    };
  }, [n]), /* @__PURE__ */ v.createElement(Zm, {
    prefixCls: t,
    popupClassName: se("".concat(t, "-popup"), j({}, "".concat(t, "-rtl"), g), a, b),
    stretch: c === "horizontal" ? "minWidth" : null,
    getPopupContainer: f,
    builtinPlacements: $,
    popupPlacement: L,
    popupVisible: O,
    popup: o,
    popupStyle: i,
    popupAlign: s && {
      offset: s
    },
    action: l ? [] : [C],
    mouseEnterDelay: h,
    mouseLeaveDelay: y,
    onPopupVisibleChange: u,
    forceRender: m,
    popupMotion: F,
    fresh: !0
  }, r);
}
function eN(e) {
  var t = e.id, n = e.open, r = e.keyPath, o = e.children, i = "inline", a = v.useContext(Xn), s = a.prefixCls, l = a.forceSubMenuRender, c = a.motion, u = a.defaultMotions, d = a.mode, f = v.useRef(!1);
  f.current = d === i;
  var g = v.useState(!f.current), h = Q(g, 2), y = h[0], p = h[1], C = f.current ? n : !1;
  v.useEffect(function() {
    f.current && p(!1);
  }, [d]);
  var m = V({}, y0(i, c, u));
  r.length > 1 && (m.motionAppear = !1);
  var b = m.onVisibleChanged;
  return m.onVisibleChanged = function(w) {
    return !f.current && !w && p(!0), b == null ? void 0 : b(w);
  }, y ? null : /* @__PURE__ */ v.createElement(Gi, {
    mode: i,
    locked: !f.current
  }, /* @__PURE__ */ v.createElement(ii, Pe({
    visible: C
  }, m, {
    forceRender: l,
    removeOnLeave: !1,
    leavedClassName: "".concat(s, "-hidden")
  }), function(w) {
    var E = w.className, S = w.style;
    return /* @__PURE__ */ v.createElement(ud, {
      id: t,
      className: E,
      style: S
    }, o);
  }));
}
var tN = ["style", "className", "title", "eventKey", "warnKey", "disabled", "internalPopupClose", "children", "itemIcon", "expandIcon", "popupClassName", "popupOffset", "popupStyle", "onClick", "onMouseEnter", "onMouseLeave", "onTitleClick", "onTitleMouseEnter", "onTitleMouseLeave"], nN = ["active"], rN = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.style, r = e.className, o = e.title, i = e.eventKey, a = e.warnKey, s = e.disabled, l = e.internalPopupClose, c = e.children, u = e.itemIcon, d = e.expandIcon, f = e.popupClassName, g = e.popupOffset, h = e.popupStyle, y = e.onClick, p = e.onMouseEnter, C = e.onMouseLeave, m = e.onTitleClick, b = e.onTitleMouseEnter, w = e.onTitleMouseLeave, E = ht(e, tN), S = u0(i), _ = v.useContext(Xn), O = _.prefixCls, P = _.mode, $ = _.openKeys, L = _.disabled, N = _.overflowDisabled, k = _.activeKey, F = _.selectedKeys, U = _.itemIcon, A = _.expandIcon, R = _.onItemClick, D = _.onOpenChange, B = _.onActive, M = v.useContext(sd), G = M._internalRenderSubMenuItem, H = v.useContext(v0), X = H.isSubPathKey, K = ai(), J = "".concat(O, "-submenu"), ie = L || s, le = v.useRef(), ne = v.useRef();
  z.env.NODE_ENV !== "production" && a && gt(!1, "SubMenu should not leave undefined `key`.");
  var te = u ?? U, re = d ?? A, _e = $.includes(i), me = !N && _e, De = X(F, i), oe = p0(i, ie, b, w), Te = oe.active, Re = ht(oe, nN), Ye = v.useState(!1), Fe = Q(Ye, 2), Ze = Fe[0], nt = Fe[1], xe = function(Y) {
    ie || nt(Y);
  }, He = function(Y) {
    xe(!0), p == null || p({
      key: i,
      domEvent: Y
    });
  }, ye = function(Y) {
    xe(!1), C == null || C({
      key: i,
      domEvent: Y
    });
  }, it = v.useMemo(function() {
    return Te || (P !== "inline" ? Ze || X([k], i) : !1);
  }, [P, Te, k, Ze, i, X]), Me = h0(K.length), Ve = function(Y) {
    ie || (m == null || m({
      key: i,
      domEvent: Y
    }), P === "inline" && D(i, !_e));
  }, lt = xi(function(W) {
    y == null || y(ws(W)), R(W);
  }), yt = function(Y) {
    P !== "inline" && D(i, Y);
  }, mt = function() {
    B(i);
  }, Ne = S && "".concat(S, "-popup"), Ue = /* @__PURE__ */ v.createElement("div", Pe({
    role: "menuitem",
    style: Me,
    className: "".concat(J, "-title"),
    tabIndex: ie ? null : -1,
    ref: le,
    title: typeof o == "string" ? o : null,
    "data-menu-id": N && S ? null : S,
    "aria-expanded": me,
    "aria-haspopup": !0,
    "aria-controls": Ne,
    "aria-disabled": ie,
    onClick: Ve,
    onFocus: mt
  }, Re), o, /* @__PURE__ */ v.createElement(m0, {
    icon: P !== "horizontal" ? re : void 0,
    props: V(V({}, e), {}, {
      isOpen: me,
      // [Legacy] Not sure why need this mark
      isSubMenu: !0
    })
  }, /* @__PURE__ */ v.createElement("i", {
    className: "".concat(J, "-arrow")
  }))), x = v.useRef(P);
  if (P !== "inline" && K.length > 1 ? x.current = "vertical" : x.current = P, !N) {
    var T = x.current;
    Ue = /* @__PURE__ */ v.createElement(JR, {
      mode: T,
      prefixCls: J,
      visible: !l && me && P !== "inline",
      popupClassName: f,
      popupOffset: g,
      popupStyle: h,
      popup: /* @__PURE__ */ v.createElement(
        Gi,
        {
          mode: T === "horizontal" ? "vertical" : T
        },
        /* @__PURE__ */ v.createElement(ud, {
          id: Ne,
          ref: ne
        }, c)
      ),
      disabled: ie,
      onVisibleChange: yt
    }, Ue);
  }
  var q = /* @__PURE__ */ v.createElement(yr.Item, Pe({
    ref: t,
    role: "none"
  }, E, {
    component: "li",
    style: n,
    className: se(J, "".concat(J, "-").concat(P), r, j(j(j(j({}, "".concat(J, "-open"), me), "".concat(J, "-active"), it), "".concat(J, "-selected"), De), "".concat(J, "-disabled"), ie)),
    onMouseEnter: He,
    onMouseLeave: ye
  }), Ue, !N && /* @__PURE__ */ v.createElement(eN, {
    id: Ne,
    open: me,
    keyPath: K
  }, c));
  return G && (q = G(q, e, {
    selected: De,
    active: it,
    open: me,
    disabled: ie
  })), /* @__PURE__ */ v.createElement(Gi, {
    onItemClick: lt,
    mode: P === "horizontal" ? "vertical" : P,
    itemIcon: te,
    expandIcon: re
  }, q);
}), aa = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.eventKey, r = e.children, o = ai(n), i = dd(r, o), a = rl();
  v.useEffect(function() {
    if (a)
      return a.registerPath(n, o), function() {
        a.unregisterPath(n, o);
      };
  }, [o]);
  var s;
  return a ? s = i : s = /* @__PURE__ */ v.createElement(rN, Pe({
    ref: t
  }, e), i), /* @__PURE__ */ v.createElement(f0.Provider, {
    value: o
  }, s);
});
z.env.NODE_ENV !== "production" && (aa.displayName = "SubMenu");
function fd(e) {
  var t = e.className, n = e.style, r = v.useContext(Xn), o = r.prefixCls, i = rl();
  return i ? null : /* @__PURE__ */ v.createElement("li", {
    role: "separator",
    className: se("".concat(o, "-item-divider"), t),
    style: n
  });
}
var oN = ["className", "title", "eventKey", "children"], iN = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.className, r = e.title;
  e.eventKey;
  var o = e.children, i = ht(e, oN), a = v.useContext(Xn), s = a.prefixCls, l = "".concat(s, "-item-group");
  return /* @__PURE__ */ v.createElement("li", Pe({
    ref: t,
    role: "presentation"
  }, i, {
    onClick: function(u) {
      return u.stopPropagation();
    },
    className: se(l, n)
  }), /* @__PURE__ */ v.createElement("div", {
    role: "presentation",
    className: "".concat(l, "-title"),
    title: typeof r == "string" ? r : void 0
  }, r), /* @__PURE__ */ v.createElement("ul", {
    role: "group",
    className: "".concat(l, "-list")
  }, o));
}), il = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n = e.eventKey, r = e.children, o = ai(n), i = dd(r, o), a = rl();
  return a ? i : /* @__PURE__ */ v.createElement(iN, Pe({
    ref: t
  }, Ur(e, ["warnKey"])), i);
});
z.env.NODE_ENV !== "production" && (il.displayName = "MenuItemGroup");
var aN = ["label", "children", "key", "type", "extra"];
function yu(e, t, n) {
  var r = t.item, o = t.group, i = t.submenu, a = t.divider;
  return (e || []).map(function(s, l) {
    if (s && Ie(s) === "object") {
      var c = s, u = c.label, d = c.children, f = c.key, g = c.type, h = c.extra, y = ht(c, aN), p = f ?? "tmp-".concat(l);
      return d || g === "group" ? g === "group" ? /* @__PURE__ */ v.createElement(o, Pe({
        key: p
      }, y, {
        title: u
      }), yu(d, t, n)) : /* @__PURE__ */ v.createElement(i, Pe({
        key: p
      }, y, {
        title: u
      }), yu(d, t, n)) : g === "divider" ? /* @__PURE__ */ v.createElement(a, Pe({
        key: p
      }, y)) : /* @__PURE__ */ v.createElement(r, Pe({
        key: p
      }, y, {
        extra: h
      }), u, (!!h || h === 0) && /* @__PURE__ */ v.createElement("span", {
        className: "".concat(n, "-item-extra")
      }, h));
    }
    return null;
  }).filter(function(s) {
    return s;
  });
}
function kv(e, t, n, r, o) {
  var i = e, a = V({
    divider: fd,
    item: ol,
    group: il,
    submenu: aa
  }, r);
  return t && (i = yu(t, a, o)), dd(i, n);
}
var sN = ["prefixCls", "rootClassName", "style", "className", "tabIndex", "items", "children", "direction", "id", "mode", "inlineCollapsed", "disabled", "disabledOverflow", "subMenuOpenDelay", "subMenuCloseDelay", "forceSubMenuRender", "defaultOpenKeys", "openKeys", "activeKey", "defaultActiveFirst", "selectable", "multiple", "defaultSelectedKeys", "selectedKeys", "onSelect", "onDeselect", "inlineIndent", "motion", "defaultMotions", "triggerSubMenuAction", "builtinPlacements", "itemIcon", "expandIcon", "overflowedIndicator", "overflowedIndicatorPopupClassName", "getPopupContainer", "onClick", "onOpenChange", "onKeyDown", "openAnimation", "openTransitionName", "_internalRenderMenuItem", "_internalRenderSubMenuItem", "_internalComponents"], Gr = [], lN = /* @__PURE__ */ v.forwardRef(function(e, t) {
  var n, r = e, o = r.prefixCls, i = o === void 0 ? "rc-menu" : o, a = r.rootClassName, s = r.style, l = r.className, c = r.tabIndex, u = c === void 0 ? 0 : c, d = r.items, f = r.children, g = r.direction, h = r.id, y = r.mode, p = y === void 0 ? "vertical" : y, C = r.inlineCollapsed, m = r.disabled, b = r.disabledOverflow, w = r.subMenuOpenDelay, E = w === void 0 ? 0.1 : w, S = r.subMenuCloseDelay, _ = S === void 0 ? 0.1 : S, O = r.forceSubMenuRender, P = r.defaultOpenKeys, $ = r.openKeys, L = r.activeKey, N = r.defaultActiveFirst, k = r.selectable, F = k === void 0 ? !0 : k, U = r.multiple, A = U === void 0 ? !1 : U, R = r.defaultSelectedKeys, D = r.selectedKeys, B = r.onSelect, M = r.onDeselect, G = r.inlineIndent, H = G === void 0 ? 24 : G, X = r.motion, K = r.defaultMotions, J = r.triggerSubMenuAction, ie = J === void 0 ? "hover" : J, le = r.builtinPlacements, ne = r.itemIcon, te = r.expandIcon, re = r.overflowedIndicator, _e = re === void 0 ? "..." : re, me = r.overflowedIndicatorPopupClassName, De = r.getPopupContainer, oe = r.onClick, Te = r.onOpenChange, Re = r.onKeyDown, Ye = r.openAnimation, Fe = r.openTransitionName, Ze = r._internalRenderMenuItem, nt = r._internalRenderSubMenuItem, xe = r._internalComponents, He = ht(r, sN), ye = v.useMemo(function() {
    return [kv(f, d, Gr, xe, i), kv(f, d, Gr, {}, i)];
  }, [f, d, xe]), it = Q(ye, 2), Me = it[0], Ve = it[1], lt = v.useState(!1), yt = Q(lt, 2), mt = yt[0], Ne = yt[1], Ue = v.useRef(), x = BR(h), T = g === "rtl";
  z.env.NODE_ENV !== "production" && gt(!Ye && !Fe, "`openAnimation` and `openTransitionName` is removed. Please use `motion` or `defaultMotion` instead.");
  var q = to(P, {
    value: $,
    postState: function(at) {
      return at || Gr;
    }
  }), W = Q(q, 2), Y = W[0], ce = W[1], fe = function(at) {
    var St = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    function an() {
      ce(at), Te == null || Te(at);
    }
    St ? Hy(an) : an();
  }, je = v.useState(Y), Be = Q(je, 2), ze = Be[0], et = Be[1], Ke = v.useRef(!1), Je = v.useMemo(function() {
    return (p === "inline" || p === "vertical") && C ? ["vertical", C] : [p, !1];
  }, [p, C]), Pt = Q(Je, 2), rt = Pt[0], we = Pt[1], ge = rt === "inline", Ee = v.useState(rt), ot = Q(Ee, 2), xt = ot[0], bt = ot[1], Dt = v.useState(we), jn = Q(Dt, 2), ct = jn[0], ut = jn[1];
  v.useEffect(function() {
    bt(rt), ut(we), Ke.current && (ge ? ce(ze) : fe(Gr));
  }, [rt, we]);
  var Wt = v.useState(0), I = Q(Wt, 2), Z = I[0], ae = I[1], be = Z >= Me.length - 1 || xt !== "horizontal" || b;
  v.useEffect(function() {
    ge && et(Y);
  }, [Y]), v.useEffect(function() {
    return Ke.current = !0, function() {
      Ke.current = !1;
    };
  }, []);
  var Oe = FR(), We = Oe.registerPath, $e = Oe.unregisterPath, Le = Oe.refreshOverflowKeys, Ct = Oe.isSubPathKey, Qe = Oe.getKeyPath, qe = Oe.getKeys, qt = Oe.getSubPathKeys, In = v.useMemo(function() {
    return {
      registerPath: We,
      unregisterPath: $e
    };
  }, [We, $e]), on = v.useMemo(function() {
    return {
      isSubPathKey: Ct
    };
  }, [Ct]);
  v.useEffect(function() {
    Le(be ? Gr : Me.slice(Z + 1).map(function(wt) {
      return wt.key;
    }));
  }, [Z, be]);
  var Mt = to(L || N && ((n = Me[0]) === null || n === void 0 ? void 0 : n.key), {
    value: L
  }), Jn = Q(Mt, 2), Tn = Jn[0], er = Jn[1], cr = xi(function(wt) {
    er(wt);
  }), go = xi(function() {
    er(void 0);
  });
  Iu(t, function() {
    return {
      list: Ue.current,
      focus: function(at) {
        var St, an = qe(), Qt = hu(an, x), Pr = Qt.elements, qr = Qt.key2element, mo = Qt.element2key, yo = ld(Ue.current, Pr), bo = Tn ?? (yo[0] ? mo.get(yo[0]) : (St = Me.find(function(ui) {
          return !ui.props.disabled;
        })) === null || St === void 0 ? void 0 : St.key), Bn = qr.get(bo);
        if (bo && Bn) {
          var fn;
          Bn == null || (fn = Bn.focus) === null || fn === void 0 || fn.call(Bn, at);
        }
      }
    };
  });
  var xr = to(R || [], {
    value: D,
    // Legacy convert key to array
    postState: function(at) {
      return Array.isArray(at) ? at : at == null ? Gr : [at];
    }
  }), $n = Q(xr, 2), ur = $n[0], po = $n[1], Rn = function(at) {
    if (F) {
      var St = at.key, an = ur.includes(St), Qt;
      A ? an ? Qt = ur.filter(function(qr) {
        return qr !== St;
      }) : Qt = [].concat(he(ur), [St]) : Qt = [St], po(Qt);
      var Pr = V(V({}, at), {}, {
        selectedKeys: Qt
      });
      an ? M == null || M(Pr) : B == null || B(Pr);
    }
    !A && Y.length && xt !== "inline" && fe(Gr);
  }, mn = xi(function(wt) {
    oe == null || oe(ws(wt)), Rn(wt);
  }), dr = xi(function(wt, at) {
    var St = Y.filter(function(Qt) {
      return Qt !== wt;
    });
    if (at)
      St.push(wt);
    else if (xt !== "inline") {
      var an = qt(wt);
      St = St.filter(function(Qt) {
        return !an.has(Qt);
      });
    }
    Vi(Y, St, !0) || fe(St, !0);
  }), Or = function(at, St) {
    var an = St ?? !Y.includes(at);
    dr(at, an);
  }, Nn = MR(xt, Tn, T, x, Ue, qe, Qe, er, Or, Re);
  v.useEffect(function() {
    Ne(!0);
  }, []);
  var li = v.useMemo(function() {
    return {
      _internalRenderMenuItem: Ze,
      _internalRenderSubMenuItem: nt
    };
  }, [Ze, nt]), ho = xt !== "horizontal" || b ? Me : (
    // Need wrap for overflow dropdown that do not response for open
    Me.map(function(wt, at) {
      return (
        // Always wrap provider to avoid sub node re-mount
        /* @__PURE__ */ v.createElement(Gi, {
          key: wt.key,
          overflowDisabled: at > Z
        }, wt)
      );
    })
  ), ci = /* @__PURE__ */ v.createElement(yr, Pe({
    id: h,
    ref: Ue,
    prefixCls: "".concat(i, "-overflow"),
    component: "ul",
    itemComponent: ol,
    className: se(i, "".concat(i, "-root"), "".concat(i, "-").concat(xt), l, j(j({}, "".concat(i, "-inline-collapsed"), ct), "".concat(i, "-rtl"), T), a),
    dir: g,
    style: s,
    role: "menu",
    tabIndex: u,
    data: ho,
    renderRawItem: function(at) {
      return at;
    },
    renderRawRest: function(at) {
      var St = at.length, an = St ? Me.slice(-St) : null;
      return /* @__PURE__ */ v.createElement(aa, {
        eventKey: mu,
        title: _e,
        disabled: be,
        internalPopupClose: St === 0,
        popupClassName: me
      }, an);
    },
    maxCount: xt !== "horizontal" || b ? yr.INVALIDATE : yr.RESPONSIVE,
    ssr: "full",
    "data-menu-list": !0,
    onVisibleChange: function(at) {
      ae(at);
    },
    onKeyDown: Nn
  }, He));
  return /* @__PURE__ */ v.createElement(sd.Provider, {
    value: li
  }, /* @__PURE__ */ v.createElement(l0.Provider, {
    value: x
  }, /* @__PURE__ */ v.createElement(Gi, {
    prefixCls: i,
    rootClassName: a,
    mode: xt,
    openKeys: Y,
    rtl: T,
    disabled: m,
    motion: mt ? X : null,
    defaultMotions: mt ? K : null,
    activeKey: Tn,
    onActive: cr,
    onInactive: go,
    selectedKeys: ur,
    inlineIndent: H,
    subMenuOpenDelay: E,
    subMenuCloseDelay: _,
    forceSubMenuRender: O,
    builtinPlacements: le,
    triggerSubMenuAction: ie,
    getPopupContainer: De,
    itemIcon: ne,
    expandIcon: te,
    onItemClick: mn,
    onOpenChange: dr
  }, /* @__PURE__ */ v.createElement(v0.Provider, {
    value: on
  }, ci), /* @__PURE__ */ v.createElement("div", {
    style: {
      display: "none"
    },
    "aria-hidden": !0
  }, /* @__PURE__ */ v.createElement(d0.Provider, {
    value: In
  }, Ve)))));
}), sa = lN;
sa.Item = ol;
sa.SubMenu = aa;
sa.ItemGroup = il;
sa.Divider = fd;
const cN = /* @__PURE__ */ v.createContext({
  siderHook: {
    addSider: () => null,
    removeSider: () => null
  }
}), uN = (e) => {
  const {
    antCls: t,
    // .ant
    componentCls: n,
    // .ant-layout
    colorText: r,
    footerBg: o,
    headerHeight: i,
    headerPadding: a,
    headerColor: s,
    footerPadding: l,
    fontSize: c,
    bodyBg: u,
    headerBg: d
  } = e;
  return {
    [n]: {
      display: "flex",
      flex: "auto",
      flexDirection: "column",
      /* fix firefox can't set height smaller than content on flex item */
      minHeight: 0,
      background: u,
      "&, *": {
        boxSizing: "border-box"
      },
      [`&${n}-has-sider`]: {
        flexDirection: "row",
        [`> ${n}, > ${n}-content`]: {
          // https://segmentfault.com/a/1190000019498300
          width: 0
        }
      },
      [`${n}-header, &${n}-footer`]: {
        flex: "0 0 auto"
      },
      // RTL
      "&-rtl": {
        direction: "rtl"
      }
    },
    // ==================== Header ====================
    [`${n}-header`]: {
      height: i,
      padding: a,
      color: s,
      lineHeight: ke(i),
      background: d,
      // Other components/menu/style/index.less line:686
      // Integration with header element so menu items have the same height
      [`${t}-menu`]: {
        lineHeight: "inherit"
      }
    },
    // ==================== Footer ====================
    [`${n}-footer`]: {
      padding: l,
      color: r,
      fontSize: c,
      background: o
    },
    // =================== Content ====================
    [`${n}-content`]: {
      flex: "auto",
      color: r,
      // fix firefox can't set height smaller than content on flex item
      minHeight: 0
    }
  };
}, b0 = (e) => {
  const {
    colorBgLayout: t,
    controlHeight: n,
    controlHeightLG: r,
    colorText: o,
    controlHeightSM: i,
    marginXXS: a,
    colorTextLightSolid: s,
    colorBgContainer: l
  } = e, c = r * 1.25;
  return {
    // Deprecated
    colorBgHeader: "#001529",
    colorBgBody: t,
    colorBgTrigger: "#002140",
    bodyBg: t,
    headerBg: "#001529",
    headerHeight: n * 2,
    headerPadding: `0 ${c}px`,
    headerColor: o,
    footerPadding: `${i}px ${c}px`,
    footerBg: t,
    siderBg: "#001529",
    triggerHeight: r + a * 2,
    triggerBg: "#002140",
    triggerColor: s,
    zeroTriggerWidth: r,
    zeroTriggerHeight: r,
    lightSiderBg: l,
    lightTriggerBg: l,
    lightTriggerColor: o
  };
}, C0 = [["colorBgBody", "bodyBg"], ["colorBgHeader", "headerBg"], ["colorBgTrigger", "triggerBg"]];
Er("Layout", (e) => [uN(e)], b0, {
  deprecatedTokens: C0
});
const dN = (e) => {
  const {
    componentCls: t,
    siderBg: n,
    motionDurationMid: r,
    motionDurationSlow: o,
    antCls: i,
    triggerHeight: a,
    triggerColor: s,
    triggerBg: l,
    headerHeight: c,
    zeroTriggerWidth: u,
    zeroTriggerHeight: d,
    borderRadiusLG: f,
    lightSiderBg: g,
    lightTriggerColor: h,
    lightTriggerBg: y,
    bodyBg: p
  } = e;
  return {
    [t]: {
      position: "relative",
      // fix firefox can't set width smaller than content on flex item
      minWidth: 0,
      background: n,
      transition: `all ${r}, background 0s`,
      "&-has-trigger": {
        paddingBottom: a
      },
      "&-right": {
        order: 1
      },
      [`${t}-children`]: {
        height: "100%",
        // Hack for fixing margin collapse bug
        // https://github.com/ant-design/ant-design/issues/7967
        // solution from https://stackoverflow.com/a/33132624/3040605
        marginTop: -0.1,
        paddingTop: 0.1,
        [`${i}-menu${i}-menu-inline-collapsed`]: {
          width: "auto"
        }
      },
      [`${t}-trigger`]: {
        position: "fixed",
        bottom: 0,
        zIndex: 1,
        height: a,
        color: s,
        lineHeight: ke(a),
        textAlign: "center",
        background: l,
        cursor: "pointer",
        transition: `all ${r}`
      },
      "&-zero-width": {
        "> *": {
          overflow: "hidden"
        },
        "&-trigger": {
          position: "absolute",
          top: c,
          insetInlineEnd: e.calc(u).mul(-1).equal(),
          zIndex: 1,
          width: u,
          height: d,
          color: s,
          fontSize: e.fontSizeXL,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: n,
          borderRadius: `0 ${ke(f)} ${ke(f)} 0`,
          cursor: "pointer",
          transition: `background ${o} ease`,
          "&::after": {
            position: "absolute",
            inset: 0,
            background: "transparent",
            transition: `all ${o}`,
            content: '""'
          },
          "&:hover::after": {
            background: "rgba(255, 255, 255, 0.2)"
          },
          "&-right": {
            insetInlineStart: e.calc(u).mul(-1).equal(),
            borderRadius: `${ke(f)} 0 0 ${ke(f)}`
          }
        }
      },
      // Light
      "&-light": {
        background: g,
        [`${t}-trigger`]: {
          color: h,
          background: y
        },
        [`${t}-zero-width-trigger`]: {
          color: h,
          background: y,
          border: `1px solid ${p}`,
          // Safe to modify to any other color
          borderInlineStart: 0
        }
      }
    }
  };
}, fN = Er(["Layout", "Sider"], (e) => [dN(e)], b0, {
  deprecatedTokens: C0
});
var vN = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const Mv = {
  xs: "479.98px",
  sm: "575.98px",
  md: "767.98px",
  lg: "991.98px",
  xl: "1199.98px",
  xxl: "1599.98px"
}, gN = (e) => !Number.isNaN(Number.parseFloat(e)) && isFinite(e), vd = /* @__PURE__ */ v.createContext({}), pN = /* @__PURE__ */ (() => {
  let e = 0;
  return function() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e += 1, `${t}${e}`;
  };
})(), hN = /* @__PURE__ */ v.forwardRef((e, t) => {
  const {
    prefixCls: n,
    className: r,
    trigger: o,
    children: i,
    defaultCollapsed: a = !1,
    theme: s = "dark",
    style: l = {},
    collapsible: c = !1,
    reverseArrow: u = !1,
    width: d = 200,
    collapsedWidth: f = 80,
    zeroWidthTriggerStyle: g,
    breakpoint: h,
    onCollapse: y,
    onBreakpoint: p
  } = e, C = vN(e, ["prefixCls", "className", "trigger", "children", "defaultCollapsed", "theme", "style", "collapsible", "reverseArrow", "width", "collapsedWidth", "zeroWidthTriggerStyle", "breakpoint", "onCollapse", "onBreakpoint"]), {
    siderHook: m
  } = Kt(cN), [b, w] = Ht("collapsed" in e ? e.collapsed : a), [E, S] = Ht(!1);
  At(() => {
    "collapsed" in e && w(e.collapsed);
  }, [e.collapsed]);
  const _ = (ne, te) => {
    "collapsed" in e || w(ne), y == null || y(ne, te);
  }, {
    getPrefixCls: O,
    direction: P
  } = Kt(kt), $ = O("layout-sider", n), [L, N, k] = fN($), F = st(null);
  F.current = (ne) => {
    S(ne.matches), p == null || p(ne.matches), b !== ne.matches && _(ne.matches, "responsive");
  }, At(() => {
    function ne(re) {
      return F.current(re);
    }
    let te;
    if (typeof window < "u") {
      const {
        matchMedia: re
      } = window;
      if (re && h && h in Mv) {
        te = re(`screen and (max-width: ${Mv[h]})`);
        try {
          te.addEventListener("change", ne);
        } catch {
          te.addListener(ne);
        }
        ne(te);
      }
    }
    return () => {
      try {
        te == null || te.removeEventListener("change", ne);
      } catch {
        te == null || te.removeListener(ne);
      }
    };
  }, [h]), At(() => {
    const ne = pN("ant-sider-");
    return m.addSider(ne), () => m.removeSider(ne);
  }, []);
  const U = () => {
    _(!b, "clickTrigger");
  }, A = Ur(C, ["collapsed"]), R = b ? f : d, D = gN(R) ? `${R}px` : String(R), B = parseFloat(String(f || 0)) === 0 ? /* @__PURE__ */ v.createElement("span", {
    onClick: U,
    className: se(`${$}-zero-width-trigger`, `${$}-zero-width-trigger-${u ? "right" : "left"}`),
    style: g
  }, o || /* @__PURE__ */ v.createElement(Vg, null)) : null, M = P === "rtl" == !u, X = {
    expanded: M ? /* @__PURE__ */ v.createElement(Sc, null) : /* @__PURE__ */ v.createElement(wc, null),
    collapsed: M ? /* @__PURE__ */ v.createElement(wc, null) : /* @__PURE__ */ v.createElement(Sc, null)
  }[b ? "collapsed" : "expanded"], K = o !== null ? B || /* @__PURE__ */ v.createElement("div", {
    className: `${$}-trigger`,
    onClick: U,
    style: {
      width: D
    }
  }, o || X) : null, J = Object.assign(Object.assign({}, l), {
    flex: `0 0 ${D}`,
    maxWidth: D,
    minWidth: D,
    width: D
  }), ie = se($, `${$}-${s}`, {
    [`${$}-collapsed`]: !!b,
    [`${$}-has-trigger`]: c && o !== null && !B,
    [`${$}-below`]: !!E,
    [`${$}-zero-width`]: parseFloat(D) === 0
  }, r, N, k), le = v.useMemo(() => ({
    siderCollapsed: b
  }), [b]);
  return L(/* @__PURE__ */ v.createElement(vd.Provider, {
    value: le
  }, /* @__PURE__ */ v.createElement("aside", Object.assign({
    className: ie
  }, A, {
    style: J,
    ref: t
  }), /* @__PURE__ */ v.createElement("div", {
    className: `${$}-children`
  }, i), c || E && B ? K : null)));
});
z.env.NODE_ENV !== "production" && (hN.displayName = "Sider");
const Ss = /* @__PURE__ */ Ts({
  prefixCls: "",
  firstLevel: !0,
  inlineCollapsed: !1
});
var mN = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
const w0 = (e) => {
  const {
    prefixCls: t,
    className: n,
    dashed: r
  } = e, o = mN(e, ["prefixCls", "className", "dashed"]), {
    getPrefixCls: i
  } = v.useContext(kt), a = i("menu", t), s = se({
    [`${a}-item-divider-dashed`]: !!r
  }, n);
  return /* @__PURE__ */ v.createElement(fd, Object.assign({
    className: s
  }, o));
}, S0 = (e) => {
  var t;
  const {
    className: n,
    children: r,
    icon: o,
    title: i,
    danger: a,
    extra: s
  } = e, {
    prefixCls: l,
    firstLevel: c,
    direction: u,
    disableMenuItemTitleTooltip: d,
    inlineCollapsed: f
  } = v.useContext(Ss), g = (b) => {
    const w = r == null ? void 0 : r[0], E = /* @__PURE__ */ v.createElement("span", {
      className: se(`${l}-title-content`, {
        [`${l}-title-content-with-extra`]: !!s || s === 0
      })
    }, r);
    return (!o || /* @__PURE__ */ v.isValidElement(r) && r.type === "span") && r && b && c && typeof w == "string" ? /* @__PURE__ */ v.createElement("div", {
      className: `${l}-inline-collapsed-noicon`
    }, w.charAt(0)) : E;
  }, {
    siderCollapsed: h
  } = v.useContext(vd);
  let y = i;
  typeof i > "u" ? y = c ? r : "" : i === !1 && (y = "");
  const p = {
    title: y
  };
  !h && !f && (p.title = null, p.open = !1);
  const C = oo(r).length;
  let m = /* @__PURE__ */ v.createElement(ol, Object.assign({}, Ur(e, ["title", "icon", "danger"]), {
    className: se({
      [`${l}-item-danger`]: a,
      [`${l}-item-only-child`]: (o ? C + 1 : C) === 1
    }, n),
    title: typeof i == "string" ? i : void 0
  }), _r(o, {
    className: se(/* @__PURE__ */ v.isValidElement(o) ? (t = o.props) === null || t === void 0 ? void 0 : t.className : "", `${l}-item-icon`)
  }), g(f));
  return d || (m = /* @__PURE__ */ v.createElement(ia, Object.assign({}, p, {
    placement: u === "rtl" ? "left" : "right",
    classNames: {
      root: `${l}-inline-collapsed-tooltip`
    }
  }), m)), m;
}, Lv = /* @__PURE__ */ v.createContext(null), yN = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    horizontalLineHeight: r,
    colorSplit: o,
    lineWidth: i,
    lineType: a,
    itemPaddingInline: s
  } = e;
  return {
    [`${t}-horizontal`]: {
      lineHeight: r,
      border: 0,
      borderBottom: `${ke(i)} ${a} ${o}`,
      boxShadow: "none",
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        content: '"\\20"'
      },
      // ======================= Item =======================
      [`${t}-item, ${t}-submenu`]: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "bottom",
        paddingInline: s
      },
      [`> ${t}-item:hover,
        > ${t}-item-active,
        > ${t}-submenu ${t}-submenu-title:hover`]: {
        backgroundColor: "transparent"
      },
      [`${t}-item, ${t}-submenu-title`]: {
        transition: [`border-color ${n}`, `background ${n}`].join(",")
      },
      // ===================== Sub Menu =====================
      [`${t}-submenu-arrow`]: {
        display: "none"
      }
    }
  };
}, bN = (e) => {
  let {
    componentCls: t,
    menuArrowOffset: n,
    calc: r
  } = e;
  return {
    [`${t}-rtl`]: {
      direction: "rtl"
    },
    [`${t}-submenu-rtl`]: {
      transformOrigin: "100% 0"
    },
    // Vertical Arrow
    [`${t}-rtl${t}-vertical,
    ${t}-submenu-rtl ${t}-vertical`]: {
      [`${t}-submenu-arrow`]: {
        "&::before": {
          transform: `rotate(-45deg) translateY(${ke(r(n).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(45deg) translateY(${ke(n)})`
        }
      }
    }
  };
}, Dv = (e) => Object.assign({}, Vh(e)), Fv = (e, t) => {
  const {
    componentCls: n,
    itemColor: r,
    itemSelectedColor: o,
    subMenuItemSelectedColor: i,
    groupTitleColor: a,
    itemBg: s,
    subMenuItemBg: l,
    itemSelectedBg: c,
    activeBarHeight: u,
    activeBarWidth: d,
    activeBarBorderWidth: f,
    motionDurationSlow: g,
    motionEaseInOut: h,
    motionEaseOut: y,
    itemPaddingInline: p,
    motionDurationMid: C,
    itemHoverColor: m,
    lineType: b,
    colorSplit: w,
    // Disabled
    itemDisabledColor: E,
    // Danger
    dangerItemColor: S,
    dangerItemHoverColor: _,
    dangerItemSelectedColor: O,
    dangerItemActiveBg: P,
    dangerItemSelectedBg: $,
    // Bg
    popupBg: L,
    itemHoverBg: N,
    itemActiveBg: k,
    menuSubMenuBg: F,
    // Horizontal
    horizontalItemSelectedColor: U,
    horizontalItemSelectedBg: A,
    horizontalItemBorderRadius: R,
    horizontalItemHoverBg: D
  } = e;
  return {
    [`${n}-${t}, ${n}-${t} > ${n}`]: {
      color: r,
      background: s,
      [`&${n}-root:focus-visible`]: Object.assign({}, Dv(e)),
      // ======================== Item ========================
      [`${n}-item`]: {
        "&-group-title, &-extra": {
          color: a
        }
      },
      [`${n}-submenu-selected > ${n}-submenu-title`]: {
        color: i
      },
      [`${n}-item, ${n}-submenu-title`]: {
        color: r,
        [`&:not(${n}-item-disabled):focus-visible`]: Object.assign({}, Dv(e))
      },
      // Disabled
      [`${n}-item-disabled, ${n}-submenu-disabled`]: {
        color: `${E} !important`
      },
      // Hover
      [`${n}-item:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
        [`&:hover, > ${n}-submenu-title:hover`]: {
          color: m
        }
      },
      [`&:not(${n}-horizontal)`]: {
        [`${n}-item:not(${n}-item-selected)`]: {
          "&:hover": {
            backgroundColor: N
          },
          "&:active": {
            backgroundColor: k
          }
        },
        [`${n}-submenu-title`]: {
          "&:hover": {
            backgroundColor: N
          },
          "&:active": {
            backgroundColor: k
          }
        }
      },
      // Danger - only Item has
      [`${n}-item-danger`]: {
        color: S,
        [`&${n}-item:hover`]: {
          [`&:not(${n}-item-selected):not(${n}-submenu-selected)`]: {
            color: _
          }
        },
        [`&${n}-item:active`]: {
          background: P
        }
      },
      [`${n}-item a`]: {
        "&, &:hover": {
          color: "inherit"
        }
      },
      [`${n}-item-selected`]: {
        color: o,
        // Danger
        [`&${n}-item-danger`]: {
          color: O
        },
        "a, a:hover": {
          color: "inherit"
        }
      },
      [`& ${n}-item-selected`]: {
        backgroundColor: c,
        // Danger
        [`&${n}-item-danger`]: {
          backgroundColor: $
        }
      },
      [`&${n}-submenu > ${n}`]: {
        backgroundColor: F
      },
      // ===== 设置浮层的颜色 =======
      // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
      [`&${n}-popup > ${n}`]: {
        backgroundColor: L
      },
      [`&${n}-submenu-popup > ${n}`]: {
        backgroundColor: L
      },
      // ===== 设置浮层的颜色 end =======
      // ====================== Horizontal ======================
      [`&${n}-horizontal`]: Object.assign(Object.assign({}, t === "dark" ? {
        borderBottom: 0
      } : {}), {
        [`> ${n}-item, > ${n}-submenu`]: {
          top: f,
          marginTop: e.calc(f).mul(-1).equal(),
          marginBottom: 0,
          borderRadius: R,
          "&::after": {
            position: "absolute",
            insetInline: p,
            bottom: 0,
            borderBottom: `${ke(u)} solid transparent`,
            transition: `border-color ${g} ${h}`,
            content: '""'
          },
          "&:hover, &-active, &-open": {
            background: D,
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: U
            }
          },
          "&-selected": {
            color: U,
            backgroundColor: A,
            "&:hover": {
              backgroundColor: A
            },
            "&::after": {
              borderBottomWidth: u,
              borderBottomColor: U
            }
          }
        }
      }),
      // ================== Inline & Vertical ===================
      //
      [`&${n}-root`]: {
        [`&${n}-inline, &${n}-vertical`]: {
          borderInlineEnd: `${ke(f)} ${b} ${w}`
        }
      },
      // ======================== Inline ========================
      [`&${n}-inline`]: {
        // Sub
        [`${n}-sub${n}-inline`]: {
          background: l
        },
        [`${n}-item`]: {
          position: "relative",
          "&::after": {
            position: "absolute",
            insetBlock: 0,
            insetInlineEnd: 0,
            borderInlineEnd: `${ke(d)} solid ${o}`,
            transform: "scaleY(0.0001)",
            opacity: 0,
            transition: [`transform ${C} ${y}`, `opacity ${C} ${y}`].join(","),
            content: '""'
          },
          // Danger
          [`&${n}-item-danger`]: {
            "&::after": {
              borderInlineEndColor: O
            }
          }
        },
        [`${n}-selected, ${n}-item-selected`]: {
          "&::after": {
            transform: "scaleY(1)",
            opacity: 1,
            transition: [`transform ${C} ${h}`, `opacity ${C} ${h}`].join(",")
          }
        }
      }
    }
  };
}, jv = (e) => {
  const {
    componentCls: t,
    itemHeight: n,
    itemMarginInline: r,
    padding: o,
    menuArrowSize: i,
    marginXS: a,
    itemMarginBlock: s,
    itemWidth: l,
    itemPaddingInline: c
  } = e, u = e.calc(i).add(o).add(a).equal();
  return {
    [`${t}-item`]: {
      position: "relative",
      overflow: "hidden"
    },
    [`${t}-item, ${t}-submenu-title`]: {
      height: n,
      lineHeight: ke(n),
      paddingInline: c,
      overflow: "hidden",
      textOverflow: "ellipsis",
      marginInline: r,
      marginBlock: s,
      width: l
    },
    [`> ${t}-item,
            > ${t}-submenu > ${t}-submenu-title`]: {
      height: n,
      lineHeight: ke(n)
    },
    [`${t}-item-group-list ${t}-submenu-title,
            ${t}-submenu-title`]: {
      paddingInlineEnd: u
    }
  };
}, CN = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    itemHeight: r,
    colorTextLightSolid: o,
    dropdownWidth: i,
    controlHeightLG: a,
    motionEaseOut: s,
    paddingXL: l,
    itemMarginInline: c,
    fontSizeLG: u,
    motionDurationFast: d,
    motionDurationSlow: f,
    paddingXS: g,
    boxShadowSecondary: h,
    collapsedWidth: y,
    collapsedIconSize: p
  } = e, C = {
    height: r,
    lineHeight: ke(r),
    listStylePosition: "inside",
    listStyleType: "disc"
  };
  return [
    {
      [t]: {
        "&-inline, &-vertical": Object.assign({
          [`&${t}-root`]: {
            boxShadow: "none"
          }
        }, jv(e))
      },
      [`${t}-submenu-popup`]: {
        [`${t}-vertical`]: Object.assign(Object.assign({}, jv(e)), {
          boxShadow: h
        })
      }
    },
    // Vertical only
    {
      [`${t}-submenu-popup ${t}-vertical${t}-sub`]: {
        minWidth: i,
        maxHeight: `calc(100vh - ${ke(e.calc(a).mul(2.5).equal())})`,
        padding: "0",
        overflow: "hidden",
        borderInlineEnd: 0,
        // https://github.com/ant-design/ant-design/issues/22244
        // https://github.com/ant-design/ant-design/issues/26812
        "&:not([class*='-active'])": {
          overflowX: "hidden",
          overflowY: "auto"
        }
      }
    },
    // Inline Only
    {
      [`${t}-inline`]: {
        width: "100%",
        // Motion enhance for first level
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu-title`]: {
            display: "flex",
            alignItems: "center",
            transition: [`border-color ${f}`, `background ${f}`, `padding ${d} ${s}`].join(","),
            [`> ${t}-title-content`]: {
              flex: "auto",
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis"
            },
            "> *": {
              flex: "none"
            }
          }
        },
        // >>>>> Sub
        [`${t}-sub${t}-inline`]: {
          padding: 0,
          border: 0,
          borderRadius: 0,
          boxShadow: "none",
          [`& > ${t}-submenu > ${t}-submenu-title`]: C,
          [`& ${t}-item-group-title`]: {
            paddingInlineStart: l
          }
        },
        // >>>>> Item
        [`${t}-item`]: C
      }
    },
    // Inline Collapse Only
    {
      [`${t}-inline-collapsed`]: {
        width: y,
        [`&${t}-root`]: {
          [`${t}-item, ${t}-submenu ${t}-submenu-title`]: {
            [`> ${t}-inline-collapsed-noicon`]: {
              fontSize: u,
              textAlign: "center"
            }
          }
        },
        [`> ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-item,
          > ${t}-item-group > ${t}-item-group-list > ${t}-submenu > ${t}-submenu-title,
          > ${t}-submenu > ${t}-submenu-title`]: {
          insetInlineStart: 0,
          paddingInline: `calc(50% - ${ke(e.calc(p).div(2).equal())} - ${ke(c)})`,
          textOverflow: "clip",
          [`
            ${t}-submenu-arrow,
            ${t}-submenu-expand-icon
          `]: {
            opacity: 0
          },
          [`${t}-item-icon, ${n}`]: {
            margin: 0,
            fontSize: p,
            lineHeight: ke(r),
            "+ span": {
              display: "inline-block",
              opacity: 0
            }
          }
        },
        [`${t}-item-icon, ${n}`]: {
          display: "inline-block"
        },
        "&-tooltip": {
          pointerEvents: "none",
          [`${t}-item-icon, ${n}`]: {
            display: "none"
          },
          "a, a:hover": {
            color: o
          }
        },
        [`${t}-item-group-title`]: Object.assign(Object.assign({}, rO), {
          paddingInline: g
        })
      }
    }
  ];
}, Bv = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionDurationMid: r,
    motionEaseInOut: o,
    motionEaseOut: i,
    iconCls: a,
    iconSize: s,
    iconMarginInlineEnd: l
  } = e;
  return {
    // >>>>> Item
    [`${t}-item, ${t}-submenu-title`]: {
      position: "relative",
      display: "block",
      margin: 0,
      whiteSpace: "nowrap",
      cursor: "pointer",
      transition: [`border-color ${n}`, `background ${n}`, `padding calc(${n} + 0.1s) ${o}`].join(","),
      [`${t}-item-icon, ${a}`]: {
        minWidth: s,
        fontSize: s,
        transition: [`font-size ${r} ${i}`, `margin ${n} ${o}`, `color ${n}`].join(","),
        "+ span": {
          marginInlineStart: l,
          opacity: 1,
          transition: [`opacity ${n} ${o}`, `margin ${n}`, `color ${n}`].join(",")
        }
      },
      [`${t}-item-icon`]: Object.assign({}, Ku()),
      [`&${t}-item-only-child`]: {
        [`> ${a}, > ${t}-item-icon`]: {
          marginInlineEnd: 0
        }
      }
    },
    // Disabled state sets text to gray and nukes hover/tab effects
    [`${t}-item-disabled, ${t}-submenu-disabled`]: {
      background: "none !important",
      cursor: "not-allowed",
      "&::after": {
        borderColor: "transparent !important"
      },
      a: {
        color: "inherit !important",
        cursor: "not-allowed",
        pointerEvents: "none"
      },
      [`> ${t}-submenu-title`]: {
        color: "inherit !important",
        cursor: "not-allowed"
      }
    }
  };
}, Vv = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    motionEaseInOut: r,
    borderRadius: o,
    menuArrowSize: i,
    menuArrowOffset: a
  } = e;
  return {
    [`${t}-submenu`]: {
      "&-expand-icon, &-arrow": {
        position: "absolute",
        top: "50%",
        insetInlineEnd: e.margin,
        width: i,
        color: "currentcolor",
        transform: "translateY(-50%)",
        transition: `transform ${n} ${r}, opacity ${n}`
      },
      "&-arrow": {
        // →
        "&::before, &::after": {
          position: "absolute",
          width: e.calc(i).mul(0.6).equal(),
          height: e.calc(i).mul(0.15).equal(),
          backgroundColor: "currentcolor",
          borderRadius: o,
          transition: [`background ${n} ${r}`, `transform ${n} ${r}`, `top ${n} ${r}`, `color ${n} ${r}`].join(","),
          content: '""'
        },
        "&::before": {
          transform: `rotate(45deg) translateY(${ke(e.calc(a).mul(-1).equal())})`
        },
        "&::after": {
          transform: `rotate(-45deg) translateY(${ke(a)})`
        }
      }
    }
  };
}, wN = (e) => {
  const {
    antCls: t,
    componentCls: n,
    fontSize: r,
    motionDurationSlow: o,
    motionDurationMid: i,
    motionEaseInOut: a,
    paddingXS: s,
    padding: l,
    colorSplit: c,
    lineWidth: u,
    zIndexPopup: d,
    borderRadiusLG: f,
    subMenuItemBorderRadius: g,
    menuArrowSize: h,
    menuArrowOffset: y,
    lineType: p,
    groupTitleLineHeight: C,
    groupTitleFontSize: m
  } = e;
  return [
    // Misc
    {
      "": {
        [n]: Object.assign(Object.assign({}, Lf()), {
          // Hidden
          "&-hidden": {
            display: "none"
          }
        })
      },
      [`${n}-submenu-hidden`]: {
        display: "none"
      }
    },
    {
      [n]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, oi(e)), Lf()), {
        marginBottom: 0,
        paddingInlineStart: 0,
        // Override default ul/ol
        fontSize: r,
        lineHeight: 0,
        listStyle: "none",
        outline: "none",
        // Magic cubic here but smooth transition
        transition: `width ${o} cubic-bezier(0.2, 0, 0, 1) 0s`,
        "ul, ol": {
          margin: 0,
          padding: 0,
          listStyle: "none"
        },
        // Overflow ellipsis
        "&-overflow": {
          display: "flex",
          [`${n}-item`]: {
            flex: "none"
          }
        },
        [`${n}-item, ${n}-submenu, ${n}-submenu-title`]: {
          borderRadius: e.itemBorderRadius
        },
        [`${n}-item-group-title`]: {
          padding: `${ke(s)} ${ke(l)}`,
          fontSize: m,
          lineHeight: C,
          transition: `all ${o}`
        },
        [`&-horizontal ${n}-submenu`]: {
          transition: [`border-color ${o} ${a}`, `background ${o} ${a}`].join(",")
        },
        [`${n}-submenu, ${n}-submenu-inline`]: {
          transition: [`border-color ${o} ${a}`, `background ${o} ${a}`, `padding ${i} ${a}`].join(",")
        },
        [`${n}-submenu ${n}-sub`]: {
          cursor: "initial",
          transition: [`background ${o} ${a}`, `padding ${o} ${a}`].join(",")
        },
        [`${n}-title-content`]: {
          transition: `color ${o}`,
          "&-with-extra": {
            display: "inline-flex",
            alignItems: "center",
            width: "100%"
          },
          // https://github.com/ant-design/ant-design/issues/41143
          [`> ${t}-typography-ellipsis-single-line`]: {
            display: "inline",
            verticalAlign: "unset"
          },
          [`${n}-item-extra`]: {
            marginInlineStart: "auto",
            paddingInlineStart: e.padding
          }
        },
        [`${n}-item a`]: {
          "&::before": {
            position: "absolute",
            inset: 0,
            backgroundColor: "transparent",
            content: '""'
          }
        },
        // Removed a Badge related style seems it's safe
        // https://github.com/ant-design/ant-design/issues/19809
        // >>>>> Divider
        [`${n}-item-divider`]: {
          overflow: "hidden",
          lineHeight: 0,
          borderColor: c,
          borderStyle: p,
          borderWidth: 0,
          borderTopWidth: u,
          marginBlock: u,
          padding: 0,
          "&-dashed": {
            borderStyle: "dashed"
          }
        }
      }), Bv(e)), {
        [`${n}-item-group`]: {
          [`${n}-item-group-list`]: {
            margin: 0,
            padding: 0,
            [`${n}-item, ${n}-submenu-title`]: {
              paddingInline: `${ke(e.calc(r).mul(2).equal())} ${ke(l)}`
            }
          }
        },
        // ======================= Sub Menu =======================
        "&-submenu": {
          "&-popup": {
            position: "absolute",
            zIndex: d,
            borderRadius: f,
            boxShadow: "none",
            transformOrigin: "0 0",
            [`&${n}-submenu`]: {
              background: "transparent"
            },
            // https://github.com/ant-design/ant-design/issues/13955
            "&::before": {
              position: "absolute",
              inset: 0,
              zIndex: -1,
              width: "100%",
              height: "100%",
              opacity: 0,
              content: '""'
            },
            [`> ${n}`]: Object.assign(Object.assign(Object.assign({
              borderRadius: f
            }, Bv(e)), Vv(e)), {
              [`${n}-item, ${n}-submenu > ${n}-submenu-title`]: {
                borderRadius: g
              },
              [`${n}-submenu-title::after`]: {
                transition: `transform ${o} ${a}`
              }
            })
          },
          "\n          &-placement-leftTop,\n          &-placement-bottomRight,\n          ": {
            transformOrigin: "100% 0"
          },
          "\n          &-placement-leftBottom,\n          &-placement-topRight,\n          ": {
            transformOrigin: "100% 100%"
          },
          "\n          &-placement-rightBottom,\n          &-placement-topLeft,\n          ": {
            transformOrigin: "0 100%"
          },
          "\n          &-placement-bottomLeft,\n          &-placement-rightTop,\n          ": {
            transformOrigin: "0 0"
          },
          "\n          &-placement-leftTop,\n          &-placement-leftBottom\n          ": {
            paddingInlineEnd: e.paddingXS
          },
          "\n          &-placement-rightTop,\n          &-placement-rightBottom\n          ": {
            paddingInlineStart: e.paddingXS
          },
          "\n          &-placement-topRight,\n          &-placement-topLeft\n          ": {
            paddingBottom: e.paddingXS
          },
          "\n          &-placement-bottomRight,\n          &-placement-bottomLeft\n          ": {
            paddingTop: e.paddingXS
          }
        }
      }), Vv(e)), {
        [`&-inline-collapsed ${n}-submenu-arrow,
        &-inline ${n}-submenu-arrow`]: {
          // ↓
          "&::before": {
            transform: `rotate(-45deg) translateX(${ke(y)})`
          },
          "&::after": {
            transform: `rotate(45deg) translateX(${ke(e.calc(y).mul(-1).equal())})`
          }
        },
        [`${n}-submenu-open${n}-submenu-inline > ${n}-submenu-title > ${n}-submenu-arrow`]: {
          // ↑
          transform: `translateY(${ke(e.calc(h).mul(0.2).mul(-1).equal())})`,
          "&::after": {
            transform: `rotate(-45deg) translateX(${ke(e.calc(y).mul(-1).equal())})`
          },
          "&::before": {
            transform: `rotate(45deg) translateX(${ke(y)})`
          }
        }
      })
    },
    // Integration with header element so menu items have the same height
    {
      [`${t}-layout-header`]: {
        [n]: {
          lineHeight: "inherit"
        }
      }
    }
  ];
}, SN = (e) => {
  var t, n, r;
  const {
    colorPrimary: o,
    colorError: i,
    colorTextDisabled: a,
    colorErrorBg: s,
    colorText: l,
    colorTextDescription: c,
    colorBgContainer: u,
    colorFillAlter: d,
    colorFillContent: f,
    lineWidth: g,
    lineWidthBold: h,
    controlItemBgActive: y,
    colorBgTextHover: p,
    controlHeightLG: C,
    lineHeight: m,
    colorBgElevated: b,
    marginXXS: w,
    padding: E,
    fontSize: S,
    controlHeightSM: _,
    fontSizeLG: O,
    colorTextLightSolid: P,
    colorErrorHover: $
  } = e, L = (t = e.activeBarWidth) !== null && t !== void 0 ? t : 0, N = (n = e.activeBarBorderWidth) !== null && n !== void 0 ? n : g, k = (r = e.itemMarginInline) !== null && r !== void 0 ? r : e.marginXXS, F = new Tt(P).setA(0.65).toRgbString();
  return {
    dropdownWidth: 160,
    zIndexPopup: e.zIndexPopupBase + 50,
    radiusItem: e.borderRadiusLG,
    itemBorderRadius: e.borderRadiusLG,
    radiusSubMenuItem: e.borderRadiusSM,
    subMenuItemBorderRadius: e.borderRadiusSM,
    colorItemText: l,
    itemColor: l,
    colorItemTextHover: l,
    itemHoverColor: l,
    colorItemTextHoverHorizontal: o,
    horizontalItemHoverColor: o,
    colorGroupTitle: c,
    groupTitleColor: c,
    colorItemTextSelected: o,
    itemSelectedColor: o,
    subMenuItemSelectedColor: o,
    colorItemTextSelectedHorizontal: o,
    horizontalItemSelectedColor: o,
    colorItemBg: u,
    itemBg: u,
    colorItemBgHover: p,
    itemHoverBg: p,
    colorItemBgActive: f,
    itemActiveBg: y,
    colorSubItemBg: d,
    subMenuItemBg: d,
    colorItemBgSelected: y,
    itemSelectedBg: y,
    colorItemBgSelectedHorizontal: "transparent",
    horizontalItemSelectedBg: "transparent",
    colorActiveBarWidth: 0,
    activeBarWidth: L,
    colorActiveBarHeight: h,
    activeBarHeight: h,
    colorActiveBarBorderSize: g,
    activeBarBorderWidth: N,
    // Disabled
    colorItemTextDisabled: a,
    itemDisabledColor: a,
    // Danger
    colorDangerItemText: i,
    dangerItemColor: i,
    colorDangerItemTextHover: i,
    dangerItemHoverColor: i,
    colorDangerItemTextSelected: i,
    dangerItemSelectedColor: i,
    colorDangerItemBgActive: s,
    dangerItemActiveBg: s,
    colorDangerItemBgSelected: s,
    dangerItemSelectedBg: s,
    itemMarginInline: k,
    horizontalItemBorderRadius: 0,
    horizontalItemHoverBg: "transparent",
    itemHeight: C,
    groupTitleLineHeight: m,
    collapsedWidth: C * 2,
    popupBg: b,
    itemMarginBlock: w,
    itemPaddingInline: E,
    horizontalLineHeight: `${C * 1.15}px`,
    iconSize: S,
    iconMarginInlineEnd: _ - S,
    collapsedIconSize: O,
    groupTitleFontSize: S,
    // Disabled
    darkItemDisabledColor: new Tt(P).setA(0.25).toRgbString(),
    // Dark
    darkItemColor: F,
    darkDangerItemColor: i,
    darkItemBg: "#001529",
    darkPopupBg: "#001529",
    darkSubMenuItemBg: "#000c17",
    darkItemSelectedColor: P,
    darkItemSelectedBg: o,
    darkDangerItemSelectedBg: i,
    darkItemHoverBg: "transparent",
    darkGroupTitleColor: F,
    darkItemHoverColor: P,
    darkDangerItemHoverColor: $,
    darkDangerItemSelectedColor: P,
    darkDangerItemActiveBg: i,
    // internal
    itemWidth: L ? `calc(100% + ${N}px)` : `calc(100% - ${k * 2}px)`
  };
}, EN = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  return Er("Menu", (o) => {
    const {
      colorBgElevated: i,
      controlHeightLG: a,
      fontSize: s,
      darkItemColor: l,
      darkDangerItemColor: c,
      darkItemBg: u,
      darkSubMenuItemBg: d,
      darkItemSelectedColor: f,
      darkItemSelectedBg: g,
      darkDangerItemSelectedBg: h,
      darkItemHoverBg: y,
      darkGroupTitleColor: p,
      darkItemHoverColor: C,
      darkItemDisabledColor: m,
      darkDangerItemHoverColor: b,
      darkDangerItemSelectedColor: w,
      darkDangerItemActiveBg: E,
      popupBg: S,
      darkPopupBg: _
    } = o, O = o.calc(s).div(7).mul(5).equal(), P = hn(o, {
      menuArrowSize: O,
      menuHorizontalHeight: o.calc(a).mul(1.15).equal(),
      menuArrowOffset: o.calc(O).mul(0.25).equal(),
      menuSubMenuBg: i,
      calc: o.calc,
      popupBg: S
    }), $ = hn(P, {
      itemColor: l,
      itemHoverColor: C,
      groupTitleColor: p,
      itemSelectedColor: f,
      itemBg: u,
      popupBg: _,
      subMenuItemBg: d,
      itemActiveBg: "transparent",
      itemSelectedBg: g,
      activeBarHeight: 0,
      activeBarBorderWidth: 0,
      itemHoverBg: y,
      // Disabled
      itemDisabledColor: m,
      // Danger
      dangerItemColor: c,
      dangerItemHoverColor: b,
      dangerItemSelectedColor: w,
      dangerItemActiveBg: E,
      dangerItemSelectedBg: h,
      menuSubMenuBg: d,
      // Horizontal
      horizontalItemSelectedColor: f,
      horizontalItemSelectedBg: g
    });
    return [
      // Basic
      wN(P),
      // Horizontal
      yN(P),
      // Hard code for some light style
      // Vertical
      CN(P),
      // Hard code for some light style
      // Theme
      Fv(P, "light"),
      Fv($, "dark"),
      // RTL
      bN(P),
      // Motion
      QP(P),
      tv(P, "slide-up"),
      tv(P, "slide-down"),
      Qu(P, "zoom-big")
    ];
  }, SN, {
    deprecatedTokens: [["colorGroupTitle", "groupTitleColor"], ["radiusItem", "itemBorderRadius"], ["radiusSubMenuItem", "subMenuItemBorderRadius"], ["colorItemText", "itemColor"], ["colorItemTextHover", "itemHoverColor"], ["colorItemTextHoverHorizontal", "horizontalItemHoverColor"], ["colorItemTextSelected", "itemSelectedColor"], ["colorItemTextSelectedHorizontal", "horizontalItemSelectedColor"], ["colorItemTextDisabled", "itemDisabledColor"], ["colorDangerItemText", "dangerItemColor"], ["colorDangerItemTextHover", "dangerItemHoverColor"], ["colorDangerItemTextSelected", "dangerItemSelectedColor"], ["colorDangerItemBgActive", "dangerItemActiveBg"], ["colorDangerItemBgSelected", "dangerItemSelectedBg"], ["colorItemBg", "itemBg"], ["colorItemBgHover", "itemHoverBg"], ["colorSubItemBg", "subMenuItemBg"], ["colorItemBgActive", "itemActiveBg"], ["colorItemBgSelectedHorizontal", "horizontalItemSelectedBg"], ["colorActiveBarWidth", "activeBarWidth"], ["colorActiveBarHeight", "activeBarHeight"], ["colorActiveBarBorderSize", "activeBarBorderWidth"], ["colorItemBgSelected", "itemSelectedBg"]],
    // Dropdown will handle menu style self. We do not need to handle this.
    injectStyle: n,
    unitless: {
      groupTitleLineHeight: !0
    }
  })(e, t);
}, E0 = (e) => {
  var t;
  const {
    popupClassName: n,
    icon: r,
    title: o,
    theme: i
  } = e, a = v.useContext(Ss), {
    prefixCls: s,
    inlineCollapsed: l,
    theme: c
  } = a, u = ai();
  let d;
  if (!r)
    d = l && !u.length && o && typeof o == "string" ? /* @__PURE__ */ v.createElement("div", {
      className: `${s}-inline-collapsed-noicon`
    }, o.charAt(0)) : /* @__PURE__ */ v.createElement("span", {
      className: `${s}-title-content`
    }, o);
  else {
    const h = /* @__PURE__ */ v.isValidElement(o) && o.type === "span";
    d = /* @__PURE__ */ v.createElement(v.Fragment, null, _r(r, {
      className: se(/* @__PURE__ */ v.isValidElement(r) ? (t = r.props) === null || t === void 0 ? void 0 : t.className : "", `${s}-item-icon`)
    }), h ? o : /* @__PURE__ */ v.createElement("span", {
      className: `${s}-title-content`
    }, o));
  }
  const f = v.useMemo(() => Object.assign(Object.assign({}, a), {
    firstLevel: !1
  }), [a]), [g] = vm("Menu");
  return /* @__PURE__ */ v.createElement(Ss.Provider, {
    value: f
  }, /* @__PURE__ */ v.createElement(aa, Object.assign({}, Ur(e, ["icon"]), {
    title: d,
    popupClassName: se(s, n, `${s}-${i || c}`),
    popupStyle: Object.assign({
      zIndex: g
    }, e.popupStyle)
  })));
};
var _N = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function Xl(e) {
  return e === null || e === !1;
}
const xN = {
  item: S0,
  submenu: E0,
  divider: w0
}, ON = /* @__PURE__ */ lo((e, t) => {
  var n;
  const r = v.useContext(Lv), o = r || {}, {
    getPrefixCls: i,
    getPopupContainer: a,
    direction: s,
    menu: l
  } = v.useContext(kt), c = i(), {
    prefixCls: u,
    className: d,
    style: f,
    theme: g = "light",
    expandIcon: h,
    _internalDisableMenuItemTitleTooltip: y,
    inlineCollapsed: p,
    siderCollapsed: C,
    rootClassName: m,
    mode: b,
    selectable: w,
    onClick: E,
    overflowedIndicatorPopupClassName: S
  } = e, _ = _N(e, ["prefixCls", "className", "style", "theme", "expandIcon", "_internalDisableMenuItemTitleTooltip", "inlineCollapsed", "siderCollapsed", "rootClassName", "mode", "selectable", "onClick", "overflowedIndicatorPopupClassName"]), O = Ur(_, ["collapsedWidth"]);
  if (z.env.NODE_ENV !== "production") {
    const H = Pn("Menu");
    z.env.NODE_ENV !== "production" && H(!("inlineCollapsed" in e && b !== "inline"), "usage", "`inlineCollapsed` should only be used when `mode` is inline."), H.deprecated("items" in e && !e.children, "children", "items");
  }
  (n = o.validator) === null || n === void 0 || n.call(o, {
    mode: b
  });
  const P = sn(function() {
    var H;
    E == null || E.apply(void 0, arguments), (H = o.onClick) === null || H === void 0 || H.call(o);
  }), $ = o.mode || b, L = w ?? o.selectable, N = p ?? C, k = {
    horizontal: {
      motionName: `${c}-slide-up`
    },
    inline: CP(c),
    other: {
      motionName: `${c}-zoom-big`
    }
  }, F = i("menu", u || o.prefixCls), U = ea(F), [A, R, D] = EN(F, U, !r), B = se(`${F}-${g}`, l == null ? void 0 : l.className, d), M = v.useMemo(() => {
    var H, X;
    if (typeof h == "function" || Xl(h))
      return h || null;
    if (typeof o.expandIcon == "function" || Xl(o.expandIcon))
      return o.expandIcon || null;
    if (typeof (l == null ? void 0 : l.expandIcon) == "function" || Xl(l == null ? void 0 : l.expandIcon))
      return (l == null ? void 0 : l.expandIcon) || null;
    const K = (H = h ?? (o == null ? void 0 : o.expandIcon)) !== null && H !== void 0 ? H : l == null ? void 0 : l.expandIcon;
    return _r(K, {
      className: se(`${F}-submenu-expand-icon`, /* @__PURE__ */ v.isValidElement(K) ? (X = K.props) === null || X === void 0 ? void 0 : X.className : void 0)
    });
  }, [h, o == null ? void 0 : o.expandIcon, l == null ? void 0 : l.expandIcon, F]), G = v.useMemo(() => ({
    prefixCls: F,
    inlineCollapsed: N || !1,
    direction: s,
    firstLevel: !0,
    theme: g,
    mode: $,
    disableMenuItemTitleTooltip: y
  }), [F, N, s, y, g]);
  return A(/* @__PURE__ */ v.createElement(Lv.Provider, {
    value: null
  }, /* @__PURE__ */ v.createElement(Ss.Provider, {
    value: G
  }, /* @__PURE__ */ v.createElement(sa, Object.assign({
    getPopupContainer: a,
    overflowedIndicator: /* @__PURE__ */ v.createElement(Wg, null),
    overflowedIndicatorPopupClassName: se(F, `${F}-${g}`, S),
    mode: $,
    selectable: L,
    onClick: P
  }, O, {
    inlineCollapsed: N,
    style: Object.assign(Object.assign({}, l == null ? void 0 : l.style), f),
    className: B,
    prefixCls: F,
    direction: s,
    defaultMotions: k,
    expandIcon: M,
    ref: t,
    rootClassName: se(m, R, o.rootClassName, D, U),
    _internalComponents: xN
  })))));
}), lr = /* @__PURE__ */ lo((e, t) => {
  const n = st(null), r = v.useContext(vd);
  return Iu(t, () => ({
    menu: n.current,
    focus: (o) => {
      var i;
      (i = n.current) === null || i === void 0 || i.focus(o);
    }
  })), /* @__PURE__ */ v.createElement(ON, Object.assign({
    ref: n
  }, e, r));
});
lr.Item = S0;
lr.SubMenu = E0;
lr.Divider = w0;
lr.ItemGroup = il;
z.env.NODE_ENV !== "production" && (lr.displayName = "Menu");
function PN(e, t, n) {
  var r = n || {}, o = r.noTrailing, i = o === void 0 ? !1 : o, a = r.noLeading, s = a === void 0 ? !1 : a, l = r.debounceMode, c = l === void 0 ? void 0 : l, u, d = !1, f = 0;
  function g() {
    u && clearTimeout(u);
  }
  function h(p) {
    var C = p || {}, m = C.upcomingOnly, b = m === void 0 ? !1 : m;
    g(), d = !b;
  }
  function y() {
    for (var p = arguments.length, C = new Array(p), m = 0; m < p; m++)
      C[m] = arguments[m];
    var b = this, w = Date.now() - f;
    if (d)
      return;
    function E() {
      f = Date.now(), t.apply(b, C);
    }
    function S() {
      u = void 0;
    }
    !s && c && !u && E(), g(), c === void 0 && w > e ? s ? (f = Date.now(), i || (u = setTimeout(c ? S : E, e))) : E() : i !== !0 && (u = setTimeout(c ? S : E, c === void 0 ? e - w : e));
  }
  return y.cancel = h, y;
}
function IN(e, t, n) {
  var r = {}, o = r.atBegin, i = o === void 0 ? !1 : o;
  return PN(e, t, {
    debounceMode: i !== !1
  });
}
const Es = 100, _0 = Es / 5, x0 = Es / 2 - _0 / 2, Yl = x0 * 2 * Math.PI, zv = 50, Hv = (e) => {
  const {
    dotClassName: t,
    style: n,
    hasCircleCls: r
  } = e;
  return /* @__PURE__ */ v.createElement("circle", {
    className: se(`${t}-circle`, {
      [`${t}-circle-bg`]: r
    }),
    r: x0,
    cx: zv,
    cy: zv,
    strokeWidth: _0,
    style: n
  });
}, TN = (e) => {
  let {
    percent: t,
    prefixCls: n
  } = e;
  const r = `${n}-dot`, o = `${r}-holder`, i = `${o}-hidden`, [a, s] = v.useState(!1);
  nn(() => {
    t !== 0 && s(!0);
  }, [t !== 0]);
  const l = Math.max(Math.min(t, 100), 0);
  if (!a)
    return null;
  const c = {
    strokeDashoffset: `${Yl / 4}`,
    strokeDasharray: `${Yl * l / 100} ${Yl * (100 - l) / 100}`
  };
  return /* @__PURE__ */ v.createElement("span", {
    className: se(o, `${r}-progress`, l <= 0 && i)
  }, /* @__PURE__ */ v.createElement("svg", {
    viewBox: `0 0 ${Es} ${Es}`,
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": l
  }, /* @__PURE__ */ v.createElement(Hv, {
    dotClassName: r,
    hasCircleCls: !0
  }), /* @__PURE__ */ v.createElement(Hv, {
    dotClassName: r,
    style: c
  })));
};
function $N(e) {
  const {
    prefixCls: t,
    percent: n = 0
  } = e, r = `${t}-dot`, o = `${r}-holder`, i = `${o}-hidden`;
  return /* @__PURE__ */ v.createElement(v.Fragment, null, /* @__PURE__ */ v.createElement("span", {
    className: se(o, n > 0 && i)
  }, /* @__PURE__ */ v.createElement("span", {
    className: se(r, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((a) => /* @__PURE__ */ v.createElement("i", {
    className: `${t}-dot-item`,
    key: a
  })))), /* @__PURE__ */ v.createElement(TN, {
    prefixCls: t,
    percent: n
  }));
}
function RN(e) {
  const {
    prefixCls: t,
    indicator: n,
    percent: r
  } = e, o = `${t}-dot`;
  return n && /* @__PURE__ */ v.isValidElement(n) ? _r(n, {
    className: se(n.props.className, o),
    percent: r
  }) : /* @__PURE__ */ v.createElement($N, {
    prefixCls: t,
    percent: r
  });
}
const NN = new _t("antSpinMove", {
  to: {
    opacity: 1
  }
}), AN = new _t("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), kN = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, oi(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        insetInlineStart: "50%"
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: NN,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: AN,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((r) => `${r} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeSM
        }
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeLG
        }
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, MN = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, LN = Er("Spin", (e) => {
  const t = hn(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [kN(t)];
}, MN), DN = 200, Uv = [[30, 0.05], [70, 0.03], [96, 0.01]];
function FN(e, t) {
  const [n, r] = v.useState(0), o = v.useRef(null), i = t === "auto";
  return v.useEffect(() => (i && e && (r(0), o.current = setInterval(() => {
    r((a) => {
      const s = 100 - a;
      for (let l = 0; l < Uv.length; l += 1) {
        const [c, u] = Uv[l];
        if (a <= c)
          return a + s * u;
      }
      return a;
    });
  }, DN)), () => {
    clearInterval(o.current);
  }), [i, e]), i ? n : t;
}
var jN = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
let O0;
function BN(e, t) {
  return !!e && !!t && !Number.isNaN(Number(t));
}
const gd = (e) => {
  var t;
  const {
    prefixCls: n,
    spinning: r = !0,
    delay: o = 0,
    className: i,
    rootClassName: a,
    size: s = "default",
    tip: l,
    wrapperClassName: c,
    style: u,
    children: d,
    fullscreen: f = !1,
    indicator: g,
    percent: h
  } = e, y = jN(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: p,
    direction: C,
    spin: m
  } = v.useContext(kt), b = p("spin", n), [w, E, S] = LN(b), [_, O] = v.useState(() => r && !BN(r, o)), P = FN(_, h);
  v.useEffect(() => {
    if (r) {
      const A = IN(o, () => {
        O(!0);
      });
      return A(), () => {
        var R;
        (R = A == null ? void 0 : A.cancel) === null || R === void 0 || R.call(A);
      };
    }
    O(!1);
  }, [o, r]);
  const $ = v.useMemo(() => typeof d < "u" && !f, [d, f]);
  if (z.env.NODE_ENV !== "production") {
    const A = Pn("Spin");
    z.env.NODE_ENV !== "production" && A(!l || $ || f, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const L = se(b, m == null ? void 0 : m.className, {
    [`${b}-sm`]: s === "small",
    [`${b}-lg`]: s === "large",
    [`${b}-spinning`]: _,
    [`${b}-show-text`]: !!l,
    [`${b}-rtl`]: C === "rtl"
  }, i, !f && a, E, S), N = se(`${b}-container`, {
    [`${b}-blur`]: _
  }), k = (t = g ?? (m == null ? void 0 : m.indicator)) !== null && t !== void 0 ? t : O0, F = Object.assign(Object.assign({}, m == null ? void 0 : m.style), u), U = /* @__PURE__ */ v.createElement("div", Object.assign({}, y, {
    style: F,
    className: L,
    "aria-live": "polite",
    "aria-busy": _
  }), /* @__PURE__ */ v.createElement(RN, {
    prefixCls: b,
    indicator: k,
    percent: P
  }), l && ($ || f) ? /* @__PURE__ */ v.createElement("div", {
    className: `${b}-text`
  }, l) : null);
  return w($ ? /* @__PURE__ */ v.createElement("div", Object.assign({}, y, {
    className: se(`${b}-nested-loading`, c, E, S)
  }), _ && /* @__PURE__ */ v.createElement("div", {
    key: "loading"
  }, U), /* @__PURE__ */ v.createElement("div", {
    className: N,
    key: "container"
  }, d)) : f ? /* @__PURE__ */ v.createElement("div", {
    className: se(`${b}-fullscreen`, {
      [`${b}-fullscreen-show`]: _
    }, a, E, S)
  }, U) : U);
};
gd.setDefaultIndicator = (e) => {
  O0 = e;
};
z.env.NODE_ENV !== "production" && (gd.displayName = "Spin");
let Hn = null, ts = (e) => e(), _s = [], Ki = {};
function Wv() {
  const {
    getContainer: e,
    rtl: t,
    maxCount: n,
    top: r,
    bottom: o,
    showProgress: i,
    pauseOnHover: a
  } = Ki, s = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => s,
    rtl: t,
    maxCount: n,
    top: r,
    bottom: o,
    showProgress: i,
    pauseOnHover: a
  };
}
const VN = /* @__PURE__ */ ee.forwardRef((e, t) => {
  const {
    notificationConfig: n,
    sync: r
  } = e, {
    getPrefixCls: o
  } = Kt(kt), i = Ki.prefixCls || o("notification"), a = Kt(_$), [s, l] = Um(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: i
  }), a.notification));
  return ee.useEffect(r, []), ee.useImperativeHandle(t, () => {
    const c = Object.assign({}, s);
    return Object.keys(c).forEach((u) => {
      c[u] = function() {
        return r(), s[u].apply(s, arguments);
      };
    }), {
      instance: c,
      sync: r
    };
  }), l;
}), zN = /* @__PURE__ */ ee.forwardRef((e, t) => {
  const [n, r] = ee.useState(Wv), o = () => {
    r(Wv);
  };
  ee.useEffect(o, []);
  const i = im(), a = i.getRootPrefixCls(), s = i.getIconPrefixCls(), l = i.getTheme(), c = /* @__PURE__ */ ee.createElement(VN, {
    ref: t,
    sync: o,
    notificationConfig: n
  });
  return /* @__PURE__ */ ee.createElement(Wr, {
    prefixCls: a,
    iconPrefixCls: s,
    theme: l
  }, i.holderRender ? i.holderRender(c) : c);
});
function pd() {
  if (!Hn) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    Hn = t, ts(() => {
      gm()(/* @__PURE__ */ ee.createElement(zN, {
        ref: (r) => {
          const {
            instance: o,
            sync: i
          } = r || {};
          Promise.resolve().then(() => {
            !t.instance && o && (t.instance = o, t.sync = i, pd());
          });
        }
      }), e);
    });
    return;
  }
  Hn.instance && (_s.forEach((e) => {
    switch (e.type) {
      case "open": {
        ts(() => {
          Hn.instance.open(Object.assign(Object.assign({}, Ki), e.config));
        });
        break;
      }
      case "destroy":
        ts(() => {
          Hn == null || Hn.instance.destroy(e.key);
        });
        break;
    }
  }), _s = []);
}
function HN(e) {
  Ki = Object.assign(Object.assign({}, Ki), e), ts(() => {
    var t;
    (t = Hn == null ? void 0 : Hn.sync) === null || t === void 0 || t.call(Hn);
  });
}
function P0(e) {
  const t = im();
  z.env.NODE_ENV !== "production" && !t.holderRender && FO("notification"), _s.push({
    type: "open",
    config: e
  }), pd();
}
const UN = (e) => {
  _s.push({
    type: "destroy",
    key: e
  }), pd();
}, WN = ["success", "info", "warning", "error"], qN = {
  open: P0,
  destroy: UN,
  config: HN,
  useNotification: E$,
  _InternalPanelDoNotUseOrYouWillBeFired: g$
}, kr = qN;
WN.forEach((e) => {
  kr[e] = (t) => P0(Object.assign(Object.assign({}, t), {
    type: e
  }));
});
z.env.NODE_ENV;
z.env.NODE_ENV;
var cn = function() {
  return cn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, cn.apply(this, arguments);
};
function Yo(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function GN(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var KN = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, XN = /* @__PURE__ */ GN(
  function(e) {
    return KN.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), It = "-ms-", Ni = "-moz-", vt = "-webkit-", I0 = "comm", al = "rule", hd = "decl", YN = "@import", T0 = "@keyframes", ZN = "@layer", $0 = Math.abs, md = String.fromCharCode, bu = Object.assign;
function QN(e, t) {
  return tn(e, 0) ^ 45 ? (((t << 2 ^ tn(e, 0)) << 2 ^ tn(e, 1)) << 2 ^ tn(e, 2)) << 2 ^ tn(e, 3) : 0;
}
function R0(e) {
  return e.trim();
}
function gr(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ge(e, t, n) {
  return e.replace(t, n);
}
function ns(e, t, n) {
  return e.indexOf(t, n);
}
function tn(e, t) {
  return e.charCodeAt(t) | 0;
}
function Zo(e, t, n) {
  return e.slice(t, n);
}
function nr(e) {
  return e.length;
}
function N0(e) {
  return e.length;
}
function Oi(e, t) {
  return t.push(e), e;
}
function JN(e, t) {
  return e.map(t).join("");
}
function qv(e, t) {
  return e.filter(function(n) {
    return !gr(n, t);
  });
}
var sl = 1, Qo = 1, A0 = 0, Fn = 0, zt = 0, si = "";
function ll(e, t, n, r, o, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: sl, column: Qo, length: a, return: "", siblings: s };
}
function Mr(e, t) {
  return bu(ll("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, t);
}
function To(e) {
  for (; e.root; )
    e = Mr(e.root, { children: [e] });
  Oi(e, e.siblings);
}
function e2() {
  return zt;
}
function t2() {
  return zt = Fn > 0 ? tn(si, --Fn) : 0, Qo--, zt === 10 && (Qo = 1, sl--), zt;
}
function Gn() {
  return zt = Fn < A0 ? tn(si, Fn++) : 0, Qo++, zt === 10 && (Qo = 1, sl++), zt;
}
function no() {
  return tn(si, Fn);
}
function rs() {
  return Fn;
}
function cl(e, t) {
  return Zo(si, e, t);
}
function Cu(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function n2(e) {
  return sl = Qo = 1, A0 = nr(si = e), Fn = 0, [];
}
function r2(e) {
  return si = "", e;
}
function Zl(e) {
  return R0(cl(Fn - 1, wu(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function o2(e) {
  for (; (zt = no()) && zt < 33; )
    Gn();
  return Cu(e) > 2 || Cu(zt) > 3 ? "" : " ";
}
function i2(e, t) {
  for (; --t && Gn() && !(zt < 48 || zt > 102 || zt > 57 && zt < 65 || zt > 70 && zt < 97); )
    ;
  return cl(e, rs() + (t < 6 && no() == 32 && Gn() == 32));
}
function wu(e) {
  for (; Gn(); )
    switch (zt) {
      case e:
        return Fn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && wu(zt);
        break;
      case 40:
        e === 41 && wu(e);
        break;
      case 92:
        Gn();
        break;
    }
  return Fn;
}
function a2(e, t) {
  for (; Gn() && e + zt !== 57; )
    if (e + zt === 84 && no() === 47)
      break;
  return "/*" + cl(t, Fn - 1) + "*" + md(e === 47 ? e : Gn());
}
function s2(e) {
  for (; !Cu(no()); )
    Gn();
  return cl(e, Fn);
}
function l2(e) {
  return r2(os("", null, null, null, [""], e = n2(e), 0, [0], e));
}
function os(e, t, n, r, o, i, a, s, l) {
  for (var c = 0, u = 0, d = a, f = 0, g = 0, h = 0, y = 1, p = 1, C = 1, m = 0, b = "", w = o, E = i, S = r, _ = b; p; )
    switch (h = m, m = Gn()) {
      case 40:
        if (h != 108 && tn(_, d - 1) == 58) {
          ns(_ += Ge(Zl(m), "&", "&\f"), "&\f", $0(c ? s[c - 1] : 0)) != -1 && (C = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Zl(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += o2(h);
        break;
      case 92:
        _ += i2(rs() - 1, 7);
        continue;
      case 47:
        switch (no()) {
          case 42:
          case 47:
            Oi(c2(a2(Gn(), rs()), t, n, l), l);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * y:
        s[c++] = nr(_) * C;
      case 125 * y:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            p = 0;
          case 59 + u:
            C == -1 && (_ = Ge(_, /\f/g, "")), g > 0 && nr(_) - d && Oi(g > 32 ? Kv(_ + ";", r, n, d - 1, l) : Kv(Ge(_, " ", "") + ";", r, n, d - 2, l), l);
            break;
          case 59:
            _ += ";";
          default:
            if (Oi(S = Gv(_, t, n, c, u, o, s, b, w = [], E = [], d, i), i), m === 123)
              if (u === 0)
                os(_, t, S, S, w, i, d, s, E);
              else
                switch (f === 99 && tn(_, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    os(e, S, S, r && Oi(Gv(e, S, S, 0, 0, o, s, b, o, w = [], d, E), E), o, E, d, s, r ? w : E);
                    break;
                  default:
                    os(_, S, S, S, [""], E, 0, s, E);
                }
        }
        c = u = g = 0, y = C = 1, b = _ = "", d = a;
        break;
      case 58:
        d = 1 + nr(_), g = h;
      default:
        if (y < 1) {
          if (m == 123)
            --y;
          else if (m == 125 && y++ == 0 && t2() == 125)
            continue;
        }
        switch (_ += md(m), m * y) {
          case 38:
            C = u > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            s[c++] = (nr(_) - 1) * C, C = 1;
            break;
          case 64:
            no() === 45 && (_ += Zl(Gn())), f = no(), u = d = nr(b = _ += s2(rs())), m++;
            break;
          case 45:
            h === 45 && nr(_) == 2 && (y = 0);
        }
    }
  return i;
}
function Gv(e, t, n, r, o, i, a, s, l, c, u, d) {
  for (var f = o - 1, g = o === 0 ? i : [""], h = N0(g), y = 0, p = 0, C = 0; y < r; ++y)
    for (var m = 0, b = Zo(e, f + 1, f = $0(p = a[y])), w = e; m < h; ++m)
      (w = R0(p > 0 ? g[m] + " " + b : Ge(b, /&\f/g, g[m]))) && (l[C++] = w);
  return ll(e, t, n, o === 0 ? al : s, l, c, u, d);
}
function c2(e, t, n, r) {
  return ll(e, t, n, I0, md(e2()), Zo(e, 2, -2), 0, r);
}
function Kv(e, t, n, r, o) {
  return ll(e, t, n, hd, Zo(e, 0, r), Zo(e, r + 1, -1), r, o);
}
function k0(e, t, n) {
  switch (QN(e, t)) {
    case 5103:
      return vt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return vt + e + e;
    case 4789:
      return Ni + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return vt + e + Ni + e + It + e + e;
    case 5936:
      switch (tn(e, t + 11)) {
        case 114:
          return vt + e + It + Ge(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return vt + e + It + Ge(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return vt + e + It + Ge(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return vt + e + It + e + e;
    case 6165:
      return vt + e + It + "flex-" + e + e;
    case 5187:
      return vt + e + Ge(e, /(\w+).+(:[^]+)/, vt + "box-$1$2" + It + "flex-$1$2") + e;
    case 5443:
      return vt + e + It + "flex-item-" + Ge(e, /flex-|-self/g, "") + (gr(e, /flex-|baseline/) ? "" : It + "grid-row-" + Ge(e, /flex-|-self/g, "")) + e;
    case 4675:
      return vt + e + It + "flex-line-pack" + Ge(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return vt + e + It + Ge(e, "shrink", "negative") + e;
    case 5292:
      return vt + e + It + Ge(e, "basis", "preferred-size") + e;
    case 6060:
      return vt + "box-" + Ge(e, "-grow", "") + vt + e + It + Ge(e, "grow", "positive") + e;
    case 4554:
      return vt + Ge(e, /([^-])(transform)/g, "$1" + vt + "$2") + e;
    case 6187:
      return Ge(Ge(Ge(e, /(zoom-|grab)/, vt + "$1"), /(image-set)/, vt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ge(e, /(image-set\([^]*)/, vt + "$1$`$1");
    case 4968:
      return Ge(Ge(e, /(.+:)(flex-)?(.*)/, vt + "box-pack:$3" + It + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + vt + e + e;
    case 4200:
      if (!gr(e, /flex-|baseline/))
        return It + "grid-column-align" + Zo(e, t) + e;
      break;
    case 2592:
    case 3360:
      return It + Ge(e, "template-", "") + e;
    case 4384:
    case 3616:
      return n && n.some(function(r, o) {
        return t = o, gr(r.props, /grid-\w+-end/);
      }) ? ~ns(e + (n = n[t].value), "span", 0) ? e : It + Ge(e, "-start", "") + e + It + "grid-row-span:" + (~ns(n, "span", 0) ? gr(n, /\d+/) : +gr(n, /\d+/) - +gr(e, /\d+/)) + ";" : It + Ge(e, "-start", "") + e;
    case 4896:
    case 4128:
      return n && n.some(function(r) {
        return gr(r.props, /grid-\w+-start/);
      }) ? e : It + Ge(Ge(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ge(e, /(.+)-inline(.+)/, vt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (nr(e) - 1 - t > 6)
        switch (tn(e, t + 1)) {
          case 109:
            if (tn(e, t + 4) !== 45)
              break;
          case 102:
            return Ge(e, /(.+:)(.+)-([^]+)/, "$1" + vt + "$2-$3$1" + Ni + (tn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ns(e, "stretch", 0) ? k0(Ge(e, "stretch", "fill-available"), t, n) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return Ge(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, o, i, a, s, l, c) {
        return It + o + ":" + i + c + (a ? It + o + "-span:" + (s ? l : +l - +i) + c : "") + e;
      });
    case 4949:
      if (tn(e, t + 6) === 121)
        return Ge(e, ":", ":" + vt) + e;
      break;
    case 6444:
      switch (tn(e, tn(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return Ge(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + vt + (tn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + vt + "$2$3$1" + It + "$2box$3") + e;
        case 100:
          return Ge(e, ":", ":" + It) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Ge(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function xs(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function u2(e, t, n, r) {
  switch (e.type) {
    case ZN:
      if (e.children.length)
        break;
    case YN:
    case hd:
      return e.return = e.return || e.value;
    case I0:
      return "";
    case T0:
      return e.return = e.value + "{" + xs(e.children, r) + "}";
    case al:
      if (!nr(e.value = e.props.join(",")))
        return "";
  }
  return nr(n = xs(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function d2(e) {
  var t = N0(e);
  return function(n, r, o, i) {
    for (var a = "", s = 0; s < t; s++)
      a += e[s](n, r, o, i) || "";
    return a;
  };
}
function f2(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function v2(e, t, n, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case hd:
        e.return = k0(e.value, e.length, n);
        return;
      case T0:
        return xs([Mr(e, { value: Ge(e.value, "@", "@" + vt) })], r);
      case al:
        if (e.length)
          return JN(n = e.props, function(o) {
            switch (gr(o, r = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                To(Mr(e, { props: [Ge(o, /:(read-\w+)/, ":" + Ni + "$1")] })), To(Mr(e, { props: [o] })), bu(e, { props: qv(n, r) });
                break;
              case "::placeholder":
                To(Mr(e, { props: [Ge(o, /:(plac\w+)/, ":" + vt + "input-$1")] })), To(Mr(e, { props: [Ge(o, /:(plac\w+)/, ":" + Ni + "$1")] })), To(Mr(e, { props: [Ge(o, /:(plac\w+)/, It + "input-$1")] })), To(Mr(e, { props: [o] })), bu(e, { props: qv(n, r) });
                break;
            }
            return "";
          });
    }
}
var g2 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ao = typeof z < "u" && z.env !== void 0 && (z.env.REACT_APP_SC_ATTR || z.env.SC_ATTR) || "data-styled", M0 = "active", L0 = "data-styled-version", ul = "6.1.12", yd = `/*!sc*/
`, Os = typeof window < "u" && "HTMLElement" in window, p2 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof z < "u" && z.env !== void 0 && z.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && z.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? z.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && z.env.REACT_APP_SC_DISABLE_SPEEDY : typeof z < "u" && z.env !== void 0 && z.env.SC_DISABLE_SPEEDY !== void 0 && z.env.SC_DISABLE_SPEEDY !== "" ? z.env.SC_DISABLE_SPEEDY !== "false" && z.env.SC_DISABLE_SPEEDY : z.env.NODE_ENV !== "production"), Xv = /invalid hook call/i, Na = /* @__PURE__ */ new Set(), h2 = function(e, t) {
  if (z.env.NODE_ENV !== "production") {
    var n = t ? ' with the id of "'.concat(t, '"') : "", r = "The component ".concat(e).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, o = console.error;
    try {
      var i = !0;
      console.error = function(a) {
        for (var s = [], l = 1; l < arguments.length; l++)
          s[l - 1] = arguments[l];
        Xv.test(a) ? (i = !1, Na.delete(r)) : o.apply(void 0, Yo([a], s, !1));
      }, st(), i && !Na.has(r) && (console.warn(r), Na.add(r));
    } catch (a) {
      Xv.test(a.message) && Na.delete(r);
    } finally {
      console.error = o;
    }
  }
}, dl = Object.freeze([]), Jo = Object.freeze({});
function m2(e, t, n) {
  return n === void 0 && (n = Jo), e.theme !== n.theme && e.theme || t || n.theme;
}
var Su = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), y2 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, b2 = /(^-|-$)/g;
function Yv(e) {
  return e.replace(y2, "-").replace(b2, "");
}
var C2 = /(a)(d)/gi, Aa = 52, Zv = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Eu(e) {
  var t, n = "";
  for (t = Math.abs(e); t > Aa; t = t / Aa | 0)
    n = Zv(t % Aa) + n;
  return (Zv(t % Aa) + n).replace(C2, "$1-$2");
}
var Ql, D0 = 5381, Yr = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, F0 = function(e) {
  return Yr(D0, e);
};
function w2(e) {
  return Eu(F0(e) >>> 0);
}
function j0(e) {
  return z.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Jl(e) {
  return typeof e == "string" && (z.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var B0 = typeof Symbol == "function" && Symbol.for, V0 = B0 ? Symbol.for("react.memo") : 60115, S2 = B0 ? Symbol.for("react.forward_ref") : 60112, E2 = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, _2 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, z0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, x2 = ((Ql = {})[S2] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, Ql[V0] = z0, Ql);
function Qv(e) {
  return ("type" in (t = e) && t.type.$$typeof) === V0 ? z0 : "$$typeof" in e ? x2[e.$$typeof] : E2;
  var t;
}
var O2 = Object.defineProperty, P2 = Object.getOwnPropertyNames, Jv = Object.getOwnPropertySymbols, I2 = Object.getOwnPropertyDescriptor, T2 = Object.getPrototypeOf, eg = Object.prototype;
function H0(e, t, n) {
  if (typeof t != "string") {
    if (eg) {
      var r = T2(t);
      r && r !== eg && H0(e, r, n);
    }
    var o = P2(t);
    Jv && (o = o.concat(Jv(t)));
    for (var i = Qv(e), a = Qv(t), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!(l in _2 || n && n[l] || a && l in a || i && l in i)) {
        var c = I2(t, l);
        try {
          O2(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
function so(e) {
  return typeof e == "function";
}
function bd(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function Jr(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function tg(e, t) {
  if (e.length === 0)
    return "";
  for (var n = e[0], r = 1; r < e.length; r++)
    n += e[r];
  return n;
}
function ei(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function _u(e, t, n) {
  if (n === void 0 && (n = !1), !n && !ei(e) && !Array.isArray(e))
    return t;
  if (Array.isArray(t))
    for (var r = 0; r < t.length; r++)
      e[r] = _u(e[r], t[r]);
  else if (ei(t))
    for (var r in t)
      e[r] = _u(e[r], t[r]);
  return e;
}
function Cd(e, t) {
  Object.defineProperty(e, "toString", { value: t });
}
var $2 = z.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function R2() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e[0], r = [], o = 1, i = e.length; o < i; o += 1)
    r.push(e[o]);
  return r.forEach(function(a) {
    n = n.replace(/%[a-z]/, a);
  }), n;
}
function br(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return z.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : "")) : new Error(R2.apply(void 0, Yo([$2[e]], t, !1)).trim());
}
var N2 = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  return e.prototype.indexOfGroup = function(t) {
    for (var n = 0, r = 0; r < t; r++)
      n += this.groupSizes[r];
    return n;
  }, e.prototype.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var r = this.groupSizes, o = r.length, i = o; t >= i; )
        if ((i <<= 1) < 0)
          throw br(16, "".concat(t));
      this.groupSizes = new Uint32Array(i), this.groupSizes.set(r), this.length = i;
      for (var a = o; a < i; a++)
        this.groupSizes[a] = 0;
    }
    for (var s = this.indexOfGroup(t + 1), l = (a = 0, n.length); a < l; a++)
      this.tag.insertRule(s, n[a]) && (this.groupSizes[t]++, s++);
  }, e.prototype.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], r = this.indexOfGroup(t), o = r + n;
      this.groupSizes[t] = 0;
      for (var i = r; i < o; i++)
        this.tag.deleteRule(r);
    }
  }, e.prototype.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var r = this.groupSizes[t], o = this.indexOfGroup(t), i = o + r, a = o; a < i; a++)
      n += "".concat(this.tag.getRule(a)).concat(yd);
    return n;
  }, e;
}(), A2 = 1 << 30, is = /* @__PURE__ */ new Map(), Ps = /* @__PURE__ */ new Map(), as = 1, ka = function(e) {
  if (is.has(e))
    return is.get(e);
  for (; Ps.has(as); )
    as++;
  var t = as++;
  if (z.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > A2))
    throw br(16, "".concat(t));
  return is.set(e, t), Ps.set(t, e), t;
}, k2 = function(e, t) {
  as = t + 1, is.set(e, t), Ps.set(t, e);
}, M2 = "style[".concat(ao, "][").concat(L0, '="').concat(ul, '"]'), L2 = new RegExp("^".concat(ao, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), D2 = function(e, t, n) {
  for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++)
    (r = o[i]) && e.registerName(t, r);
}, F2 = function(e, t) {
  for (var n, r = ((n = t.textContent) !== null && n !== void 0 ? n : "").split(yd), o = [], i = 0, a = r.length; i < a; i++) {
    var s = r[i].trim();
    if (s) {
      var l = s.match(L2);
      if (l) {
        var c = 0 | parseInt(l[1], 10), u = l[2];
        c !== 0 && (k2(u, c), D2(e, u, l[3]), e.getTag().insertRules(c, o)), o.length = 0;
      } else
        o.push(s);
    }
  }
}, ng = function(e) {
  for (var t = document.querySelectorAll(M2), n = 0, r = t.length; n < r; n++) {
    var o = t[n];
    o && o.getAttribute(ao) !== M0 && (F2(e, o), o.parentNode && o.parentNode.removeChild(o));
  }
};
function j2() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var U0 = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), o = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(ao, "]")));
    return l[l.length - 1];
  }(n), i = o !== void 0 ? o.nextSibling : null;
  r.setAttribute(ao, M0), r.setAttribute(L0, ul);
  var a = j2();
  return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
}, B2 = function() {
  function e(t) {
    this.element = U0(t), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var r = document.styleSheets, o = 0, i = r.length; o < i; o++) {
        var a = r[o];
        if (a.ownerNode === n)
          return a;
      }
      throw br(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, e.prototype.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n && n.cssText ? n.cssText : "";
  }, e;
}(), V2 = function() {
  function e(t) {
    this.element = U0(t), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var r = document.createTextNode(n);
      return this.element.insertBefore(r, this.nodes[t] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), z2 = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, e.prototype.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, e.prototype.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), rg = Os, H2 = { isServer: !Os, useCSSOMInjection: !p2 }, W0 = function() {
  function e(t, n, r) {
    t === void 0 && (t = Jo), n === void 0 && (n = {});
    var o = this;
    this.options = cn(cn({}, H2), t), this.gs = n, this.names = new Map(r), this.server = !!t.isServer, !this.server && Os && rg && (rg = !1, ng(this)), Cd(this, function() {
      return function(i) {
        for (var a = i.getTag(), s = a.length, l = "", c = function(d) {
          var f = function(C) {
            return Ps.get(C);
          }(d);
          if (f === void 0)
            return "continue";
          var g = i.names.get(f), h = a.getGroup(d);
          if (g === void 0 || !g.size || h.length === 0)
            return "continue";
          var y = "".concat(ao, ".g").concat(d, '[id="').concat(f, '"]'), p = "";
          g !== void 0 && g.forEach(function(C) {
            C.length > 0 && (p += "".concat(C, ","));
          }), l += "".concat(h).concat(y, '{content:"').concat(p, '"}').concat(yd);
        }, u = 0; u < s; u++)
          c(u);
        return l;
      }(o);
    });
  }
  return e.registerId = function(t) {
    return ka(t);
  }, e.prototype.rehydrate = function() {
    !this.server && Os && ng(this);
  }, e.prototype.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(cn(cn({}, this.options), t), this.gs, n && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (t = function(n) {
      var r = n.useCSSOMInjection, o = n.target;
      return n.isServer ? new z2(o) : r ? new B2(o) : new V2(o);
    }(this.options), new N2(t)));
    var t;
  }, e.prototype.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, e.prototype.registerName = function(t, n) {
    if (ka(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(n), this.names.set(t, r);
    }
  }, e.prototype.insertRules = function(t, n, r) {
    this.registerName(t, n), this.getTag().insertRules(ka(t), r);
  }, e.prototype.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, e.prototype.clearRules = function(t) {
    this.getTag().clearGroup(ka(t)), this.clearNames(t);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), U2 = /&/g, W2 = /^\s*\/\/.*$/gm;
function q0(e, t) {
  return e.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(t, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(t, " ")), n.props = n.props.map(function(r) {
      return "".concat(t, " ").concat(r);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = q0(n.children, t)), n;
  });
}
function q2(e) {
  var t, n, r, o = Jo, i = o.options, a = i === void 0 ? Jo : i, s = o.plugins, l = s === void 0 ? dl : s, c = function(f, g, h) {
    return h.startsWith(n) && h.endsWith(n) && h.replaceAll(n, "").length > 0 ? ".".concat(t) : f;
  }, u = l.slice();
  u.push(function(f) {
    f.type === al && f.value.includes("&") && (f.props[0] = f.props[0].replace(U2, n).replace(r, c));
  }), a.prefix && u.push(v2), u.push(u2);
  var d = function(f, g, h, y) {
    g === void 0 && (g = ""), h === void 0 && (h = ""), y === void 0 && (y = "&"), t = y, n = g, r = new RegExp("\\".concat(n, "\\b"), "g");
    var p = f.replace(W2, ""), C = l2(h || g ? "".concat(h, " ").concat(g, " { ").concat(p, " }") : p);
    a.namespace && (C = q0(C, a.namespace));
    var m = [];
    return xs(C, d2(u.concat(f2(function(b) {
      return m.push(b);
    })))), m;
  };
  return d.hash = l.length ? l.reduce(function(f, g) {
    return g.name || br(15), Yr(f, g.name);
  }, D0).toString() : "", d;
}
var G2 = new W0(), xu = q2(), G0 = ee.createContext({ shouldForwardProp: void 0, styleSheet: G2, stylis: xu });
G0.Consumer;
ee.createContext(void 0);
function og() {
  return Kt(G0);
}
var ig = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(o, i) {
      i === void 0 && (i = xu);
      var a = r.name + i.hash;
      o.hasNameForId(r.id, a) || o.insertRules(r.id, a, i(r.rules, a, "@keyframes"));
    }, this.name = t, this.id = "sc-keyframes-".concat(t), this.rules = n, Cd(this, function() {
      throw br(12, String(r.name));
    });
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = xu), this.name + t.hash;
  }, e;
}(), K2 = function(e) {
  return e >= "A" && e <= "Z";
};
function ag(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var r = e[n];
    if (n === 1 && r === "-" && e[0] === "-")
      return e;
    K2(r) ? t += "-" + r.toLowerCase() : t += r;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var K0 = function(e) {
  return e == null || e === !1 || e === "";
}, X0 = function(e) {
  var t, n, r = [];
  for (var o in e) {
    var i = e[o];
    e.hasOwnProperty(o) && !K0(i) && (Array.isArray(i) && i.isCss || so(i) ? r.push("".concat(ag(o), ":"), i, ";") : ei(i) ? r.push.apply(r, Yo(Yo(["".concat(o, " {")], X0(i), !1), ["}"], !1)) : r.push("".concat(ag(o), ": ").concat((t = o, (n = i) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || t in g2 || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return r;
};
function ro(e, t, n, r) {
  if (K0(e))
    return [];
  if (bd(e))
    return [".".concat(e.styledComponentId)];
  if (so(e)) {
    if (!so(i = e) || i.prototype && i.prototype.isReactComponent || !t)
      return [e];
    var o = e(t);
    return z.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || o instanceof ig || ei(o) || o === null || console.error("".concat(j0(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), ro(o, t, n, r);
  }
  var i;
  return e instanceof ig ? n ? (e.inject(n, r), [e.getName(r)]) : [e] : ei(e) ? X0(e) : Array.isArray(e) ? Array.prototype.concat.apply(dl, e.map(function(a) {
    return ro(a, t, n, r);
  })) : [e.toString()];
}
function X2(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (so(n) && !bd(n))
      return !1;
  }
  return !0;
}
var Y2 = F0(ul), Z2 = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = z.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && X2(t), this.componentId = n, this.baseHash = Yr(Y2, n), this.baseStyle = r, W0.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(t, n, r) : "";
    if (this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        o = Jr(o, this.staticRulesId);
      else {
        var i = tg(ro(this.rules, t, n, r)), a = Eu(Yr(this.baseHash, i) >>> 0);
        if (!n.hasNameForId(this.componentId, a)) {
          var s = r(i, ".".concat(a), void 0, this.componentId);
          n.insertRules(this.componentId, a, s);
        }
        o = Jr(o, a), this.staticRulesId = a;
      }
    else {
      for (var l = Yr(this.baseHash, r.hash), c = "", u = 0; u < this.rules.length; u++) {
        var d = this.rules[u];
        if (typeof d == "string")
          c += d, z.env.NODE_ENV !== "production" && (l = Yr(l, d));
        else if (d) {
          var f = tg(ro(d, t, n, r));
          l = Yr(l, f + u), c += f;
        }
      }
      if (c) {
        var g = Eu(l >>> 0);
        n.hasNameForId(this.componentId, g) || n.insertRules(this.componentId, g, r(c, ".".concat(g), void 0, this.componentId)), o = Jr(o, g);
      }
    }
    return o;
  }, e;
}(), Is = ee.createContext(void 0);
Is.Consumer;
function Q2(e) {
  var t = ee.useContext(Is), n = Kn(function() {
    return function(r, o) {
      if (!r)
        throw br(14);
      if (so(r)) {
        var i = r(o);
        if (z.env.NODE_ENV !== "production" && (i === null || Array.isArray(i) || typeof i != "object"))
          throw br(7);
        return i;
      }
      if (Array.isArray(r) || typeof r != "object")
        throw br(8);
      return o ? cn(cn({}, o), r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? ee.createElement(Is.Provider, { value: n }, e.children) : null;
}
var ec = {}, sg = /* @__PURE__ */ new Set();
function J2(e, t, n) {
  var r = bd(e), o = e, i = !Jl(e), a = t.attrs, s = a === void 0 ? dl : a, l = t.componentId, c = l === void 0 ? function(w, E) {
    var S = typeof w != "string" ? "sc" : Yv(w);
    ec[S] = (ec[S] || 0) + 1;
    var _ = "".concat(S, "-").concat(w2(ul + S + ec[S]));
    return E ? "".concat(E, "-").concat(_) : _;
  }(t.displayName, t.parentComponentId) : l, u = t.displayName, d = u === void 0 ? function(w) {
    return Jl(w) ? "styled.".concat(w) : "Styled(".concat(j0(w), ")");
  }(e) : u, f = t.displayName && t.componentId ? "".concat(Yv(t.displayName), "-").concat(t.componentId) : t.componentId || c, g = r && o.attrs ? o.attrs.concat(s).filter(Boolean) : s, h = t.shouldForwardProp;
  if (r && o.shouldForwardProp) {
    var y = o.shouldForwardProp;
    if (t.shouldForwardProp) {
      var p = t.shouldForwardProp;
      h = function(w, E) {
        return y(w, E) && p(w, E);
      };
    } else
      h = y;
  }
  var C = new Z2(n, f, r ? o.componentStyle : void 0);
  function m(w, E) {
    return function(S, _, O) {
      var P = S.attrs, $ = S.componentStyle, L = S.defaultProps, N = S.foldedComponentIds, k = S.styledComponentId, F = S.target, U = ee.useContext(Is), A = og(), R = S.shouldForwardProp || A.shouldForwardProp;
      z.env.NODE_ENV !== "production" && Sd(k);
      var D = m2(_, U, L) || Jo, B = function(J, ie, le) {
        for (var ne, te = cn(cn({}, ie), { className: void 0, theme: le }), re = 0; re < J.length; re += 1) {
          var _e = so(ne = J[re]) ? ne(te) : ne;
          for (var me in _e)
            te[me] = me === "className" ? Jr(te[me], _e[me]) : me === "style" ? cn(cn({}, te[me]), _e[me]) : _e[me];
        }
        return ie.className && (te.className = Jr(te.className, ie.className)), te;
      }(P, _, D), M = B.as || F, G = {};
      for (var H in B)
        B[H] === void 0 || H[0] === "$" || H === "as" || H === "theme" && B.theme === D || (H === "forwardedAs" ? G.as = B.forwardedAs : R && !R(H, M) || (G[H] = B[H], R || z.env.NODE_ENV !== "development" || XN(H) || sg.has(H) || !Su.has(M) || (sg.add(H), console.warn('styled-components: it looks like an unknown prop "'.concat(H, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var X = function(J, ie) {
        var le = og(), ne = J.generateAndInjectStyles(ie, le.styleSheet, le.stylis);
        return z.env.NODE_ENV !== "production" && Sd(ne), ne;
      }($, B);
      z.env.NODE_ENV !== "production" && S.warnTooManyClasses && S.warnTooManyClasses(X);
      var K = Jr(N, k);
      return X && (K += " " + X), B.className && (K += " " + B.className), G[Jl(M) && !Su.has(M) ? "class" : "className"] = K, G.ref = O, Dy(M, G);
    }(b, w, E);
  }
  m.displayName = d;
  var b = ee.forwardRef(m);
  return b.attrs = g, b.componentStyle = C, b.displayName = d, b.shouldForwardProp = h, b.foldedComponentIds = r ? Jr(o.foldedComponentIds, o.styledComponentId) : "", b.styledComponentId = f, b.target = r ? o.target : e, Object.defineProperty(b, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(w) {
    this._foldedDefaultProps = r ? function(E) {
      for (var S = [], _ = 1; _ < arguments.length; _++)
        S[_ - 1] = arguments[_];
      for (var O = 0, P = S; O < P.length; O++)
        _u(E, P[O], !0);
      return E;
    }({}, o.defaultProps, w) : w;
  } }), z.env.NODE_ENV !== "production" && (h2(d, f), b.warnTooManyClasses = /* @__PURE__ */ function(w, E) {
    var S = {}, _ = !1;
    return function(O) {
      if (!_ && (S[O] = !0, Object.keys(S).length >= 200)) {
        var P = E ? ' with the id of "'.concat(E, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(w).concat(P, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), _ = !0, S = {};
      }
    };
  }(d, f)), Cd(b, function() {
    return ".".concat(b.styledComponentId);
  }), i && H0(b, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), b;
}
function lg(e, t) {
  for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}
var cg = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function Y0(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  if (so(e) || ei(e))
    return cg(ro(lg(dl, Yo([e], t, !0))));
  var r = e;
  return t.length === 0 && r.length === 1 && typeof r[0] == "string" ? ro(r) : cg(ro(lg(r, t)));
}
function Ou(e, t, n) {
  if (n === void 0 && (n = Jo), !t)
    throw br(1, t);
  var r = function(o) {
    for (var i = [], a = 1; a < arguments.length; a++)
      i[a - 1] = arguments[a];
    return e(t, n, Y0.apply(void 0, Yo([o], i, !1)));
  };
  return r.attrs = function(o) {
    return Ou(e, t, cn(cn({}, n), { attrs: Array.prototype.concat(n.attrs, o).filter(Boolean) }));
  }, r.withConfig = function(o) {
    return Ou(e, t, cn(cn({}, n), o));
  }, r;
}
var Z0 = function(e) {
  return Ou(J2, e);
}, un = Z0;
Su.forEach(function(e) {
  un[e] = Z0(e);
});
z.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var Ma = "__sc-".concat(ao, "__");
z.env.NODE_ENV !== "production" && z.env.NODE_ENV !== "test" && typeof window < "u" && (window[Ma] || (window[Ma] = 0), window[Ma] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[Ma] += 1);
const Lr = {
  0: "#FFFFFF",
  10: "#F3F4F6",
  20: "#DFE2E7",
  30: "#C2C7D0",
  40: "#A3A9B9",
  50: "#868CA2",
  60: "#696F88",
  70: "#4D5165",
  80: "#363948",
  90: "#232630",
  100: "#14151C"
}, eA = un(s0)`
  cursor: default;
  border: 1px solid ${Lr[20]};
  background-color: ${Lr[10]};

  ${({
  $pressed: e
}) => e !== void 0 && `
      transition: color 300ms ease-in-out, border-color 300ms ease-in-out,
        background-color 300ms ease-in-out;
      border-color: ${e ? Lr[30] : Lr[20]};
      background-color: ${e ? Lr[20] : Lr[10]};
      &:hover {
        background-color: ${Lr[20]};
      }
    `}
`, Q0 = ({
  children: e,
  pressed: t,
  ...n
}) => /* @__PURE__ */ ue.jsx(eA, { ...n, $pressed: t, gap: 10, children: /* @__PURE__ */ ue.jsx("p", { style: {
  margin: 0,
  color: Lr[70]
}, children: e }) }), tA = un(ia)``, J0 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ ue.jsx(tA, { arrow: {
  pointAtCenter: !0
}, color: "#232630", overlayInnerStyle: {
  borderRadius: 4,
  ...t.overlayInnerStyle
}, ...t, children: e }), nA = un(tl)`
  border-radius: 4px;
`, rA = ({
  tooltipTitle: e,
  ...t
}) => {
  const n = /* @__PURE__ */ ue.jsx(nA, { ...t, className: se(t.className) });
  return e ? /* @__PURE__ */ ue.jsx(J0, { title: e, children: n }) : n;
}, oA = ({
  children: e,
  ...t
}) => /* @__PURE__ */ ue.jsx(nl, { overlayInnerStyle: {
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  borderRadius: 4,
  padding: 0,
  paddingTop: 6,
  background: "#fff",
  backgroundColor: "#fff",
  ...t.overlayInnerStyle
}, ...t, children: e }), iA = (e) => /* @__PURE__ */ v.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z", fill: "#696F88" })), aA = (e) => /* @__PURE__ */ v.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2L2 2L2 16L10 16V18H2C0.9 18 0 17.1 0 16V2C0 0.899999 0.900002 0 2 0H10L10 2ZM13.6 5.4L15 4L20 9L15 14L13.6 12.6L16.2 10H6V8H16.2L13.6 5.4Z", fill: "currentColor" })), ey = (e) => /* @__PURE__ */ v.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H12V18H4V8L12 13L20 8V13H22V6C22 4.9 21.1 4 20 4ZM12 11L4 6H20L12 11ZM17.34 22L13.8 18.46L15.21 17.05L17.33 19.17L21.57 14.93L23 16.34L17.34 22Z", fill: "#0092E4" })), ug = (e) => /* @__PURE__ */ v.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.75 1.75V12.25H12.25V7H13.75V12.25C13.75 13.075 13.075 13.75 12.25 13.75H1.75C0.9175 13.75 0.25 13.075 0.25 12.25V1.75C0.25 0.925 0.9175 0.25 1.75 0.25H7V1.75H1.75ZM8.5 1.75V0.25H13.75V5.5H12.25V2.8075L4.8775 10.18L3.82 9.1225L11.1925 1.75H8.5Z", fill: "#696F88" })), sA = (e) => /* @__PURE__ */ v.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ v.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 21.5L12 2.5L23 21.5H1ZM19.5297 19.4983L11.9997 6.48828L4.46973 19.4983H19.5297ZM11 16.5V18.5H13V16.5H11ZM11 10.5H13V14.5H11V10.5Z", fill: "#0092E4" })), lA = {}, cA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lA
}, Symbol.toStringTag, { value: "Module" })), uA = {}, dA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uA
}, Symbol.toStringTag, { value: "Module" })), fA = {}, vA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fA
}, Symbol.toStringTag, { value: "Module" })), gA = {}, pA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gA
}, Symbol.toStringTag, { value: "Module" })), ty = "Account", ny = {
  cw_logout: "Log out from Cropwise",
  cwlogout: "Log out",
  edit_profile: "Edit profile",
  legal_docs: "Legal documents"
}, ry = {
  input: {
    language_select: "Language"
  },
  unit_system: {
    canada: "Canada",
    imperial: "Imperial",
    label: "Unit system",
    metric: "Metric"
  }
}, oy = {
  error: {
    resending_email: "We couldn't resend your email, please try again later!"
  },
  verify: {
    access_email: "Access your e-mail account",
    click_link: "and click the link we've sent you",
    continue_having_access: "to continue to have access to Cropwise products",
    resend_button: "Resend e-mail",
    title: "Confirm your email"
  }
}, iy = {
  title: "Preferences"
}, ay = {
  log_out_all_apps: "Log Out from all Apps",
  log_out_all_cw_apps: "Log Out from all Cropwise Apps"
}, hA = {
  account: ty,
  button: ny,
  common: ry,
  notifications: oy,
  preferences: iy,
  tooltip: ay
}, mA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: ty,
  button: ny,
  common: ry,
  default: hA,
  notifications: oy,
  preferences: iy,
  tooltip: ay
}, Symbol.toStringTag, { value: "Module" })), sy = "Cuenta", ly = {
  cw_logout: "Salir de Cropwise",
  cwlogout: "Cerrar sesión",
  edit_profile: "Editar perfil",
  legal_docs: "Documentos legales"
}, cy = {
  input: {
    language_select: "Idioma"
  },
  unit_system: {
    canada: "Canadá",
    imperial: "Imperial",
    label: "Sistema de unidades",
    metric: "Métrico"
  }
}, uy = {
  error: {
    resending_email: "No hemos podido reenviarte el correo, inténtalo más tarde."
  },
  verify: {
    access_email: "Acceda a su cuenta de correo electrónico",
    click_link: "y haga clic en el enlace que le hemos enviado",
    continue_having_access: "seguir teniendo acceso a los productos de Cropwise",
    resend_button: "Reenviar el correo electrónico",
    title: "Confirme su correo electrónico"
  }
}, dy = {
  title: "Preferencias"
}, fy = {
  log_out_all_apps: "Cerrar sesión en todas las aplicaciones",
  log_out_all_cw_apps: "Cerrar sesión en todas las aplicaciones de Cropwise"
}, yA = {
  account: sy,
  button: ly,
  common: cy,
  notifications: uy,
  preferences: dy,
  tooltip: fy
}, bA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: sy,
  button: ly,
  common: cy,
  default: yA,
  notifications: uy,
  preferences: dy,
  tooltip: fy
}, Symbol.toStringTag, { value: "Module" })), vy = "Cuenta", gy = {
  cw_logout: "Cerrar sesión en Cropwise",
  cwlogout: "Cerrar sesión ",
  edit_profile: "Editar Perfil ",
  legal_docs: "Documentos legales "
}, py = {
  input: {
    language_select: "Idioma"
  },
  unit_system: {
    canada: "Canadá",
    imperial: "Imperial",
    label: "Sistema unitario",
    metric: "Sistema métrico"
  }
}, hy = {
  error: {
    resending_email: "No pudimos reenviar su correo electrónico, ¡inténtelo nuevamente más tarde!"
  },
  verify: {
    access_email: "Acceda a su cuenta de correo electrónico",
    click_link: "Y haz clic en el enlace que te hemos enviado",
    continue_having_access: "Para seguir teniendo acceso a los productos Cropwise",
    resend_button: "Reenviar el correo electrónico",
    title: "Confirme su email"
  }
}, my = {
  title: "Preferencias "
}, yy = {
  log_out_all_apps: "Cerrar sesión en todas las aplicaciones",
  log_out_all_cw_apps: "Cerrar sesión en todas las aplicaciones de Cropwise"
}, CA = {
  account: vy,
  button: gy,
  common: py,
  notifications: hy,
  preferences: my,
  tooltip: yy
}, wA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: vy,
  button: gy,
  common: py,
  default: CA,
  notifications: hy,
  preferences: my,
  tooltip: yy
}, Symbol.toStringTag, { value: "Module" })), by = "Compte", Cy = {
  cw_logout: "Se déconnecter de Cropwise",
  cwlogout: "Déconnexion",
  edit_profile: "Modifier le profil",
  legal_docs: "Documents légaux"
}, wy = {
  input: {
    language_select: "Langue"
  },
  unit_system: {
    canada: "Canada",
    imperial: "Impérial",
    label: "Unité de mesures",
    metric: "Métrique"
  }
}, Sy = {
  error: {
    resending_email: "Nous n'avons pas pu renvoyer votre e-mail, veuillez réessayer plus tard"
  },
  verify: {
    access_email: "Accédez à votre messagerie email",
    click_link: "et cliquez sur le lien que nous vous avons envoyé",
    continue_having_access: "pour continuer à avoir accès aux produits Cropwise",
    resend_button: "Renvoyer l'email",
    title: "Confirmez votre email"
  }
}, Ey = {
  title: "Préférences"
}, _y = {
  log_out_all_apps: "Déconnectez-vous de toutes les applications",
  log_out_all_cw_apps: "Déconnectez-vous de toutes les applications Cropwise"
}, SA = {
  account: by,
  button: Cy,
  common: wy,
  notifications: Sy,
  preferences: Ey,
  tooltip: _y
}, EA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: by,
  button: Cy,
  common: wy,
  default: SA,
  notifications: Sy,
  preferences: Ey,
  tooltip: _y
}, Symbol.toStringTag, { value: "Module" })), _A = {}, xA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _A
}, Symbol.toStringTag, { value: "Module" })), OA = {}, PA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: OA
}, Symbol.toStringTag, { value: "Module" })), IA = {}, TA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IA
}, Symbol.toStringTag, { value: "Module" })), $A = {}, RA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $A
}, Symbol.toStringTag, { value: "Module" })), NA = {}, AA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: NA
}, Symbol.toStringTag, { value: "Module" })), xy = "Conta", Oy = {
  cw_logout: "Sair de Cropwise",
  cwlogout: "Log out",
  edit_profile: "Editar perfil",
  legal_docs: "Documentos legais"
}, Py = {
  input: {
    language_select: "Idioma"
  },
  unit_system: {
    canada: "Canadá",
    imperial: "Imperial",
    label: "Sistema de medida",
    metric: "Métrico"
  }
}, Iy = {
  error: {
    resending_email: "Nós não conseguimos reenviar seu email, por favor tente novamente mais tarde!"
  },
  verify: {
    access_email: "Accesse sua conta de e-mail",
    click_link: "e clique no link que te mandamos",
    continue_having_access: "para continuar a usar os produtos Cropwise",
    resend_button: "Reenviar e-mail",
    title: "Confirme seu email"
  }
}, Ty = {
  title: "Preferências"
}, $y = {
  log_out_all_apps: "Log Out from all Apps",
  log_out_all_cw_apps: "Sair de todos os Apps Cropwise"
}, kA = {
  account: xy,
  button: Oy,
  common: Py,
  notifications: Iy,
  preferences: Ty,
  tooltip: $y
}, MA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  account: xy,
  button: Oy,
  common: Py,
  default: kA,
  notifications: Iy,
  preferences: Ty,
  tooltip: $y
}, Symbol.toStringTag, { value: "Module" })), LA = {}, DA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: LA
}, Symbol.toStringTag, { value: "Module" })), FA = {}, jA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FA
}, Symbol.toStringTag, { value: "Module" })), BA = {}, VA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: BA
}, Symbol.toStringTag, { value: "Module" }));
var Ry = { exports: {} };
(function(e) {
  (function() {
    function t(x, T, q) {
      return x.call.apply(x.bind, arguments);
    }
    function n(x, T, q) {
      if (!x)
        throw Error();
      if (2 < arguments.length) {
        var W = Array.prototype.slice.call(arguments, 2);
        return function() {
          var Y = Array.prototype.slice.call(arguments);
          return Array.prototype.unshift.apply(Y, W), x.apply(T, Y);
        };
      }
      return function() {
        return x.apply(T, arguments);
      };
    }
    function r(x, T, q) {
      return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? t : n, r.apply(null, arguments);
    }
    var o = Date.now || function() {
      return +/* @__PURE__ */ new Date();
    };
    function i(x, T) {
      this.a = x, this.o = T || x, this.c = this.o.document;
    }
    var a = !!window.FontFace;
    function s(x, T, q, W) {
      if (T = x.c.createElement(T), q)
        for (var Y in q)
          q.hasOwnProperty(Y) && (Y == "style" ? T.style.cssText = q[Y] : T.setAttribute(Y, q[Y]));
      return W && T.appendChild(x.c.createTextNode(W)), T;
    }
    function l(x, T, q) {
      x = x.c.getElementsByTagName(T)[0], x || (x = document.documentElement), x.insertBefore(q, x.lastChild);
    }
    function c(x) {
      x.parentNode && x.parentNode.removeChild(x);
    }
    function u(x, T, q) {
      T = T || [], q = q || [];
      for (var W = x.className.split(/\s+/), Y = 0; Y < T.length; Y += 1) {
        for (var ce = !1, fe = 0; fe < W.length; fe += 1)
          if (T[Y] === W[fe]) {
            ce = !0;
            break;
          }
        ce || W.push(T[Y]);
      }
      for (T = [], Y = 0; Y < W.length; Y += 1) {
        for (ce = !1, fe = 0; fe < q.length; fe += 1)
          if (W[Y] === q[fe]) {
            ce = !0;
            break;
          }
        ce || T.push(W[Y]);
      }
      x.className = T.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function d(x, T) {
      for (var q = x.className.split(/\s+/), W = 0, Y = q.length; W < Y; W++)
        if (q[W] == T)
          return !0;
      return !1;
    }
    function f(x) {
      return x.o.location.hostname || x.a.location.hostname;
    }
    function g(x, T, q) {
      function W() {
        je && Y && ce && (je(fe), je = null);
      }
      T = s(x, "link", { rel: "stylesheet", href: T, media: "all" });
      var Y = !1, ce = !0, fe = null, je = q || null;
      a ? (T.onload = function() {
        Y = !0, W();
      }, T.onerror = function() {
        Y = !0, fe = Error("Stylesheet failed to load"), W();
      }) : setTimeout(function() {
        Y = !0, W();
      }, 0), l(x, "head", T);
    }
    function h(x, T, q, W) {
      var Y = x.c.getElementsByTagName("head")[0];
      if (Y) {
        var ce = s(x, "script", { src: T }), fe = !1;
        return ce.onload = ce.onreadystatechange = function() {
          fe || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (fe = !0, q && q(null), ce.onload = ce.onreadystatechange = null, ce.parentNode.tagName == "HEAD" && Y.removeChild(ce));
        }, Y.appendChild(ce), setTimeout(function() {
          fe || (fe = !0, q && q(Error("Script load timeout")));
        }, W || 5e3), ce;
      }
      return null;
    }
    function y() {
      this.a = 0, this.c = null;
    }
    function p(x) {
      return x.a++, function() {
        x.a--, m(x);
      };
    }
    function C(x, T) {
      x.c = T, m(x);
    }
    function m(x) {
      x.a == 0 && x.c && (x.c(), x.c = null);
    }
    function b(x) {
      this.a = x || "-";
    }
    b.prototype.c = function(x) {
      for (var T = [], q = 0; q < arguments.length; q++)
        T.push(arguments[q].replace(/[\W_]+/g, "").toLowerCase());
      return T.join(this.a);
    };
    function w(x, T) {
      this.c = x, this.f = 4, this.a = "n";
      var q = (T || "n4").match(/^([nio])([1-9])$/i);
      q && (this.a = q[1], this.f = parseInt(q[2], 10));
    }
    function E(x) {
      return O(x) + " " + (x.f + "00") + " 300px " + S(x.c);
    }
    function S(x) {
      var T = [];
      x = x.split(/,\s*/);
      for (var q = 0; q < x.length; q++) {
        var W = x[q].replace(/['"]/g, "");
        W.indexOf(" ") != -1 || /^\d/.test(W) ? T.push("'" + W + "'") : T.push(W);
      }
      return T.join(",");
    }
    function _(x) {
      return x.a + x.f;
    }
    function O(x) {
      var T = "normal";
      return x.a === "o" ? T = "oblique" : x.a === "i" && (T = "italic"), T;
    }
    function P(x) {
      var T = 4, q = "n", W = null;
      return x && ((W = x.match(/(normal|oblique|italic)/i)) && W[1] && (q = W[1].substr(0, 1).toLowerCase()), (W = x.match(/([1-9]00|normal|bold)/i)) && W[1] && (/bold/i.test(W[1]) ? T = 7 : /[1-9]00/.test(W[1]) && (T = parseInt(W[1].substr(0, 1), 10)))), q + T;
    }
    function $(x, T) {
      this.c = x, this.f = x.o.document.documentElement, this.h = T, this.a = new b("-"), this.j = T.events !== !1, this.g = T.classes !== !1;
    }
    function L(x) {
      x.g && u(x.f, [x.a.c("wf", "loading")]), k(x, "loading");
    }
    function N(x) {
      if (x.g) {
        var T = d(x.f, x.a.c("wf", "active")), q = [], W = [x.a.c("wf", "loading")];
        T || q.push(x.a.c("wf", "inactive")), u(x.f, q, W);
      }
      k(x, "inactive");
    }
    function k(x, T, q) {
      x.j && x.h[T] && (q ? x.h[T](q.c, _(q)) : x.h[T]());
    }
    function F() {
      this.c = {};
    }
    function U(x, T, q) {
      var W = [], Y;
      for (Y in T)
        if (T.hasOwnProperty(Y)) {
          var ce = x.c[Y];
          ce && W.push(ce(T[Y], q));
        }
      return W;
    }
    function A(x, T) {
      this.c = x, this.f = T, this.a = s(this.c, "span", { "aria-hidden": "true" }, this.f);
    }
    function R(x) {
      l(x.c, "body", x.a);
    }
    function D(x) {
      return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + S(x.c) + ";" + ("font-style:" + O(x) + ";font-weight:" + (x.f + "00") + ";");
    }
    function B(x, T, q, W, Y, ce) {
      this.g = x, this.j = T, this.a = W, this.c = q, this.f = Y || 3e3, this.h = ce || void 0;
    }
    B.prototype.start = function() {
      var x = this.c.o.document, T = this, q = o(), W = new Promise(function(fe, je) {
        function Be() {
          o() - q >= T.f ? je() : x.fonts.load(E(T.a), T.h).then(function(ze) {
            1 <= ze.length ? fe() : setTimeout(Be, 25);
          }, function() {
            je();
          });
        }
        Be();
      }), Y = null, ce = new Promise(function(fe, je) {
        Y = setTimeout(je, T.f);
      });
      Promise.race([ce, W]).then(function() {
        Y && (clearTimeout(Y), Y = null), T.g(T.a);
      }, function() {
        T.j(T.a);
      });
    };
    function M(x, T, q, W, Y, ce, fe) {
      this.v = x, this.B = T, this.c = q, this.a = W, this.s = fe || "BESbswy", this.f = {}, this.w = Y || 3e3, this.u = ce || null, this.m = this.j = this.h = this.g = null, this.g = new A(this.c, this.s), this.h = new A(this.c, this.s), this.j = new A(this.c, this.s), this.m = new A(this.c, this.s), x = new w(this.a.c + ",serif", _(this.a)), x = D(x), this.g.a.style.cssText = x, x = new w(this.a.c + ",sans-serif", _(this.a)), x = D(x), this.h.a.style.cssText = x, x = new w("serif", _(this.a)), x = D(x), this.j.a.style.cssText = x, x = new w("sans-serif", _(this.a)), x = D(x), this.m.a.style.cssText = x, R(this.g), R(this.h), R(this.j), R(this.m);
    }
    var G = { D: "serif", C: "sans-serif" }, H = null;
    function X() {
      if (H === null) {
        var x = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        H = !!x && (536 > parseInt(x[1], 10) || parseInt(x[1], 10) === 536 && 11 >= parseInt(x[2], 10));
      }
      return H;
    }
    M.prototype.start = function() {
      this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = o(), J(this);
    };
    function K(x, T, q) {
      for (var W in G)
        if (G.hasOwnProperty(W) && T === x.f[G[W]] && q === x.f[G[W]])
          return !0;
      return !1;
    }
    function J(x) {
      var T = x.g.a.offsetWidth, q = x.h.a.offsetWidth, W;
      (W = T === x.f.serif && q === x.f["sans-serif"]) || (W = X() && K(x, T, q)), W ? o() - x.A >= x.w ? X() && K(x, T, q) && (x.u === null || x.u.hasOwnProperty(x.a.c)) ? le(x, x.v) : le(x, x.B) : ie(x) : le(x, x.v);
    }
    function ie(x) {
      setTimeout(r(function() {
        J(this);
      }, x), 50);
    }
    function le(x, T) {
      setTimeout(r(function() {
        c(this.g.a), c(this.h.a), c(this.j.a), c(this.m.a), T(this.a);
      }, x), 0);
    }
    function ne(x, T, q) {
      this.c = x, this.a = T, this.f = 0, this.m = this.j = !1, this.s = q;
    }
    var te = null;
    ne.prototype.g = function(x) {
      var T = this.a;
      T.g && u(T.f, [T.a.c("wf", x.c, _(x).toString(), "active")], [T.a.c("wf", x.c, _(x).toString(), "loading"), T.a.c("wf", x.c, _(x).toString(), "inactive")]), k(T, "fontactive", x), this.m = !0, re(this);
    }, ne.prototype.h = function(x) {
      var T = this.a;
      if (T.g) {
        var q = d(T.f, T.a.c("wf", x.c, _(x).toString(), "active")), W = [], Y = [T.a.c("wf", x.c, _(x).toString(), "loading")];
        q || W.push(T.a.c("wf", x.c, _(x).toString(), "inactive")), u(T.f, W, Y);
      }
      k(T, "fontinactive", x), re(this);
    };
    function re(x) {
      --x.f == 0 && x.j && (x.m ? (x = x.a, x.g && u(x.f, [x.a.c("wf", "active")], [x.a.c("wf", "loading"), x.a.c("wf", "inactive")]), k(x, "active")) : N(x.a));
    }
    function _e(x) {
      this.j = x, this.a = new F(), this.h = 0, this.f = this.g = !0;
    }
    _e.prototype.load = function(x) {
      this.c = new i(this.j, x.context || this.j), this.g = x.events !== !1, this.f = x.classes !== !1, De(this, new $(this.c, x), x);
    };
    function me(x, T, q, W, Y) {
      var ce = --x.h == 0;
      (x.f || x.g) && setTimeout(function() {
        var fe = Y || null, je = W || null || {};
        if (q.length === 0 && ce)
          N(T.a);
        else {
          T.f += q.length, ce && (T.j = ce);
          var Be, ze = [];
          for (Be = 0; Be < q.length; Be++) {
            var et = q[Be], Ke = je[et.c], Je = T.a, Pt = et;
            if (Je.g && u(Je.f, [Je.a.c("wf", Pt.c, _(Pt).toString(), "loading")]), k(Je, "fontloading", Pt), Je = null, te === null)
              if (window.FontFace) {
                var Pt = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), rt = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                te = Pt ? 42 < parseInt(Pt[1], 10) : !rt;
              } else
                te = !1;
            te ? Je = new B(r(T.g, T), r(T.h, T), T.c, et, T.s, Ke) : Je = new M(r(T.g, T), r(T.h, T), T.c, et, T.s, fe, Ke), ze.push(Je);
          }
          for (Be = 0; Be < ze.length; Be++)
            ze[Be].start();
        }
      }, 0);
    }
    function De(x, T, q) {
      var Y = [], W = q.timeout;
      L(T);
      var Y = U(x.a, q, x.c), ce = new ne(x.c, T, W);
      for (x.h = Y.length, T = 0, q = Y.length; T < q; T++)
        Y[T].load(function(fe, je, Be) {
          me(x, ce, fe, je, Be);
        });
    }
    function oe(x, T) {
      this.c = x, this.a = T;
    }
    oe.prototype.load = function(x) {
      function T() {
        if (ce["__mti_fntLst" + W]) {
          var fe = ce["__mti_fntLst" + W](), je = [], Be;
          if (fe)
            for (var ze = 0; ze < fe.length; ze++) {
              var et = fe[ze].fontfamily;
              fe[ze].fontStyle != null && fe[ze].fontWeight != null ? (Be = fe[ze].fontStyle + fe[ze].fontWeight, je.push(new w(et, Be))) : je.push(new w(et));
            }
          x(je);
        } else
          setTimeout(function() {
            T();
          }, 50);
      }
      var q = this, W = q.a.projectId, Y = q.a.version;
      if (W) {
        var ce = q.c.o;
        h(this.c, (q.a.api || "https://fast.fonts.net/jsapi") + "/" + W + ".js" + (Y ? "?v=" + Y : ""), function(fe) {
          fe ? x([]) : (ce["__MonotypeConfiguration__" + W] = function() {
            return q.a;
          }, T());
        }).id = "__MonotypeAPIScript__" + W;
      } else
        x([]);
    };
    function Te(x, T) {
      this.c = x, this.a = T;
    }
    Te.prototype.load = function(x) {
      var T, q, W = this.a.urls || [], Y = this.a.families || [], ce = this.a.testStrings || {}, fe = new y();
      for (T = 0, q = W.length; T < q; T++)
        g(this.c, W[T], p(fe));
      var je = [];
      for (T = 0, q = Y.length; T < q; T++)
        if (W = Y[T].split(":"), W[1])
          for (var Be = W[1].split(","), ze = 0; ze < Be.length; ze += 1)
            je.push(new w(W[0], Be[ze]));
        else
          je.push(new w(W[0]));
      C(fe, function() {
        x(je, ce);
      });
    };
    function Re(x, T) {
      x ? this.c = x : this.c = Ye, this.a = [], this.f = [], this.g = T || "";
    }
    var Ye = "https://fonts.googleapis.com/css";
    function Fe(x, T) {
      for (var q = T.length, W = 0; W < q; W++) {
        var Y = T[W].split(":");
        Y.length == 3 && x.f.push(Y.pop());
        var ce = "";
        Y.length == 2 && Y[1] != "" && (ce = ":"), x.a.push(Y.join(ce));
      }
    }
    function Ze(x) {
      if (x.a.length == 0)
        throw Error("No fonts to load!");
      if (x.c.indexOf("kit=") != -1)
        return x.c;
      for (var T = x.a.length, q = [], W = 0; W < T; W++)
        q.push(x.a[W].replace(/ /g, "+"));
      return T = x.c + "?family=" + q.join("%7C"), 0 < x.f.length && (T += "&subset=" + x.f.join(",")), 0 < x.g.length && (T += "&text=" + encodeURIComponent(x.g)), T;
    }
    function nt(x) {
      this.f = x, this.a = [], this.c = {};
    }
    var xe = { latin: "BESbswy", "latin-ext": "çöüğş", cyrillic: "йяЖ", greek: "αβΣ", khmer: "កខគ", Hanuman: "កខគ" }, He = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, ye = { i: "i", italic: "i", n: "n", normal: "n" }, it = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Me(x) {
      for (var T = x.f.length, q = 0; q < T; q++) {
        var W = x.f[q].split(":"), Y = W[0].replace(/\+/g, " "), ce = ["n4"];
        if (2 <= W.length) {
          var fe, je = W[1];
          if (fe = [], je)
            for (var je = je.split(","), Be = je.length, ze = 0; ze < Be; ze++) {
              var et;
              if (et = je[ze], et.match(/^[\w-]+$/)) {
                var Ke = it.exec(et.toLowerCase());
                if (Ke == null)
                  et = "";
                else {
                  if (et = Ke[2], et = et == null || et == "" ? "n" : ye[et], Ke = Ke[1], Ke == null || Ke == "")
                    Ke = "4";
                  else
                    var Je = He[Ke], Ke = Je || (isNaN(Ke) ? "4" : Ke.substr(0, 1));
                  et = [et, Ke].join("");
                }
              } else
                et = "";
              et && fe.push(et);
            }
          0 < fe.length && (ce = fe), W.length == 3 && (W = W[2], fe = [], W = W ? W.split(",") : fe, 0 < W.length && (W = xe[W[0]]) && (x.c[Y] = W));
        }
        for (x.c[Y] || (W = xe[Y]) && (x.c[Y] = W), W = 0; W < ce.length; W += 1)
          x.a.push(new w(Y, ce[W]));
      }
    }
    function Ve(x, T) {
      this.c = x, this.a = T;
    }
    var lt = { Arimo: !0, Cousine: !0, Tinos: !0 };
    Ve.prototype.load = function(x) {
      var T = new y(), q = this.c, W = new Re(this.a.api, this.a.text), Y = this.a.families;
      Fe(W, Y);
      var ce = new nt(Y);
      Me(ce), g(q, Ze(W), p(T)), C(T, function() {
        x(ce.a, ce.c, lt);
      });
    };
    function yt(x, T) {
      this.c = x, this.a = T;
    }
    yt.prototype.load = function(x) {
      var T = this.a.id, q = this.c.o;
      T ? h(this.c, (this.a.api || "https://use.typekit.net") + "/" + T + ".js", function(W) {
        if (W)
          x([]);
        else if (q.Typekit && q.Typekit.config && q.Typekit.config.fn) {
          W = q.Typekit.config.fn;
          for (var Y = [], ce = 0; ce < W.length; ce += 2)
            for (var fe = W[ce], je = W[ce + 1], Be = 0; Be < je.length; Be++)
              Y.push(new w(fe, je[Be]));
          try {
            q.Typekit.load({ events: !1, classes: !1, async: !0 });
          } catch {
          }
          x(Y);
        }
      }, 2e3) : x([]);
    };
    function mt(x, T) {
      this.c = x, this.f = T, this.a = [];
    }
    mt.prototype.load = function(x) {
      var T = this.f.id, q = this.c.o, W = this;
      T ? (q.__webfontfontdeckmodule__ || (q.__webfontfontdeckmodule__ = {}), q.__webfontfontdeckmodule__[T] = function(Y, ce) {
        for (var fe = 0, je = ce.fonts.length; fe < je; ++fe) {
          var Be = ce.fonts[fe];
          W.a.push(new w(Be.name, P("font-weight:" + Be.weight + ";font-style:" + Be.style)));
        }
        x(W.a);
      }, h(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + T + ".js", function(Y) {
        Y && x([]);
      })) : x([]);
    };
    var Ne = new _e(window);
    Ne.a.c.custom = function(x, T) {
      return new Te(T, x);
    }, Ne.a.c.fontdeck = function(x, T) {
      return new mt(T, x);
    }, Ne.a.c.monotype = function(x, T) {
      return new oe(T, x);
    }, Ne.a.c.typekit = function(x, T) {
      return new yt(T, x);
    }, Ne.a.c.google = function(x, T) {
      return new Ve(T, x);
    };
    var Ue = { load: r(Ne.load, Ne) };
    e.exports ? e.exports = Ue : (window.WebFont = Ue, window.WebFontConfig && Ne.load(window.WebFontConfig));
  })();
})(Ry);
var zA = Ry.exports;
const HA = /* @__PURE__ */ xg(zA);
var UA = { VITE_MAPBOX_TOKEN: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNsMWdnM3BrbzBiemQzaHBiaDhja2RleXAifQ.0QfwjSzZeGiEjkkA-0dH6w", VITE_CJS_IGNORE_WARNING: "true", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
async function WA() {
  HA.load({
    google: {
      families: ["Noto Sans:400,600"]
    }
  });
  let e;
  UA && (e = /* @__PURE__ */ Object.assign({
    "../translations/bg.json": cA,
    "../translations/da.json": dA,
    "../translations/de.json": vA,
    "../translations/el.json": pA,
    "../translations/en.json": mA,
    "../translations/es-419.json": bA,
    "../translations/es.json": wA,
    "../translations/fr.json": EA,
    "../translations/hu.json": xA,
    "../translations/it.json": PA,
    "../translations/ja.json": TA,
    "../translations/nl.json": RA,
    "../translations/pl.json": AA,
    "../translations/pt-BR.json": MA,
    "../translations/ro.json": DA,
    "../translations/sv.json": jA,
    "../translations/uk.json": VA
  }), Fy("profile-dropdown", e));
}
const Mo = class Mo {
};
Mo.config = $s(), Mo.resendEmail = async () => {
  const t = `${Mo.config.getAPIURL()}/v2/accounts/email/resend`;
  return (await jy.get(t, {
    headers: {
      ...Mo.config.getDefaultHeaders()
    }
  })).data;
};
let Pu = Mo;
const qA = {
  colors: {
    base_dark_blue: "#00a0be",
    base_light_blue: "#00b5d8",
    base_dark_green: "#749204",
    base_light_green: "#aab400",
    base_light_green_2: "#cbcf6e",
    base_orange: "#eb8205",
    base_yellow: "#ffca41",
    base_yellow_2: "#ffd17e",
    base_red: "#d91e3f",
    base_dark_grey: "#c1c5c8",
    base_light_grey: "#f2f4f6",
    base_white: "#ffffff",
    base_black: "#2f3031",
    base_purple_heart: "#882d8e",
    base_iris: "#4b57d1",
    base_dark_orchid: "#ac38c0",
    base_field_drab: "#7b5d21",
    base_flame: "#df4c29",
    base_steel_blue: "#3c7ea1",
    base_dark_tan: "#977c42",
    base_deep_carrot_orange: "#dc7237",
    base_bleu_de_france: "#4396ef",
    base_old_rose: "#cb7b80",
    base_cadet_blue: "#53a491",
    base_cornflower_blue: "#6f93e3",
    base_persian_pink: "#e977b3",
    base_brass: "#bba536",
    base_olivine: "#9eaa75",
    base_tiger_eye: "#e89d3c",
    base_mantis: "#73c461",
    base_apple_green: "#a3bc10",
    base_sky_blue: "#81bddb",
    base_bright_ube: "#c2a5f5",
    base_medium_turquoise: "#69d5d1",
    base_june_bud: "#b9d950",
    base_light_green_3: "#7dea99",
    base_straw: "#e3d66d",
    base_medium_spring_bud: "#d7dd9d",
    base_gainsboro: "#d9e3e4",
    cws_blue_10: "#EAF6FF",
    cws_blue_20: "#C6E6FF",
    cws_blue_30: "#82CFFF",
    cws_blue_40: "#31B4F2",
    cws_blue_50: "#0092E4",
    cws_blue_60: "#0071CD",
    cws_blue_70: "#005693",
    cws_blue_80: "#003B69",
    cws_blue_90: "#002747",
    cws_blue_100: "#00172D",
    cws_green_10: "#DFFBE8",
    cws_green_20: "#C3EAD1",
    cws_green_30: "#90D6AA",
    cws_green_40: "#5EBB7F",
    cws_green_50: "#19A04B",
    cws_green_60: "#14803C",
    cws_green_70: "#0C612C",
    cws_green_80: "#06431C",
    cws_green_90: "#032D10",
    cws_green_100: "#011B07",
    cws_red_10: "#FFF1F1",
    cws_red_20: "#FFD9D9",
    cws_red_30: "#FFB3B3",
    cws_red_40: "#F98989",
    cws_red_50: "#EB4B4B",
    cws_red_60: "#CF3537",
    cws_red_70: "#9C2628",
    cws_red_80: "#70191A",
    cws_red_90: "#4C0E0F",
    cws_red_100: "#300606",
    cws_orange_10: "#FFF1ED",
    cws_orange_20: "#FFDACE",
    cws_orange_30: "#FFB59D",
    cws_orange_40: "#FF785A",
    cws_orange_50: "#EE5B3A",
    cws_orange_60: "#C1462B",
    cws_orange_70: "#92331E",
    cws_orange_80: "#682213",
    cws_orange_90: "#48150A",
    cws_orange_100: "#2D0A04",
    cws_yellow_10: "#FFF3DD",
    cws_yellow_20: "#FFE4AE",
    cws_yellow_30: "#F0C355",
    cws_yellow_40: "#E99921",
    cws_yellow_50: "#C17E19",
    cws_yellow_60: "#9A6412",
    cws_yellow_70: "#744A0B",
    cws_yellow_80: "#523305",
    cws_yellow_90: "#372102",
    cws_yellow_100: "#221201",
    cws_teal_10: "#E0F9F7",
    cws_teal_20: "#A9EFE8",
    cws_teal_30: "#5FD2C8",
    cws_teal_40: "#46BBB0",
    cws_teal_50: "#2B9C92",
    cws_teal_60: "#217C74",
    cws_teal_70: "#165C56",
    cws_teal_80: "#0D413C",
    cws_teal_90: "#062B27",
    cws_teal_100: "#021917",
    cws_purple_10: "#F6F2FE",
    cws_purple_20: "#E7DDFC",
    cws_purple_30: "#D2BDF9",
    cws_purple_40: "#BA99F6",
    cws_purple_50: "#9664F0",
    cws_purple_60: "#8354D6",
    cws_purple_70: "#643AAA",
    cws_purple_80: "#462779",
    cws_purple_90: "#2E1954",
    cws_purple_100: "#1C0D35",
    cws_pink_10: "#FFF1F3",
    cws_pink_20: "#FFD8DF",
    cws_pink_30: "#FFB2C1",
    cws_pink_40: "#FF7D96",
    cws_pink_50: "#E85D78",
    cws_pink_60: "#BB485D",
    cws_pink_70: "#8D3545",
    cws_pink_80: "#65232F",
    cws_pink_90: "#45161E",
    cws_pink_100: "#2B0A10",
    cws_neutral_00: "#FFFFFF",
    cws_neutral_10: "#F3F4F6",
    cws_neutral_20: "#DFE2E7",
    cws_neutral_30: "#C2C7D0",
    cws_neutral_40: "#A3A9B9",
    cws_neutral_50: "#868CA2",
    cws_neutral_60: "#696F88",
    cws_neutral_70: "#4D5165",
    cws_neutral_80: "#363948",
    cws_neutral_90: "#232630",
    cws_neutral_100: "#14151C"
  }
}, GA = [{
  key: "en",
  label: "English (USA)"
}, {
  key: "en-GB",
  label: "English (GB)"
}, {
  key: "pt-BR",
  label: "Português"
}, {
  key: "fr",
  label: "Français"
}, {
  key: "de",
  label: "Deutsch"
}, {
  key: "pl",
  label: "Polski"
}, {
  key: "es",
  label: "Español"
}, {
  key: "es-419",
  label: "Español (América Latina)"
}, {
  key: "es-AR",
  label: "Español (AR)"
}, {
  key: "bg",
  label: "Български"
}, {
  key: "hu",
  label: "Magyar"
}, {
  key: "ro",
  label: "Română"
}, {
  key: "el",
  label: "Ελληνικά"
}, {
  key: "nl",
  label: "Nederlands"
}, {
  key: "da",
  label: "Dansk"
}, {
  key: "sv",
  label: "Svenska"
}, {
  key: "uk",
  label: "Українська"
}, {
  key: "it",
  label: "Italiano"
}, {
  key: "sk",
  label: "Slovenčina"
}, {
  key: "ru",
  label: "Русский"
}, {
  key: "cs",
  label: "Čeština"
}, {
  key: "tr",
  label: "Türk"
}, {
  key: "zh",
  label: "中国人"
}, {
  key: "sr",
  label: "Српски"
}], tc = "cropwise-language";
var Ny = {}, fl = {}, la = {};
Object.defineProperty(la, "__esModule", {
  value: !0
});
la.formatCookie = void 0;
var KA = function(t) {
  var n = t.sameSite;
  return typeof n > "u" ? null : ["none", "lax", "strict"].indexOf(n.toLowerCase()) >= 0 ? n : null;
}, XA = function(t) {
  var n = t.path, r = t.domain, o = t.expires, i = t.secure, a = KA(t);
  return [typeof n > "u" || n === null ? "" : ";path=" + n, typeof r > "u" || r === null ? "" : ";domain=" + r, typeof o > "u" || o === null ? "" : ";expires=" + o.toUTCString(), typeof i > "u" || i === !1 ? "" : ";secure", a === null ? "" : ";SameSite=" + a].join("");
}, YA = function(t, n, r) {
  return [encodeURIComponent(t), "=", encodeURIComponent(n), XA(r)].join("");
};
la.formatCookie = YA;
var ca = {};
function ZA(e, t) {
  return tk(e) || ek(e, t) || JA(e, t) || QA();
}
function QA() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JA(e, t) {
  if (e) {
    if (typeof e == "string")
      return dg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return dg(e, t);
  }
}
function dg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function ek(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, o = !1, i = void 0;
    try {
      for (var a = e[Symbol.iterator](), s; !(r = (s = a.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
        ;
    } catch (l) {
      o = !0, i = l;
    } finally {
      try {
        !r && a.return != null && a.return();
      } finally {
        if (o)
          throw i;
      }
    }
    return n;
  }
}
function tk(e) {
  if (Array.isArray(e))
    return e;
}
Object.defineProperty(ca, "__esModule", {
  value: !0
});
ca.parseCookies = void 0;
var nk = function(t) {
  if (t.length === 0)
    return {};
  var n = {}, r = new RegExp("\\s*;\\s*");
  return t.split(r).forEach(function(o) {
    var i = o.split("="), a = ZA(i, 2), s = a[0], l = a[1], c = decodeURIComponent(s), u = decodeURIComponent(l);
    n[c] = u;
  }), n;
};
ca.parseCookies = nk;
function rk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ok(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ik(e, t, n) {
  return t && ok(e.prototype, t), e;
}
Object.defineProperty(fl, "__esModule", {
  value: !0
});
fl.CookieStorage = void 0;
var fg = la, La = ca, ak = function() {
  function e(t) {
    if (rk(this, e), this._defaultOptions = Object.assign({
      domain: null,
      expires: null,
      path: null,
      secure: !1
    }, t), typeof Proxy < "u")
      return new Proxy(this, sk);
  }
  return ik(e, [{
    key: "clear",
    value: function() {
      var n = this, r = La.parseCookies(this._getCookie()), o = Object.keys(r);
      o.forEach(function(i) {
        return n.removeItem(i);
      });
    }
  }, {
    key: "getItem",
    value: function(n) {
      var r = La.parseCookies(this._getCookie());
      return Object.prototype.hasOwnProperty.call(r, n) ? r[n] : null;
    }
  }, {
    key: "key",
    value: function(n) {
      var r = La.parseCookies(this._getCookie()), o = Object.keys(r).sort();
      return n < o.length ? o[n] : null;
    }
  }, {
    key: "removeItem",
    value: function(n, r) {
      var o = "", i = Object.assign(Object.assign(Object.assign({}, this._defaultOptions), r), {
        expires: /* @__PURE__ */ new Date(0)
      }), a = fg.formatCookie(n, o, i);
      this._setCookie(a);
    }
  }, {
    key: "setItem",
    value: function(n, r, o) {
      var i = Object.assign(Object.assign({}, this._defaultOptions), o), a = fg.formatCookie(n, r, i);
      this._setCookie(a);
    }
  }, {
    key: "_getCookie",
    value: function() {
      return typeof document > "u" || typeof document.cookie > "u" ? "" : document.cookie;
    }
  }, {
    key: "_setCookie",
    value: function(n) {
      document.cookie = n;
    }
  }, {
    key: "length",
    get: function() {
      var n = La.parseCookies(this._getCookie()), r = Object.keys(n);
      return r.length;
    }
  }]), e;
}();
fl.CookieStorage = ak;
var sk = {
  defineProperty: function(t, n, r) {
    return t.setItem(n.toString(), String(r.value)), !0;
  },
  deleteProperty: function(t, n) {
    return t.removeItem(n.toString()), !0;
  },
  get: function(t, n, r) {
    if (typeof n == "string" && n in t)
      return t[n];
    var o = t.getItem(n.toString());
    return o !== null ? o : void 0;
  },
  getOwnPropertyDescriptor: function(t, n) {
    if (!(n in t))
      return {
        configurable: !0,
        enumerable: !0,
        value: t.getItem(n.toString()),
        writable: !0
      };
  },
  has: function(t, n) {
    return typeof n == "string" && n in t ? !0 : t.getItem(n.toString()) !== null;
  },
  ownKeys: function(t) {
    for (var n = [], r = 0; r < t.length; r++) {
      var o = t.key(r);
      o !== null && n.push(o);
    }
    return n;
  },
  preventExtensions: function(t) {
    throw new TypeError("can't prevent extensions on this proxy object");
  },
  set: function(t, n, r, o) {
    return t.setItem(n.toString(), String(r)), !0;
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var t = fl;
  Object.defineProperty(e, "CookieStorage", {
    enumerable: !0,
    get: function() {
      return t.CookieStorage;
    }
  });
  var n = la;
  Object.defineProperty(e, "formatCookie", {
    enumerable: !0,
    get: function() {
      return n.formatCookie;
    }
  });
  var r = ca;
  Object.defineProperty(e, "parseCookies", {
    enumerable: !0,
    get: function() {
      return r.parseCookies;
    }
  });
})(Ny);
const nc = new Ny.CookieStorage();
function lk({
  availableLanguages: e,
  onLanguageChange: t
}) {
  const [n, r] = Ht();
  return At(() => {
    const o = GA.reduce((s, {
      key: l
    }) => ((e === void 0 || e.includes(l)) && s.push(l), s), []), i = nc.getItem(tc);
    i && o.includes(i) && i !== n && (r(i), Ed.changeLanguage(i), nc.setItem(tc, i, {
      path: "/",
      domain: window.location.hostname.includes("cropwise.com") ? "cropwise.com" : "",
      expires: new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1e3)
      // avoid expire in near future (10 years)
    }), t == null || t(i));
  }, [n, e, t]), {
    activeLanguage: n ?? "en",
    setActiveLanguage: (o) => {
      r(o), t == null || t(o), Ed.changeLanguage(o), nc.setItem(tc, o, {
        path: "/",
        domain: window.location.hostname.includes("cropwise.com") ? "cropwise.com" : "",
        expires: new Date(Date.now() + 10 * 365 * 24 * 60 * 60 * 1e3)
        // avoid expire in near future (10 years)
      });
    }
  };
}
const vg = [{
  key: "en",
  label: "English (USA)"
}, {
  key: "en-GB",
  label: "English (GB)"
}, {
  key: "pt-BR",
  label: "Português"
}, {
  key: "fr",
  label: "Français"
}, {
  key: "de",
  label: "Deutsch"
}, {
  key: "pl",
  label: "Polski"
}, {
  key: "es",
  label: "Español"
}, {
  key: "es-419",
  label: "Español (América Latina)"
}, {
  key: "es-AR",
  label: "Español (AR)"
}, {
  key: "bg",
  label: "Български"
}, {
  key: "hu",
  label: "Magyar"
}, {
  key: "ro",
  label: "Română"
}, {
  key: "el",
  label: "Ελληνικά"
}, {
  key: "nl",
  label: "Nederlands"
}, {
  key: "da",
  label: "Dansk"
}, {
  key: "sv",
  label: "Svenska"
}, {
  key: "uk",
  label: "Українська"
}, {
  key: "it",
  label: "Italiano"
}, {
  key: "sk",
  label: "Slovenčina"
}, {
  key: "ru",
  label: "Русский"
}, {
  key: "cs",
  label: "Čeština"
}, {
  key: "tr",
  label: "Türk"
}, {
  key: "zh",
  label: "中国人"
}, {
  key: "sr",
  label: "Српски"
}], gg = [{
  key: "metric",
  label: "common.unit_system.metric",
  description: "kg, ha, m/s, mm, °C"
}, {
  key: "imperial",
  label: "common.unit_system.imperial",
  description: "lbs, ac, mph, inch, °F"
}, {
  key: "canada",
  label: "common.unit_system.canada",
  description: "lbs, ac, m/s, inch, °C"
}];
function Ay(e) {
  if (typeof e != "string")
    return "";
  const t = e.split(" ");
  return t.length === 1 ? t[0].charAt(0).toLocaleUpperCase() + t[0].charAt(1).toLocaleLowerCase() : t[0].charAt(0).toLocaleUpperCase() + t[t.length - 1].charAt(0).toLocaleUpperCase();
}
WA();
const xk = (e) => /* @__PURE__ */ ue.jsx(By, { ns: "profile-dropdown", children: /* @__PURE__ */ ue.jsx(ck, { ...e }) }), ck = ({
  defaultLanguage: e,
  availableLanguages: t,
  onLanguageChange: n,
  ...r
}) => {
  const {
    t: o
  } = mg(), i = $s(), [a, s] = Ht(!0), [l, c] = Ht(!1), [u, d] = Ht(null), [f, g] = Ht(), [h, y] = Ht({});
  L1();
  const p = Xp(), {
    activeLanguage: C,
    setActiveLanguage: m
  } = lk({
    availableLanguages: t,
    onLanguageChange: n
  }), b = wn(() => {
    s(!0), Vy.getCurrentUser().then((_) => {
      if (_) {
        const {
          id: O,
          type: P,
          name: $,
          email: L,
          photo_uri: N,
          email_verified: k,
          country_code: F
        } = _;
        L && P !== "MANAGED" && d(k), g({
          id: O,
          name: $,
          email: L,
          photoUrl: N,
          countryCode: F
        }), y({
          defaultWorkspaceId: _.default_workspace_id
        });
      }
    }).finally(() => {
      s(!1);
    });
  }, []);
  At(() => {
    i.addCallbackAfterSetToken(b);
  }, [i, b]), At(() => {
    kr.config({
      prefixCls: "cw-elements-notification",
      closeIcon: /* @__PURE__ */ ue.jsx(iA, {}),
      duration: 0,
      placement: "topRight",
      top: 68,
      // 56 (header) + 12 (padding)
      getContainer: () => document.getElementById("cw-elements-profile-dropdown") || document.body
    }), b();
  }, [b]);
  const w = wn(() => {
    kr.info({
      icon: /* @__PURE__ */ ue.jsx(sA, {}),
      message: null,
      description: /* @__PURE__ */ ue.jsx("div", { style: {
        fontSize: 16,
        lineHeight: "24px"
      }, children: /* @__PURE__ */ ue.jsxs("span", { children: [
        /* @__PURE__ */ ue.jsxs("span", { style: {
          fontWeight: 600
        }, children: [
          o("notifications.verify.title"),
          " "
        ] }),
        o("notifications.verify.continue_having_access"),
        "."
      ] }) }),
      key: "cw-email-notification",
      className: "cw-email-notification"
    });
  }, [o]), E = wn(() => {
    c(!1), kr.info({
      icon: /* @__PURE__ */ ue.jsx(ey, {}),
      btn: /* @__PURE__ */ ue.jsx(rA, { onClick: () => kr.destroy("cw-resend-notification"), children: "OK" }),
      message: o("We send you the confirmation link"),
      description: o("Please accsess your e-mail account and click the link to Confirm your e-mail."),
      key: "cw-resend-notification",
      className: "cw-resend-notification"
    });
  }, [o]), S = wn((_) => {
    c(_), kr.destroy("cw-resend-notification"), kr.destroy("cw-email-notification"), _ && p("Profile Dropdown - Opened Profile Dropdown component", h);
  }, [p, h]);
  return At(() => {
    document.querySelector(".cw-elements-profile-dropdown-open") || (u === !1 ? w() : kr.destroy("cw-email-notification"));
  }, [u, w]), /* @__PURE__ */ ue.jsx(fk, { id: "cw-elements-profile-dropdown", children: /* @__PURE__ */ ue.jsx(Q2, { theme: qA, children: /* @__PURE__ */ ue.jsx(Wr, { prefixCls: "cw-elements", iconPrefixCls: "cw-elements", children: /* @__PURE__ */ ue.jsx(oA, { content: /* @__PURE__ */ ue.jsx(uk, { ...r, activeLanguage: C, availableLanguages: t, onLanguageChange: (_) => {
    p("Profile Dropdown - Changed language", h), m(_);
  }, userInfo: f, isVerified: u, loadUserInfo: b, openEmailSentNotification: E, analyticsPayload: h }), align: {
    offset: [0, 10]
  }, trigger: "click", open: l, onOpenChange: S, arrow: !1, placement: "bottomRight", overlayStyle: {
    width: 282
  }, openClassName: "cw-elements-profile-dropdown-open", children: /* @__PURE__ */ ue.jsxs("div", { style: {
    position: "relative"
  }, "data-testid": "profile-dropdown", children: [
    /* @__PURE__ */ ue.jsx(Q0, { size: 40, pressed: l, src: f == null ? void 0 : f.photoUrl, style: {
      cursor: "pointer"
    }, "data-testid": "profile-dropdown-toggle", children: a ? /* @__PURE__ */ ue.jsx(Ns, {}) : Ay((f == null ? void 0 : f.name) ?? "") }),
    u === !1 && /* @__PURE__ */ ue.jsx(vk, {})
  ] }) }) }) }) });
}, uk = ({
  userInfo: e,
  onLogout: t,
  activeLanguage: n,
  defaultUnitSystem: r,
  availableLanguages: o,
  availableUnitSystems: i,
  isVerified: a,
  onLanguageChange: s,
  onUnitSystemChange: l,
  openEmailSentNotification: c,
  loadUserInfo: u,
  analyticsPayload: d
}) => {
  const f = Xp(), {
    t: g
  } = mg(), h = $s(), [y, p] = Ht(!1), [C, m] = Ht(!1), b = Kn(() => {
    var N;
    return (N = vg.find((k) => k.key === n)) == null ? void 0 : N.label;
  }, [n]), [w, E] = Ht(localStorage.getItem("unitSystem") || r || "metric"), S = Kn(() => {
    var N;
    return (N = gg.find((k) => k.key === w)) == null ? void 0 : N.label;
  }, [w]);
  At(() => {
    !localStorage.getItem("unitSystem") && r && localStorage.setItem("unitSystem", r);
  }, [r]);
  const _ = (o == null ? void 0 : o.length) !== 0, O = (i == null ? void 0 : i.length) !== 0, P = _ || O, $ = wn((N) => {
    E(N), l == null || l(N), localStorage.setItem("unitSystem", N);
  }, [l]), L = () => {
    m(!0), p(!1), Pu.resendEmail().then(() => {
      c();
    }).catch(() => p(!0)).finally(() => m(!1));
  };
  return /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
    /* @__PURE__ */ ue.jsxs(pk, { "data-testid": "profile-dropdown-title", children: [
      /* @__PURE__ */ ue.jsx(gk, { children: g("account") }),
      /* @__PURE__ */ ue.jsx(hk, { children: e ? /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
        /* @__PURE__ */ ue.jsx(Q0, { size: 32, src: e == null ? void 0 : e.photoUrl, children: Ay((e == null ? void 0 : e.name) ?? "") }),
        /* @__PURE__ */ ue.jsx(mk, { children: e == null ? void 0 : e.name })
      ] }) : /* @__PURE__ */ ue.jsxs("p", { style: {
        color: "#CF3537",
        fontSize: 12,
        margin: 0
      }, children: [
        g("We couldn't load your information"),
        ", ",
        /* @__PURE__ */ ue.jsx("span", { style: {
          cursor: "pointer",
          textDecoration: "underline"
        }, onClick: u, children: g("click here to try again") })
      ] }) }),
      a === !1 && /* @__PURE__ */ ue.jsxs(yk, { children: [
        /* @__PURE__ */ ue.jsx("span", { className: "icon", children: /* @__PURE__ */ ue.jsx(ey, {}) }),
        /* @__PURE__ */ ue.jsxs("div", { children: [
          /* @__PURE__ */ ue.jsx("p", { className: "title", children: g("Confirm your e-mail") }),
          /* @__PURE__ */ ue.jsxs("div", { children: [
            /* @__PURE__ */ ue.jsxs("p", { children: [
              g("notifications.verify.access_email"),
              ", "
            ] }),
            /* @__PURE__ */ ue.jsxs("span", { className: "email", style: {
              overflowWrap: "anywhere"
            }, children: [
              e == null ? void 0 : e.email,
              ", "
            ] }),
            /* @__PURE__ */ ue.jsxs("span", { children: [
              g("notifications.verify.click_link"),
              "."
            ] })
          ] }),
          C ? /* @__PURE__ */ ue.jsx(gd, { indicator: /* @__PURE__ */ ue.jsx(Ns, { style: {
            fontSize: 12
          }, spin: !0 }) }) : /* @__PURE__ */ ue.jsx("p", { className: "resend", onClick: L, children: g("notifications.verify.resend_button") }),
          y && /* @__PURE__ */ ue.jsx("p", { style: {
            color: "#CF3537",
            fontSize: 12,
            marginTop: 4
          }, children: g("notifications.error.resending_email") })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ ue.jsxs(lr, { mode: "vertical", style: {
      width: 282,
      border: "none",
      borderRadius: 4,
      paddingBottom: 4
    }, getPopupContainer: () => document.getElementById("cw-elements-profile-dropdown") || document.body, children: [
      /* @__PURE__ */ ue.jsxs(Ei, { "data-testid": "profile-dropdown-edit", onClick: () => {
        var N;
        f("Profile Dropdown - Clicked to edit profile", d), (N = window.open(`${h.getAccountsURL()}/app/profile`, "_blank")) == null || N.focus();
      }, children: [
        g("button.edit_profile"),
        /* @__PURE__ */ ue.jsx(ug, {})
      ] }, "edit"),
      /* @__PURE__ */ ue.jsx(rc, {}),
      P && /* @__PURE__ */ ue.jsxs(ue.Fragment, { children: [
        /* @__PURE__ */ ue.jsxs(bk, { title: g("preferences.title"), children: [
          _ && /* @__PURE__ */ ue.jsx(hg, { title: /* @__PURE__ */ ue.jsxs(pg, { "data-testid": "profile-dropdown-language", children: [
            /* @__PURE__ */ ue.jsx("span", { children: g("common.input.language_select") }),
            /* @__PURE__ */ ue.jsx("span", { className: "language", style: {
              color: "#696F88"
            }, children: b })
          ] }), popupClassName: "cw-submenu-popup", children: vg.filter(({
            key: N
          }) => o === void 0 || o.includes(N)).map(({
            key: N,
            label: k
          }) => /* @__PURE__ */ ue.jsx(Ei, { $active: N === n, onClick: (F) => s == null ? void 0 : s(F.key), "data-testid": "profile-dropdown-language-item", children: k }, N)) }, "languages"),
          O && /* @__PURE__ */ ue.jsx(hg, { title: /* @__PURE__ */ ue.jsxs(pg, { children: [
            /* @__PURE__ */ ue.jsx("span", { children: g("common.unit_system.label") }),
            /* @__PURE__ */ ue.jsx("span", { style: {
              color: "#696F88"
            }, children: g(S) })
          ] }), popupClassName: "cw-submenu-popup", children: gg.filter(({
            key: N
          }) => i === void 0 || i.includes(N)).map(({
            key: N,
            label: k,
            description: F
          }) => /* @__PURE__ */ ue.jsx(Ei, { onClick: $.bind(void 0, N), children: /* @__PURE__ */ ue.jsxs("div", { style: {
            display: "flex",
            flexDirection: "column"
          }, children: [
            /* @__PURE__ */ ue.jsx("span", { style: {
              fontWeight: N === w ? 600 : 400,
              marginBottom: 6
            }, children: g(k) }),
            /* @__PURE__ */ ue.jsx("span", { style: {
              color: "#4D5165"
            }, children: F })
          ] }) }, N)) }, "unit-systems")
        ] }),
        /* @__PURE__ */ ue.jsx(rc, {})
      ] }),
      /* @__PURE__ */ ue.jsxs(Ei, { "data-testid": "profile-dropdown-legal-docs", onClick: () => {
        var N;
        f("Profile Dropdown - Clicked on legal documents", d), (N = window.open(`${h.getAccountsURL()}/app/legaldocs/${(e == null ? void 0 : e.countryCode) || "US"}`, "_blank")) == null || N.focus();
      }, children: [
        g("button.legal_docs"),
        /* @__PURE__ */ ue.jsx(ug, {})
      ] }, "legal-docs"),
      /* @__PURE__ */ ue.jsx(rc, {}),
      /* @__PURE__ */ ue.jsx(J0, { title: g("tooltip.log_out_all_cw_apps"), placement: "top", "data-testid": "profile-dropdown-logout-tooltip", children: /* @__PURE__ */ ue.jsx(Ei, { danger: !0, onClick: () => {
        f("Profile Dropdown - Clicked to log out", d), t();
      }, "data-testid": "profile-dropdown-logout", children: /* @__PURE__ */ ue.jsxs("div", { style: {
        display: "flex",
        alignItems: "center",
        gap: 10
      }, children: [
        /* @__PURE__ */ ue.jsx(aA, {}),
        /* @__PURE__ */ ue.jsx("span", { children: g("button.cw_logout") })
      ] }) }, "logout") })
    ] })
  ] });
}, dk = Y0`
  * {
    font-family: 'Noto Sans', sans-serif;
  }

  * > * {
    font-family: 'Noto Sans', sans-serif;
  }
`, fk = un.div`
  ${dk}

  .cw-submenu-popup .cw-elements-menu-sub {
    max-height: calc(100vh - 400px);
    padding: 4px 0 !important;
    border-radius: 4px !important;

    overflow-y: auto !important;
    overflow-y: overlay !important;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border: 4px solid transparent;
      background-clip: padding-box;
      border-radius: 5px;
      background-color: #c2c7d0;
    }
  }

  .cw-email-notification,
  .cw-resend-notification {
    border-radius: 4px;

    .cw-elements-notification-notice-icon {
      left: 24px;
      margin: 0;
    }

    .cw-elements-notification-notice-description {
      margin: 0 14px 0 40px;
    }
  }

  .cw-email-notification {
    padding: 18px 16px;
    border: 1px solid rgb(130, 207, 255);
    background-color: rgb(234, 246, 255);
    box-shadow: none;
    display: flex;
    align-items: flex-start;
    max-width: 367px;

    .cw-elements-notification-notice-message {
      display: none;
    }

    .cw-elements-notification-notice-close {
      position: unset;

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .cw-resend-notification {
    padding: 24px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    max-width: 423px;

    .cw-elements-notification-notice-description {
      font-size: 14px;
    }

    .cw-elements-notification-notice-message {
      font-weight: 600;
      margin: 0 0 0 40px;
      padding: 0;
    }

    .cw-elements-notification-notice-close {
      display: none;
    }

    .cw-elements-notification-notice-btn {
      margin-top: 24px;
    }

    .cw-elements-notification-notice-btn button {
      padding: 10px 16px;
      height: auto;
    }
  }
`, vk = un.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #0092e4;
  position: absolute;
  bottom: 3px;
  right: 2px;
`, gk = un.p`
  margin: 0 0 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`, pk = un.div`
  padding: 12px;
`, hk = un.div`
  display: flex;
  gap: 10px;
  align-items: center;
`, mk = un.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`, yk = un.div`
  display: flex;
  gap: 6px;
  margin-top: 8px;

  border: 1px solid #82cfff;
  border-radius: 4px;
  background-color: #eaf6ff;
  padding: 10px;
  color: #696f88;

  p {
    margin: 0;
  }

  .title {
    color: #14151c;
  }

  .email {
    color: #0071cd;
  }

  .resend {
    cursor: pointer;
    text-decoration: underline;
  }

  .icon svg {
    flex-shrink: 0;
  }
`, pg = un.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 24px;
  flex: 1;

  .language {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`, hg = un(lr.SubMenu)`
  /* Reset ant styles */
  border-radius: 0 !important;

  .cw-elements-menu-submenu-title {
    margin: 0 !important;
    padding: 6px 12px !important;
    height: auto !important;

    display: flex;
    align-items: center;
    font-size: 14px !important;
    line-height: 20px !important;
    color: #14151c !important;
    border-radius: 0 !important;
    background-color: transparent !important;
  }

  .cw-elements-menu-submenu-arrow {
    right: 12px;

    &:before,
    &:after {
      background-color: #696f88;
    }
  }

  .cw-elements-menu-title-content {
    flex: 1;
  }
  /* End Reset ant styles */

  &:hover {
    background-color: #eaf6ff !important;
  }
`, bk = un(lr.ItemGroup)`
  /* Reset ant styles */
  .cw-elements-menu-item-group-title {
    font-size: 12px;
    font-weight: 600;
    padding: 6px 12px !important;
  }
  /* End Reset ant styles */
`, rc = un(lr.Divider)`
  border-color: #dfe2e7;
  margin: 4px 0 !important;
`, Ck = un(lr.Item)`
  /* Reset ant styles */
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;

  font-size: 14px !important;
  line-height: 20px !important;
  color: #14151c !important;
  border-radius: 0 !important;
  width: 100% !important;
  /* End Reset ant styles */

  .cw-elements-menu-title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  padding: 6px 12px !important;

  &:hover {
    background-color: #eaf6ff !important;
  }

  ${({
  danger: e
}) => e && `
      color: #cf3537 !important;

      svg {
        fill: #cf3537 !important;
      }
    `}

  ${({
  $active: e
}) => e && `
      color: ##14151C !important;
      font-weight: 600;
    `}
`, Ei = ee.forwardRef((e, t) => /* @__PURE__ */ ue.jsx(Ck, { ...e }));
export {
  uk as Content,
  xk as ProfileDropdown
};
